exports['react-phone-number-input'] = /******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {} // The require function
  /******/
  /******/ /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports
      /******/
    } // Create a new module (and put it into the cache)
    /******/ /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {},
      /******/
    }) // Execute the module function
    /******/
    /******/ /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__) // Flag the module as loaded
    /******/
    /******/ /******/ module.l = true // Return the exports of the module
    /******/
    /******/ /******/ return module.exports
    /******/
  } // expose the modules object (__webpack_modules__)
  /******/
  /******/
  /******/ /******/ __webpack_require__.m = modules // expose the module cache
  /******/
  /******/ /******/ __webpack_require__.c = installedModules // define getter function for harmony exports
  /******/
  /******/ /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, { enumerable: true, get: getter })
      /******/
    }
    /******/
  } // define __esModule on exports
  /******/
  /******/ /******/ __webpack_require__.r = function (exports) {
    /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/ Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' })
      /******/
    }
    /******/ Object.defineProperty(exports, '__esModule', { value: true })
    /******/
  } // create a fake namespace object // mode & 1: value is a module id, require it // mode & 2: merge all properties of value into the ns // mode & 4: return value when already ns object // mode & 8|1: behave like require
  /******/
  /******/ /******/ /******/ /******/ /******/ /******/ __webpack_require__.t = function (value, mode) {
    /******/ if (mode & 1) value = __webpack_require__(value)
    /******/ if (mode & 8) return value
    /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value
    /******/ var ns = Object.create(null)
    /******/ __webpack_require__.r(ns)
    /******/ Object.defineProperty(ns, 'default', { enumerable: true, value: value })
    /******/ if (mode & 2 && typeof value != 'string')
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key]
          }.bind(null, key)
        )
    /******/ return ns
    /******/
  } // getDefaultExport function for compatibility with non-harmony modules
  /******/
  /******/ /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module['default']
          }
        : /******/ function getModuleExports() {
            return module
          }
    /******/ __webpack_require__.d(getter, 'a', getter)
    /******/ return getter
    /******/
  } // Object.prototype.hasOwnProperty.call
  /******/
  /******/ /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property)
  } // __webpack_public_path__
  /******/
  /******/ /******/ __webpack_require__.p = '' // Load entry module and return exports
  /******/
  /******/
  /******/ /******/ return __webpack_require__((__webpack_require__.s = './index.js'))
  /******/
})(
  /************************************************************************/
  /******/ {
    /***/ '../node_modules/amator/index.js':
      /*!***************************************!*\
  !*** ../node_modules/amator/index.js ***!
  \***************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var BezierEasing = __webpack_require__(/*! bezier-easing */ '../node_modules/bezier-easing/src/index.js')

        // Predefined set of animations. Similar to CSS easing functions
        var animations = {
          ease: BezierEasing(0.25, 0.1, 0.25, 1),
          easeIn: BezierEasing(0.42, 0, 1, 1),
          easeOut: BezierEasing(0, 0, 0.58, 1),
          easeInOut: BezierEasing(0.42, 0, 0.58, 1),
          linear: BezierEasing(0, 0, 1, 1),
        }

        module.exports = animate

        function animate(source, target, options) {
          var start = Object.create(null)
          var diff = Object.create(null)
          options = options || {}
          // We let clients specify their own easing function
          var easing = typeof options.easing === 'function' ? options.easing : animations[options.easing]

          // if nothing is specified, default to ease (similar to CSS animations)
          if (!easing) {
            if (options.easing) {
              console.warn('Unknown easing function in amator: ' + options.easing)
            }
            easing = animations.ease
          }

          var step = typeof options.step === 'function' ? options.step : noop
          var done = typeof options.done === 'function' ? options.done : noop

          var scheduler = getScheduler(options.scheduler)

          var keys = Object.keys(target)
          keys.forEach(function (key) {
            start[key] = source[key]
            diff[key] = target[key] - source[key]
          })

          var durationInMs = options.duration || 400
          var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
          var previousAnimationId
          var frame = 0

          previousAnimationId = scheduler.next(loop)

          return {
            cancel: cancel,
          }

          function cancel() {
            scheduler.cancel(previousAnimationId)
            previousAnimationId = 0
          }

          function loop() {
            var t = easing(frame / durationInFrames)
            frame += 1
            setValues(t)
            if (frame <= durationInFrames) {
              previousAnimationId = scheduler.next(loop)
              step(source)
            } else {
              previousAnimationId = 0
              setTimeout(function () {
                done(source)
              }, 0)
            }
          }

          function setValues(t) {
            keys.forEach(function (key) {
              source[key] = diff[key] * t + start[key]
            })
          }
        }

        function noop() {}

        function getScheduler(scheduler) {
          if (!scheduler) {
            var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame
            return canRaf ? rafScheduler() : timeoutScheduler()
          }
          if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function')
          if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function')

          return scheduler
        }

        function rafScheduler() {
          return {
            next: window.requestAnimationFrame.bind(window),
            cancel: window.cancelAnimationFrame.bind(window),
          }
        }

        function timeoutScheduler() {
          return {
            next: function (cb) {
              return setTimeout(cb, 1000 / 60)
            },
            cancel: function (id) {
              return clearTimeout(id)
            },
          }
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/get-iterator.js':
      /*!*************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/get-iterator.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(/*! core-js/library/fn/get-iterator */ '../node_modules/core-js/library/fn/get-iterator.js'),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/object/assign.js':
      /*!**************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/object/assign.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(/*! core-js/library/fn/object/assign */ '../node_modules/core-js/library/fn/object/assign.js'),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/object/create.js':
      /*!**************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/object/create.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(/*! core-js/library/fn/object/create */ '../node_modules/core-js/library/fn/object/create.js'),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/object/define-property.js':
      /*!***********************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/object/define-property.js ***!
  \***********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(
            /*! core-js/library/fn/object/define-property */ '../node_modules/core-js/library/fn/object/define-property.js'
          ),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/object/get-prototype-of.js':
      /*!************************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/object/get-prototype-of.js ***!
  \************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(
            /*! core-js/library/fn/object/get-prototype-of */ '../node_modules/core-js/library/fn/object/get-prototype-of.js'
          ),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/object/set-prototype-of.js':
      /*!************************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/object/set-prototype-of.js ***!
  \************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(
            /*! core-js/library/fn/object/set-prototype-of */ '../node_modules/core-js/library/fn/object/set-prototype-of.js'
          ),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/symbol.js':
      /*!*******************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/symbol.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(/*! core-js/library/fn/symbol */ '../node_modules/core-js/library/fn/symbol/index.js'),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/core-js/symbol/iterator.js':
      /*!****************************************************************!*\
  !*** ../node_modules/babel-runtime/core-js/symbol/iterator.js ***!
  \****************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = {
          default: __webpack_require__(/*! core-js/library/fn/symbol/iterator */ '../node_modules/core-js/library/fn/symbol/iterator.js'),
          __esModule: true,
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/classCallCheck.js':
      /*!***************************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        exports.default = function (instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/createClass.js':
      /*!************************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/createClass.js ***!
  \************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        var _defineProperty = __webpack_require__(
          /*! ../core-js/object/define-property */ '../node_modules/babel-runtime/core-js/object/define-property.js'
        )

        var _defineProperty2 = _interopRequireDefault(_defineProperty)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        exports.default = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              ;(0, _defineProperty2.default)(target, descriptor.key, descriptor)
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/extends.js':
      /*!********************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/extends.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        var _assign = __webpack_require__(/*! ../core-js/object/assign */ '../node_modules/babel-runtime/core-js/object/assign.js')

        var _assign2 = _interopRequireDefault(_assign)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        exports.default =
          _assign2.default ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]

              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }

            return target
          }

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/inherits.js':
      /*!*********************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/inherits.js ***!
  \*********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        var _setPrototypeOf = __webpack_require__(
          /*! ../core-js/object/set-prototype-of */ '../node_modules/babel-runtime/core-js/object/set-prototype-of.js'
        )

        var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf)

        var _create = __webpack_require__(/*! ../core-js/object/create */ '../node_modules/babel-runtime/core-js/object/create.js')

        var _create2 = _interopRequireDefault(_create)

        var _typeof2 = __webpack_require__(/*! ../helpers/typeof */ '../node_modules/babel-runtime/helpers/typeof.js')

        var _typeof3 = _interopRequireDefault(_typeof2)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        exports.default = function (subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass))
            )
          }

          subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true,
            },
          })
          if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/objectWithoutProperties.js':
      /*!************************************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        exports.default = function (obj, keys) {
          var target = {}

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
            target[i] = obj[i]
          }

          return target
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/possibleConstructorReturn.js':
      /*!**************************************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js ***!
  \**************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        var _typeof2 = __webpack_require__(/*! ../helpers/typeof */ '../node_modules/babel-runtime/helpers/typeof.js')

        var _typeof3 = _interopRequireDefault(_typeof2)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        exports.default = function (self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }

          return call &&
            ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        /***/
      },

    /***/ '../node_modules/babel-runtime/helpers/typeof.js':
      /*!*******************************************************!*\
  !*** ../node_modules/babel-runtime/helpers/typeof.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports.__esModule = true

        var _iterator = __webpack_require__(/*! ../core-js/symbol/iterator */ '../node_modules/babel-runtime/core-js/symbol/iterator.js')

        var _iterator2 = _interopRequireDefault(_iterator)

        var _symbol = __webpack_require__(/*! ../core-js/symbol */ '../node_modules/babel-runtime/core-js/symbol.js')

        var _symbol2 = _interopRequireDefault(_symbol)

        var _typeof =
          typeof _symbol2.default === 'function' && typeof _iterator2.default === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj &&
                  typeof _symbol2.default === 'function' &&
                  obj.constructor === _symbol2.default &&
                  obj !== _symbol2.default.prototype
                  ? 'symbol'
                  : typeof obj
              }

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        exports.default =
          typeof _symbol2.default === 'function' && _typeof(_iterator2.default) === 'symbol'
            ? function (obj) {
                return typeof obj === 'undefined' ? 'undefined' : _typeof(obj)
              }
            : function (obj) {
                return obj &&
                  typeof _symbol2.default === 'function' &&
                  obj.constructor === _symbol2.default &&
                  obj !== _symbol2.default.prototype
                  ? 'symbol'
                  : typeof obj === 'undefined'
                  ? 'undefined'
                  : _typeof(obj)
              }

        /***/
      },

    /***/ '../node_modules/bezier-easing/src/index.js':
      /*!**************************************************!*\
  !*** ../node_modules/bezier-easing/src/index.js ***!
  \**************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        /**
         * https://github.com/gre/bezier-easing
         * BezierEasing - use bezier curve for transition easing function
         * by Gaëtan Renaudeau 2014 - 2015 – MIT License
         */

        // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4
        var NEWTON_MIN_SLOPE = 0.001
        var SUBDIVISION_PRECISION = 0.0000001
        var SUBDIVISION_MAX_ITERATIONS = 10

        var kSplineTableSize = 11
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0)

        var float32ArraySupported = typeof Float32Array === 'function'

        function A(aA1, aA2) {
          return 1.0 - 3.0 * aA2 + 3.0 * aA1
        }
        function B(aA1, aA2) {
          return 3.0 * aA2 - 6.0 * aA1
        }
        function C(aA1) {
          return 3.0 * aA1
        }

        // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
          return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT
        }

        // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
          return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1)
        }

        function binarySubdivide(aX, aA, aB, mX1, mX2) {
          var currentX,
            currentT,
            i = 0
          do {
            currentT = aA + (aB - aA) / 2.0
            currentX = calcBezier(currentT, mX1, mX2) - aX
            if (currentX > 0.0) {
              aB = currentT
            } else {
              aA = currentT
            }
          } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS)
          return currentT
        }

        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
          for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2)
            if (currentSlope === 0.0) {
              return aGuessT
            }
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX
            aGuessT -= currentX / currentSlope
          }
          return aGuessT
        }

        function LinearEasing(x) {
          return x
        }

        module.exports = function bezier(mX1, mY1, mX2, mY2) {
          if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
            throw new Error('bezier x values must be in [0, 1] range')
          }

          if (mX1 === mY1 && mX2 === mY2) {
            return LinearEasing
          }

          // Precompute samples table
          var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize)
          for (var i = 0; i < kSplineTableSize; ++i) {
            sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2)
          }

          function getTForX(aX) {
            var intervalStart = 0.0
            var currentSample = 1
            var lastSample = kSplineTableSize - 1

            for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
              intervalStart += kSampleStepSize
            }
            --currentSample

            // Interpolate to provide an initial guess for t
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample])
            var guessForT = intervalStart + dist * kSampleStepSize

            var initialSlope = getSlope(guessForT, mX1, mX2)
            if (initialSlope >= NEWTON_MIN_SLOPE) {
              return newtonRaphsonIterate(aX, guessForT, mX1, mX2)
            } else if (initialSlope === 0.0) {
              return guessForT
            } else {
              return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2)
            }
          }

          return function BezierEasing(x) {
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) {
              return 0
            }
            if (x === 1) {
              return 1
            }
            return calcBezier(getTForX(x), mY1, mY2)
          }
        }

        /***/
      },

    /***/ '../node_modules/classnames/index.js':
      /*!*******************************************!*\
  !*** ../node_modules/classnames/index.js ***!
  \*******************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__,
          __WEBPACK_AMD_DEFINE_RESULT__ /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
        /* global define */

        ;(function () {
          'use strict'

          var hasOwn = {}.hasOwnProperty

          function classNames() {
            var classes = []

            for (var i = 0; i < arguments.length; i++) {
              var arg = arguments[i]
              if (!arg) continue

              var argType = typeof arg

              if (argType === 'string' || argType === 'number') {
                classes.push(arg)
              } else if (Array.isArray(arg)) {
                classes.push(classNames.apply(null, arg))
              } else if (argType === 'object') {
                for (var key in arg) {
                  if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key)
                  }
                }
              }
            }

            return classes.join(' ')
          }

          if (true && module.exports) {
            module.exports = classNames
          } else if (true) {
            // register as 'classnames', consistent with npm package name
            !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
            (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return classNames
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
          } else {
          }
        })()

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/get-iterator.js':
      /*!**********************************************************!*\
  !*** ../node_modules/core-js/library/fn/get-iterator.js ***!
  \**********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ../modules/web.dom.iterable */ '../node_modules/core-js/library/modules/web.dom.iterable.js')
        __webpack_require__(/*! ../modules/es6.string.iterator */ '../node_modules/core-js/library/modules/es6.string.iterator.js')
        module.exports = __webpack_require__(
          /*! ../modules/core.get-iterator */ '../node_modules/core-js/library/modules/core.get-iterator.js'
        )

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/object/assign.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/fn/object/assign.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ../../modules/es6.object.assign */ '../node_modules/core-js/library/modules/es6.object.assign.js')
        module.exports = __webpack_require__(/*! ../../modules/_core */ '../node_modules/core-js/library/modules/_core.js').Object.assign

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/object/create.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/fn/object/create.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ../../modules/es6.object.create */ '../node_modules/core-js/library/modules/es6.object.create.js')
        var $Object = __webpack_require__(/*! ../../modules/_core */ '../node_modules/core-js/library/modules/_core.js').Object
        module.exports = function create(P, D) {
          return $Object.create(P, D)
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/object/define-property.js':
      /*!********************************************************************!*\
  !*** ../node_modules/core-js/library/fn/object/define-property.js ***!
  \********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(
          /*! ../../modules/es6.object.define-property */ '../node_modules/core-js/library/modules/es6.object.define-property.js'
        )
        var $Object = __webpack_require__(/*! ../../modules/_core */ '../node_modules/core-js/library/modules/_core.js').Object
        module.exports = function defineProperty(it, key, desc) {
          return $Object.defineProperty(it, key, desc)
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/object/get-prototype-of.js':
      /*!*********************************************************************!*\
  !*** ../node_modules/core-js/library/fn/object/get-prototype-of.js ***!
  \*********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(
          /*! ../../modules/es6.object.get-prototype-of */ '../node_modules/core-js/library/modules/es6.object.get-prototype-of.js'
        )
        module.exports = __webpack_require__(
          /*! ../../modules/_core */ '../node_modules/core-js/library/modules/_core.js'
        ).Object.getPrototypeOf

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/object/set-prototype-of.js':
      /*!*********************************************************************!*\
  !*** ../node_modules/core-js/library/fn/object/set-prototype-of.js ***!
  \*********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(
          /*! ../../modules/es6.object.set-prototype-of */ '../node_modules/core-js/library/modules/es6.object.set-prototype-of.js'
        )
        module.exports = __webpack_require__(
          /*! ../../modules/_core */ '../node_modules/core-js/library/modules/_core.js'
        ).Object.setPrototypeOf

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/symbol/index.js':
      /*!**********************************************************!*\
  !*** ../node_modules/core-js/library/fn/symbol/index.js ***!
  \**********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ../../modules/es6.symbol */ '../node_modules/core-js/library/modules/es6.symbol.js')
        __webpack_require__(/*! ../../modules/es6.object.to-string */ '../node_modules/core-js/library/modules/es6.object.to-string.js')
        __webpack_require__(
          /*! ../../modules/es7.symbol.async-iterator */ '../node_modules/core-js/library/modules/es7.symbol.async-iterator.js'
        )
        __webpack_require__(/*! ../../modules/es7.symbol.observable */ '../node_modules/core-js/library/modules/es7.symbol.observable.js')
        module.exports = __webpack_require__(/*! ../../modules/_core */ '../node_modules/core-js/library/modules/_core.js').Symbol

        /***/
      },

    /***/ '../node_modules/core-js/library/fn/symbol/iterator.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/fn/symbol/iterator.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ../../modules/es6.string.iterator */ '../node_modules/core-js/library/modules/es6.string.iterator.js')
        __webpack_require__(/*! ../../modules/web.dom.iterable */ '../node_modules/core-js/library/modules/web.dom.iterable.js')
        module.exports = __webpack_require__(/*! ../../modules/_wks-ext */ '../node_modules/core-js/library/modules/_wks-ext.js').f(
          'iterator'
        )

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_a-function.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_a-function.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!')
          return it
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_add-to-unscopables.js':
      /*!**********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_add-to-unscopables.js ***!
  \**********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function () {
          /* empty */
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_an-object.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_an-object.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(/*! ./_is-object */ '../node_modules/core-js/library/modules/_is-object.js')
        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!')
          return it
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_array-includes.js':
      /*!******************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_array-includes.js ***!
  \******************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(/*! ./_to-iobject */ '../node_modules/core-js/library/modules/_to-iobject.js')
        var toLength = __webpack_require__(/*! ./_to-length */ '../node_modules/core-js/library/modules/_to-length.js')
        var toAbsoluteIndex = __webpack_require__(
          /*! ./_to-absolute-index */ '../node_modules/core-js/library/modules/_to-absolute-index.js'
        )
        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this)
            var length = toLength(O.length)
            var index = toAbsoluteIndex(fromIndex, length)
            var value
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare
            if (IS_INCLUDES && el != el)
              while (length > index) {
                value = O[index++]
                // eslint-disable-next-line no-self-compare
                if (value != value) return true
                // Array#indexOf ignores holes, Array#includes - not
              }
            else
              for (; length > index; index++)
                if (IS_INCLUDES || index in O) {
                  if (O[index] === el) return IS_INCLUDES || index || 0
                }
            return !IS_INCLUDES && -1
          }
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_classof.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_classof.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__(/*! ./_cof */ '../node_modules/core-js/library/modules/_cof.js')
        var TAG = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')('toStringTag')
        // ES3 wrong here
        var ARG =
          cof(
            (function () {
              return arguments
            })()
          ) == 'Arguments'

        // fallback for IE11 Script Access Denied error
        var tryGet = function (it, key) {
          try {
            return it[key]
          } catch (e) {
            /* empty */
          }
        }

        module.exports = function (it) {
          var O, T, B
          return it === undefined
            ? 'Undefined'
            : it === null
            ? 'Null'
            : // @@toStringTag case
            typeof (T = tryGet((O = Object(it)), TAG)) == 'string'
            ? T
            : // builtinTag case
            ARG
            ? cof(O)
            : // ES3 arguments fallback
            (B = cof(O)) == 'Object' && typeof O.callee == 'function'
            ? 'Arguments'
            : B
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_cof.js':
      /*!*******************************************************!*\
  !*** ../node_modules/core-js/library/modules/_cof.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        var toString = {}.toString

        module.exports = function (it) {
          return toString.call(it).slice(8, -1)
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_core.js':
      /*!********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_core.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        var core = (module.exports = { version: '2.5.3' })
        if (typeof __e == 'number') __e = core // eslint-disable-line no-undef

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_ctx.js':
      /*!*******************************************************!*\
  !*** ../node_modules/core-js/library/modules/_ctx.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(/*! ./_a-function */ '../node_modules/core-js/library/modules/_a-function.js')
        module.exports = function (fn, that, length) {
          aFunction(fn)
          if (that === undefined) return fn
          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a)
              }
            case 2:
              return function (a, b) {
                return fn.call(that, a, b)
              }
            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c)
              }
          }
          return function (/* ...args */) {
            return fn.apply(that, arguments)
          }
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_defined.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_defined.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it)
          return it
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_descriptors.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_descriptors.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(/*! ./_fails */ '../node_modules/core-js/library/modules/_fails.js')(function () {
          return (
            Object.defineProperty({}, 'a', {
              get: function () {
                return 7
              },
            }).a != 7
          )
        })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_dom-create.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_dom-create.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(/*! ./_is-object */ '../node_modules/core-js/library/modules/_is-object.js')
        var document = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js').document
        // typeof document.createElement is 'object' in old IE
        var is = isObject(document) && isObject(document.createElement)
        module.exports = function (it) {
          return is ? document.createElement(it) : {}
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_enum-bug-keys.js':
      /*!*****************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_enum-bug-keys.js ***!
  \*****************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',')

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_enum-keys.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_enum-keys.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // all enumerable object keys, includes symbols
        var getKeys = __webpack_require__(/*! ./_object-keys */ '../node_modules/core-js/library/modules/_object-keys.js')
        var gOPS = __webpack_require__(/*! ./_object-gops */ '../node_modules/core-js/library/modules/_object-gops.js')
        var pIE = __webpack_require__(/*! ./_object-pie */ '../node_modules/core-js/library/modules/_object-pie.js')
        module.exports = function (it) {
          var result = getKeys(it)
          var getSymbols = gOPS.f
          if (getSymbols) {
            var symbols = getSymbols(it)
            var isEnum = pIE.f
            var i = 0
            var key
            while (symbols.length > i) if (isEnum.call(it, (key = symbols[i++]))) result.push(key)
          }
          return result
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_export.js':
      /*!**********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_export.js ***!
  \**********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js')
        var core = __webpack_require__(/*! ./_core */ '../node_modules/core-js/library/modules/_core.js')
        var ctx = __webpack_require__(/*! ./_ctx */ '../node_modules/core-js/library/modules/_ctx.js')
        var hide = __webpack_require__(/*! ./_hide */ '../node_modules/core-js/library/modules/_hide.js')
        var PROTOTYPE = 'prototype'

        var $export = function (type, name, source) {
          var IS_FORCED = type & $export.F
          var IS_GLOBAL = type & $export.G
          var IS_STATIC = type & $export.S
          var IS_PROTO = type & $export.P
          var IS_BIND = type & $export.B
          var IS_WRAP = type & $export.W
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {})
          var expProto = exports[PROTOTYPE]
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
          var key, own, out
          if (IS_GLOBAL) source = name
          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined
            if (own && key in exports) continue
            // export native or passed
            out = own ? target[key] : source[key]
            // prevent global pollution for namespaces
            exports[key] =
              IS_GLOBAL && typeof target[key] != 'function'
                ? source[key]
                : // bind timers to global for call from export context
                IS_BIND && own
                ? ctx(out, global)
                : // wrap global constructors for prevent change them in library
                IS_WRAP && target[key] == out
                ? (function (C) {
                    var F = function (a, b, c) {
                      if (this instanceof C) {
                        switch (arguments.length) {
                          case 0:
                            return new C()
                          case 1:
                            return new C(a)
                          case 2:
                            return new C(a, b)
                        }
                        return new C(a, b, c)
                      }
                      return C.apply(this, arguments)
                    }
                    F[PROTOTYPE] = C[PROTOTYPE]
                    return F
                    // make static versions for prototype methods
                  })(out)
                : IS_PROTO && typeof out == 'function'
                ? ctx(Function.call, out)
                : out
            // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
            if (IS_PROTO) {
              ;(exports.virtual || (exports.virtual = {}))[key] = out
              // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
              if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out)
            }
          }
        }
        // type bitmap
        $export.F = 1 // forced
        $export.G = 2 // global
        $export.S = 4 // static
        $export.P = 8 // proto
        $export.B = 16 // bind
        $export.W = 32 // wrap
        $export.U = 64 // safe
        $export.R = 128 // real proto method for `library`
        module.exports = $export

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_fails.js':
      /*!*********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_fails.js ***!
  \*********************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec()
          } catch (e) {
            return true
          }
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_global.js':
      /*!**********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_global.js ***!
  \**********************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = (module.exports =
          typeof window != 'undefined' && window.Math == Math
            ? window
            : typeof self != 'undefined' && self.Math == Math
            ? self
            : // eslint-disable-next-line no-new-func
              Function('return this')())
        if (typeof __g == 'number') __g = global // eslint-disable-line no-undef

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_has.js':
      /*!*******************************************************!*\
  !*** ../node_modules/core-js/library/modules/_has.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        var hasOwnProperty = {}.hasOwnProperty
        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key)
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_hide.js':
      /*!********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_hide.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var dP = __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js')
        var createDesc = __webpack_require__(/*! ./_property-desc */ '../node_modules/core-js/library/modules/_property-desc.js')
        module.exports = __webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js')
          ? function (object, key, value) {
              return dP.f(object, key, createDesc(1, value))
            }
          : function (object, key, value) {
              object[key] = value
              return object
            }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_html.js':
      /*!********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_html.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var document = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js').document
        module.exports = document && document.documentElement

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_ie8-dom-define.js':
      /*!******************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_ie8-dom-define.js ***!
  \******************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports =
          !__webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js') &&
          !__webpack_require__(/*! ./_fails */ '../node_modules/core-js/library/modules/_fails.js')(function () {
            return (
              Object.defineProperty(
                __webpack_require__(/*! ./_dom-create */ '../node_modules/core-js/library/modules/_dom-create.js')('div'),
                'a',
                {
                  get: function () {
                    return 7
                  },
                }
              ).a != 7
            )
          })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_iobject.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_iobject.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(/*! ./_cof */ '../node_modules/core-js/library/modules/_cof.js')
        // eslint-disable-next-line no-prototype-builtins
        module.exports = Object('z').propertyIsEnumerable(0)
          ? Object
          : function (it) {
              return cof(it) == 'String' ? it.split('') : Object(it)
            }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_is-array.js':
      /*!************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_is-array.js ***!
  \************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 7.2.2 IsArray(argument)
        var cof = __webpack_require__(/*! ./_cof */ '../node_modules/core-js/library/modules/_cof.js')
        module.exports =
          Array.isArray ||
          function isArray(arg) {
            return cof(arg) == 'Array'
          }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_is-object.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_is-object.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function'
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_iter-create.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_iter-create.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var create = __webpack_require__(/*! ./_object-create */ '../node_modules/core-js/library/modules/_object-create.js')
        var descriptor = __webpack_require__(/*! ./_property-desc */ '../node_modules/core-js/library/modules/_property-desc.js')
        var setToStringTag = __webpack_require__(
          /*! ./_set-to-string-tag */ '../node_modules/core-js/library/modules/_set-to-string-tag.js'
        )
        var IteratorPrototype = {}

        // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
        __webpack_require__(/*! ./_hide */ '../node_modules/core-js/library/modules/_hide.js')(
          IteratorPrototype,
          __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')('iterator'),
          function () {
            return this
          }
        )

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) })
          setToStringTag(Constructor, NAME + ' Iterator')
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_iter-define.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_iter-define.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var LIBRARY = __webpack_require__(/*! ./_library */ '../node_modules/core-js/library/modules/_library.js')
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')
        var redefine = __webpack_require__(/*! ./_redefine */ '../node_modules/core-js/library/modules/_redefine.js')
        var hide = __webpack_require__(/*! ./_hide */ '../node_modules/core-js/library/modules/_hide.js')
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var Iterators = __webpack_require__(/*! ./_iterators */ '../node_modules/core-js/library/modules/_iterators.js')
        var $iterCreate = __webpack_require__(/*! ./_iter-create */ '../node_modules/core-js/library/modules/_iter-create.js')
        var setToStringTag = __webpack_require__(
          /*! ./_set-to-string-tag */ '../node_modules/core-js/library/modules/_set-to-string-tag.js'
        )
        var getPrototypeOf = __webpack_require__(/*! ./_object-gpo */ '../node_modules/core-js/library/modules/_object-gpo.js')
        var ITERATOR = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')('iterator')
        var BUGGY = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
        var FF_ITERATOR = '@@iterator'
        var KEYS = 'keys'
        var VALUES = 'values'

        var returnThis = function () {
          return this
        }

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next)
          var getMethod = function (kind) {
            if (!BUGGY && kind in proto) return proto[kind]
            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind)
                }
              case VALUES:
                return function values() {
                  return new Constructor(this, kind)
                }
            }
            return function entries() {
              return new Constructor(this, kind)
            }
          }
          var TAG = NAME + ' Iterator'
          var DEF_VALUES = DEFAULT == VALUES
          var VALUES_BUG = false
          var proto = Base.prototype
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || (DEFAULT && proto[DEFAULT])
          var $default = (!BUGGY && $native) || getMethod(DEFAULT)
          var $entries = DEFAULT ? (!DEF_VALUES ? $default : getMethod('entries')) : undefined
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native
          var methods, key, IteratorPrototype
          // Fix native
          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()))
            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true)
              // fix for some old engines
              if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis)
            }
          }
          // fix Array#{values, @@iterator}.name in V8 / FF
          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true
            $default = function values() {
              return $native.call(this)
            }
          }
          // Define iterator
          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default)
          }
          // Plug for library
          Iterators[NAME] = $default
          Iterators[TAG] = returnThis
          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries,
            }
            if (FORCED)
              for (key in methods) {
                if (!(key in proto)) redefine(proto, key, methods[key])
              }
            else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods)
          }
          return methods
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_iter-step.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_iter-step.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function (done, value) {
          return { value: value, done: !!done }
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_iterators.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_iterators.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = {}

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_library.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_library.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = true

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_meta.js':
      /*!********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_meta.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var META = __webpack_require__(/*! ./_uid */ '../node_modules/core-js/library/modules/_uid.js')('meta')
        var isObject = __webpack_require__(/*! ./_is-object */ '../node_modules/core-js/library/modules/_is-object.js')
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var setDesc = __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js').f
        var id = 0
        var isExtensible =
          Object.isExtensible ||
          function () {
            return true
          }
        var FREEZE = !__webpack_require__(/*! ./_fails */ '../node_modules/core-js/library/modules/_fails.js')(function () {
          return isExtensible(Object.preventExtensions({}))
        })
        var setMeta = function (it) {
          setDesc(it, META, {
            value: {
              i: 'O' + ++id, // object ID
              w: {}, // weak collections IDs
            },
          })
        }
        var fastKey = function (it, create) {
          // return primitive with prefix
          if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F'
            // not necessary to add metadata
            if (!create) return 'E'
            // add missing metadata
            setMeta(it)
            // return object ID
          }
          return it[META].i
        }
        var getWeak = function (it, create) {
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true
            // not necessary to add metadata
            if (!create) return false
            // add missing metadata
            setMeta(it)
            // return hash weak collections IDs
          }
          return it[META].w
        }
        // add metadata on freeze-family methods calling
        var onFreeze = function (it) {
          if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it)
          return it
        }
        var meta = (module.exports = {
          KEY: META,
          NEED: false,
          fastKey: fastKey,
          getWeak: getWeak,
          onFreeze: onFreeze,
        })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-assign.js':
      /*!*****************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-assign.js ***!
  \*****************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        // 19.1.2.1 Object.assign(target, source, ...)
        var getKeys = __webpack_require__(/*! ./_object-keys */ '../node_modules/core-js/library/modules/_object-keys.js')
        var gOPS = __webpack_require__(/*! ./_object-gops */ '../node_modules/core-js/library/modules/_object-gops.js')
        var pIE = __webpack_require__(/*! ./_object-pie */ '../node_modules/core-js/library/modules/_object-pie.js')
        var toObject = __webpack_require__(/*! ./_to-object */ '../node_modules/core-js/library/modules/_to-object.js')
        var IObject = __webpack_require__(/*! ./_iobject */ '../node_modules/core-js/library/modules/_iobject.js')
        var $assign = Object.assign

        // should work with symbols and should have deterministic property order (V8 bug)
        module.exports =
          !$assign ||
          __webpack_require__(/*! ./_fails */ '../node_modules/core-js/library/modules/_fails.js')(function () {
            var A = {}
            var B = {}
            // eslint-disable-next-line no-undef
            var S = Symbol()
            var K = 'abcdefghijklmnopqrst'
            A[S] = 7
            K.split('').forEach(function (k) {
              B[k] = k
            })
            return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K
          })
            ? function assign(target, source) {
                // eslint-disable-line no-unused-vars
                var T = toObject(target)
                var aLen = arguments.length
                var index = 1
                var getSymbols = gOPS.f
                var isEnum = pIE.f
                while (aLen > index) {
                  var S = IObject(arguments[index++])
                  var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
                  var length = keys.length
                  var j = 0
                  var key
                  while (length > j) if (isEnum.call(S, (key = keys[j++]))) T[key] = S[key]
                }
                return T
              }
            : $assign

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-create.js':
      /*!*****************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-create.js ***!
  \*****************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(/*! ./_an-object */ '../node_modules/core-js/library/modules/_an-object.js')
        var dPs = __webpack_require__(/*! ./_object-dps */ '../node_modules/core-js/library/modules/_object-dps.js')
        var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ '../node_modules/core-js/library/modules/_enum-bug-keys.js')
        var IE_PROTO = __webpack_require__(/*! ./_shared-key */ '../node_modules/core-js/library/modules/_shared-key.js')('IE_PROTO')
        var Empty = function () {
          /* empty */
        }
        var PROTOTYPE = 'prototype'

        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var createDict = function () {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(/*! ./_dom-create */ '../node_modules/core-js/library/modules/_dom-create.js')('iframe')
          var i = enumBugKeys.length
          var lt = '<'
          var gt = '>'
          var iframeDocument
          iframe.style.display = 'none'
          __webpack_require__(/*! ./_html */ '../node_modules/core-js/library/modules/_html.js').appendChild(iframe)
          iframe.src = 'javascript:' // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);
          iframeDocument = iframe.contentWindow.document
          iframeDocument.open()
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt)
          iframeDocument.close()
          createDict = iframeDocument.F
          while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]]
          return createDict()
        }

        module.exports =
          Object.create ||
          function create(O, Properties) {
            var result
            if (O !== null) {
              Empty[PROTOTYPE] = anObject(O)
              result = new Empty()
              Empty[PROTOTYPE] = null
              // add "__proto__" for Object.getPrototypeOf polyfill
              result[IE_PROTO] = O
            } else result = createDict()
            return Properties === undefined ? result : dPs(result, Properties)
          }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-dp.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-dp.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var anObject = __webpack_require__(/*! ./_an-object */ '../node_modules/core-js/library/modules/_an-object.js')
        var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ '../node_modules/core-js/library/modules/_ie8-dom-define.js')
        var toPrimitive = __webpack_require__(/*! ./_to-primitive */ '../node_modules/core-js/library/modules/_to-primitive.js')
        var dP = Object.defineProperty

        exports.f = __webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js')
          ? Object.defineProperty
          : function defineProperty(O, P, Attributes) {
              anObject(O)
              P = toPrimitive(P, true)
              anObject(Attributes)
              if (IE8_DOM_DEFINE)
                try {
                  return dP(O, P, Attributes)
                } catch (e) {
                  /* empty */
                }
              if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!')
              if ('value' in Attributes) O[P] = Attributes.value
              return O
            }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-dps.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-dps.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var dP = __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js')
        var anObject = __webpack_require__(/*! ./_an-object */ '../node_modules/core-js/library/modules/_an-object.js')
        var getKeys = __webpack_require__(/*! ./_object-keys */ '../node_modules/core-js/library/modules/_object-keys.js')

        module.exports = __webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js')
          ? Object.defineProperties
          : function defineProperties(O, Properties) {
              anObject(O)
              var keys = getKeys(Properties)
              var length = keys.length
              var i = 0
              var P
              while (length > i) dP.f(O, (P = keys[i++]), Properties[P])
              return O
            }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-gopd.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-gopd.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var pIE = __webpack_require__(/*! ./_object-pie */ '../node_modules/core-js/library/modules/_object-pie.js')
        var createDesc = __webpack_require__(/*! ./_property-desc */ '../node_modules/core-js/library/modules/_property-desc.js')
        var toIObject = __webpack_require__(/*! ./_to-iobject */ '../node_modules/core-js/library/modules/_to-iobject.js')
        var toPrimitive = __webpack_require__(/*! ./_to-primitive */ '../node_modules/core-js/library/modules/_to-primitive.js')
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ '../node_modules/core-js/library/modules/_ie8-dom-define.js')
        var gOPD = Object.getOwnPropertyDescriptor

        exports.f = __webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js')
          ? gOPD
          : function getOwnPropertyDescriptor(O, P) {
              O = toIObject(O)
              P = toPrimitive(P, true)
              if (IE8_DOM_DEFINE)
                try {
                  return gOPD(O, P)
                } catch (e) {
                  /* empty */
                }
              if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P])
            }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-gopn-ext.js':
      /*!*******************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-gopn-ext.js ***!
  \*******************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        var toIObject = __webpack_require__(/*! ./_to-iobject */ '../node_modules/core-js/library/modules/_to-iobject.js')
        var gOPN = __webpack_require__(/*! ./_object-gopn */ '../node_modules/core-js/library/modules/_object-gopn.js').f
        var toString = {}.toString

        var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : []

        var getWindowNames = function (it) {
          try {
            return gOPN(it)
          } catch (e) {
            return windowNames.slice()
          }
        }

        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it))
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-gopn.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-gopn.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var $keys = __webpack_require__(/*! ./_object-keys-internal */ '../node_modules/core-js/library/modules/_object-keys-internal.js')
        var hiddenKeys = __webpack_require__(/*! ./_enum-bug-keys */ '../node_modules/core-js/library/modules/_enum-bug-keys.js').concat(
          'length',
          'prototype'
        )

        exports.f =
          Object.getOwnPropertyNames ||
          function getOwnPropertyNames(O) {
            return $keys(O, hiddenKeys)
          }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-gops.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-gops.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        exports.f = Object.getOwnPropertySymbols

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-gpo.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-gpo.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var toObject = __webpack_require__(/*! ./_to-object */ '../node_modules/core-js/library/modules/_to-object.js')
        var IE_PROTO = __webpack_require__(/*! ./_shared-key */ '../node_modules/core-js/library/modules/_shared-key.js')('IE_PROTO')
        var ObjectProto = Object.prototype

        module.exports =
          Object.getPrototypeOf ||
          function (O) {
            O = toObject(O)
            if (has(O, IE_PROTO)) return O[IE_PROTO]
            if (typeof O.constructor == 'function' && O instanceof O.constructor) {
              return O.constructor.prototype
            }
            return O instanceof Object ? ObjectProto : null
          }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-keys-internal.js':
      /*!************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-keys-internal.js ***!
  \************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var toIObject = __webpack_require__(/*! ./_to-iobject */ '../node_modules/core-js/library/modules/_to-iobject.js')
        var arrayIndexOf = __webpack_require__(/*! ./_array-includes */ '../node_modules/core-js/library/modules/_array-includes.js')(false)
        var IE_PROTO = __webpack_require__(/*! ./_shared-key */ '../node_modules/core-js/library/modules/_shared-key.js')('IE_PROTO')

        module.exports = function (object, names) {
          var O = toIObject(object)
          var i = 0
          var result = []
          var key
          for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key)
          // Don't enum bug & hidden keys
          while (names.length > i)
            if (has(O, (key = names[i++]))) {
              ~arrayIndexOf(result, key) || result.push(key)
            }
          return result
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-keys.js':
      /*!***************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-keys.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(/*! ./_object-keys-internal */ '../node_modules/core-js/library/modules/_object-keys-internal.js')
        var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ '../node_modules/core-js/library/modules/_enum-bug-keys.js')

        module.exports =
          Object.keys ||
          function keys(O) {
            return $keys(O, enumBugKeys)
          }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-pie.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-pie.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        exports.f = {}.propertyIsEnumerable

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_object-sap.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_object-sap.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')
        var core = __webpack_require__(/*! ./_core */ '../node_modules/core-js/library/modules/_core.js')
        var fails = __webpack_require__(/*! ./_fails */ '../node_modules/core-js/library/modules/_fails.js')
        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY]
          var exp = {}
          exp[KEY] = exec(fn)
          $export(
            $export.S +
              $export.F *
                fails(function () {
                  fn(1)
                }),
            'Object',
            exp
          )
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_property-desc.js':
      /*!*****************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_property-desc.js ***!
  \*****************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value,
          }
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_redefine.js':
      /*!************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_redefine.js ***!
  \************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(/*! ./_hide */ '../node_modules/core-js/library/modules/_hide.js')

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_set-proto.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_set-proto.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // Works with __proto__ only. Old v8 can't work with null proto objects.
        /* eslint-disable no-proto */
        var isObject = __webpack_require__(/*! ./_is-object */ '../node_modules/core-js/library/modules/_is-object.js')
        var anObject = __webpack_require__(/*! ./_an-object */ '../node_modules/core-js/library/modules/_an-object.js')
        var check = function (O, proto) {
          anObject(O)
          if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!")
        }
        module.exports = {
          set:
            Object.setPrototypeOf ||
            ('__proto__' in {} // eslint-disable-line
              ? (function (test, buggy, set) {
                  try {
                    set = __webpack_require__(/*! ./_ctx */ '../node_modules/core-js/library/modules/_ctx.js')(
                      Function.call,
                      __webpack_require__(/*! ./_object-gopd */ '../node_modules/core-js/library/modules/_object-gopd.js').f(
                        Object.prototype,
                        '__proto__'
                      ).set,
                      2
                    )
                    set(test, [])
                    buggy = !(test instanceof Array)
                  } catch (e) {
                    buggy = true
                  }
                  return function setPrototypeOf(O, proto) {
                    check(O, proto)
                    if (buggy) O.__proto__ = proto
                    else set(O, proto)
                    return O
                  }
                })({}, false)
              : undefined),
          check: check,
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_set-to-string-tag.js':
      /*!*********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_set-to-string-tag.js ***!
  \*********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var def = __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js').f
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var TAG = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')('toStringTag')

        module.exports = function (it, tag, stat) {
          if (it && !has((it = stat ? it : it.prototype), TAG)) def(it, TAG, { configurable: true, value: tag })
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_shared-key.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_shared-key.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var shared = __webpack_require__(/*! ./_shared */ '../node_modules/core-js/library/modules/_shared.js')('keys')
        var uid = __webpack_require__(/*! ./_uid */ '../node_modules/core-js/library/modules/_uid.js')
        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key))
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_shared.js':
      /*!**********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_shared.js ***!
  \**********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js')
        var SHARED = '__core-js_shared__'
        var store = global[SHARED] || (global[SHARED] = {})
        module.exports = function (key) {
          return store[key] || (store[key] = {})
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_string-at.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_string-at.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(/*! ./_to-integer */ '../node_modules/core-js/library/modules/_to-integer.js')
        var defined = __webpack_require__(/*! ./_defined */ '../node_modules/core-js/library/modules/_defined.js')
        // true  -> String#at
        // false -> String#codePointAt
        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that))
            var i = toInteger(pos)
            var l = s.length
            var a, b
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined
            a = s.charCodeAt(i)
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
              ? TO_STRING
                ? s.charAt(i)
                : a
              : TO_STRING
              ? s.slice(i, i + 2)
              : ((a - 0xd800) << 10) + (b - 0xdc00) + 0x10000
          }
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_to-absolute-index.js':
      /*!*********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_to-absolute-index.js ***!
  \*********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(/*! ./_to-integer */ '../node_modules/core-js/library/modules/_to-integer.js')
        var max = Math.max
        var min = Math.min
        module.exports = function (index, length) {
          index = toInteger(index)
          return index < 0 ? max(index + length, 0) : min(index, length)
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_to-integer.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_to-integer.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil
        var floor = Math.floor
        module.exports = function (it) {
          return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it)
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_to-iobject.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_to-iobject.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(/*! ./_iobject */ '../node_modules/core-js/library/modules/_iobject.js')
        var defined = __webpack_require__(/*! ./_defined */ '../node_modules/core-js/library/modules/_defined.js')
        module.exports = function (it) {
          return IObject(defined(it))
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_to-length.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_to-length.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(/*! ./_to-integer */ '../node_modules/core-js/library/modules/_to-integer.js')
        var min = Math.min
        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0 // pow(2, 53) - 1 == 9007199254740991
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_to-object.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_to-object.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(/*! ./_defined */ '../node_modules/core-js/library/modules/_defined.js')
        module.exports = function (it) {
          return Object(defined(it))
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_to-primitive.js':
      /*!****************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_to-primitive.js ***!
  \****************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(/*! ./_is-object */ '../node_modules/core-js/library/modules/_is-object.js')
        // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string
        module.exports = function (it, S) {
          if (!isObject(it)) return it
          var fn, val
          if (S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val
          if (typeof (fn = it.valueOf) == 'function' && !isObject((val = fn.call(it)))) return val
          if (!S && typeof (fn = it.toString) == 'function' && !isObject((val = fn.call(it)))) return val
          throw TypeError("Can't convert object to primitive value")
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_uid.js':
      /*!*******************************************************!*\
  !*** ../node_modules/core-js/library/modules/_uid.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        var id = 0
        var px = Math.random()
        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36))
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_wks-define.js':
      /*!**************************************************************!*\
  !*** ../node_modules/core-js/library/modules/_wks-define.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js')
        var core = __webpack_require__(/*! ./_core */ '../node_modules/core-js/library/modules/_core.js')
        var LIBRARY = __webpack_require__(/*! ./_library */ '../node_modules/core-js/library/modules/_library.js')
        var wksExt = __webpack_require__(/*! ./_wks-ext */ '../node_modules/core-js/library/modules/_wks-ext.js')
        var defineProperty = __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js').f
        module.exports = function (name) {
          var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {})
          if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) })
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_wks-ext.js':
      /*!***********************************************************!*\
  !*** ../node_modules/core-js/library/modules/_wks-ext.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        exports.f = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/_wks.js':
      /*!*******************************************************!*\
  !*** ../node_modules/core-js/library/modules/_wks.js ***!
  \*******************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var store = __webpack_require__(/*! ./_shared */ '../node_modules/core-js/library/modules/_shared.js')('wks')
        var uid = __webpack_require__(/*! ./_uid */ '../node_modules/core-js/library/modules/_uid.js')
        var Symbol = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js').Symbol
        var USE_SYMBOL = typeof Symbol == 'function'

        var $exports = (module.exports = function (name) {
          return store[name] || (store[name] = (USE_SYMBOL && Symbol[name]) || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name))
        })

        $exports.store = store

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/core.get-iterator-method.js':
      /*!***************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/core.get-iterator-method.js ***!
  \***************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var classof = __webpack_require__(/*! ./_classof */ '../node_modules/core-js/library/modules/_classof.js')
        var ITERATOR = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')('iterator')
        var Iterators = __webpack_require__(/*! ./_iterators */ '../node_modules/core-js/library/modules/_iterators.js')
        module.exports = __webpack_require__(
          /*! ./_core */ '../node_modules/core-js/library/modules/_core.js'
        ).getIteratorMethod = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)]
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/core.get-iterator.js':
      /*!********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/core.get-iterator.js ***!
  \********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var anObject = __webpack_require__(/*! ./_an-object */ '../node_modules/core-js/library/modules/_an-object.js')
        var get = __webpack_require__(
          /*! ./core.get-iterator-method */ '../node_modules/core-js/library/modules/core.get-iterator-method.js'
        )
        module.exports = __webpack_require__(/*! ./_core */ '../node_modules/core-js/library/modules/_core.js').getIterator = function (
          it
        ) {
          var iterFn = get(it)
          if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!')
          return anObject(iterFn.call(it))
        }

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.array.iterator.js':
      /*!*********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.array.iterator.js ***!
  \*********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var addToUnscopables = __webpack_require__(
          /*! ./_add-to-unscopables */ '../node_modules/core-js/library/modules/_add-to-unscopables.js'
        )
        var step = __webpack_require__(/*! ./_iter-step */ '../node_modules/core-js/library/modules/_iter-step.js')
        var Iterators = __webpack_require__(/*! ./_iterators */ '../node_modules/core-js/library/modules/_iterators.js')
        var toIObject = __webpack_require__(/*! ./_to-iobject */ '../node_modules/core-js/library/modules/_to-iobject.js')

        // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()
        module.exports = __webpack_require__(/*! ./_iter-define */ '../node_modules/core-js/library/modules/_iter-define.js')(
          Array,
          'Array',
          function (iterated, kind) {
            this._t = toIObject(iterated) // target
            this._i = 0 // next index
            this._k = kind // kind
            // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
          },
          function () {
            var O = this._t
            var kind = this._k
            var index = this._i++
            if (!O || index >= O.length) {
              this._t = undefined
              return step(1)
            }
            if (kind == 'keys') return step(0, index)
            if (kind == 'values') return step(0, O[index])
            return step(0, [index, O[index]])
          },
          'values'
        )

        // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
        Iterators.Arguments = Iterators.Array

        addToUnscopables('keys')
        addToUnscopables('values')
        addToUnscopables('entries')

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.object.assign.js':
      /*!********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.object.assign.js ***!
  \********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.3.1 Object.assign(target, source)
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')

        $export($export.S + $export.F, 'Object', {
          assign: __webpack_require__(/*! ./_object-assign */ '../node_modules/core-js/library/modules/_object-assign.js'),
        })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.object.create.js':
      /*!********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.object.create.js ***!
  \********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        $export($export.S, 'Object', {
          create: __webpack_require__(/*! ./_object-create */ '../node_modules/core-js/library/modules/_object-create.js'),
        })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.object.define-property.js':
      /*!*****************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.object.define-property.js ***!
  \*****************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')
        // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
        $export(
          $export.S + $export.F * !__webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js'),
          'Object',
          { defineProperty: __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js').f }
        )

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.object.get-prototype-of.js':
      /*!******************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.object.get-prototype-of.js ***!
  \******************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.9 Object.getPrototypeOf(O)
        var toObject = __webpack_require__(/*! ./_to-object */ '../node_modules/core-js/library/modules/_to-object.js')
        var $getPrototypeOf = __webpack_require__(/*! ./_object-gpo */ '../node_modules/core-js/library/modules/_object-gpo.js')

        __webpack_require__(/*! ./_object-sap */ '../node_modules/core-js/library/modules/_object-sap.js')('getPrototypeOf', function () {
          return function getPrototypeOf(it) {
            return $getPrototypeOf(toObject(it))
          }
        })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.object.set-prototype-of.js':
      /*!******************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.object.set-prototype-of.js ***!
  \******************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.3.19 Object.setPrototypeOf(O, proto)
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')
        $export($export.S, 'Object', {
          setPrototypeOf: __webpack_require__(/*! ./_set-proto */ '../node_modules/core-js/library/modules/_set-proto.js').set,
        })

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.object.to-string.js':
      /*!***********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.object.to-string.js ***!
  \***********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.string.iterator.js':
      /*!**********************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.string.iterator.js ***!
  \**********************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var $at = __webpack_require__(/*! ./_string-at */ '../node_modules/core-js/library/modules/_string-at.js')(true)

        // 21.1.3.27 String.prototype[@@iterator]()
        __webpack_require__(/*! ./_iter-define */ '../node_modules/core-js/library/modules/_iter-define.js')(
          String,
          'String',
          function (iterated) {
            this._t = String(iterated) // target
            this._i = 0 // next index
            // 21.1.5.2.1 %StringIteratorPrototype%.next()
          },
          function () {
            var O = this._t
            var index = this._i
            var point
            if (index >= O.length) return { value: undefined, done: true }
            point = $at(O, index)
            this._i += point.length
            return { value: point, done: false }
          }
        )

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es6.symbol.js':
      /*!*************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es6.symbol.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        // ECMAScript 6 symbols shim
        var global = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js')
        var has = __webpack_require__(/*! ./_has */ '../node_modules/core-js/library/modules/_has.js')
        var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ '../node_modules/core-js/library/modules/_descriptors.js')
        var $export = __webpack_require__(/*! ./_export */ '../node_modules/core-js/library/modules/_export.js')
        var redefine = __webpack_require__(/*! ./_redefine */ '../node_modules/core-js/library/modules/_redefine.js')
        var META = __webpack_require__(/*! ./_meta */ '../node_modules/core-js/library/modules/_meta.js').KEY
        var $fails = __webpack_require__(/*! ./_fails */ '../node_modules/core-js/library/modules/_fails.js')
        var shared = __webpack_require__(/*! ./_shared */ '../node_modules/core-js/library/modules/_shared.js')
        var setToStringTag = __webpack_require__(
          /*! ./_set-to-string-tag */ '../node_modules/core-js/library/modules/_set-to-string-tag.js'
        )
        var uid = __webpack_require__(/*! ./_uid */ '../node_modules/core-js/library/modules/_uid.js')
        var wks = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')
        var wksExt = __webpack_require__(/*! ./_wks-ext */ '../node_modules/core-js/library/modules/_wks-ext.js')
        var wksDefine = __webpack_require__(/*! ./_wks-define */ '../node_modules/core-js/library/modules/_wks-define.js')
        var enumKeys = __webpack_require__(/*! ./_enum-keys */ '../node_modules/core-js/library/modules/_enum-keys.js')
        var isArray = __webpack_require__(/*! ./_is-array */ '../node_modules/core-js/library/modules/_is-array.js')
        var anObject = __webpack_require__(/*! ./_an-object */ '../node_modules/core-js/library/modules/_an-object.js')
        var isObject = __webpack_require__(/*! ./_is-object */ '../node_modules/core-js/library/modules/_is-object.js')
        var toIObject = __webpack_require__(/*! ./_to-iobject */ '../node_modules/core-js/library/modules/_to-iobject.js')
        var toPrimitive = __webpack_require__(/*! ./_to-primitive */ '../node_modules/core-js/library/modules/_to-primitive.js')
        var createDesc = __webpack_require__(/*! ./_property-desc */ '../node_modules/core-js/library/modules/_property-desc.js')
        var _create = __webpack_require__(/*! ./_object-create */ '../node_modules/core-js/library/modules/_object-create.js')
        var gOPNExt = __webpack_require__(/*! ./_object-gopn-ext */ '../node_modules/core-js/library/modules/_object-gopn-ext.js')
        var $GOPD = __webpack_require__(/*! ./_object-gopd */ '../node_modules/core-js/library/modules/_object-gopd.js')
        var $DP = __webpack_require__(/*! ./_object-dp */ '../node_modules/core-js/library/modules/_object-dp.js')
        var $keys = __webpack_require__(/*! ./_object-keys */ '../node_modules/core-js/library/modules/_object-keys.js')
        var gOPD = $GOPD.f
        var dP = $DP.f
        var gOPN = gOPNExt.f
        var $Symbol = global.Symbol
        var $JSON = global.JSON
        var _stringify = $JSON && $JSON.stringify
        var PROTOTYPE = 'prototype'
        var HIDDEN = wks('_hidden')
        var TO_PRIMITIVE = wks('toPrimitive')
        var isEnum = {}.propertyIsEnumerable
        var SymbolRegistry = shared('symbol-registry')
        var AllSymbols = shared('symbols')
        var OPSymbols = shared('op-symbols')
        var ObjectProto = Object[PROTOTYPE]
        var USE_NATIVE = typeof $Symbol == 'function'
        var QObject = global.QObject
        // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
        var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild

        // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
        var setSymbolDesc =
          DESCRIPTORS &&
          $fails(function () {
            return (
              _create(
                dP({}, 'a', {
                  get: function () {
                    return dP(this, 'a', { value: 7 }).a
                  },
                })
              ).a != 7
            )
          })
            ? function (it, key, D) {
                var protoDesc = gOPD(ObjectProto, key)
                if (protoDesc) delete ObjectProto[key]
                dP(it, key, D)
                if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc)
              }
            : dP

        var wrap = function (tag) {
          var sym = (AllSymbols[tag] = _create($Symbol[PROTOTYPE]))
          sym._k = tag
          return sym
        }

        var isSymbol =
          USE_NATIVE && typeof $Symbol.iterator == 'symbol'
            ? function (it) {
                return typeof it == 'symbol'
              }
            : function (it) {
                return it instanceof $Symbol
              }

        var $defineProperty = function defineProperty(it, key, D) {
          if (it === ObjectProto) $defineProperty(OPSymbols, key, D)
          anObject(it)
          key = toPrimitive(key, true)
          anObject(D)
          if (has(AllSymbols, key)) {
            if (!D.enumerable) {
              if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}))
              it[HIDDEN][key] = true
            } else {
              if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false
              D = _create(D, { enumerable: createDesc(0, false) })
            }
            return setSymbolDesc(it, key, D)
          }
          return dP(it, key, D)
        }
        var $defineProperties = function defineProperties(it, P) {
          anObject(it)
          var keys = enumKeys((P = toIObject(P)))
          var i = 0
          var l = keys.length
          var key
          while (l > i) $defineProperty(it, (key = keys[i++]), P[key])
          return it
        }
        var $create = function create(it, P) {
          return P === undefined ? _create(it) : $defineProperties(_create(it), P)
        }
        var $propertyIsEnumerable = function propertyIsEnumerable(key) {
          var E = isEnum.call(this, (key = toPrimitive(key, true)))
          if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false
          return E || !has(this, key) || !has(AllSymbols, key) || (has(this, HIDDEN) && this[HIDDEN][key]) ? E : true
        }
        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
          it = toIObject(it)
          key = toPrimitive(key, true)
          if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return
          var D = gOPD(it, key)
          if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true
          return D
        }
        var $getOwnPropertyNames = function getOwnPropertyNames(it) {
          var names = gOPN(toIObject(it))
          var result = []
          var i = 0
          var key
          while (names.length > i) {
            if (!has(AllSymbols, (key = names[i++])) && key != HIDDEN && key != META) result.push(key)
          }
          return result
        }
        var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
          var IS_OP = it === ObjectProto
          var names = gOPN(IS_OP ? OPSymbols : toIObject(it))
          var result = []
          var i = 0
          var key
          while (names.length > i) {
            if (has(AllSymbols, (key = names[i++])) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key])
          }
          return result
        }

        // 19.4.1.1 Symbol([description])
        if (!USE_NATIVE) {
          $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!')
            var tag = uid(arguments.length > 0 ? arguments[0] : undefined)
            var $set = function (value) {
              if (this === ObjectProto) $set.call(OPSymbols, value)
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false
              setSymbolDesc(this, tag, createDesc(1, value))
            }
            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set })
            return wrap(tag)
          }
          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return this._k
          })

          $GOPD.f = $getOwnPropertyDescriptor
          $DP.f = $defineProperty
          __webpack_require__(
            /*! ./_object-gopn */ '../node_modules/core-js/library/modules/_object-gopn.js'
          ).f = gOPNExt.f = $getOwnPropertyNames
          __webpack_require__(/*! ./_object-pie */ '../node_modules/core-js/library/modules/_object-pie.js').f = $propertyIsEnumerable
          __webpack_require__(/*! ./_object-gops */ '../node_modules/core-js/library/modules/_object-gops.js').f = $getOwnPropertySymbols

          if (DESCRIPTORS && !__webpack_require__(/*! ./_library */ '../node_modules/core-js/library/modules/_library.js')) {
            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true)
          }

          wksExt.f = function (name) {
            return wrap(wks(name))
          }
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol })

        for (
          var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
            'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','),
            j = 0;
          es6Symbols.length > j;

        )
          wks(es6Symbols[j++])

        for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; ) wksDefine(wellKnownSymbols[k++])

        $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
          // 19.4.2.1 Symbol.for(key)
          for: function (key) {
            return has(SymbolRegistry, (key += '')) ? SymbolRegistry[key] : (SymbolRegistry[key] = $Symbol(key))
          },
          // 19.4.2.5 Symbol.keyFor(sym)
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!')
            for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key
          },
          useSetter: function () {
            setter = true
          },
          useSimple: function () {
            setter = false
          },
        })

        $export($export.S + $export.F * !USE_NATIVE, 'Object', {
          // 19.1.2.2 Object.create(O [, Properties])
          create: $create,
          // 19.1.2.4 Object.defineProperty(O, P, Attributes)
          defineProperty: $defineProperty,
          // 19.1.2.3 Object.defineProperties(O, Properties)
          defineProperties: $defineProperties,
          // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
          // 19.1.2.7 Object.getOwnPropertyNames(O)
          getOwnPropertyNames: $getOwnPropertyNames,
          // 19.1.2.8 Object.getOwnPropertySymbols(O)
          getOwnPropertySymbols: $getOwnPropertySymbols,
        })

        // 24.3.2 JSON.stringify(value [, replacer [, space]])
        $JSON &&
          $export(
            $export.S +
              $export.F *
                (!USE_NATIVE ||
                  $fails(function () {
                    var S = $Symbol()
                    // MS Edge converts symbol values to JSON as {}
                    // WebKit converts symbol values to JSON as null
                    // V8 throws on boxed symbols
                    return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}'
                  })),
            'JSON',
            {
              stringify: function stringify(it) {
                var args = [it]
                var i = 1
                var replacer, $replacer
                while (arguments.length > i) args.push(arguments[i++])
                $replacer = replacer = args[1]
                if ((!isObject(replacer) && it === undefined) || isSymbol(it)) return // IE8 returns string on undefined
                if (!isArray(replacer))
                  replacer = function (key, value) {
                    if (typeof $replacer == 'function') value = $replacer.call(this, key, value)
                    if (!isSymbol(value)) return value
                  }
                args[1] = replacer
                return _stringify.apply($JSON, args)
              },
            }
          )

        // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
        $Symbol[PROTOTYPE][TO_PRIMITIVE] ||
          __webpack_require__(/*! ./_hide */ '../node_modules/core-js/library/modules/_hide.js')(
            $Symbol[PROTOTYPE],
            TO_PRIMITIVE,
            $Symbol[PROTOTYPE].valueOf
          )
        // 19.4.3.5 Symbol.prototype[@@toStringTag]
        setToStringTag($Symbol, 'Symbol')
        // 20.2.1.9 Math[@@toStringTag]
        setToStringTag(Math, 'Math', true)
        // 24.3.3 JSON[@@toStringTag]
        setToStringTag(global.JSON, 'JSON', true)

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es7.symbol.async-iterator.js':
      /*!****************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es7.symbol.async-iterator.js ***!
  \****************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ./_wks-define */ '../node_modules/core-js/library/modules/_wks-define.js')('asyncIterator')

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/es7.symbol.observable.js':
      /*!************************************************************************!*\
  !*** ../node_modules/core-js/library/modules/es7.symbol.observable.js ***!
  \************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ./_wks-define */ '../node_modules/core-js/library/modules/_wks-define.js')('observable')

        /***/
      },

    /***/ '../node_modules/core-js/library/modules/web.dom.iterable.js':
      /*!*******************************************************************!*\
  !*** ../node_modules/core-js/library/modules/web.dom.iterable.js ***!
  \*******************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(/*! ./es6.array.iterator */ '../node_modules/core-js/library/modules/es6.array.iterator.js')
        var global = __webpack_require__(/*! ./_global */ '../node_modules/core-js/library/modules/_global.js')
        var hide = __webpack_require__(/*! ./_hide */ '../node_modules/core-js/library/modules/_hide.js')
        var Iterators = __webpack_require__(/*! ./_iterators */ '../node_modules/core-js/library/modules/_iterators.js')
        var TO_STRING_TAG = __webpack_require__(/*! ./_wks */ '../node_modules/core-js/library/modules/_wks.js')('toStringTag')

        var DOMIterables = (
          'CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
          'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
          'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
          'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
          'TextTrackList,TouchList'
        ).split(',')

        for (var i = 0; i < DOMIterables.length; i++) {
          var NAME = DOMIterables[i]
          var Collection = global[NAME]
          var proto = Collection && Collection.prototype
          if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME)
          Iterators[NAME] = Iterators.Array
        }

        /***/
      },

    /***/ '../node_modules/input-format/index.js':
      /*!*********************************************!*\
  !*** ../node_modules/input-format/index.js ***!
  \*********************************************/
      /*! exports provided: templateParser, templateFormatter, ReactInput, parseDigit, parse, format, onChange, onPaste, onCut, onKeyDown */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony import */ var _modules_template_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./modules/template parser */ '../node_modules/input-format/modules/template parser.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'templateParser', function () {
          return _modules_template_parser__WEBPACK_IMPORTED_MODULE_0__['default']
        })

        /* harmony import */ var _modules_template_formatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! ./modules/template formatter */ '../node_modules/input-format/modules/template formatter.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'templateFormatter', function () {
          return _modules_template_formatter__WEBPACK_IMPORTED_MODULE_1__['default']
        })

        /* harmony import */ var _modules_ReactInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          /*! ./modules/ReactInput */ '../node_modules/input-format/modules/ReactInput.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'ReactInput', function () {
          return _modules_ReactInput__WEBPACK_IMPORTED_MODULE_2__['default']
        })

        /* harmony import */ var _modules_parse_digit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          /*! ./modules/parse digit */ '../node_modules/input-format/modules/parse digit.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'parseDigit', function () {
          return _modules_parse_digit__WEBPACK_IMPORTED_MODULE_3__['default']
        })

        /* harmony import */ var _modules_parse__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
          /*! ./modules/parse */ '../node_modules/input-format/modules/parse.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'parse', function () {
          return _modules_parse__WEBPACK_IMPORTED_MODULE_4__['default']
        })

        /* harmony import */ var _modules_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
          /*! ./modules/format */ '../node_modules/input-format/modules/format.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'format', function () {
          return _modules_format__WEBPACK_IMPORTED_MODULE_5__['default']
        })

        /* harmony import */ var _modules_input_control__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
          /*! ./modules/input control */ '../node_modules/input-format/modules/input control.js'
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'onChange', function () {
          return _modules_input_control__WEBPACK_IMPORTED_MODULE_6__['onChange']
        })

        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'onPaste', function () {
          return _modules_input_control__WEBPACK_IMPORTED_MODULE_6__['onPaste']
        })

        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'onCut', function () {
          return _modules_input_control__WEBPACK_IMPORTED_MODULE_6__['onCut']
        })

        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'onKeyDown', function () {
          return _modules_input_control__WEBPACK_IMPORTED_MODULE_6__['onKeyDown']
        })

        /***/
      },

    /***/ '../node_modules/input-format/modules/ReactInput.js':
      /*!**********************************************************!*\
  !*** ../node_modules/input-format/modules/ReactInput.js ***!
  \**********************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony import */ var babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! babel-runtime/helpers/objectWithoutProperties */ '../node_modules/babel-runtime/helpers/objectWithoutProperties.js'
        )
        /* harmony import */ var babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__
        )
        /* harmony import */ var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! babel-runtime/helpers/extends */ '../node_modules/babel-runtime/helpers/extends.js'
        )
        /* harmony import */ var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__
        )
        /* harmony import */ var babel_runtime_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          /*! babel-runtime/core-js/object/get-prototype-of */ '../node_modules/babel-runtime/core-js/object/get-prototype-of.js'
        )
        /* harmony import */ var babel_runtime_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2__
        )
        /* harmony import */ var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          /*! babel-runtime/helpers/classCallCheck */ '../node_modules/babel-runtime/helpers/classCallCheck.js'
        )
        /* harmony import */ var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__
        )
        /* harmony import */ var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
          /*! babel-runtime/helpers/createClass */ '../node_modules/babel-runtime/helpers/createClass.js'
        )
        /* harmony import */ var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__
        )
        /* harmony import */ var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
          /*! babel-runtime/helpers/possibleConstructorReturn */ '../node_modules/babel-runtime/helpers/possibleConstructorReturn.js'
        )
        /* harmony import */ var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__
        )
        /* harmony import */ var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
          /*! babel-runtime/helpers/inherits */ '../node_modules/babel-runtime/helpers/inherits.js'
        )
        /* harmony import */ var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__
        )
        /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! react */ 'react')
        /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/ __webpack_require__.n(
          react__WEBPACK_IMPORTED_MODULE_7__
        )
        /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
          /*! prop-types */ '../node_modules/prop-types/index.js'
        )
        /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/ __webpack_require__.n(
          prop_types__WEBPACK_IMPORTED_MODULE_8__
        )
        /* harmony import */ var _parse__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
          /*! ./parse */ '../node_modules/input-format/modules/parse.js'
        )
        /* harmony import */ var _input_control__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
          /*! ./input control */ '../node_modules/input-format/modules/input control.js'
        )

        // Usage:
        //
        // <ReactInput
        // 	value={this.state.phone}
        // 	onChange={phone => this.setState({ phone })}
        // 	parse={character => character}
        // 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
        //

        var ReactInput = (function (_React$Component) {
          babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ReactInput, _React$Component)

          function ReactInput() {
            var _ref

            var _temp, _this, _ret

            babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ReactInput)

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key]
            }

            return (
              (_ret =
                ((_temp =
                  ((_this = babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(
                    this,
                    (_ref =
                      ReactInput.__proto__ ||
                      babel_runtime_core_js_object_get_prototype_of__WEBPACK_IMPORTED_MODULE_2___default()(ReactInput)).call.apply(
                      _ref,
                      [this].concat(args)
                    )
                  )),
                  _this)),
                (_this.storeInstance = function (instance) {
                  _this.input = instance
                }),
                (_this.getInputElement = function () {
                  return _this.input
                }),
                (_this.onChange = function (event) {
                  var _this$props = _this.props,
                    parse = _this$props.parse,
                    format = _this$props.format

                  return Object(_input_control__WEBPACK_IMPORTED_MODULE_10__['onChange'])(
                    event,
                    _this.getInputElement(),
                    parse,
                    format,
                    _this.props.onChange
                  )
                }),
                (_this.onPaste = function (event) {
                  var _this$props2 = _this.props,
                    parse = _this$props2.parse,
                    format = _this$props2.format

                  return Object(_input_control__WEBPACK_IMPORTED_MODULE_10__['onPaste'])(
                    event,
                    _this.getInputElement(),
                    parse,
                    format,
                    _this.props.onChange
                  )
                }),
                (_this.onCut = function (event) {
                  var _this$props3 = _this.props,
                    parse = _this$props3.parse,
                    format = _this$props3.format

                  return Object(_input_control__WEBPACK_IMPORTED_MODULE_10__['onCut'])(
                    event,
                    _this.getInputElement(),
                    parse,
                    format,
                    _this.props.onChange
                  )
                }),
                (_this.onBlur = function (event) {
                  var _this$props4 = _this.props,
                    parse = _this$props4.parse,
                    onBlur = _this$props4.onBlur

                  // This `onBlur` interceptor is a workaround for `redux-form`,
                  // so that it gets the right (parsed, not the formatted one)
                  // `event.target.value` in its `onBlur` handler.

                  if (onBlur) {
                    var _event = babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({}, event, {
                      target: babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({}, event.target, {
                        value: Object(_parse__WEBPACK_IMPORTED_MODULE_9__['default'])(_this.getInputElement().value, undefined, parse)
                          .value,
                      }),

                      // For `redux-form` event detection.
                      // https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
                    })
                    _event.stopPropagation = event.stopPropagation
                    _event.preventDefault = event.preventDefault

                    onBlur(_event)
                  }
                }),
                (_this.onKeyDown = function (event) {
                  var _this$props5 = _this.props,
                    parse = _this$props5.parse,
                    format = _this$props5.format

                  if (_this.props.onKeyDown) {
                    _this.props.onKeyDown(event)
                  }

                  return Object(_input_control__WEBPACK_IMPORTED_MODULE_10__['onKeyDown'])(
                    event,
                    _this.getInputElement(),
                    parse,
                    format,
                    _this.props.onChange
                  )
                }),
                _temp)),
              babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(_this, _ret)
            )
          }

          babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ReactInput, [
            {
              key: 'render',
              value: function render() {
                var _props = this.props,
                  value = _props.value,
                  parse = _props.parse,
                  format = _props.format,
                  inputComponent = _props.inputComponent,
                  rest = babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default()(_props, [
                    'value',
                    'parse',
                    'format',
                    'inputComponent',
                  ])

                // Non-string `inputComponent`s would work in this case
                // but it would also introduce a caret reset bug:
                // the caret position would reset on each input.
                // The origins of this bug are unknown, they may be
                // somehow related to the `ref` property
                // being intercepted by React here.

                return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(
                  inputComponent,
                  babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({}, rest, {
                    ref: this.storeInstance,
                    value: format(isEmpty(value) ? '' : value).text,
                    onKeyDown: this.onKeyDown,
                    onChange: this.onChange,
                    onPaste: this.onPaste,
                    onCut: this.onCut,
                    onBlur: this.onBlur,
                  })
                )
              },

              /**
               * Returns `<input/>` DOM Element.
               * @return {DOMElement}
               */

              // This handler is a workaround for `redux-form`.
            },
            {
              key: 'focus',

              /**
               * Focuses the `<input/>`.
               * Can be called manually.
               */
              value: function focus() {
                this.getInputElement().focus()
              },
            },
          ])

          return ReactInput
        })(react__WEBPACK_IMPORTED_MODULE_7___default.a.Component)

        ReactInput.propTypes = {
          // Parses a single characher of `<input/>` text.
          parse: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func.isRequired,

          // Formats `value` into `<input/>` text.
          format: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func.isRequired,

          // Renders `<input/>` by default.
          // For some reason non-default `inputComponent`
          // will reset caret position.
          inputComponent: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string.isRequired,

          // `<input/>` `type` attribute.
          type: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string.isRequired,

          // Is parsed from <input/> text.
          value: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

          // This handler is called each time `<input/>` text is changed.
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func.isRequired,

          // This `onBlur` interceptor is a workaround for `redux-form`,
          // so that it gets the parsed `value` in its `onBlur` handler,
          // not the formatted text.
          onBlur: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,

          // Passthrough
          onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,
        }
        ReactInput.defaultProps = {
          // Renders `<input/>` by default.
          // For some reason non-default `inputComponent`
          // will reset caret position.
          inputComponent: 'input',

          // `<input/>` `type` attribute.
          type: 'text',
        }
        /* harmony default export */ __webpack_exports__['default'] = ReactInput

        function isEmpty(value) {
          return value === undefined || value === null
        }
        //# sourceMappingURL=ReactInput.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/close braces.js':
      /*!************************************************************!*\
  !*** ../node_modules/input-format/modules/close braces.js ***!
  \************************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return close_braces
        })
        /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./helpers */ '../node_modules/input-format/modules/helpers.js'
        )

        function close_braces(retained_template, template) {
          var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x'
          var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' '

          var cut_before = retained_template.length

          var opening_braces = Object(_helpers__WEBPACK_IMPORTED_MODULE_0__['count_occurences'])('(', retained_template)
          var closing_braces = Object(_helpers__WEBPACK_IMPORTED_MODULE_0__['count_occurences'])(')', retained_template)

          var dangling_braces = opening_braces - closing_braces

          while (dangling_braces > 0 && cut_before < template.length) {
            retained_template += template[cut_before].replace(placeholder, empty_placeholder)

            if (template[cut_before] === ')') {
              dangling_braces--
            }

            cut_before++
          }

          return retained_template
        }
        //# sourceMappingURL=close braces.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/dom.js':
      /*!***************************************************!*\
  !*** ../node_modules/input-format/modules/dom.js ***!
  \***************************************************/
      /*! exports provided: getSelection, Keys, getOperation, getCaretPosition, setCaretPosition */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'getSelection', function () {
          return getSelection
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'Keys', function () {
          return Keys
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'getOperation', function () {
          return getOperation
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'getCaretPosition', function () {
          return getCaretPosition
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'setCaretPosition', function () {
          return setCaretPosition
        })
        // Gets <input/> selection bounds
        function getSelection(element) {
          // If no selection, return nothing
          if (element.selectionStart === element.selectionEnd) {
            return
          }

          return { start: element.selectionStart, end: element.selectionEnd }
        }

        // Key codes
        var Keys = {
          Backspace: 8,
          Delete: 46,

          // Finds out the operation to be intercepted and performed
          // based on the key down event `keyCode`.
        }
        function getOperation(event) {
          switch (event.keyCode) {
            case Keys.Backspace:
              return 'Backspace'

            case Keys.Delete:
              return 'Delete'
          }
        }

        // Gets <input/> caret position
        function getCaretPosition(element) {
          return element.selectionStart
        }

        // Sets <input/> caret position
        function setCaretPosition(element, caret_position) {
          // Sanity check
          if (caret_position === undefined) {
            return
          }

          // Set caret position
          element.setSelectionRange(caret_position, caret_position)
        }
        //# sourceMappingURL=dom.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/edit.js':
      /*!****************************************************!*\
  !*** ../node_modules/input-format/modules/edit.js ***!
  \****************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return edit
        })
        // Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
        //
        // Example:
        //
        // value - '88005553535'
        // caret - 2 // starting from 0; is positioned before the first zero
        // operation - 'Backspace'
        //
        // Returns
        // {
        // 	value: '8005553535'
        // 	caret: 1
        // }
        //
        // Currently supports just 'Delete' and 'Backspace' operations
        //
        function edit(value, caret, operation) {
          switch (operation) {
            case 'Backspace':
              // If there exists the previous character,
              // then erase it and reposition the caret.
              if (caret > 0) {
                // Remove the previous character
                value = value.slice(0, caret - 1) + value.slice(caret)
                // Position the caret where the previous (erased) character was
                caret--
              }
              break

            case 'Delete':
              // Remove current digit (if any)
              value = value.slice(0, caret) + value.slice(caret + 1)
              break
          }

          return { value: value, caret: caret }
        }
        //# sourceMappingURL=edit.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/format.js':
      /*!******************************************************!*\
  !*** ../node_modules/input-format/modules/format.js ***!
  \******************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return format
        })
        /* harmony import */ var _template_formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./template formatter */ '../node_modules/input-format/modules/template formatter.js'
        )

        // Formats `value` value preserving `caret` at the same character.
        //
        // `{ value, caret }` attribute is the result of `parse()` function call.
        //
        // Returns `{ text, caret }` where the new `caret` is the caret position
        // inside `text` text corresponding to the original `caret` position inside `value`.
        //
        // `formatter(value)` is a function returning `{ text, template }`.
        //
        // `text` is the `value` value formatted using `template`.
        // It may either cut off the non-filled right part of the `template`
        // or it may fill the non-filled character placeholders
        // in the right part of the `template` with `spacer`
        // which is a space (' ') character by default.
        //
        // `template` is the template used to format the `value`.
        // It can be either a full-length template or a partial template.
        //
        // `formatter` can also be a string — a `template`
        // where character placeholders are denoted by 'x'es.
        // In this case `formatter` function is automatically created.
        //
        // Example:
        //
        // `value` is '880',
        // `caret` is `2` (before the first `0`)
        //
        // `formatter` is `'880' =>
        //   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
        //
        // The result is `{ text: '8 (80 )', caret: 4 }`.
        //
        function format(value, caret, formatter) {
          if (typeof formatter === 'string') {
            formatter = Object(_template_formatter__WEBPACK_IMPORTED_MODULE_0__['default'])(formatter)
          }

          var _ref = formatter(value) || {},
            text = _ref.text,
            template = _ref.template

          if (text === undefined) {
            text = value
          }

          if (template) {
            if (caret === undefined) {
              caret = text.length
            } else {
              var index = 0
              var found = false

              var possibly_last_input_character_index = -1

              while (index < text.length && index < template.length) {
                // Character placeholder found
                if (text[index] !== template[index]) {
                  if (caret === 0) {
                    found = true
                    caret = index
                    break
                  }

                  possibly_last_input_character_index = index

                  caret--
                }

                index++
              }

              // If the caret was positioned after last input character,
              // then the text caret index is just after the last input character.
              if (!found) {
                caret = possibly_last_input_character_index + 1
              }
            }
          }

          return { text: text, caret: caret }
        }
        //# sourceMappingURL=format.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/helpers.js':
      /*!*******************************************************!*\
  !*** ../node_modules/input-format/modules/helpers.js ***!
  \*******************************************************/
      /*! exports provided: count_occurences */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'count_occurences', function () {
          return count_occurences
        })
        /* harmony import */ var babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! babel-runtime/core-js/get-iterator */ '../node_modules/babel-runtime/core-js/get-iterator.js'
        )
        /* harmony import */ var babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0__
        )

        // Counts all occurences of a symbol in a string
        function count_occurences(symbol, string) {
          var count = 0

          var _iteratorNormalCompletion = true
          var _didIteratorError = false
          var _iteratorError = undefined

          try {
            for (
              var _iterator = babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0___default()(string), _step;
              !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
              _iteratorNormalCompletion = true
            ) {
              var character = _step.value

              if (character === symbol) {
                count++
              }
            }
          } catch (err) {
            _didIteratorError = true
            _iteratorError = err
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return()
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError
              }
            }
          }

          return count
        }
        //# sourceMappingURL=helpers.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/input control.js':
      /*!*************************************************************!*\
  !*** ../node_modules/input-format/modules/input control.js ***!
  \*************************************************************/
      /*! exports provided: onCut, onPaste, onChange, onKeyDown */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'onCut', function () {
          return onCut
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'onPaste', function () {
          return onPaste
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'onChange', function () {
          return onChange
        })
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'onKeyDown', function () {
          return onKeyDown
        })
        /* harmony import */ var _edit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./edit */ '../node_modules/input-format/modules/edit.js'
        )
        /* harmony import */ var _parse__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! ./parse */ '../node_modules/input-format/modules/parse.js'
        )
        /* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          /*! ./format */ '../node_modules/input-format/modules/format.js'
        )
        /* harmony import */ var _dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          /*! ./dom */ '../node_modules/input-format/modules/dom.js'
        )

        function onCut(event, input, _parse, _format, on_change) {
          // The actual cut hasn't happened just yet hence the timeout.
          setTimeout(function () {
            return format_input_text(input, _parse, _format, undefined, on_change)
          }, 0)
        }

        function onPaste(event, input, _parse, _format, on_change) {
          var selection = Object(_dom__WEBPACK_IMPORTED_MODULE_3__['getSelection'])(input)

          // If selection is made,
          // just erase the selected text
          // prior to pasting
          if (selection) {
            erase_selection(input, selection)
          }

          format_input_text(input, _parse, _format, undefined, on_change)
        }

        function onChange(event, input, _parse, _format, on_change) {
          format_input_text(input, _parse, _format, undefined, on_change)
        }

        // Intercepts "Delete" and "Backspace" keys.
        // (hitting "Delete" or "Backspace" at any caret
        //  position should always result in rasing a digit)
        function onKeyDown(event, input, _parse, _format, on_change) {
          var operation = Object(_dom__WEBPACK_IMPORTED_MODULE_3__['getOperation'])(event)

          switch (operation) {
            case 'Delete':
            case 'Backspace':
              // Intercept this operation and perform it manually.
              event.preventDefault()

              var selection = Object(_dom__WEBPACK_IMPORTED_MODULE_3__['getSelection'])(input)

              // If selection is made,
              // just erase the selected text,
              // and don't apply any more operations to it.
              if (selection) {
                erase_selection(input, selection)
                return format_input_text(input, _parse, _format, undefined, on_change)
              }

              // Else, perform the (character erasing) operation manually
              return format_input_text(input, _parse, _format, operation, on_change)

            default:
            // Will be handled when `onChange` fires.
          }
        }

        /**
         * Erases the selected text inside an `<input/>`.
         * @param  {DOMElement} input
         * @param  {Selection} selection
         */
        function erase_selection(input, selection) {
          var text = input.value
          text = text.slice(0, selection.start) + text.slice(selection.end)

          input.value = text
          Object(_dom__WEBPACK_IMPORTED_MODULE_3__['setCaretPosition'])(input, selection.start)
        }

        /**
         * Parses and re-formats `<input/>` textual value.
         * E.g. when a user enters something into the `<input/>`
         * that raw input must first be parsed and the re-formatted properly.
         * Is called either after some user input (e.g. entered a character, pasted something)
         * or after the user performed an `operation` (e.g. "Backspace", "Delete").
         * @param  {DOMElement} input
         * @param  {Function} parse
         * @param  {Function} format
         * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
         * @param  {Function} onChange
         */
        function format_input_text(input, _parse, _format, operation, on_change) {
          // Parse `<input/>` textual value.
          // Get `value` and `caret` position.
          var _parse2 = Object(_parse__WEBPACK_IMPORTED_MODULE_1__['default'])(
              input.value,
              Object(_dom__WEBPACK_IMPORTED_MODULE_3__['getCaretPosition'])(input),
              _parse
            ),
            value = _parse2.value,
            caret = _parse2.caret

          // If a user performed an operation (e.g. "Backspace", "Delete")
          // then apply that operation and get new `value` and `caret` position.

          if (operation) {
            var operation_applied = Object(_edit__WEBPACK_IMPORTED_MODULE_0__['default'])(value, caret, operation)

            value = operation_applied.value
            caret = operation_applied.caret
          }

          // Format the `value`.
          // (and reposition the caret accordingly)
          var formatted = Object(_format__WEBPACK_IMPORTED_MODULE_2__['default'])(value, caret, _format)

          var text = formatted.text
          caret = formatted.caret

          // Set `<input/>` textual value manually
          // to prevent React from resetting the caret position
          // later inside subsequent `render()`.
          // Doesn't work for custom `inputComponent`s for some reason.
          input.value = text
          // Position the caret properly.
          Object(_dom__WEBPACK_IMPORTED_MODULE_3__['setCaretPosition'])(input, caret)

          // `<input/>` textual value may have changed,
          // so the parsed `value` may have changed too.
          // The `value` didn't neccessarily change
          // but it might have.
          on_change(value)
        }
        //# sourceMappingURL=input control.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/parse digit.js':
      /*!***********************************************************!*\
  !*** ../node_modules/input-format/modules/parse digit.js ***!
  \***********************************************************/
      /*! exports provided: DIGITS, default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'DIGITS', function () {
          return DIGITS
        })
        // Copied from `libphonenumber-js`:
        // https://github.com/catamphetamine/libphonenumber-js/blob/master/source/parse.js
        //
        // These mappings map a character (key) to a specific digit that should
        // replace it for normalization purposes. Non-European digits that
        // may be used in phone numbers are mapped to a European equivalent.
        //
        // E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
        //
        var DIGITS = {
          0: '0',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          7: '7',
          8: '8',
          9: '9',
          '\uFF10': '0', // Fullwidth digit 0
          '\uFF11': '1', // Fullwidth digit 1
          '\uFF12': '2', // Fullwidth digit 2
          '\uFF13': '3', // Fullwidth digit 3
          '\uFF14': '4', // Fullwidth digit 4
          '\uFF15': '5', // Fullwidth digit 5
          '\uFF16': '6', // Fullwidth digit 6
          '\uFF17': '7', // Fullwidth digit 7
          '\uFF18': '8', // Fullwidth digit 8
          '\uFF19': '9', // Fullwidth digit 9
          '\u0660': '0', // Arabic-indic digit 0
          '\u0661': '1', // Arabic-indic digit 1
          '\u0662': '2', // Arabic-indic digit 2
          '\u0663': '3', // Arabic-indic digit 3
          '\u0664': '4', // Arabic-indic digit 4
          '\u0665': '5', // Arabic-indic digit 5
          '\u0666': '6', // Arabic-indic digit 6
          '\u0667': '7', // Arabic-indic digit 7
          '\u0668': '8', // Arabic-indic digit 8
          '\u0669': '9', // Arabic-indic digit 9
          '\u06F0': '0', // Eastern-Arabic digit 0
          '\u06F1': '1', // Eastern-Arabic digit 1
          '\u06F2': '2', // Eastern-Arabic digit 2
          '\u06F3': '3', // Eastern-Arabic digit 3
          '\u06F4': '4', // Eastern-Arabic digit 4
          '\u06F5': '5', // Eastern-Arabic digit 5
          '\u06F6': '6', // Eastern-Arabic digit 6
          '\u06F7': '7', // Eastern-Arabic digit 7
          '\u06F8': '8', // Eastern-Arabic digit 8
          '\u06F9': '9', // Eastern-Arabic digit 9
        }

        /* harmony default export */ __webpack_exports__['default'] = function (character, value) {
          return DIGITS[character]
        }
        //# sourceMappingURL=parse digit.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/parse.js':
      /*!*****************************************************!*\
  !*** ../node_modules/input-format/modules/parse.js ***!
  \*****************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return parse
        })
        // Parses the `text`.
        //
        // Returns `{ value, caret }` where `caret` is
        // the caret position inside `value`
        // corresponding to the `caret_position` inside `text`.
        //
        // The `text` is parsed by feeding each character sequentially to
        // `parse_character(character, value)` function
        // and appending the result (if it's not `undefined`) to `value`.
        //
        // Example:
        //
        // `text` is `8 (800) 555-35-35`,
        // `caret_position` is `4` (before the first `0`).
        // `parse_character` is `(character, value) =>
        //   if (character >= '0' && character <= '9') { return character }`.
        //
        // then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
        //
        function parse(text, caret_position, parse_character) {
          var value = ''

          var focused_input_character_index = 0

          var index = 0
          while (index < text.length) {
            var character = parse_character(text[index], value)

            if (character !== undefined) {
              value += character

              if (caret_position !== undefined) {
                if (caret_position === index) {
                  focused_input_character_index = value.length - 1
                } else if (caret_position > index) {
                  focused_input_character_index = value.length
                }
              }
            }

            index++
          }

          // If caret position wasn't specified
          if (caret_position === undefined) {
            // Then set caret position to "after the last input character"
            focused_input_character_index = value.length
          }

          var result = {
            value: value,
            caret: focused_input_character_index,
          }

          return result
        }
        //# sourceMappingURL=parse.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/template formatter.js':
      /*!******************************************************************!*\
  !*** ../node_modules/input-format/modules/template formatter.js ***!
  \******************************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony import */ var babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! babel-runtime/core-js/get-iterator */ '../node_modules/babel-runtime/core-js/get-iterator.js'
        )
        /* harmony import */ var babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(
          babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0__
        )
        /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! ./helpers */ '../node_modules/input-format/modules/helpers.js'
        )
        /* harmony import */ var _close_braces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          /*! ./close braces */ '../node_modules/input-format/modules/close braces.js'
        )

        // Takes a `template` where character placeholders
        // are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
        //
        // Returns a function which takes `value` characters
        // and returns the `template` filled with those characters.
        // If the `template` can only be partially filled
        // then it is cut off.
        //
        // If `should_close_braces` is `true`,
        // then it will also make sure all dangling braces are closed,
        // e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
        //
        /* harmony default export */ __webpack_exports__['default'] = function (template) {
          var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x'
          var should_close_braces = arguments[2]

          if (!template) {
            return function (value) {
              return { text: value }
            }
          }

          var characters_in_template = Object(_helpers__WEBPACK_IMPORTED_MODULE_1__['count_occurences'])(placeholder, template)

          return function (value) {
            if (!value) {
              return { text: '', template: template }
            }

            var value_character_index = 0
            var filled_in_template = ''

            var _iteratorNormalCompletion = true
            var _didIteratorError = false
            var _iteratorError = undefined

            try {
              for (
                var _iterator = babel_runtime_core_js_get_iterator__WEBPACK_IMPORTED_MODULE_0___default()(template), _step;
                !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                _iteratorNormalCompletion = true
              ) {
                var character = _step.value

                if (character !== placeholder) {
                  filled_in_template += character
                  continue
                }

                filled_in_template += value[value_character_index]
                value_character_index++

                // If the last available value character has been filled in,
                // then return the filled in template
                // (either trim the right part or retain it,
                //  if no more character placeholders in there)
                if (value_character_index === value.length) {
                  // If there are more character placeholders
                  // in the right part of the template
                  // then simply trim it.
                  if (value.length < characters_in_template) {
                    break
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true
              _iteratorError = err
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return()
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError
                }
              }
            }

            if (should_close_braces) {
              filled_in_template = Object(_close_braces__WEBPACK_IMPORTED_MODULE_2__['default'])(filled_in_template, template)
            }

            return { text: filled_in_template, template: template }
          }
        }
        //# sourceMappingURL=template formatter.js.map

        /***/
      },

    /***/ '../node_modules/input-format/modules/template parser.js':
      /*!***************************************************************!*\
  !*** ../node_modules/input-format/modules/template parser.js ***!
  \***************************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./helpers */ '../node_modules/input-format/modules/helpers.js'
        )

        /* harmony default export */ __webpack_exports__['default'] = function (template, placeholder, parse) {
          if (typeof placeholder === 'function') {
            parse = placeholder
            placeholder = 'x'
          }

          var max_characters = Object(_helpers__WEBPACK_IMPORTED_MODULE_0__['count_occurences'])(placeholder, template)

          return function (character, value) {
            if (value.length < max_characters) {
              return parse(character, value)
            }
          }
        }
        //# sourceMappingURL=template parser.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/AsYouType.js':
      /*!************************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/AsYouType.js ***!
  \************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.DIGIT_PLACEHOLDER = undefined

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })() // This is an enhanced port of Google Android `libphonenumber`'s
        // `asyoutypeformatter.js` of 17th November, 2016.
        //
        // https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js

        exports.close_dangling_braces = close_dangling_braces
        exports.count_occurences = count_occurences
        exports.repeat = repeat

        var _metadata = __webpack_require__(/*! ./metadata */ '../node_modules/libphonenumber-js/build/metadata.js')

        var _metadata2 = _interopRequireDefault(_metadata)

        var _common = __webpack_require__(/*! ./common */ '../node_modules/libphonenumber-js/build/common.js')

        var _parse = __webpack_require__(/*! ./parse */ '../node_modules/libphonenumber-js/build/parse.js')

        var _format = __webpack_require__(/*! ./format */ '../node_modules/libphonenumber-js/build/format.js')

        var _types = __webpack_require__(/*! ./types */ '../node_modules/libphonenumber-js/build/types.js')

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        // Used in phone number format template creation.
        // Could be any digit, I guess.
        var DUMMY_DIGIT = '9'
        var DUMMY_DIGIT_MATCHER = new RegExp(DUMMY_DIGIT, 'g')
        // I don't know why is it exactly `15`
        var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15
        // Create a phone number consisting only of the digit 9 that matches the
        // `number_pattern` by applying the pattern to the "longest phone number" string.
        var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH)

        // The digits that have not been entered yet will be represented by a \u2008,
        // the punctuation space.
        var DIGIT_PLACEHOLDER = (exports.DIGIT_PLACEHOLDER = 'x') // '\u2008' (punctuation space)
        var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER)
        var DIGIT_PLACEHOLDER_MATCHER_GLOBAL = new RegExp(DIGIT_PLACEHOLDER, 'g')

        // A pattern that is used to match character classes in regular expressions.
        // An example of a character class is "[1-4]".
        var CHARACTER_CLASS_PATTERN = /\[([^\[\]])*\]/g

        // Any digit in a regular expression that actually denotes a digit. For
        // example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
        // (8 and 0) are standalone digits, but the rest are not.
        // Two look-aheads are needed because the number following \\d could be a
        // two-digit number, since the phone number can be as long as 15 digits.
        var STANDALONE_DIGIT_PATTERN = /\d(?=[^,}][^,}])/g

        // A pattern that is used to determine if a `format` is eligible
        // to be used by the "as you type formatter".
        // It is eligible when the `format` contains groups of the dollar sign
        // followed by a single digit, separated by valid phone number punctuation.
        // This prevents invalid punctuation (such as the star sign in Israeli star numbers)
        // getting into the output of the "as you type formatter".
        var ELIGIBLE_FORMAT_PATTERN = new RegExp(
          '^' + '[' + _common.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _common.VALID_PUNCTUATION + ']*)+' + '$'
        )

        // This is the minimum length of the leading digits of a phone number
        // to guarantee the first "leading digits pattern" for a phone number format
        // to be preemptive.
        var MIN_LEADING_DIGITS_LENGTH = 3

        var VALID_INCOMPLETE_PHONE_NUMBER =
          '[' + _common.PLUS_CHARS + ']{0,1}' + '[' + _common.VALID_PUNCTUATION + _common.VALID_DIGITS + ']*'

        var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i')

        var AsYouType = (function () {
          /**
           * @param {string} [country_code] - The default country used for parsing non-international phone numbers.
           * @param {Object} metadata
           */
          function AsYouType(country_code, metadata) {
            _classCallCheck(this, AsYouType)

            this.metadata = new _metadata2.default(metadata)

            if (country_code && this.metadata.hasCountry(country_code)) {
              this.default_country = country_code
            }

            this.reset()
          }

          _createClass(AsYouType, [
            {
              key: 'input',
              value: function input(text) {
                // Parse input

                var extracted_number = (0, _parse.extract_formatted_phone_number)(text) || ''

                // Special case for a lone '+' sign
                // since it's not considered a possible phone number.
                if (!extracted_number) {
                  if (text && text.indexOf('+') >= 0) {
                    extracted_number = '+'
                  }
                }

                // Validate possible first part of a phone number
                if (!(0, _common.matches_entirely)(extracted_number, VALID_INCOMPLETE_PHONE_NUMBER_PATTERN)) {
                  return this.current_output
                }

                return this.process_input((0, _common.parse_phone_number_digits)(extracted_number))
              },
            },
            {
              key: 'process_input',
              value: function process_input(input) {
                // If an out of position '+' sign detected
                // (or a second '+' sign),
                // then just drop it from the input.
                if (input[0] === '+') {
                  if (!this.parsed_input) {
                    this.parsed_input += '+'

                    // If a default country was set
                    // then reset it because an explicitly international
                    // phone number is being entered
                    this.reset_countriness()
                  }

                  input = input.slice(1)
                }

                // Raw phone number
                this.parsed_input += input

                // // Reset phone number validation state
                // this.valid = false

                // Add digits to the national number
                this.national_number += input

                // TODO: Deprecated: rename `this.national_number`
                // to `this.nationalNumber` and remove `.getNationalNumber()`.

                // Try to format the parsed input

                if (this.is_international()) {
                  if (!this.countryCallingCode) {
                    // No need to format anything
                    // if there's no national phone number.
                    // (e.g. just the country calling code)
                    if (!this.national_number) {
                      // Return raw phone number
                      return this.parsed_input
                    }

                    // If one looks at country phone codes
                    // then he can notice that no one country phone code
                    // is ever a (leftmost) substring of another country phone code.
                    // So if a valid country code is extracted so far
                    // then it means that this is the country code.

                    // If no country phone code could be extracted so far,
                    // then just return the raw phone number,
                    // because it has no way of knowing
                    // how to format the phone number so far.
                    if (!this.extract_country_calling_code()) {
                      // Return raw phone number
                      return this.parsed_input
                    }

                    // Initialize country-specific data
                    this.initialize_phone_number_formats_for_this_country_calling_code()
                    this.reset_format()
                    this.determine_the_country()
                  }
                  // `this.country` could be `undefined`,
                  // for instance, when there is ambiguity
                  // in a form of several different countries
                  // each corresponding to the same country phone code
                  // (e.g. NANPA: USA, Canada, etc),
                  // and there's not enough digits entered
                  // to reliably determine the country
                  // the phone number belongs to.
                  // Therefore, in cases of such ambiguity,
                  // each time something is input,
                  // try to determine the country
                  // (if it's not determined yet).
                  else if (!this.country) {
                    this.determine_the_country()
                  }
                } else {
                  // Some national prefixes are substrings of other national prefixes
                  // (for the same country), therefore try to extract national prefix each time
                  // because a longer national prefix might be available at some point in time.

                  var previous_national_prefix = this.national_prefix
                  this.national_number = this.national_prefix + this.national_number

                  // Possibly extract a national prefix
                  this.extract_national_prefix()

                  if (this.national_prefix !== previous_national_prefix) {
                    // National number has changed
                    // (due to another national prefix been extracted)
                    // therefore national number has changed
                    // therefore reset all previous formatting data.
                    // (and leading digits matching state)
                    this.matching_formats = this.available_formats
                    this.reset_format()
                  }
                }

                if (!this.should_format()) {
                  return this.format_as_non_formatted_number()
                }

                // Check the available phone number formats
                // based on the currently available leading digits.
                this.match_formats_by_leading_digits()

                // Format the phone number (given the next digits)
                var formatted_national_phone_number = this.format_national_phone_number(input)

                // If the phone number could be formatted,
                // then return it, possibly prepending with country phone code
                // (for international phone numbers only)
                if (formatted_national_phone_number) {
                  return this.full_phone_number(formatted_national_phone_number)
                }

                // If the phone number couldn't be formatted,
                // then just fall back to the raw phone number.
                return this.parsed_input
              },
            },
            {
              key: 'format_as_non_formatted_number',
              value: function format_as_non_formatted_number() {
                if (this.is_international() && this.countryCallingCode) {
                  if (this.national_number) {
                    // For convenience, the public `.template` property
                    // contains the whole international number
                    // if the phone number being input is international:
                    // 'x' for the '+' sign, 'x'es for the country phone code,
                    // a spacebar and then the template for the national number digits.
                    this.template =
                      DIGIT_PLACEHOLDER +
                      repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) +
                      ' ' +
                      repeat(DIGIT_PLACEHOLDER, this.national_number.length)

                    return '+' + this.countryCallingCode + ' ' + this.national_number
                  }

                  return '+' + this.countryCallingCode
                }

                return this.parsed_input
              },
            },
            {
              key: 'format_national_phone_number',
              value: function format_national_phone_number(next_digits) {
                // Format the next phone number digits
                // using the previously chosen phone number format.
                //
                // This is done here because if `attempt_to_format_complete_phone_number`
                // was placed before this call then the `template`
                // wouldn't reflect the situation correctly (and would therefore be inconsistent)
                //
                var national_number_formatted_with_previous_format = void 0
                if (this.chosen_format) {
                  national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits)
                }

                // See if the input digits can be formatted properly already. If not,
                // use the results from format_next_national_number_digits(), which does formatting
                // based on the formatting pattern chosen.

                var formatted_number = this.attempt_to_format_complete_phone_number()

                // Just because a phone number doesn't have a suitable format
                // that doesn't mean that the phone is invalid
                // because phone number formats only format phone numbers,
                // they don't validate them and some (rare) phone numbers
                // are meant to stay non-formatted.
                if (formatted_number) {
                  // if (this.country)
                  // {
                  // 	this.valid = true
                  // }

                  return formatted_number
                }

                // For some phone number formats national prefix

                // If the previously chosen phone number format
                // didn't match the next (current) digit being input
                // (leading digits pattern didn't match).
                if (this.choose_another_format()) {
                  // And a more appropriate phone number format
                  // has been chosen for these `leading digits`,
                  // then format the national phone number (so far)
                  // using the newly selected phone number pattern.

                  // Will return `undefined` if it couldn't format
                  // the supplied national number
                  // using the selected phone number pattern.

                  return this.reformat_national_number()
                }

                // If could format the next (current) digit
                // using the previously chosen phone number format
                // then return the formatted number so far.

                // If no new phone number format could be chosen,
                // and couldn't format the supplied national number
                // using the selected phone number pattern,
                // then it will return `undefined`.

                return national_number_formatted_with_previous_format
              },
            },
            {
              key: 'reset',
              value: function reset() {
                // Input stripped of non-phone-number characters.
                // Can only contain a possible leading '+' sign and digits.
                this.parsed_input = ''

                this.current_output = ''

                // This contains the national prefix that has been extracted. It contains only
                // digits without formatting.
                this.national_prefix = ''

                this.national_number = ''

                this.reset_countriness()

                this.reset_format()

                // this.valid = false

                return this
              },
            },
            {
              key: 'reset_country',
              value: function reset_country() {
                if (this.is_international()) {
                  this.country = undefined
                } else {
                  this.country = this.default_country
                }
              },
            },
            {
              key: 'reset_countriness',
              value: function reset_countriness() {
                this.reset_country()

                if (this.default_country && !this.is_international()) {
                  this.metadata.country(this.default_country)
                  this.countryCallingCode = this.metadata.countryCallingCode()

                  this.initialize_phone_number_formats_for_this_country_calling_code()
                } else {
                  this.metadata.country(undefined)
                  this.countryCallingCode = undefined

                  this.available_formats = []
                  this.matching_formats = this.available_formats
                }
              },
            },
            {
              key: 'reset_format',
              value: function reset_format() {
                this.chosen_format = undefined
                this.template = undefined
                this.partially_populated_template = undefined
                this.last_match_position = -1
              },

              // Format each digit of national phone number (so far)
              // using the newly selected phone number pattern.
            },
            {
              key: 'reformat_national_number',
              value: function reformat_national_number() {
                // Format each digit of national phone number (so far)
                // using the selected phone number pattern.
                return this.format_next_national_number_digits(this.national_number)
              },
            },
            {
              key: 'initialize_phone_number_formats_for_this_country_calling_code',
              value: function initialize_phone_number_formats_for_this_country_calling_code() {
                // Get all "eligible" phone number formats for this country
                this.available_formats = this.metadata.formats().filter(function (format) {
                  return ELIGIBLE_FORMAT_PATTERN.test(format.internationalFormat())
                })

                this.matching_formats = this.available_formats
              },
            },
            {
              key: 'match_formats_by_leading_digits',
              value: function match_formats_by_leading_digits() {
                var leading_digits = this.national_number

                // "leading digits" pattern list starts with
                // one of a maximum length of 3 digits,
                // and then with each additional digit
                // a more precise "leading digits" pattern is specified.

                var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH

                if (index_of_leading_digits_pattern < 0) {
                  index_of_leading_digits_pattern = 0
                }

                this.matching_formats = this.matching_formats.filter(function (format) {
                  var leading_digits_pattern_count = format.leadingDigitsPatterns().length

                  // Keep everything that isn't restricted by leading digits.
                  if (leading_digits_pattern_count === 0) {
                    return true
                  }

                  var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_pattern_count - 1)
                  var leading_digits_pattern = format.leadingDigitsPatterns()[leading_digits_pattern_index]

                  // Brackets are required for `^` to be applied to
                  // all or-ed (`|`) parts, not just the first one.
                  return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits)
                })

                // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
                  this.reset_format()
                }
              },
            },
            {
              key: 'should_format',
              value: function should_format() {
                // Start matching any formats at all when the national number
                // entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives
                // like when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Google could have provided leading digits patterns starting
                // with a single digit but they chose not to (for whatever reasons).
                //
                return this.national_number >= MIN_LEADING_DIGITS_LENGTH
              },

              // Check to see if there is an exact pattern match for these digits. If so, we
              // should use this instead of any other formatting template whose
              // `leadingDigitsPattern` also matches the input.
            },
            {
              key: 'attempt_to_format_complete_phone_number',
              value: function attempt_to_format_complete_phone_number() {
                for (
                  var _iterator = this.matching_formats,
                    _isArray = Array.isArray(_iterator),
                    _i = 0,
                    _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
                  ;

                ) {
                  var _ref

                  if (_isArray) {
                    if (_i >= _iterator.length) break
                    _ref = _iterator[_i++]
                  } else {
                    _i = _iterator.next()
                    if (_i.done) break
                    _ref = _i.value
                  }

                  var format = _ref

                  var matcher = new RegExp('^(?:' + format.pattern() + ')$')

                  if (!matcher.test(this.national_number)) {
                    continue
                  }

                  if (!this.is_format_applicable(format)) {
                    continue
                  }

                  // To leave the formatter in a consistent state
                  this.reset_format()
                  this.chosen_format = format

                  var formatted_number = (0, _format.format_national_number_using_format)(
                    this.national_number,
                    format,
                    this.is_international(),
                    this.national_prefix.length > 0,
                    this.metadata
                  )

                  // Set `this.template` and `this.partially_populated_template`.
                  //
                  // `else` case doesn't ever happen
                  // with the current metadata,
                  // but just in case.
                  //
                  /* istanbul ignore else */
                  if (this.create_formatting_template(format)) {
                    // Populate `this.partially_populated_template`
                    this.reformat_national_number()
                  } else {
                    // Prepend `+CountryCode` in case of an international phone number
                    var full_number = this.full_phone_number(formatted_number)
                    this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER)
                    this.partially_populated_template = full_number
                  }

                  return formatted_number
                }
              },

              // Prepends `+CountryCode` in case of an international phone number
            },
            {
              key: 'full_phone_number',
              value: function full_phone_number(formatted_national_number) {
                if (this.is_international()) {
                  return '+' + this.countryCallingCode + ' ' + formatted_national_number
                }

                return formatted_national_number
              },

              // Extracts the country calling code from the beginning
              // of the entered `national_number` (so far),
              // and places the remaining input into the `national_number`.
            },
            {
              key: 'extract_country_calling_code',
              value: function extract_country_calling_code() {
                var _parse_national_numbe = (0, _common.parse_national_number_and_country_calling_code)(this.parsed_input, this.metadata),
                  countryCallingCode = _parse_national_numbe.countryCallingCode,
                  number = _parse_national_numbe.number

                if (!countryCallingCode) {
                  return
                }

                this.countryCallingCode = countryCallingCode
                this.national_number = number

                this.metadata.chooseCountryByCountryCallingCode(countryCallingCode)
                return this.metadata.selectedCountry() !== undefined
              },
            },
            {
              key: 'extract_national_prefix',
              value: function extract_national_prefix() {
                this.national_prefix = ''

                if (!this.metadata.selectedCountry()) {
                  return
                }

                // Only strip national prefixes for non-international phone numbers
                // because national prefixes can't be present in international phone numbers.
                // Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
                // first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
                // and then it would assume that's a valid number which it isn't.
                // So no forgiveness for grandmas here.
                // The issue asking for this fix:
                // https://github.com/catamphetamine/libphonenumber-js/issues/159

                var _strip_national_prefi = (0, _parse.strip_national_prefix_and_carrier_code)(this.national_number, this.metadata),
                  potential_national_number = _strip_national_prefi.number

                // We require that the NSN remaining after stripping the national prefix and
                // carrier code be long enough to be a possible length for the region.
                // Otherwise, we don't do the stripping, since the original number could be
                // a valid short number.

                if (
                  !this.metadata.possibleLengths() ||
                  (this.is_possible_number(this.national_number) && !this.is_possible_number(potential_national_number))
                ) {
                  // Verify the parsed national (significant) number for this country
                  var national_number_rule = new RegExp(this.metadata.nationalNumberPattern())
                  //
                  // If the original number (before stripping national prefix) was viable,
                  // and the resultant number is not, then prefer the original phone number.
                  // This is because for some countries (e.g. Russia) the same digit could be both
                  // a national prefix and a leading digit of a valid national phone number,
                  // like `8` is the national prefix for Russia and both
                  // `8 800 555 35 35` and `800 555 35 35` are valid numbers.
                  if (
                    (0, _common.matches_entirely)(this.national_number, national_number_rule) &&
                    !(0, _common.matches_entirely)(potential_national_number, national_number_rule)
                  ) {
                    return
                  }
                }

                this.national_prefix = this.national_number.slice(0, this.national_number.length - potential_national_number.length)
                this.national_number = potential_national_number

                return this.national_prefix
              },
            },
            {
              key: 'is_possible_number',
              value: function is_possible_number(number) {
                var validation_result = (0, _types.check_number_length_for_type)(number, undefined, this.metadata)
                switch (validation_result) {
                  case 'IS_POSSIBLE':
                    return true
                  // case 'IS_POSSIBLE_LOCAL_ONLY':
                  // 	return !this.is_international()
                  default:
                    return false
                }
              },
            },
            {
              key: 'choose_another_format',
              value: function choose_another_format() {
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                for (
                  var _iterator2 = this.matching_formats,
                    _isArray2 = Array.isArray(_iterator2),
                    _i2 = 0,
                    _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();
                  ;

                ) {
                  var _ref2

                  if (_isArray2) {
                    if (_i2 >= _iterator2.length) break
                    _ref2 = _iterator2[_i2++]
                  } else {
                    _i2 = _iterator2.next()
                    if (_i2.done) break
                    _ref2 = _i2.value
                  }

                  var format = _ref2

                  // If this format is currently being used
                  // and is still possible, then stick to it.
                  if (this.chosen_format === format) {
                    return
                  }

                  // If this `format` is suitable for "as you type",
                  // then extract the template from this format
                  // and use it to format the phone number being input.

                  if (!this.is_format_applicable(format)) {
                    continue
                  }

                  if (!this.create_formatting_template(format)) {
                    continue
                  }

                  this.chosen_format = format

                  // With a new formatting template, the matched position
                  // using the old template needs to be reset.
                  this.last_match_position = -1

                  return true
                }

                // No format matches the phone number,
                // therefore set `country` to `undefined`
                // (or to the default country).
                this.reset_country()

                // No format matches the national phone number entered
                this.reset_format()
              },
            },
            {
              key: 'is_format_applicable',
              value: function is_format_applicable(format) {
                // If national prefix is mandatory for this phone number format
                // and the user didn't input the national prefix,
                // then this phone number format isn't suitable.
                if (!this.is_international() && !this.national_prefix && format.nationalPrefixIsMandatoryWhenFormatting()) {
                  return false
                }

                return true
              },
            },
            {
              key: 'create_formatting_template',
              value: function create_formatting_template(format) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */
                if (format.pattern().indexOf('|') >= 0) {
                  return
                }

                // Get formatting template for this phone number format
                var template = this.get_template_for_phone_number_format_pattern(format)

                // If the national number entered is too long
                // for any phone number format, then abort.
                if (!template) {
                  return
                }

                // This one is for national number only
                this.partially_populated_template = template

                // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (this.is_international()) {
                  this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + template
                }
                // For local numbers, replace national prefix
                // with a digit placeholder.
                else {
                  this.template = template.replace(/\d/g, DIGIT_PLACEHOLDER)
                }

                // This one is for the full phone number
                return this.template
              },

              // Generates formatting template for a phone number format
            },
            {
              key: 'get_template_for_phone_number_format_pattern',
              value: function get_template_for_phone_number_format_pattern(format) {
                // A very smart trick by the guys at Google
                var number_pattern = format
                  .pattern()
                  // Replace anything in the form of [..] with \d
                  .replace(CHARACTER_CLASS_PATTERN, '\\d')
                  // Replace any standalone digit (not the one in `{}`) with \d
                  .replace(STANDALONE_DIGIT_PATTERN, '\\d')

                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0]

                // If the national number entered is too long
                // for any phone number format, then abort.
                if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
                  return
                }

                // Prepare the phone number format
                var number_format = this.get_format_format(format)

                // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.

                // Below `strict_pattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strict_pattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.national_number : `111111111` (9 digits)
                //
                // number_pattern : (\d{2})(\d{3,4})(\d{4})
                // number_format : `$1 $2 $3`
                // dummy_phone_number_matching_format_pattern : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `number_pattern`.
                //
                // The fix is, if `this.national_number` has already sufficient length
                // to satisfy the `number_pattern` completely then `this.national_number` is used
                // instead of `dummy_phone_number_matching_format_pattern`.

                var strict_pattern = new RegExp('^' + number_pattern + '$')
                var national_number_dummy_digits = this.national_number.replace(/\d/g, DUMMY_DIGIT)

                // If `this.national_number` has already sufficient length
                // to satisfy the `number_pattern` completely then use it
                // instead of `dummy_phone_number_matching_format_pattern`.
                if (strict_pattern.test(national_number_dummy_digits)) {
                  dummy_phone_number_matching_format_pattern = national_number_dummy_digits
                }

                // Generate formatting template for this phone number format
                return (
                  dummy_phone_number_matching_format_pattern
                    // Format the dummy phone number according to the format
                    .replace(new RegExp(number_pattern), number_format)
                    // Replace each dummy digit with a DIGIT_PLACEHOLDER
                    .replace(DUMMY_DIGIT_MATCHER, DIGIT_PLACEHOLDER)
                )
              },
            },
            {
              key: 'format_next_national_number_digits',
              value: function format_next_national_number_digits(digits) {
                // Using `.split('')` to iterate through a string here
                // to avoid requiring `Symbol.iterator` polyfill.
                // `.split('')` is generally not safe for Unicode,
                // but in this particular case for `digits` it is safe.
                // for (const digit of digits)
                for (
                  var _iterator3 = digits.split(''),
                    _isArray3 = Array.isArray(_iterator3),
                    _i3 = 0,
                    _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();
                  ;

                ) {
                  var _ref3

                  if (_isArray3) {
                    if (_i3 >= _iterator3.length) break
                    _ref3 = _iterator3[_i3++]
                  } else {
                    _i3 = _iterator3.next()
                    if (_i3.done) break
                    _ref3 = _i3.value
                  }

                  var digit = _ref3

                  // If there is room for more digits in current `template`,
                  // then set the next digit in the `template`,
                  // and return the formatted digits so far.

                  // If more digits are entered than the current format could handle
                  if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
                    // Reset the current format,
                    // so that the new format will be chosen
                    // in a subsequent `this.choose_another_format()` call
                    // later in code.
                    this.chosen_format = undefined
                    this.template = undefined
                    this.partially_populated_template = undefined
                    return
                  }

                  this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER)
                  this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit)
                }

                // Return the formatted phone number so far
                return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1).replace(
                  DIGIT_PLACEHOLDER_MATCHER_GLOBAL,
                  ' '
                )
              },
            },
            {
              key: 'is_international',
              value: function is_international() {
                return this.parsed_input && this.parsed_input[0] === '+'
              },
            },
            {
              key: 'get_format_format',
              value: function get_format_format(format) {
                if (this.is_international()) {
                  return (0, _format.local_to_international_style)(format.internationalFormat())
                }

                // If national prefix formatting rule is set
                // for this phone number format
                if (format.nationalPrefixFormattingRule()) {
                  // If the user did input the national prefix
                  // (or if the national prefix formatting rule does not require national prefix)
                  // then maybe make it part of the phone number template
                  if (this.national_prefix || !format.usesNationalPrefix()) {
                    // Make the national prefix part of the phone number template
                    return format.format().replace(_format.FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
                  }
                }

                return format.format()
              },

              // Determines the country of the phone number
              // entered so far based on the country phone code
              // and the national phone number.
            },
            {
              key: 'determine_the_country',
              value: function determine_the_country() {
                this.country = (0, _parse.find_country_code)(this.countryCallingCode, this.national_number, this.metadata)
              },
            },
            {
              key: 'getNationalNumber',
              value: function getNationalNumber() {
                return this.national_number
              },
            },
          ])

          return AsYouType
        })()

        exports.default = AsYouType
        function close_dangling_braces(template, cut_before) {
          var retained_template = template.slice(0, cut_before)

          var opening_braces = count_occurences('(', retained_template)
          var closing_braces = count_occurences(')', retained_template)

          var dangling_braces = opening_braces - closing_braces

          while (dangling_braces > 0 && cut_before < template.length) {
            if (template[cut_before] === ')') {
              dangling_braces--
            }
            cut_before++
          }

          return template.slice(0, cut_before)
        }

        // Counts all occurences of a symbol in a string.
        // Unicode-unsafe (because using `.split()`).
        function count_occurences(symbol, string) {
          var count = 0

          // Using `.split('')` to iterate through a string here
          // to avoid requiring `Symbol.iterator` polyfill.
          // `.split('')` is generally not safe for Unicode,
          // but in this particular case for counting brackets it is safe.
          // for (const character of string)
          for (
            var _iterator4 = string.split(''),
              _isArray4 = Array.isArray(_iterator4),
              _i4 = 0,
              _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();
            ;

          ) {
            var _ref4

            if (_isArray4) {
              if (_i4 >= _iterator4.length) break
              _ref4 = _iterator4[_i4++]
            } else {
              _i4 = _iterator4.next()
              if (_i4.done) break
              _ref4 = _i4.value
            }

            var character = _ref4

            if (character === symbol) {
              count++
            }
          }

          return count
        }

        // Repeats a string (or a symbol) N times.
        // http://stackoverflow.com/questions/202605/repeat-string-javascript
        function repeat(string, times) {
          if (times < 1) {
            return ''
          }

          var result = ''

          while (times > 1) {
            if (times & 1) {
              result += string
            }

            times >>= 1
            string += string
          }

          return result + string
        }
        //# sourceMappingURL=AsYouType.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/RFC3966.js':
      /*!**********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/RFC3966.js ***!
  \**********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = []
            var _n = true
            var _d = false
            var _e = undefined
            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value)
                if (i && _arr.length === i) break
              }
            } catch (err) {
              _d = true
              _e = err
            } finally {
              try {
                if (!_n && _i['return']) _i['return']()
              } finally {
                if (_d) throw _e
              }
            }
            return _arr
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i)
            } else {
              throw new TypeError('Invalid attempt to destructure non-iterable instance')
            }
          }
        })()

        exports.parseRFC3966 = parseRFC3966
        exports.formatRFC3966 = formatRFC3966

        var _parse = __webpack_require__(/*! ./parse */ '../node_modules/libphonenumber-js/build/parse.js')

        // https://www.ietf.org/rfc/rfc3966.txt

        /**
         * @param  {string} text - Phone URI (RFC 3966).
         * @return {object} `{ ?number, ?ext }`.
         */
        function parseRFC3966(text) {
          var number = void 0
          var ext = void 0

          for (
            var _iterator = text.split(';'),
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var part = _ref

            var _part$split = part.split(':'),
              _part$split2 = _slicedToArray(_part$split, 2),
              name = _part$split2[0],
              value = _part$split2[1]

            switch (name) {
              case 'tel':
                number = value
                break
              case 'ext':
                ext = value
                break
              case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') {
                  number = value + number
                }
                break
            }
          }

          // If the phone number is not viable, then abort.
          if (!(0, _parse.is_viable_phone_number)(number)) {
            return {}
          }

          var result = { number: number }
          if (ext) {
            result.ext = ext
          }
          return result
        }

        /**
         * @param  {object} - `{ ?number, ?extension }`.
         * @return {string} Phone URI (RFC 3966).
         */
        function formatRFC3966(_ref2) {
          var number = _ref2.number,
            ext = _ref2.ext

          if (!number) {
            return ''
          }

          if (number[0] !== '+') {
            throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.')
          }

          return 'tel:' + number + (ext ? ';ext=' + ext : '')
        }
        //# sourceMappingURL=RFC3966.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/common.js':
      /*!*********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/common.js ***!
  \*********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.parse_phone_number_digits = parse_phone_number_digits
        exports.parse_national_number_and_country_calling_code = parse_national_number_and_country_calling_code
        exports.matches_entirely = matches_entirely
        exports.create_extension_pattern = create_extension_pattern
        // `DASHES` will be right after the opening square bracket of the "character class"
        var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D'
        var SLASHES = '\uFF0F/'
        var DOTS = '\uFF0E.'
        var WHITESPACE = (exports.WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000')
        var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]'
        // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
        var TILDES = '~\u2053\u223C\uFF5E'

        // Digits accepted in phone numbers
        // (ascii, fullwidth, arabic-indic, and eastern arabic digits).
        var VALID_DIGITS = (exports.VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9')

        // Regular expression of acceptable punctuation found in phone numbers. This
        // excludes punctuation found as a leading character only. This consists of dash
        // characters, white space characters, full stops, slashes, square brackets,
        // parentheses and tildes. Full-width variants are also present.
        var VALID_PUNCTUATION = (exports.VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES)

        var PLUS_CHARS = (exports.PLUS_CHARS = '+\uFF0B')
        var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

        // The ITU says the maximum length should be 15,
        // but one can find longer numbers in Germany.
        var MAX_LENGTH_FOR_NSN = (exports.MAX_LENGTH_FOR_NSN = 17)

        // The maximum length of the country calling code.
        var MAX_LENGTH_COUNTRY_CODE = (exports.MAX_LENGTH_COUNTRY_CODE = 3)

        // These mappings map a character (key) to a specific digit that should
        // replace it for normalization purposes. Non-European digits that
        // may be used in phone numbers are mapped to a European equivalent.
        //
        // E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
        //
        var DIGIT_MAPPINGS = (exports.DIGIT_MAPPINGS = {
          0: '0',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          7: '7',
          8: '8',
          9: '9',
          '\uFF10': '0', // Fullwidth digit 0
          '\uFF11': '1', // Fullwidth digit 1
          '\uFF12': '2', // Fullwidth digit 2
          '\uFF13': '3', // Fullwidth digit 3
          '\uFF14': '4', // Fullwidth digit 4
          '\uFF15': '5', // Fullwidth digit 5
          '\uFF16': '6', // Fullwidth digit 6
          '\uFF17': '7', // Fullwidth digit 7
          '\uFF18': '8', // Fullwidth digit 8
          '\uFF19': '9', // Fullwidth digit 9
          '\u0660': '0', // Arabic-indic digit 0
          '\u0661': '1', // Arabic-indic digit 1
          '\u0662': '2', // Arabic-indic digit 2
          '\u0663': '3', // Arabic-indic digit 3
          '\u0664': '4', // Arabic-indic digit 4
          '\u0665': '5', // Arabic-indic digit 5
          '\u0666': '6', // Arabic-indic digit 6
          '\u0667': '7', // Arabic-indic digit 7
          '\u0668': '8', // Arabic-indic digit 8
          '\u0669': '9', // Arabic-indic digit 9
          '\u06F0': '0', // Eastern-Arabic digit 0
          '\u06F1': '1', // Eastern-Arabic digit 1
          '\u06F2': '2', // Eastern-Arabic digit 2
          '\u06F3': '3', // Eastern-Arabic digit 3
          '\u06F4': '4', // Eastern-Arabic digit 4
          '\u06F5': '5', // Eastern-Arabic digit 5
          '\u06F6': '6', // Eastern-Arabic digit 6
          '\u06F7': '7', // Eastern-Arabic digit 7
          '\u06F8': '8', // Eastern-Arabic digit 8
          '\u06F9': '9', // Eastern-Arabic digit 9

          /**
           * Drops all punctuation leaving only digits and the leading `+` sign (if any).
           * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
           *
           * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
           *
           * @param  {string} number
           * @return {string}
           */
        })
        function parse_phone_number_digits(number) {
          return (LEADING_PLUS_CHARS_PATTERN.test(number) ? '+' : '') + drop_and_substitute_characters(number, DIGIT_MAPPINGS)
        }

        // Parses a formatted phone number
        // and returns `{ country_calling_code, number }`
        // where `number` is the national (significant) phone number.
        //
        // (aka `maybeExtractCountryPhoneCode`)
        //
        function parse_national_number_and_country_calling_code(number, metadata) {
          number = parse_phone_number_digits(number)

          if (!number) {
            return {}
          }

          // If this is not an international phone number,
          // then don't extract country phone code.
          if (number[0] !== '+') {
            return { number: number }
          }

          // Fast abortion: country codes do not begin with a '0'
          if (number[1] === '0') {
            return {}
          }

          // The thing with country phone codes
          // is that they are orthogonal to each other
          // i.e. there's no such country phone code A
          // for which country phone code B exists
          // where B starts with A.
          // Therefore, while scanning digits,
          // if a valid country code is found,
          // that means that it is the country code.
          //
          var i = 2
          while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
            var countryCallingCode = number.slice(1, i)

            if (metadata.countryCallingCodes()[countryCallingCode]) {
              return {
                countryCallingCode: countryCallingCode,
                number: number.slice(i),
              }
            }

            i++
          }

          return {}
        }

        // Checks whether the entire input sequence can be matched
        // against the regular expression.
        function matches_entirely() {
          var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
          var regular_expression = arguments[1]

          if (typeof regular_expression === 'string') {
            regular_expression = '^(?:' + regular_expression + ')$'
          }

          var matched_groups = text.match(regular_expression)
          return matched_groups !== null && matched_groups[0].length === text.length
        }

        // For any character not being part of `replacements`
        // it is removed from the phone number.
        function drop_and_substitute_characters(text, replacements) {
          var replaced = ''

          // Using `.split('')` to iterate through a string here
          // to avoid requiring `Symbol.iterator` polyfill.
          // `.split('')` is generally not safe for Unicode,
          // but in this particular case for `digits` it is safe.
          // for (const character of text)
          for (
            var _iterator = text.split(''),
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var character = _ref

            var replacement = replacements[character.toUpperCase()]

            if (replacement) {
              replaced += replacement
            }
          }

          return replaced
        }

        // The RFC 3966 format for extensions.
        var RFC3966_EXTN_PREFIX = ';ext='

        // Pattern to capture digits used in an extension.
        // Places a maximum length of '7' for an extension.
        var CAPTURING_EXTN_DIGITS = '([' + VALID_DIGITS + ']{1,7})'

        /**
         * Regexp of all possible ways to write extensions, for use when parsing. This
         * will be run as a case-insensitive regexp match. Wide character versions are
         * also provided after each ASCII version. There are three regular expressions
         * here. The first covers RFC 3966 format, where the extension is added using
         * ';ext='. The second more generic one starts with optional white space and
         * ends with an optional full stop (.), followed by zero or more spaces/tabs
         * /commas and then the numbers themselves. The other one covers the special
         * case of American numbers where the extension is written with a hash at the
         * end, such as '- 503#'. Note that the only capturing groups should be around
         * the digits that you want to capture as part of the extension, or else parsing
         * will fail! We allow two options for representing the accented o - the
         * character itself, and one in the unicode decomposed form with the combining
         * acute accent.
         */
        function create_extension_pattern(purpose) {
          // One-character symbols that can be used to indicate an extension.
          var single_extension_characters = 'x\uFF58#\uFF03~\uFF5E'

          switch (purpose) {
            // For parsing, we are slightly more lenient in our interpretation than for matching. Here we
            // allow "comma" and "semicolon" as possible extension indicators. When matching, these are
            case 'parsing':
              single_extension_characters = ',;' + single_extension_characters
          }

          return (
            RFC3966_EXTN_PREFIX +
            CAPTURING_EXTN_DIGITS +
            '|' +
            '[ \xA0\\t,]*' +
            '(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|' +
            '[' +
            single_extension_characters +
            ']|int|anexo|\uFF49\uFF4E\uFF54)' +
            '[:\\.\uFF0E]?[ \xA0\\t,-]*' +
            CAPTURING_EXTN_DIGITS +
            '#?|' +
            '[- ]+([' +
            VALID_DIGITS +
            ']{1,5})#'
          )
        }
        //# sourceMappingURL=common.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/findPhoneNumbers.js':
      /*!*******************************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/findPhoneNumbers.js ***!
  \*******************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.PhoneNumberSearch = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        exports.default = findPhoneNumbers
        exports.searchPhoneNumbers = searchPhoneNumbers
        exports.sort_out_arguments = sort_out_arguments

        var _parse = __webpack_require__(/*! ./parse */ '../node_modules/libphonenumber-js/build/parse.js')

        var _parse2 = _interopRequireDefault(_parse)

        var _metadata = __webpack_require__(/*! ./metadata */ '../node_modules/libphonenumber-js/build/metadata.js')

        var _metadata2 = _interopRequireDefault(_metadata)

        var _common = __webpack_require__(/*! ./common */ '../node_modules/libphonenumber-js/build/common.js')

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true })
          } else {
            obj[key] = value
          }
          return obj
        }

        // Copy-pasted from `./parse.js`.
        var VALID_PHONE_NUMBER =
          '[' +
          _common.PLUS_CHARS +
          ']{0,1}' +
          '(?:' +
          '[' +
          _common.VALID_PUNCTUATION +
          ']*' +
          '[' +
          _common.VALID_DIGITS +
          ']' +
          '){3,}' +
          '[' +
          _common.VALID_PUNCTUATION +
          _common.VALID_DIGITS +
          ']*'

        var EXTN_PATTERNS_FOR_PARSING = (0, _common.create_extension_pattern)('parsing')

        var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + _common.WHITESPACE + ']+')
        var WHITESPACE_IN_THE_END_PATTERN = new RegExp('[' + _common.WHITESPACE + ']+$')

        // // Regular expression for getting opening brackets for a valid number
        // // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
        // const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')

        function findPhoneNumbers(arg_1, arg_2, arg_3, arg_4) {
          var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
            text = _sort_out_arguments.text,
            options = _sort_out_arguments.options,
            metadata = _sort_out_arguments.metadata

          var search = new PhoneNumberSearch(text, options, metadata.metadata)

          var phones = []

          while (search.hasNext()) {
            phones.push(search.next())
          }

          return phones
        }

        /**
         * @return ES6 `for ... of` iterator.
         */
        function searchPhoneNumbers(arg_1, arg_2, arg_3, arg_4) {
          var _sort_out_arguments2 = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
            text = _sort_out_arguments2.text,
            options = _sort_out_arguments2.options,
            metadata = _sort_out_arguments2.metadata

          var search = new PhoneNumberSearch(text, options, metadata.metadata)

          return _defineProperty({}, Symbol.iterator, function () {
            return {
              next: function next() {
                if (search.hasNext()) {
                  return {
                    done: false,
                    value: search.next(),
                  }
                }
                return {
                  done: true,
                }
              },
            }
          })
        }

        /**
         * Extracts a parseable phone number including any opening brackets, etc.
         * @param  {string} text - Input.
         * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
         */

        var PhoneNumberSearch = (exports.PhoneNumberSearch = (function () {
          function PhoneNumberSearch(text) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
            var metadata = arguments[2]

            _classCallCheck(this, PhoneNumberSearch)

            this.state = 'NOT_READY'

            this.text = text
            this.options = options
            this.metadata = metadata

            this.regexp = new RegExp(
              VALID_PHONE_NUMBER +
                // Phone number extensions
                '(?:' +
                EXTN_PATTERNS_FOR_PARSING +
                ')?',
              'ig'
            )

            // this.searching_from = 0
          }
          // Iteration tristate.

          _createClass(PhoneNumberSearch, [
            {
              key: 'find',
              value: function find() {
                var matches = this.regexp.exec(this.text)

                if (!matches) {
                  return
                }

                var number = matches[0]
                var startsAt = matches.index

                number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '')
                startsAt += matches[0].length - number.length
                number = number.replace(WHITESPACE_IN_THE_END_PATTERN, '')

                // // Prepend any opening brackets left behind by the
                // // `PHONE_NUMBER_START_PATTERN` regexp.
                // const text_before_number = text.slice(this.searching_from, startsAt)
                // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
                // if (full_number_starts_at >= 0)
                // {
                // 	number   = text_before_number.slice(full_number_starts_at) + number
                // 	startsAt = full_number_starts_at
                // }
                //
                // this.searching_from = matches.lastIndex

                var result = (0, _parse2.default)(number, { defaultCountry: this.options.defaultCountry }, this.metadata)

                if (result.phone) {
                  result.startsAt = startsAt
                  result.endsAt = startsAt + number.length

                  return result
                }

                // Tail recursion.
                // Try the next one if this one is not a valid phone number.
                return this.find()
              },
            },
            {
              key: 'hasNext',
              value: function hasNext() {
                if (this.state === 'NOT_READY') {
                  this.last_match = this.find()

                  if (this.last_match) {
                    this.state = 'READY'
                  } else {
                    this.state = 'DONE'
                  }
                }

                return this.state === 'READY'
              },
            },
            {
              key: 'next',
              value: function next() {
                // Check the state and find the next match as a side-effect if necessary.
                if (!this.hasNext()) {
                  throw new Error('No next element')
                }

                // Don't retain that memory any longer than necessary.
                var result = this.last_match
                this.last_match = null
                this.state = 'NOT_READY'
                return result
              },
            },
          ])

          return PhoneNumberSearch
        })())

        function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
          var text = void 0
          var options = void 0
          var metadata = void 0

          // If the phone number is passed as a string.
          // `parse('88005553535', ...)`.
          if (typeof arg_1 === 'string') {
            text = arg_1
          } else throw new TypeError('A text for parsing must be a string.')

          // If "default country" argument is being passed
          // then move it to `options`.
          // `findNumbers('88005553535', 'RU', [options], metadata)`.
          if (typeof arg_2 === 'string') {
            if (arg_4) {
              options = _extends({ defaultCountry: arg_2 }, arg_3)
              metadata = arg_4
            } else {
              options = { defaultCountry: arg_2 }
              metadata = arg_3
            }
          }
          // No "default country" argument is being passed.
          // Only international phone numbers are passed.
          // `findNumbers('+78005553535', [options], metadata)`.
          else {
            if (arg_3) {
              options = arg_2
              metadata = arg_3
            } else {
              metadata = arg_2
            }
          }

          // Metadata is required.
          if (!metadata || !metadata.countries) {
            throw new Error('Metadata is required')
          }

          if (!options) {
            options = {}
          }

          // // Apply default options.
          // if (options)
          // {
          // 	options = { ...default_options, ...options }
          // }
          // else
          // {
          // 	options = default_options
          // }

          return { text: text, options: options, metadata: new _metadata2.default(metadata) }
        }
        //# sourceMappingURL=findPhoneNumbers.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/format.js':
      /*!*********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/format.js ***!
  \*********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.FIRST_GROUP_PATTERN = undefined

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          } // This is a port of Google Android `libphonenumber`'s
        // `phonenumberutil.js` of 17th November, 2016.
        //
        // https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

        exports.default = format
        exports.format_national_number_using_format = format_national_number_using_format
        exports.choose_format_for_number = choose_format_for_number
        exports.local_to_international_style = local_to_international_style

        var _common = __webpack_require__(/*! ./common */ '../node_modules/libphonenumber-js/build/common.js')

        var _metadata = __webpack_require__(/*! ./metadata */ '../node_modules/libphonenumber-js/build/metadata.js')

        var _metadata2 = _interopRequireDefault(_metadata)

        var _RFC = __webpack_require__(/*! ./RFC3966 */ '../node_modules/libphonenumber-js/build/RFC3966.js')

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        var default_options = {
          formatExtension: function formatExtension(number, extension) {
            return number + ' ext. ' + extension
          },

          // Formats a phone number
          //
          // Example use cases:
          //
          // ```js
          // format('8005553535', 'RU', 'International')
          // format('8005553535', 'RU', 'International', metadata)
          // format({ phone: '8005553535', country: 'RU' }, 'International')
          // format({ phone: '8005553535', country: 'RU' }, 'International', metadata)
          // format('+78005553535', 'National')
          // format('+78005553535', 'National', metadata)
          // ```
          //
        }
        function format(arg_1, arg_2, arg_3, arg_4, arg_5) {
          var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5),
            input = _sort_out_arguments.input,
            format_type = _sort_out_arguments.format_type,
            options = _sort_out_arguments.options,
            metadata = _sort_out_arguments.metadata

          if (input.country && metadata.hasCountry(input.country)) {
            metadata.country(input.country)
          }

          var _parse_national_numbe = (0, _common.parse_national_number_and_country_calling_code)(input.phone, metadata),
            countryCallingCode = _parse_national_numbe.countryCallingCode,
            number = _parse_national_numbe.number

          countryCallingCode = countryCallingCode || input.countryCallingCode

          if (countryCallingCode) {
            // Check country restriction
            if (input.country && metadata.selectedCountry() && countryCallingCode !== metadata.countryCallingCode()) {
              return input.phone
            }

            metadata.chooseCountryByCountryCallingCode(countryCallingCode)
          }

          if (!metadata.selectedCountry()) {
            return input.phone
          }

          switch (format_type) {
            case 'International':
              if (!number) {
                return '+' + metadata.countryCallingCode()
              }
              number = format_national_number(number, 'International', false, metadata)
              number = '+' + metadata.countryCallingCode() + ' ' + number
              return add_extension(number, input.ext, options.formatExtension)

            case 'E.164':
              // `E.164` doesn't define "phone number extensions".
              return '+' + metadata.countryCallingCode() + input.phone

            case 'RFC3966':
              return (0, _RFC.formatRFC3966)({
                number: '+' + metadata.countryCallingCode() + input.phone,
                ext: input.ext,
              })

            case 'National':
              if (!number) {
                return ''
              }
              number = format_national_number(number, 'National', false, metadata)
              return add_extension(number, input.ext, options.formatExtension)
          }
        }

        // This was originally set to $1 but there are some countries for which the
        // first group is not used in the national pattern (e.g. Argentina) so the $1
        // group does not match correctly.  Therefore, we use \d, so that the first
        // group actually used in the pattern will be matched.
        var FIRST_GROUP_PATTERN = (exports.FIRST_GROUP_PATTERN = /(\$\d)/)

        function format_national_number_using_format(number, format, international, enforce_national_prefix, metadata) {
          var format_pattern_matcher = new RegExp(format.pattern())

          // National prefix is omitted if there's no national prefix formatting rule
          // set for this country, or when this rule is set but
          // national prefix is optional for this phone number format
          // (and it is not enforced explicitly)
          var national_prefix_may_be_omitted =
            !format.nationalPrefixFormattingRule() ||
            (format.nationalPrefixFormattingRule() && format.nationalPrefixIsOptionalWhenFormatting() && !enforce_national_prefix)

          if (!international && !national_prefix_may_be_omitted) {
            return number.replace(
              format_pattern_matcher,
              format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
            )
          }

          var formatted_number = number.replace(format_pattern_matcher, international ? format.internationalFormat() : format.format())

          if (international) {
            return local_to_international_style(formatted_number)
          }

          return formatted_number
        }

        function format_national_number(number, format_as, enforce_national_prefix, metadata) {
          var format = choose_format_for_number(metadata.formats(), number)

          if (!format) {
            return number
          }

          return format_national_number_using_format(number, format, format_as === 'International', enforce_national_prefix, metadata)
        }

        function choose_format_for_number(available_formats, national_number) {
          for (
            var _iterator = available_formats,
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var _format = _ref

            // Validate leading digits
            if (_format.leadingDigitsPatterns().length > 0) {
              // The last leading_digits_pattern is used here, as it is the most detailed
              var last_leading_digits_pattern = _format.leadingDigitsPatterns()[_format.leadingDigitsPatterns().length - 1]

              // If leading digits don't match then move on to the next phone number format
              if (national_number.search(last_leading_digits_pattern) !== 0) {
                continue
              }
            }

            // Check that the national number matches the phone number format regular expression
            if ((0, _common.matches_entirely)(national_number, new RegExp(_format.pattern()))) {
              return _format
            }
          }
        }

        // Removes brackets and replaces dashes with spaces.
        //
        // E.g. "(999) 111-22-33" -> "999 111 22 33"
        //
        function local_to_international_style(local) {
          return local.replace(new RegExp('[' + _common.VALID_PUNCTUATION + ']+', 'g'), ' ').trim()
        }

        // Sort out arguments
        function sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5) {
          var input = void 0
          var format_type = void 0
          var options = void 0
          var metadata = void 0

          // Sort out arguments.

          // If the phone number is passed as a string.
          // `format('8005553535', ...)`.
          if (typeof arg_1 === 'string') {
            // If country code is supplied.
            // `format('8005553535', 'RU', 'National', [options], metadata)`.
            if (typeof arg_3 === 'string') {
              // Will be `parse()`d later in code
              input = {
                phone: arg_1,
                country: arg_2,
              }

              format_type = arg_3

              if (arg_5) {
                options = arg_4
                metadata = arg_5
              } else {
                metadata = arg_4
              }
            }
            // Just an international phone number is supplied
            // `format('+78005553535', 'National', [options], metadata)`.
            else {
              // Will be `parse()`d later in code
              input = {
                phone: arg_1,
              }

              if (typeof arg_2 !== 'string') {
                throw new Error('Format type argument not passed for `format()`')
              }

              format_type = arg_2

              if (arg_4) {
                options = arg_3
                metadata = arg_4
              } else {
                metadata = arg_3
              }
            }
          }
          // If the phone number is passed as a parsed number object.
          // `format({ phone: '8005553535', country: 'RU' }, 'National', [options], metadata)`.
          else if (is_object(arg_1) && typeof arg_1.phone === 'string') {
            input = arg_1
            format_type = arg_2

            if (arg_4) {
              options = arg_3
              metadata = arg_4
            } else {
              metadata = arg_3
            }
          } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.')

          // Metadata is required.
          if (!metadata) {
            throw new Error('Metadata is required')
          }

          // Validate `format_type`.
          switch (format_type) {
            case 'International':
            case 'E.164':
            case 'National':
            case 'RFC3966':
              break
            default:
              throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"')
          }

          // Apply default options.
          if (options) {
            options = _extends({}, default_options, options)
          } else {
            options = default_options
          }

          return { input: input, format_type: format_type, options: options, metadata: new _metadata2.default(metadata) }
        }

        // Babel transforms `typeof` into some "branches"
        // so istanbul will show this as "branch not covered".
        /* istanbul ignore next */
        var is_object = function is_object(_) {
          return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object'
        }

        function add_extension(number, ext, formatExtension) {
          return ext ? formatExtension(number, ext) : number
        }
        //# sourceMappingURL=format.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/getCountryCallingCode.js':
      /*!************************************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/getCountryCallingCode.js ***!
  \************************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        exports.default = function (country, metadata) {
          metadata = new _metadata2.default(metadata)

          if (!metadata.hasCountry(country)) {
            throw new Error('Unknown country: ' + country)
          }

          return metadata.country(country).countryCallingCode()
        }

        var _metadata = __webpack_require__(/*! ./metadata */ '../node_modules/libphonenumber-js/build/metadata.js')

        var _metadata2 = _interopRequireDefault(_metadata)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }
        //# sourceMappingURL=getCountryCallingCode.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/metadata.js':
      /*!***********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/metadata.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _semverCompare = __webpack_require__(/*! semver-compare */ '../node_modules/semver-compare/index.js')

        var _semverCompare2 = _interopRequireDefault(_semverCompare)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        // Added "possibleLengths" and renamed
        // "country_phone_code_to_countries" to "country_calling_codes".
        var V2 = '1.0.18'

        var Metadata = (function () {
          function Metadata(metadata) {
            _classCallCheck(this, Metadata)

            // Metadata is required.
            if (!metadata || !metadata.countries) {
              throw new Error('Metadata is required')
            }

            this.metadata = metadata

            this.v1 = !metadata.version
            this.v2 = metadata.version // && compare(version, V3) === -1
          }

          _createClass(Metadata, [
            {
              key: 'hasCountry',
              value: function hasCountry(country) {
                return this.metadata.countries[country] !== undefined
              },
            },
            {
              key: 'country',
              value: function country(_country) {
                if (!_country) {
                  this._country = undefined
                  this.country_metadata = undefined
                  return this
                }

                if (!this.hasCountry(_country)) {
                  throw new Error('Unknown country: ' + _country)
                }

                this._country = _country
                this.country_metadata = this.metadata.countries[_country]
                return this
              },
            },
            {
              key: 'countryCallingCode',
              value: function countryCallingCode() {
                return this.country_metadata[0]
              },
            },
            {
              key: 'nationalNumberPattern',
              value: function nationalNumberPattern() {
                return this.country_metadata[1]
              },
            },
            {
              key: 'possibleLengths',
              value: function possibleLengths() {
                if (this.v1) return
                return this.country_metadata[2]
              },
            },
            {
              key: 'formats',
              value: function formats() {
                var _this = this

                var formats = this.country_metadata[this.v1 ? 2 : 3] || []
                return formats.map(function (_) {
                  return new Format(_, _this)
                })
              },
            },
            {
              key: 'nationalPrefix',
              value: function nationalPrefix() {
                return this.country_metadata[this.v1 ? 3 : 4]
              },
            },
            {
              key: 'nationalPrefixFormattingRule',
              value: function nationalPrefixFormattingRule() {
                return this.country_metadata[this.v1 ? 4 : 5]
              },
            },
            {
              key: 'nationalPrefixForParsing',
              value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this.country_metadata[this.v1 ? 5 : 6] || this.nationalPrefix()
              },
            },
            {
              key: 'nationalPrefixTransformRule',
              value: function nationalPrefixTransformRule() {
                return this.country_metadata[this.v1 ? 6 : 7]
              },
            },
            {
              key: 'nationalPrefixIsOptionalWhenFormatting',
              value: function nationalPrefixIsOptionalWhenFormatting() {
                return this.country_metadata[this.v1 ? 7 : 8]
              },
            },
            {
              key: 'leadingDigits',
              value: function leadingDigits() {
                return this.country_metadata[this.v1 ? 8 : 9]
              },
            },
            {
              key: 'types',
              value: function types() {
                return this.country_metadata[this.v1 ? 9 : 10]
              },
            },
            {
              key: 'hasTypes',
              value: function hasTypes() {
                return this.types() !== undefined
              },
            },
            {
              key: 'type',
              value: function type(_type) {
                if (this.hasTypes() && getType(this.types(), _type)) {
                  return new Type(getType(this.types(), _type), this)
                }
              },
            },
            {
              key: 'countryCallingCodes',
              value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries
                return this.metadata.country_calling_codes
              },

              // Formatting information for regions which share
              // a country calling code is contained by only one region
              // for performance reasons. For example, for NANPA region
              // ("North American Numbering Plan Administration",
              //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
              // it will be contained in the metadata for `US`.
              //
              // `country_calling_code` is always valid.
              // But the actual country may not necessarily be part of the metadata.
              //
            },
            {
              key: 'chooseCountryByCountryCallingCode',
              value: function chooseCountryByCountryCallingCode(country_calling_code) {
                var country = this.countryCallingCodes()[country_calling_code][0]

                // Do not want to test this case.
                // (custom metadata, not all countries).
                /* istanbul ignore else */
                if (this.hasCountry(country)) {
                  this.country(country)
                }
              },
            },
            {
              key: 'selectedCountry',
              value: function selectedCountry() {
                return this._country
              },
            },
          ])

          return Metadata
        })()

        exports.default = Metadata

        var Format = (function () {
          function Format(format, metadata) {
            _classCallCheck(this, Format)

            this._format = format
            this.metadata = metadata
          }

          _createClass(Format, [
            {
              key: 'pattern',
              value: function pattern() {
                return this._format[0]
              },
            },
            {
              key: 'format',
              value: function format() {
                return this._format[1]
              },
            },
            {
              key: 'leadingDigitsPatterns',
              value: function leadingDigitsPatterns() {
                return this._format[2] || []
              },
            },
            {
              key: 'nationalPrefixFormattingRule',
              value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule()
              },
            },
            {
              key: 'nationalPrefixIsOptionalWhenFormatting',
              value: function nationalPrefixIsOptionalWhenFormatting() {
                return this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormatting()
              },
            },
            {
              key: 'nationalPrefixIsMandatoryWhenFormatting',
              value: function nationalPrefixIsMandatoryWhenFormatting() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return (
                  this.nationalPrefixFormattingRule() &&
                  // Check that national prefix formatting rule is not a dummy one.
                  // Check that national prefix formatting rule actually has national prefix digit(s).
                  this.usesNationalPrefix() &&
                  // Or maybe national prefix is optional for this format
                  !this.nationalPrefixIsOptionalWhenFormatting()
                )
              },

              // Checks whether national prefix formatting rule contains national prefix
            },
            {
              key: 'usesNationalPrefix',
              value: function usesNationalPrefix() {
                // Check that national prefix formatting rule is not a dummy one
                return (
                  this.nationalPrefixFormattingRule() !== '$1' &&
                  // Check that national prefix formatting rule actually has national prefix digit(s)
                  /\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''))
                )
              },
            },
            {
              key: 'internationalFormat',
              value: function internationalFormat() {
                return this._format[5] || this.format()
              },
            },
          ])

          return Format
        })()

        var Type = (function () {
          function Type(type, metadata) {
            _classCallCheck(this, Type)

            this.type = type
            this.metadata = metadata
          }

          _createClass(Type, [
            {
              key: 'pattern',
              value: function pattern() {
                if (this.metadata.v1) return this.type
                return this.type[0]
              },
            },
            {
              key: 'possibleLengths',
              value: function possibleLengths() {
                if (this.metadata.v1) return
                return this.type[1] || this.metadata.possibleLengths()
              },
            },
          ])

          return Type
        })()

        function getType(types, type) {
          switch (type) {
            case 'FIXED_LINE':
              return types[0]
            case 'MOBILE':
              return types[1]
            case 'TOLL_FREE':
              return types[2]
            case 'PREMIUM_RATE':
              return types[3]
            case 'PERSONAL_NUMBER':
              return types[4]
            case 'VOICEMAIL':
              return types[5]
            case 'UAN':
              return types[6]
            case 'PAGER':
              return types[7]
            case 'VOIP':
              return types[8]
            case 'SHARED_COST':
              return types[9]
          }
        }
        //# sourceMappingURL=metadata.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/parse.js':
      /*!********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/parse.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          } // This is a port of Google Android `libphonenumber`'s
        // `phonenumberutil.js` of 17th November, 2016.
        //
        // https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

        exports.default = parse
        exports.is_viable_phone_number = is_viable_phone_number
        exports.extract_formatted_phone_number = extract_formatted_phone_number
        exports.strip_national_prefix_and_carrier_code = strip_national_prefix_and_carrier_code
        exports.find_country_code = find_country_code

        var _common = __webpack_require__(/*! ./common */ '../node_modules/libphonenumber-js/build/common.js')

        var _metadata = __webpack_require__(/*! ./metadata */ '../node_modules/libphonenumber-js/build/metadata.js')

        var _metadata2 = _interopRequireDefault(_metadata)

        var _types = __webpack_require__(/*! ./types */ '../node_modules/libphonenumber-js/build/types.js')

        var _types2 = _interopRequireDefault(_types)

        var _RFC = __webpack_require__(/*! ./RFC3966 */ '../node_modules/libphonenumber-js/build/RFC3966.js')

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        // The minimum length of the national significant number.
        var MIN_LENGTH_FOR_NSN = 2

        // We don't allow input strings for parsing to be longer than 250 chars.
        // This prevents malicious input from consuming CPU.
        var MAX_INPUT_STRING_LENGTH = 250

        /**
         * Regexp of all possible ways to write extensions, for use when parsing. This
         * will be run as a case-insensitive regexp match. Wide character versions are
         * also provided after each ASCII version. There are three regular expressions
         * here. The first covers RFC 3966 format, where the extension is added using
         * ';ext='. The second more generic one starts with optional white space and
         * ends with an optional full stop (.), followed by zero or more spaces/tabs
         * /commas and then the numbers themselves. The other one covers the special
         * case of American numbers where the extension is written with a hash at the
         * end, such as '- 503#'. Note that the only capturing groups should be around
         * the digits that you want to capture as part of the extension, or else parsing
         * will fail! We allow two options for representing the accented o - the
         * character itself, and one in the unicode decomposed form with the combining
         * acute accent.
         */
        var EXTN_PATTERNS_FOR_PARSING = (0, _common.create_extension_pattern)('parsing')

        // Regexp of all known extension prefixes used by different regions followed by
        // 1 or more valid digits, for use when parsing.
        var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i')

        //  Regular expression of viable phone numbers. This is location independent.
        //  Checks we have at least three leading digits, and only valid punctuation,
        //  alpha characters and digits in the phone number. Does not include extension
        //  data. The symbol 'x' is allowed here as valid punctuation since it is often
        //  used as a placeholder for carrier codes, for example in Brazilian phone
        //  numbers. We also allow multiple '+' characters at the start.
        //
        //  Corresponds to the following:
        //  [digits]{minLengthNsn}|
        //  plus_sign*
        //  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
        //
        //  The first reg-ex is to allow short numbers (two digits long) to be parsed if
        //  they are entered as "15" etc, but only if there is no punctuation in them.
        //  The second expression restricts the number of digits to three or more, but
        //  then allows them to be in international form, and to have alpha-characters
        //  and punctuation. We split up the two reg-exes here and combine them when
        //  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
        //  with ^ and append $ to each branch.
        //
        //  "Note VALID_PUNCTUATION starts with a -,
        //   so must be the first in the range" (c) Google devs.
        //  (wtf did they mean by saying that; probably nothing)
        //
        var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + _common.VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'
        //
        // And this is the second reg-exp:
        // (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
        //
        var VALID_PHONE_NUMBER =
          '[' +
          _common.PLUS_CHARS +
          ']{0,1}' +
          '(?:' +
          '[' +
          _common.VALID_PUNCTUATION +
          ']*' +
          '[' +
          _common.VALID_DIGITS +
          ']' +
          '){3,}' +
          '[' +
          _common.VALID_PUNCTUATION +
          _common.VALID_DIGITS +
          ']*'

        // The combined regular expression for valid phone numbers:
        //
        var VALID_PHONE_NUMBER_PATTERN = new RegExp(
          // Either a short two-digit-only phone number
          '^' +
            MIN_LENGTH_PHONE_NUMBER_PATTERN +
            '$' +
            '|' +
            // Or a longer fully parsed phone number (min 3 characters)
            '^' +
            VALID_PHONE_NUMBER +
            // Phone number extensions
            '(?:' +
            EXTN_PATTERNS_FOR_PARSING +
            ')?' +
            '$',
          'i'
        )

        // This consists of the plus symbol, digits, and arabic-indic digits.
        var PHONE_NUMBER_START_PATTERN = new RegExp('[' + _common.PLUS_CHARS + _common.VALID_DIGITS + ']')

        // Regular expression of trailing characters that we want to remove.
        var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + _common.VALID_DIGITS + ']+$')

        var default_options = {
          country: {},

          // `options`:
          //  {
          //    country:
          //    {
          //      restrict - (a two-letter country code)
          //                 the phone number must be in this country
          //
          //      default - (a two-letter country code)
          //                default country to use for phone number parsing and validation
          //                (if no country code could be derived from the phone number)
          //    }
          //  }
          //
          // Returns `{ country, number }`
          //
          // Example use cases:
          //
          // ```js
          // parse('8 (800) 555-35-35', 'RU')
          // parse('8 (800) 555-35-35', 'RU', metadata)
          // parse('8 (800) 555-35-35', { country: { default: 'RU' } })
          // parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
          // parse('+7 800 555 35 35')
          // parse('+7 800 555 35 35', metadata)
          // ```
          //
        }
        function parse(arg_1, arg_2, arg_3, arg_4) {
          var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
            text = _sort_out_arguments.text,
            options = _sort_out_arguments.options,
            metadata = _sort_out_arguments.metadata

          // Validate `defaultCountry`.

          if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
            throw new Error('Unknown country: ' + options.defaultCountry)
          }

          // Parse the phone number.

          var _parse_input = parse_input(text),
            formatted_phone_number = _parse_input.number,
            ext = _parse_input.ext

          // If the phone number is not viable then return nothing.

          if (!formatted_phone_number) {
            return {}
          }

          var _parse_phone_number = parse_phone_number(formatted_phone_number, options.defaultCountry, metadata),
            country = _parse_phone_number.country,
            national_number = _parse_phone_number.national_number,
            countryCallingCode = _parse_phone_number.countryCallingCode,
            carrierCode = _parse_phone_number.carrierCode

          if (!metadata.selectedCountry()) {
            return options.extended ? { countryCallingCode: countryCallingCode } : {}
          }

          // Validate national (significant) number length.
          //
          // A sidenote:
          //
          // They say that sometimes national (significant) numbers
          // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
          // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
          // Such numbers will just be discarded.
          //
          if (national_number.length < MIN_LENGTH_FOR_NSN || national_number.length > _common.MAX_LENGTH_FOR_NSN) {
            // Google's demo just throws an error in this case.
            return {}
          }

          // Check if national phone number pattern matches the number
          // National number pattern is different for each country,
          // even for those ones which are part of the "NANPA" group.
          var valid = country && (0, _common.matches_entirely)(national_number, new RegExp(metadata.nationalNumberPattern())) ? true : false

          if (!options.extended) {
            return valid ? result(country, national_number, ext) : {}
          }

          return {
            country: country,
            countryCallingCode: countryCallingCode,
            carrierCode: carrierCode,
            valid: valid,
            possible: valid
              ? true
              : options.extended === true &&
                metadata.possibleLengths() &&
                is_possible_number(national_number, countryCallingCode !== undefined, metadata),
            phone: national_number,
            ext: ext,
          }
        }

        // Checks to see if the string of characters could possibly be a phone number at
        // all. At the moment, checks to see that the string begins with at least 2
        // digits, ignoring any punctuation commonly found in phone numbers. This method
        // does not require the number to be normalized in advance - but does assume
        // that leading non-number symbols have been removed, such as by the method
        // `extract_possible_number`.
        //
        function is_viable_phone_number(number) {
          return number.length >= MIN_LENGTH_FOR_NSN && (0, _common.matches_entirely)(number, VALID_PHONE_NUMBER_PATTERN)
        }

        /**
         * Extracts a parseable phone number.
         * @param  {string} text - Input.
         * @return {string}.
         */
        function extract_formatted_phone_number(text) {
          if (!text || text.length > MAX_INPUT_STRING_LENGTH) {
            return
          }

          // Attempt to extract a possible number from the string passed in

          var starts_at = text.search(PHONE_NUMBER_START_PATTERN)

          if (starts_at < 0) {
            return
          }

          return (
            text
              // Trim everything to the left of the phone number
              .slice(starts_at)
              // Remove trailing non-numerical characters
              .replace(AFTER_PHONE_NUMBER_END_PATTERN, '')
          )
        }

        // Strips any national prefix (such as 0, 1) present in the number provided.
        // "Carrier codes" are only used  in Colombia and Brazil,
        // and only when dialing within those countries from a mobile phone to a fixed line number.
        function strip_national_prefix_and_carrier_code(number, metadata) {
          if (!number || !metadata.nationalPrefixForParsing()) {
            return { number: number }
          }

          // Attempt to parse the first digits as a national prefix
          var national_prefix_pattern = new RegExp('^(?:' + metadata.nationalPrefixForParsing() + ')')
          var national_prefix_matcher = national_prefix_pattern.exec(number)

          // If no national prefix is present in the phone number,
          // but the national prefix is optional for this country,
          // then consider this phone number valid.
          //
          // Google's reference `libphonenumber` implementation
          // wouldn't recognize such phone numbers as valid,
          // but I think it would perfectly make sense
          // to consider such phone numbers as valid
          // because if a national phone number was originally
          // formatted without the national prefix
          // then it must be parseable back into the original national number.
          // In other words, `parse(format(number))`
          // must always be equal to `number`.
          //
          if (!national_prefix_matcher) {
            return { number: number }
          }

          var national_significant_number = void 0

          // `national_prefix_for_parsing` capturing groups
          // (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
          var captured_groups_count = national_prefix_matcher.length - 1

          // If the national number tranformation is needed then do it.
          //
          // I don't know what did they mean by `&& national_prefix_matcher[captured_groups_count]`.
          // https://github.com/googlei18n/libphonenumber/blob/d978e59c2e6b1ddfb6816cd190e1b62d9a96bc3b/javascript/i18n/phonenumbers/phonenumberutil.js#L3885
          // https://github.com/googlei18n/libphonenumber/blob/d978e59c2e6b1ddfb6816cd190e1b62d9a96bc3b/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2906
          //
          if (metadata.nationalPrefixTransformRule() && national_prefix_matcher[captured_groups_count]) {
            national_significant_number = number.replace(national_prefix_pattern, metadata.nationalPrefixTransformRule())
          }
          // Else, no transformation is necessary,
          // and just strip the national prefix.
          else {
            national_significant_number = number.slice(national_prefix_matcher[0].length)
          }

          var carrierCode = void 0
          if (captured_groups_count > 0) {
            carrierCode = national_prefix_matcher[1]
          }

          // The following is done in `get_country_and_national_number_for_local_number()` instead.
          //
          // // Verify the parsed national (significant) number for this country
          // const national_number_rule = new RegExp(metadata.nationalNumberPattern())
          // //
          // // If the original number (before stripping national prefix) was viable,
          // // and the resultant number is not, then prefer the original phone number.
          // // This is because for some countries (e.g. Russia) the same digit could be both
          // // a national prefix and a leading digit of a valid national phone number,
          // // like `8` is the national prefix for Russia and both
          // // `8 800 555 35 35` and `800 555 35 35` are valid numbers.
          // if (matches_entirely(number, national_number_rule) &&
          // 		!matches_entirely(national_significant_number, national_number_rule))
          // {
          // 	return number
          // }

          // Return the parsed national (significant) number
          return {
            number: national_significant_number,
            carrierCode: carrierCode,
          }
        }

        function find_country_code(country_calling_code, national_phone_number, metadata) {
          // Is always non-empty, because `country_calling_code` is always valid
          var possible_countries = metadata.countryCallingCodes()[country_calling_code]

          // If there's just one country corresponding to the country code,
          // then just return it, without further phone number digits validation.
          if (possible_countries.length === 1) {
            return possible_countries[0]
          }

          var original_country = metadata.selectedCountry()
          var country = _find_country_code(possible_countries, national_phone_number, metadata)
          metadata.country(original_country)
          return country
        }

        // Changes `metadata` `country`.
        function _find_country_code(possible_countries, national_phone_number, metadata) {
          for (
            var _iterator = possible_countries,
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var country = _ref

            metadata.country(country)

            // Leading digits check would be the simplest one
            if (metadata.leadingDigits()) {
              if (national_phone_number && national_phone_number.search(metadata.leadingDigits()) === 0) {
                return country
              }
            }
            // Else perform full validation with all of those
            // fixed-line/mobile/etc regular expressions.
            else if ((0, _types2.default)({ phone: national_phone_number, country: country }, metadata.metadata)) {
              return country
            }
          }
        }

        // Sort out arguments
        function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
          var text = void 0
          var options = void 0
          var metadata = void 0

          // If the phone number is passed as a string.
          // `parse('88005553535', ...)`.
          if (typeof arg_1 === 'string') {
            text = arg_1
          } else throw new TypeError('A phone number for parsing must be a string.')

          // If "default country" argument is being passed
          // then move it to `options`.
          // `parse('88005553535', 'RU', [options], metadata)`.
          if (typeof arg_2 === 'string') {
            if (arg_4) {
              options = _extends({ defaultCountry: arg_2 }, arg_3)
              metadata = arg_4
            } else {
              options = { defaultCountry: arg_2 }
              metadata = arg_3
            }
          }
          // No "default country" argument is being passed.
          // International phone number is passed.
          // `parse('+78005553535', [options], metadata)`.
          else {
            if (arg_3) {
              options = arg_2
              metadata = arg_3
            } else {
              metadata = arg_2
            }
          }

          // Metadata is required.
          if (!metadata || !metadata.countries) {
            throw new Error('Metadata is required')
          }

          // Apply default options.
          if (options) {
            options = _extends({}, default_options, options)
          } else {
            options = default_options
          }

          return { text: text, options: options, metadata: new _metadata2.default(metadata) }
        }

        // Strips any extension (as in, the part of the number dialled after the call is
        // connected, usually indicated with extn, ext, x or similar) from the end of
        // the number, and returns it.
        function strip_extension(number) {
          var start = number.search(EXTN_PATTERN)
          if (start < 0) {
            return {}
          }

          // If we find a potential extension, and the number preceding this is a viable
          // number, we assume it is an extension.
          var number_without_extension = number.slice(0, start)
          /* istanbul ignore if - seems a bit of a redundant check */
          if (!is_viable_phone_number(number_without_extension)) {
            return {}
          }

          var matches = number.match(EXTN_PATTERN)
          var i = 1
          while (i < matches.length) {
            if (matches[i] != null && matches[i].length > 0) {
              return {
                number: number_without_extension,
                ext: matches[i],
              }
            }
            i++
          }
        }

        function is_possible_number(national_number, is_international, metadata) {
          switch ((0, _types.check_number_length_for_type)(national_number, undefined, metadata)) {
            case 'IS_POSSIBLE':
              return true
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            // 	return !is_international
            default:
              return false
          }
        }

        /**
         * @param  {string} text - Input.
         * @return {object} `{ ?number, ?ext }`.
         */
        function parse_input(text) {
          // Parse RFC 3966 phone number URI.
          if (text && text.indexOf('tel:') === 0) {
            return (0, _RFC.parseRFC3966)(text)
          }

          var number = extract_formatted_phone_number(text)

          // If the phone number is not viable, then abort.
          if (!number || !is_viable_phone_number(number)) {
            return {}
          }

          // Attempt to parse extension first, since it doesn't require region-specific
          // data and we want to have the non-normalised number here.
          var with_extension_stripped = strip_extension(number)
          if (with_extension_stripped.ext) {
            return with_extension_stripped
          }

          return { number: number }
        }

        /**
         * Creates `parse()` result object.
         */
        function result(country, national_number, ext) {
          var result = {
            country: country,
            phone: national_number,
          }

          if (ext) {
            result.ext = ext
          }

          return result
        }

        /**
         * Parses a viable phone number.
         * Returns `{ country, countryCallingCode, national_number }`.
         */
        function parse_phone_number(formatted_phone_number, default_country, metadata) {
          var _parse_national_numbe = (0, _common.parse_national_number_and_country_calling_code)(formatted_phone_number, metadata),
            countryCallingCode = _parse_national_numbe.countryCallingCode,
            number = _parse_national_numbe.number

          if (!number) {
            return { countryCallingCode: countryCallingCode }
          }

          var country = void 0

          // Attempt to extract country from international phone number.
          if (countryCallingCode) {
            // Sometimes there are several countries
            // corresponding to the same country phone code
            // (e.g. NANPA countries all having `1` country phone code).
            // Therefore, to reliably determine the exact country,
            // national (significant) number should have been parsed first.
            //
            // When `metadata.json` is generated, all "ambiguous" country phone codes
            // get their countries populated with the full set of
            // "phone number type" regular expressions.
            //
            country = find_country_code(countryCallingCode, number, metadata)

            if (country) {
              metadata.country(country)
            } else {
              // Formatting information for regions which share
              // a country calling code is contained by only one region
              // for performance reasons. For example, for NANPA region
              // ("North American Numbering Plan Administration",
              //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
              // it will be contained in the metadata for `US`.
              metadata.chooseCountryByCountryCallingCode(countryCallingCode)
            }
          } else if (default_country) {
            country = default_country
            metadata.country(country)
            countryCallingCode = metadata.countryCallingCode()
          } else return {}

          // Parsing national prefixes and carrier codes
          // is only required for local phone numbers
          // but some people don't understand that
          // and sometimes write international phone numbers
          // with national prefixes (or maybe even carrier codes).
          // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
          // Google's original library forgives such mistakes
          // and so does this library, because it has been requested:
          // https://github.com/catamphetamine/libphonenumber-js/issues/127

          var _parse_national_numbe2 = parse_national_number(number, metadata),
            national_number = _parse_national_numbe2.national_number,
            carrier_code = _parse_national_numbe2.carrier_code

          return {
            country: country,
            countryCallingCode: countryCallingCode,
            national_number: national_number,
            carrierCode: carrier_code,
          }
        }

        function parse_national_number(number, metadata) {
          var national_number = (0, _common.parse_phone_number_digits)(number)
          var carrier_code = void 0

          // Only strip national prefixes for non-international phone numbers
          // because national prefixes can't be present in international phone numbers.
          // Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
          // first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
          // and then it would assume that's a valid number which it isn't.
          // So no forgiveness for grandmas here.
          // The issue asking for this fix:
          // https://github.com/catamphetamine/libphonenumber-js/issues/159

          var _strip_national_prefi = strip_national_prefix_and_carrier_code(national_number, metadata),
            potential_national_number = _strip_national_prefi.number,
            carrierCode = _strip_national_prefi.carrierCode

          // If metadata has "possible lengths" then employ the new algorythm.

          if (metadata.possibleLengths()) {
            // We require that the NSN remaining after stripping the national prefix and
            // carrier code be long enough to be a possible length for the region.
            // Otherwise, we don't do the stripping, since the original number could be
            // a valid short number.
            switch ((0, _types.check_number_length_for_type)(potential_national_number, undefined, metadata)) {
              case 'TOO_SHORT':
              // case 'IS_POSSIBLE_LOCAL_ONLY':
              case 'INVALID_LENGTH':
                break
              default:
                national_number = potential_national_number
                carrier_code = carrierCode
            }
          } else {
            // If the original number (before stripping national prefix) was viable,
            // and the resultant number is not, then prefer the original phone number.
            // This is because for some countries (e.g. Russia) the same digit could be both
            // a national prefix and a leading digit of a valid national phone number,
            // like `8` is the national prefix for Russia and both
            // `8 800 555 35 35` and `800 555 35 35` are valid numbers.
            if (
              (0, _common.matches_entirely)(national_number, metadata.nationalNumberPattern()) &&
              !(0, _common.matches_entirely)(potential_national_number, metadata.nationalNumberPattern())
            ) {
              // Keep the number without stripping national prefix.
            } else {
              national_number = potential_national_number
              carrier_code = carrierCode
            }
          }

          return {
            national_number: national_number,
            carrier_code: carrier_code,
          }
        }

        // Determines the country for a given (possibly incomplete) phone number.
        // export function get_country_from_phone_number(number, metadata)
        // {
        // 	return parse_phone_number(number, null, metadata).country
        // }
        //# sourceMappingURL=parse.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/types.js':
      /*!********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/types.js ***!
  \********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        exports.default = get_number_type
        exports.is_of_type = is_of_type
        exports.sort_out_arguments = sort_out_arguments
        exports.check_number_length_for_type = check_number_length_for_type
        exports.merge_arrays = merge_arrays

        var _parse = __webpack_require__(/*! ./parse */ '../node_modules/libphonenumber-js/build/parse.js')

        var _parse2 = _interopRequireDefault(_parse)

        var _common = __webpack_require__(/*! ./common */ '../node_modules/libphonenumber-js/build/common.js')

        var _metadata = __webpack_require__(/*! ./metadata */ '../node_modules/libphonenumber-js/build/metadata.js')

        var _metadata2 = _interopRequireDefault(_metadata)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        var non_fixed_line_types = [
          'MOBILE',
          'PREMIUM_RATE',
          'TOLL_FREE',
          'SHARED_COST',
          'VOIP',
          'PERSONAL_NUMBER',
          'PAGER',
          'UAN',
          'VOICEMAIL',
        ]

        // Finds out national phone number type (fixed line, mobile, etc)
        function get_number_type(arg_1, arg_2, arg_3) {
          var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3),
            input = _sort_out_arguments.input,
            metadata = _sort_out_arguments.metadata

          // When no input was passed

          if (!input) {
            return
          }

          // When `parse()` returned `{}`
          // meaning that the phone number is not a valid one.
          if (!input.country) {
            return
          }

          if (!metadata.hasCountry(input.country)) {
            throw new Error('Unknown country: ' + input.country)
          }

          var national_number = input.phone
          metadata.country(input.country)

          // The following is copy-pasted from the original function:
          // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835

          // Is this national number even valid for this country
          if (!(0, _common.matches_entirely)(national_number, metadata.nationalNumberPattern())) {
            return
          }

          // Is it fixed line number
          if (is_of_type(national_number, 'FIXED_LINE', metadata)) {
            // Because duplicate regular expressions are removed
            // to reduce metadata size, if "mobile" pattern is ""
            // then it means it was removed due to being a duplicate of the fixed-line pattern.
            //
            if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
              return 'FIXED_LINE_OR_MOBILE'
            }

            // v1 metadata.
            // Legacy.
            // Deprecated.
            if (!metadata.type('MOBILE')) {
              return 'FIXED_LINE_OR_MOBILE'
            }

            // Check if the number happens to qualify as both fixed line and mobile.
            // (no such country in the minimal metadata set)
            /* istanbul ignore if */
            if (is_of_type(national_number, 'MOBILE', metadata)) {
              return 'FIXED_LINE_OR_MOBILE'
            }

            return 'FIXED_LINE'
          }

          for (
            var _iterator = non_fixed_line_types,
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var _type = _ref

            if (is_of_type(national_number, _type, metadata)) {
              return _type
            }
          }
        }

        function is_of_type(national_number, type, metadata) {
          type = metadata.type(type)

          if (!type || !type.pattern()) {
            return false
          }

          // Check if any possible number lengths are present;
          // if so, we use them to avoid checking
          // the validation pattern if they don't match.
          // If they are absent, this means they match
          // the general description, which we have
          // already checked before a specific number type.
          if (type.possibleLengths() && type.possibleLengths().indexOf(national_number.length) < 0) {
            return false
          }

          return (0, _common.matches_entirely)(national_number, type.pattern())
        }

        // Sort out arguments
        function sort_out_arguments(arg_1, arg_2, arg_3) {
          var input = void 0
          var metadata = void 0

          // If the phone number is passed as a string.
          // `getNumberType('88005553535', ...)`.
          if (typeof arg_1 === 'string') {
            // If "resrict country" argument is being passed
            // then convert it to an `options` object.
            // `getNumberType('88005553535', 'RU', metadata)`.
            if (typeof arg_2 === 'string' || arg_2 === undefined) {
              metadata = arg_3

              // `parse` extracts phone numbers from raw text,
              // therefore it will cut off all "garbage" characters,
              // while this `validate` function needs to verify
              // that the phone number contains no "garbage"
              // therefore the explicit `is_viable_phone_number` check.
              if ((0, _parse.is_viable_phone_number)(arg_1)) {
                input = (0, _parse2.default)(arg_1, arg_2, metadata)
              }
            }
            // No "resrict country" argument is being passed.
            // International phone number is passed.
            // `getNumberType('+78005553535', metadata)`.
            else {
              metadata = arg_2

              // `parse` extracts phone numbers from raw text,
              // therefore it will cut off all "garbage" characters,
              // while this `validate` function needs to verify
              // that the phone number contains no "garbage"
              // therefore the explicit `is_viable_phone_number` check.
              if ((0, _parse.is_viable_phone_number)(arg_1)) {
                input = (0, _parse2.default)(arg_1, metadata)
              }
            }
          }
          // If the phone number is passed as a parsed phone number.
          // `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
          else if (is_object(arg_1) && typeof arg_1.phone === 'string') {
            // The `arg_1` must be a valid phone number
            // as a whole, not just a part of it which gets parsed here.
            if ((0, _parse.is_viable_phone_number)(arg_1.phone)) {
              input = arg_1
            }

            metadata = arg_2
          } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.')

          // Metadata is required.
          if (!metadata || !metadata.countries) {
            throw new Error('Metadata is required')
          }

          return { input: input, metadata: new _metadata2.default(metadata) }
        }

        // Should only be called for the "new" metadata which has "possible lengths".
        function check_number_length_for_type(national_number, type, metadata) {
          var type_info = metadata.type(type)

          // There should always be "<possiblePengths/>" set for every type element.
          // This is declared in the XML schema.
          // For size efficiency, where a sub-description (e.g. fixed-line)
          // has the same "<possiblePengths/>" as the "general description", this is missing,
          // so we fall back to the "general description". Where no numbers of the type
          // exist at all, there is one possible length (-1) which is guaranteed
          // not to match the length of any real phone number.
          var possible_lengths = (type_info && type_info.possibleLengths()) || metadata.possibleLengths()
          // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()

          if (type === 'FIXED_LINE_OR_MOBILE') {
            // No such country in metadata.
            /* istanbul ignore next */
            if (!metadata.type('FIXED_LINE')) {
              // The rare case has been encountered where no fixedLine data is available
              // (true for some non-geographical entities), so we just check mobile.
              return test_number_length_for_type(national_number, 'MOBILE', metadata)
            }

            var mobile_type = metadata.type('MOBILE')

            if (mobile_type) {
              // Merge the mobile data in if there was any. "Concat" creates a new
              // array, it doesn't edit possible_lengths in place, so we don't need a copy.
              // Note that when adding the possible lengths from mobile, we have
              // to again check they aren't empty since if they are this indicates
              // they are the same as the general desc and should be obtained from there.
              possible_lengths = merge_arrays(possible_lengths, mobile_type.possibleLengths())
              // The current list is sorted; we need to merge in the new list and
              // re-sort (duplicates are okay). Sorting isn't so expensive because
              // the lists are very small.

              // if (local_lengths)
              // {
              // 	local_lengths = merge_arrays(local_lengths, mobile_type.possibleLengthsLocal())
              // }
              // else
              // {
              // 	local_lengths = mobile_type.possibleLengthsLocal()
              // }
            }
          }
          // If the type doesn't exist then return 'INVALID_LENGTH'.
          else if (type && !type_info) {
            return 'INVALID_LENGTH'
          }

          var actual_length = national_number.length

          // // This is safe because there is never an overlap beween the possible lengths
          // // and the local-only lengths; this is checked at build time.
          // if (local_lengths && local_lengths.indexOf(national_number.length) >= 0)
          // {
          // 	return 'IS_POSSIBLE_LOCAL_ONLY'
          // }

          var minimum_length = possible_lengths[0]

          if (minimum_length === actual_length) {
            return 'IS_POSSIBLE'
          }

          if (minimum_length > actual_length) {
            return 'TOO_SHORT'
          }

          if (possible_lengths[possible_lengths.length - 1] < actual_length) {
            return 'TOO_LONG'
          }

          // We skip the first element since we've already checked it.
          return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH'
        }

        // Babel transforms `typeof` into some "branches"
        // so istanbul will show this as "branch not covered".
        /* istanbul ignore next */
        var is_object = function is_object(_) {
          return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object'
        }

        function merge_arrays(a, b) {
          var merged = a.slice()

          for (
            var _iterator2 = b,
              _isArray2 = Array.isArray(_iterator2),
              _i2 = 0,
              _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();
            ;

          ) {
            var _ref2

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break
              _ref2 = _iterator2[_i2++]
            } else {
              _i2 = _iterator2.next()
              if (_i2.done) break
              _ref2 = _i2.value
            }

            var element = _ref2

            if (a.indexOf(element) < 0) {
              merged.push(element)
            }
          }

          return merged.sort(function (a, b) {
            return a - b
          })

          // ES6 version, requires Set polyfill.
          // let merged = new Set(a)
          // for (const element of b)
          // {
          // 	merged.add(i)
          // }
          // return Array.from(merged).sort((a, b) => a - b)
        }
        //# sourceMappingURL=types.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/build/validate.js':
      /*!***********************************************************!*\
  !*** ../node_modules/libphonenumber-js/build/validate.js ***!
  \***********************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = is_valid

        var _parse = __webpack_require__(/*! ./parse */ '../node_modules/libphonenumber-js/build/parse.js')

        var _parse2 = _interopRequireDefault(_parse)

        var _types = __webpack_require__(/*! ./types */ '../node_modules/libphonenumber-js/build/types.js')

        var _types2 = _interopRequireDefault(_types)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        // Checks if a given phone number is valid
        //
        // Example use cases:
        //
        // ```js
        // is_valid('8005553535', 'RU')
        // is_valid('8005553535', 'RU', metadata)
        // is_valid({ phone: '8005553535', country: 'RU' })
        // is_valid({ phone: '8005553535', country: 'RU' }, metadata)
        // is_valid('+78005553535')
        // is_valid('+78005553535', metadata)
        // ```
        //
        function is_valid(arg_1, arg_2, arg_3) {
          var _sort_out_arguments = (0, _types.sort_out_arguments)(arg_1, arg_2, arg_3),
            input = _sort_out_arguments.input,
            metadata = _sort_out_arguments.metadata

          if (!input) {
            return false
          }

          if (!input.country) {
            return false
          }

          if (!metadata.hasCountry(input.country)) {
            throw new Error('Unknown country: ' + input.country)
          }

          metadata.country(input.country)

          if (metadata.hasTypes()) {
            return (0, _types2.default)(input, metadata.metadata) !== undefined
          }

          return true
        }
        //# sourceMappingURL=validate.js.map

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/custom.js':
      /*!***************************************************!*\
  !*** ../node_modules/libphonenumber-js/custom.js ***!
  \***************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        exports = module.exports = {}

        // Deprecated: remove `parse()` export in 2.0.0.
        // (renamed to `parseNumber()`)
        exports.parse = __webpack_require__(/*! ./build/parse */ '../node_modules/libphonenumber-js/build/parse.js').default
        exports.parseNumber = __webpack_require__(/*! ./build/parse */ '../node_modules/libphonenumber-js/build/parse.js').default
        // Deprecated: remove `format()` export in 2.0.0.
        // (renamed to `formatNumber()`)
        exports.format = __webpack_require__(/*! ./build/format */ '../node_modules/libphonenumber-js/build/format.js').default
        exports.formatNumber = __webpack_require__(/*! ./build/format */ '../node_modules/libphonenumber-js/build/format.js').default
        exports.getNumberType = __webpack_require__(/*! ./build/types */ '../node_modules/libphonenumber-js/build/types.js').default
        exports.isValidNumber = __webpack_require__(/*! ./build/validate */ '../node_modules/libphonenumber-js/build/validate.js').default
        exports.findPhoneNumbers = __webpack_require__(
          /*! ./build/findPhoneNumbers */ '../node_modules/libphonenumber-js/build/findPhoneNumbers.js'
        ).default
        exports.searchPhoneNumbers = __webpack_require__(
          /*! ./build/findPhoneNumbers */ '../node_modules/libphonenumber-js/build/findPhoneNumbers.js'
        ).searchPhoneNumbers
        exports.PhoneNumberSearch = __webpack_require__(
          /*! ./build/findPhoneNumbers */ '../node_modules/libphonenumber-js/build/findPhoneNumbers.js'
        ).PhoneNumberSearch
        exports.AsYouType = __webpack_require__(/*! ./build/AsYouType */ '../node_modules/libphonenumber-js/build/AsYouType.js').default

        // `DIGITS` are used by `react-phone-number-input`.
        // `DIGIT_PLACEHOLDER` is used by `react-phone-number-input`.
        exports.DIGITS = __webpack_require__(/*! ./build/common */ '../node_modules/libphonenumber-js/build/common.js').DIGIT_MAPPINGS
        exports.DIGIT_PLACEHOLDER = __webpack_require__(
          /*! ./build/AsYouType */ '../node_modules/libphonenumber-js/build/AsYouType.js'
        ).DIGIT_PLACEHOLDER

        exports.getCountryCallingCode = __webpack_require__(
          /*! ./build/getCountryCallingCode */ '../node_modules/libphonenumber-js/build/getCountryCallingCode.js'
        ).default
        // `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.
        exports.getPhoneCode = exports.getCountryCallingCode

        exports.parseRFC3966 = __webpack_require__(/*! ./build/RFC3966 */ '../node_modules/libphonenumber-js/build/RFC3966.js').parseRFC3966
        exports.formatRFC3966 = __webpack_require__(
          /*! ./build/RFC3966 */ '../node_modules/libphonenumber-js/build/RFC3966.js'
        ).formatRFC3966

        exports.Metadata = __webpack_require__(/*! ./build/metadata */ '../node_modules/libphonenumber-js/build/metadata.js').default

        // exports['default'] = ...

        /***/
      },

    /***/ '../node_modules/libphonenumber-js/metadata.min.json':
      /*!***********************************************************!*\
  !*** ../node_modules/libphonenumber-js/metadata.min.json ***!
  \***********************************************************/
      /*! exports provided: version, country_calling_codes, countries, default */
      /***/ function (module) {
        module.exports = JSON.parse(
          '{"version":"1.1.10","country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"800":["001"],"808":["001"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"870":["001"],"878":["001"],"880":["BD"],"881":["001"],"882":["001"],"883":["001"],"886":["TW"],"888":["001"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"979":["001"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","[46]\\\\d{4}|[01589]\\\\d{5}",[5,6]],"AD":["376","[16]\\\\d{5,8}|[37-9]\\\\d{5}",[6,8,9],[["(\\\\d{3})(\\\\d{3})","$1 $2",["[137-9]|6[0-8]"]],["(\\\\d{4})(\\\\d{4})","$1 $2",["180","180[02]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["690"]]]],"AE":["971","[2-79]\\\\d{7,8}|800\\\\d{2,9}",[5,6,7,8,9,10,11,12],[["([2-4679])(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[2-4679][2-8]"]],["(5\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["5"]],["([479]00)(\\\\d)(\\\\d{5})","$1 $2 $3",["[479]00"],"$1"],["([68]00)(\\\\d{2,9})","$1 $2",["[68]00"],"$1"]],"0","0$1"],"AF":["93","[2-7]\\\\d{8}",[9],[["([2-7]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[2-7]"]]],"0","0$1"],"AG":["1","[2589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"268"],"AI":["1","[2589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"264"],"AL":["355","[2-57]\\\\d{7}|6\\\\d{8}|8\\\\d{5,7}|9\\\\d{5}",[6,7,8,9],[["(4)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["4[0-6]"]],["(6\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["6"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"]],["(\\\\d{3})(\\\\d{3,5})","$1 $2",["[235][16-9]|[79]|8[016-9]"]]],"0","0$1"],"AM":["374","[1-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{6})","$1 $2",["1|47"]],["(\\\\d{2})(\\\\d{6})","$1 $2",["4[1349]|[5-7]|88|9[1-9]"],"0$1"],["(\\\\d{3})(\\\\d{5})","$1 $2",["[23]"]],["(\\\\d{3})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["8|90"],"0 $1"]],"0","(0$1)"],"AO":["244","[29]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3"]]],"AR":["54","11\\\\d{8}|[2368]\\\\d{9}|9\\\\d{10}",[10,11],[["([68]\\\\d{2})(\\\\d{3})(\\\\d{4})","$1-$2-$3",["[68]"]],["(9)(11)(\\\\d{4})(\\\\d{4})","$2 15-$3-$4",["911"],null,null,"$1 $2 $3-$4"],["(9)(\\\\d{3})(\\\\d{3})(\\\\d{4})","$2 15-$3-$4",["9(?:2[2-4689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],null,null,"$1 $2 $3-$4"],["(9)(\\\\d{4})(\\\\d{2})(\\\\d{4})","$2 15-$3-$4",["9[23]"],null,null,"$1 $2 $3-$4"],["(11)(\\\\d{4})(\\\\d{4})","$1 $2-$3",["11"],null,"true"],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],null,"true"],["(\\\\d{4})(\\\\d{2})(\\\\d{4})","$1 $2-$3",["[23]"],null,"true"]],"0","0$1","0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1"],"AS":["1","[5689]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"684"],"AT":["43","[1-9]\\\\d{3,12}",[4,5,6,7,8,9,10,11,12,13],[["(116\\\\d{3})","$1",["116"],"$1"],["(1)(\\\\d{3,12})","$1 $2",["1"]],["(5\\\\d)(\\\\d{3,5})","$1 $2",["5[079]"]],["(5\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["5[079]"]],["(5\\\\d)(\\\\d{4})(\\\\d{4,7})","$1 $2 $3",["5[079]"]],["(\\\\d{3})(\\\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"]],["(\\\\d{4})(\\\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"]]],"0","0$1"],"AU":["61","1\\\\d{4,9}|[2-578]\\\\d{8}",[5,6,7,8,9,10],[["([2378])(\\\\d{4})(\\\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\\\d{3})(\\\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\\\d{3})","$1 $2",["180","1802"]],["(19\\\\d)(\\\\d{3})","$1 $2",["19[13]"]],["(19\\\\d{2})(\\\\d{4})","$1 $2",["19[679]"]],["(13)(\\\\d{2})(\\\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,[["[237]\\\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\\\d|4[0-4]))|[6-8]\\\\d{4}|9(?:[02-9]\\\\d{3}|1(?:[0-57-9]\\\\d{2}|6[0135-9]\\\\d)))\\\\d{3}",[9]],["14(?:5\\\\d|71)\\\\d{5}|4(?:[0-3]\\\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\\\d{6}",[9]],["180(?:0\\\\d{3}|2)\\\\d{3}",[7,10]],["19(?:0[0126]\\\\d|[679])\\\\d{5}",[8,10]],["500\\\\d{6}",[9]],null,null,["16\\\\d{3,7}",[5,6,7,8,9]],["550\\\\d{6}",[9]],["13(?:00\\\\d{3}|45[0-4]|\\\\d)\\\\d{3}",[6,8,10]]]],"AW":["297","[25-9]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"AX":["358","1\\\\d{5,11}|[35]\\\\d{5,9}|2\\\\d{4,9}|4\\\\d{5,10}|6\\\\d{7,9}|7\\\\d{4,9}|8\\\\d{6,9}",[5,6,7,8,9,10,11,12],[["(\\\\d{3})(\\\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(75\\\\d{3})","$1",["75[12]"]],["(116\\\\d{3})","$1",["116"],"$1"],["(\\\\d{2})(\\\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\\\d)(\\\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0",null,null,null,null,null,[["18[1-8]\\\\d{3,9}",[6,7,8,9,10,11,12]],["4\\\\d{5,10}|50\\\\d{4,8}",[6,7,8,9,10,11]],["800\\\\d{4,7}",[7,8,9,10]],["[67]00\\\\d{5,6}",[8,9]],null,null,["[13]0\\\\d{4,8}|2(?:0(?:[016-8]\\\\d{3,7}|[2-59]\\\\d{2,7})|9\\\\d{4,8})|60(?:[12]\\\\d{5,6}|6\\\\d{7})|7(?:1\\\\d{7}|3\\\\d{8}|5[03-9]\\\\d{2,7})",[5,6,7,8,9,10]]]],"AZ":["994","[1-9]\\\\d{8}",[9],[["(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["1[28]|2(?:[0-36]|[45]2)|365"]],["(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[4-8]"],"0$1"],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],"0","(0$1)"],"BA":["387","[3-9]\\\\d{7,8}",[8,9],[["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2-$3",["[3-5]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3 $4",["6[047]"]]],"0","0$1"],"BB":["1","[2589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"246"],"BD":["880","[2-79]\\\\d{5,9}|1\\\\d{9}|8[0-7]\\\\d{4,8}",[6,7,8,9,10],[["(2)(\\\\d{7,8})","$1-$2",["2"]],["(\\\\d{2})(\\\\d{4,6})","$1-$2",["[3-79]1"]],["(\\\\d{4})(\\\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[01367])"]],["(\\\\d{3})(\\\\d{3,7})","$1-$2",["[3-79][2-9]|8"]]],"0","0$1"],"BE":["32","[1-9]\\\\d{7,8}",[8,9],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["4[5-9]"]],["(\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"]],["(\\\\d{3})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["(?:80|9)0"]]],"0","0$1"],"BF":["226","[25-7]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"BG":["359","[23567]\\\\d{5,7}|[489]\\\\d{6,8}",[6,7,8,9],[["(2)(\\\\d)(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["2"]],["(2)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["2"]],["(\\\\d{3})(\\\\d{4})","$1 $2",["43[124-7]|70[1-9]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"]],["(\\\\d{3})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["[78]00"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["99[69]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"]]],"0","0$1"],"BH":["973","[136-9]\\\\d{7}",[8],[["(\\\\d{4})(\\\\d{4})","$1 $2"]]],"BI":["257","[267]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"BJ":["229","[2689]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[2689]"]]]],"BL":["590","[56]\\\\d{8}",[9],[["([56]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["590|69[01]"]]],"0",null,null,null,null,null,[["590(?:2[7-9]|5[12]|87)\\\\d{4}"],["69(?:0\\\\d{2}|1(?:2[29]|3[0-5]))\\\\d{4}"]]],"BM":["1","[4589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"441"],"BN":["673","[2-578]\\\\d{6}",[7],[["([2-578]\\\\d{2})(\\\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","[23467]\\\\d{7}|8\\\\d{8}",[8,9],[["([234])(\\\\d{7})","$1 $2",["[2-4]"]],["([67]\\\\d{7})","$1",["[67]"]],["(800)(\\\\d{2})(\\\\d{4})","$1 $2 $3",["800"]]],"0",null,"0(1\\\\d)?"],"BQ":["599","[347]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[13-7]"]],["(9)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,[["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\\\d)\\\\d{3}"],["(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\\\d|9[056])\\\\d)\\\\d{3}"]]],"BR":["55","[1-46-9]\\\\d{7,10}|5(?:[0-4]\\\\d{7,9}|5(?:[2-8]\\\\d{7}|9\\\\d{7,8}))",[8,9,10,11],[["(\\\\d{4})(\\\\d{4})","$1-$2",["300|40[02]","300|40(?:0|20)"]],["([3589]00)(\\\\d{2,3})(\\\\d{4})","$1 $2 $3",["[3589]00"],"0$1"],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)"],["(\\\\d{2})(\\\\d{5})(\\\\d{4})","$1 $2-$3",["[1-9][1-9]9"],"($1)"]],"0",null,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\\\d{10,11}))?","$2"],"BS":["1","[2589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"242"],"BT":["975","[1-8]\\\\d{6,7}",[7,8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["1|77"]],["([2-8])(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[2-68]|7[246]"]]]],"BW":["267","[2-79]\\\\d{6,7}",[7,8],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[2-6]"]],["(7\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["7"]],["(90)(\\\\d{5})","$1 $2",["90"]]]],"BY":["375","[1-4]\\\\d{8}|8(?:0(?:0\\\\d{3,7}|[13]\\\\d{7})|(?:10|20\\\\d)\\\\d{7})|9\\\\d{9,10}",[6,7,8,9,10,11],[["(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],["(\\\\d{4})(\\\\d{2})(\\\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["([89]\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],["(82\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["82"],"8 $1"],["(800)(\\\\d{3})","$1 $2",["800"],"8 $1"],["(800)(\\\\d{2})(\\\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],"8",null,"8?0?"],"BZ":["501","[2-8]\\\\d{6}|0\\\\d{10}",[7,11],[["(\\\\d{3})(\\\\d{4})","$1-$2",["[2-8]"]],["(0)(800)(\\\\d{4})(\\\\d{3})","$1-$2-$3-$4",["080","0800"]]]],"CA":["1","[2-9]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,null,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\\\d{6}"],["900[2-9]\\\\d{6}"],["5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\\\d{6}"]]],"CC":["61","[1458]\\\\d{5,9}",[6,7,8,9,10],[["([2378])(\\\\d{4})(\\\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\\\d{3})(\\\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\\\d{3})","$1 $2",["180","1802"]],["(19\\\\d)(\\\\d{3})","$1 $2",["19[13]"]],["(19\\\\d{2})(\\\\d{4})","$1 $2",["19[679]"]],["(13)(\\\\d{2})(\\\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,[["8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:08|22|68)|4[29]8|62\\\\d|70[23]|959))\\\\d{3}",[9]],["14(?:5\\\\d|71)\\\\d{5}|4(?:[0-3]\\\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\\\d{6}",[9]],["180(?:0\\\\d{3}|2)\\\\d{3}",[7,10]],["19(?:0[0126]\\\\d|[679])\\\\d{5}",[8,10]],["500\\\\d{6}",[9]],null,null,null,["550\\\\d{6}",[9]],["13(?:00\\\\d{2})?\\\\d{4}",[6,10]]]],"CD":["243","[2-6]\\\\d{6}|[18]\\\\d{6,8}|9\\\\d{8}",[7,9],[["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["12"]],["([89]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["8[0-2459]|9"]],["(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["88"]],["(\\\\d{2})(\\\\d{5})","$1 $2",["[1-6]"]]],"0","0$1"],"CF":["236","[278]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"CG":["242","[028]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["801"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[02]"]],["(\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["800"]]]],"CH":["41","[2-9]\\\\d{8}|860\\\\d{9}",[9],[["([2-9]\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"]],["([89]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["8[047]|90"]],["(\\\\d{3})(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4 $5",["860"]]],"0","0$1"],"CI":["225","[02-8]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"CK":["682","[2-8]\\\\d{4}",[5],[["(\\\\d{2})(\\\\d{3})","$1 $2"]]],"CL":["56","1230\\\\d{7}|[2-46-9]\\\\d{8,10}|5[1-3578]\\\\d{7}",[9,10,11],[["(\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["2[23]"],"($1)"],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(9)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["9"]],["(44)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["44"]],["([68]00)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[68]00"]],["(600)(\\\\d{3})(\\\\d{2})(\\\\d{3})","$1 $2 $3 $4",["600"]],["(1230)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["123","1230"]],["(\\\\d{5})(\\\\d{4})","$1 $2",["219"],"($1)"]]],"CM":["237","[2368]\\\\d{7,8}",[8,9],[["([26])(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4 $5",["[26]"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[23]|88"]]]],"CN":["86","[1-7]\\\\d{6,11}|8[0-357-9]\\\\d{6,9}|9\\\\d{7,10}",[7,8,9,10,11,12],[["([48]00)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[48]00"]],["(\\\\d{2})(\\\\d{5,6})","$1 $2",["(?:10|2\\\\d)[19]","(?:10|2\\\\d)(?:10|9[56])","(?:10|2\\\\d)(?:100|9[56])"],"0$1"],["(\\\\d{3})(\\\\d{5,6})","$1 $2",["[3-9]","[3-9]\\\\d\\\\d[19]","[3-9]\\\\d\\\\d(?:10|9[56])"],"0$1"],["(21)(\\\\d{4})(\\\\d{4,6})","$1 $2 $3",["21"],"0$1","true"],["([12]\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"],"0$1","true"],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","true"],["(\\\\d{3})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"],"0$1","true"],["(\\\\d{4})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["807","8078"],"0$1","true"],["(\\\\d{3})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["1(?:[3-57-9]|66)"]],["(10800)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["108","1080","10800"]],["(\\\\d{3})(\\\\d{7,8})","$1 $2",["950"]]],"0",null,"(1(?:[12]\\\\d{3}|79\\\\d{2}|9[0-7]\\\\d{2}))|0"],"CO":["57","(?:[13]\\\\d{0,3}|[24-8])\\\\d{7}",[8,10,11],[["(\\\\d)(\\\\d{7})","$1 $2",["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]","1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"],"($1)"],["(\\\\d{3})(\\\\d{7})","$1 $2",["3"]],["(1)(\\\\d{3})(\\\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1",null,"$1 $2 $3"]],"0",null,"0([3579]|4(?:44|56))?"],"CR":["506","[24-9]\\\\d{7,9}",[8,10],[["(\\\\d{4})(\\\\d{4})","$1 $2",["[24-7]|8[3-9]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1-$2-$3",["[89]0"]]],null,null,"(19(?:0[012468]|1[09]|20|66|77|99))"],"CU":["53","[2-57]\\\\d{5,7}",[6,7,8],[["(\\\\d)(\\\\d{6,7})","$1 $2",["7"]],["(\\\\d{2})(\\\\d{4,6})","$1 $2",["[2-4]"]],["(\\\\d)(\\\\d{7})","$1 $2",["5"],"0$1"]],"0","(0$1)"],"CV":["238","[2-59]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3"]]],"CW":["599","[134679]\\\\d{6,7}",[7,8],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[13-7]"]],["(9)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,[["9(?:[48]\\\\d{2}|50\\\\d|7(?:2[0-24]|[34]\\\\d|6[35-7]|77|8[7-9]))\\\\d{4}",[8]],["9(?:5(?:[12467]\\\\d|3[01])|6(?:[15-9]\\\\d|3[01]))\\\\d{4}",[8]],null,null,null,null,null,["955\\\\d{5}",[8]],null,["60[0-2]\\\\d{4}",[7]]]],"CX":["61","[1458]\\\\d{5,9}",[6,7,8,9,10],[["([2378])(\\\\d{4})(\\\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\\\d{3})(\\\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\\\d{3})","$1 $2",["180","1802"]],["(19\\\\d)(\\\\d{3})","$1 $2",["19[13]"]],["(19\\\\d{2})(\\\\d{4})","$1 $2",["19[679]"]],["(13)(\\\\d{2})(\\\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,[["8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:21|49|78|81)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\\\d|7(?:0[01]|1[0-2])|958))\\\\d{3}",[9]],["14(?:5\\\\d|71)\\\\d{5}|4(?:[0-3]\\\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\\\d{6}",[9]],["180(?:0\\\\d{3}|2)\\\\d{3}",[7,10]],["19(?:0[0126]\\\\d|[679])\\\\d{5}",[8,10]],["500\\\\d{6}",[9]],null,null,null,["550\\\\d{6}",[9]],["13(?:00\\\\d{2})?\\\\d{4}",[6,8,10]]]],"CY":["357","[257-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{6})","$1 $2"]]],"CZ":["420","[2-8]\\\\d{8}|9\\\\d{8,11}",[9],[["([2-9]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(96\\\\d)(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["96"]],["(9\\\\d)(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["9[36]"]]]],"DE":["49","[1-35-9]\\\\d{3,14}|4(?:[0-8]\\\\d{3,12}|9(?:[0-37]\\\\d|4(?:[1-35-8]|4\\\\d?)|5\\\\d{1,2}|6[1-8]\\\\d?)\\\\d{2,8})",[4,5,6,7,8,9,10,11,12,13,14,15],[["(1\\\\d{2})(\\\\d{7,8})","$1 $2",["1[67]"]],["(15\\\\d{3})(\\\\d{6})","$1 $2",["15[0568]"]],["(1\\\\d{3})(\\\\d{7})","$1 $2",["15"]],["(\\\\d{2})(\\\\d{3,11})","$1 $2",["3[02]|40|[68]9"]],["(\\\\d{3})(\\\\d{3,11})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)","2(?:0[1-389]|1(?:[14]|2[0-8])|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"]],["(\\\\d{4})(\\\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[13468]|8[13568])|6(?:0[1356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"]],["(3\\\\d{4})(\\\\d{1,10})","$1 $2",["3"]],["(800)(\\\\d{7,12})","$1 $2",["800"]],["(\\\\d{3})(\\\\d)(\\\\d{4,10})","$1 $2 $3",["1(?:37|80)|900","1(?:37|80)|900[1359]"]],["(1\\\\d{2})(\\\\d{5,11})","$1 $2",["181"]],["(18\\\\d{3})(\\\\d{6})","$1 $2",["185","1850","18500"]],["(18\\\\d{2})(\\\\d{7})","$1 $2",["18[68]"]],["(18\\\\d)(\\\\d{8})","$1 $2",["18[2-579]"]],["(700)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["700"]],["(138)(\\\\d{4})","$1 $2",["138"]],["(15[013-68])(\\\\d{2})(\\\\d{8})","$1 $2 $3",["15[013-68]"]],["(15[279]\\\\d)(\\\\d{2})(\\\\d{7})","$1 $2 $3",["15[279]"]],["(1[67]\\\\d)(\\\\d{2})(\\\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"]]],"0","0$1"],"DJ":["253","[27]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"DK":["45","[2-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"DM":["1","[57-9]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"767"],"DO":["1","[589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"8[024]9"],"DZ":["213","(?:[1-4]|[5-9]\\\\d)\\\\d{7}",[8,9],[["([1-4]\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[1-4]"]],["([5-8]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[5-8]"]],["(9\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["9"]]],"0","0$1"],"EC":["593","1\\\\d{9,10}|[2-8]\\\\d{7}|9\\\\d{8}",[8,9,10,11],[["(\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],null,null,"$1-$2-$3"],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["9"],"0$1"],["(1800)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["180","1800"],"$1"]],"0","(0$1)"],"EE":["372","[3-9]\\\\d{6,7}|800\\\\d{6,7}",[7,8,10],[["([3-79]\\\\d{2})(\\\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],["(70)(\\\\d{2})(\\\\d{4})","$1 $2 $3",["70"]],["(8000)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["800","8000"]],["([458]\\\\d{3})(\\\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"]]]],"EG":["20","1\\\\d{4,9}|[24-6]\\\\d{8}|3\\\\d{7}|[89]\\\\d{8,9}",[8,9,10],[["(\\\\d)(\\\\d{7,8})","$1 $2",["[23]"]],["(\\\\d{2})(\\\\d{6,7})","$1 $2",["1(?:3|5[239])|[4-6]|[89][2-9]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1[0-25]|[89]00"]]],"0","0$1"],"EH":["212","[5-9]\\\\d{8}",[9],[["([5-7]\\\\d{2})(\\\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\\\d{3})(\\\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\\\d{4})(\\\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0",null,null,null,null,"528[89]"],"ER":["291","[178]\\\\d{6}",[7],[["(\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3"]],"0","0$1"],"ES":["34","[5-9]\\\\d{8}",[9],[["([89]00)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[89]00"]],["([5-9]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"]]]],"ET":["251","[1-59]\\\\d{8}",[9],[["([1-59]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[1-59]"]]],"0","0$1"],"FI":["358","1\\\\d{4,11}|[2-9]\\\\d{4,10}",[5,6,7,8,9,10,11,12],[["(\\\\d{3})(\\\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(75\\\\d{3})","$1",["75[12]"]],["(116\\\\d{3})","$1",["116"],"$1"],["(\\\\d{2})(\\\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\\\d)(\\\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0","0$1",null,null,null,null,[["1(?:[3569][1-8]\\\\d{3,9}|[47]\\\\d{5,10})|2[1-8]\\\\d{3,9}|3(?:[1-8]\\\\d{3,9}|9\\\\d{4,8})|[5689][1-8]\\\\d{3,9}"],["4(?:[0-8]\\\\d{4,9}|9\\\\d{3,8})|50\\\\d{4,8}",[6,7,8,9,10,11]],["800\\\\d{4,7}",[7,8,9,10]],["[67]00\\\\d{5,6}",[8,9]],null,null,["[13]0\\\\d{4,8}|2(?:0(?:[016-8]\\\\d{3,7}|[2-59]\\\\d{2,7})|9\\\\d{4,8})|60(?:[12]\\\\d{5,6}|6\\\\d{7})|7(?:1\\\\d{7}|3\\\\d{8}|5[03-9]\\\\d{3,7})",[5,6,7,8,9,10]]]],"FJ":["679","[2-9]\\\\d{6}|0\\\\d{10}",[7,11],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[2-9]"]],["(\\\\d{4})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["0"]]]],"FK":["500","[2-7]\\\\d{4}",[5]],"FM":["691","[39]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"FO":["298","[2-9]\\\\d{5}",[6],[["(\\\\d{6})","$1"]],null,null,"(10(?:01|[12]0|88))"],"FR":["33","[1-9]\\\\d{8}",[9],[["([1-79])(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4 $5",["[1-79]"]],["(8\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],"0","0$1"],"GA":["241","0?\\\\d{7}",[7,8],[["(\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["0"]]]],"GB":["44","\\\\d{7,10}",[7,9,10],[["(7\\\\d{3})(\\\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\\\d{5})(\\\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\\\d{3})(\\\\d{5,6})","$1 $2",["1"]],["(800)(\\\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["80"]],["(800)(\\\\d{6})","$1 $2",["800"]]],"0","0$1",null,null,null,null,[["2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\\\d)\\\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\\\d)|3(?:0\\\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\\\d|9[2-57]))\\\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\\\d)|276\\\\d|6(?:26[06-9]|686))|6(?:06(?:4\\\\d|7[4-79])|295[567]|35[34]\\\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\\\d{3}|176888[2-46-8]\\\\d{2}|16977[23]\\\\d{3}",[9,10]],["7(?:[1-3]\\\\d{3}|4(?:[0-46-9]\\\\d{2}|5(?:[0-689]\\\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\\\d|2[0-35-9])\\\\d|7(?:0(?:0[01]|[1-9]\\\\d)|[1-7]\\\\d{2}|8[02-9]\\\\d|9[0-689]\\\\d)|8(?:[014-9]\\\\d|[23][0-8])\\\\d|9(?:[024-9]\\\\d{2}|1(?:[02-9]\\\\d|1[028])|3[0-689]\\\\d))\\\\d{5}",[10]],["80(?:0(?:1111|\\\\d{6,7})|8\\\\d{7})"],["(?:87[123]|9(?:[01]\\\\d|8[2349]))\\\\d{7}",[10]],["70\\\\d{8}",[10]],null,["(?:3[0347]|55)\\\\d{8}",[10]],["76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\\\d{6}",[10]],["56\\\\d{8}",[10]],["8(?:4(?:5464\\\\d|[2-5]\\\\d{7})|70\\\\d{7})",[7,10]]]],"GD":["1","[4589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"473"],"GE":["995","[34578]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["7"],"0$1"],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["5"]]],"0"],"GF":["594","[56]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"GG":["44","[135789]\\\\d{6,9}",[7,9,10],[["(7\\\\d{3})(\\\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\\\d{5})(\\\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\\\d{3})(\\\\d{5,6})","$1 $2",["1"]],["(800)(\\\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["80"]],["(800)(\\\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,[["1481[25-9]\\\\d{5}",[10]],["7(?:781\\\\d|839\\\\d|911[17])\\\\d{5}",[10]],["80(?:0(?:1111|\\\\d{6,7})|8\\\\d{7})"],["(?:87[123]|9(?:[01]\\\\d|8[0-3]))\\\\d{7}",[10]],["70\\\\d{8}",[10]],null,["(?:3[0347]|55)\\\\d{8}",[10]],["76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\\\d{6}",[10]],["56\\\\d{8}",[10]],["8(?:4(?:5464\\\\d|[2-5]\\\\d{7})|70\\\\d{7})",[7,10]]]],"GH":["233","[235]\\\\d{8}|8\\\\d{7}",[8,9],[["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[235]"]],["(\\\\d{3})(\\\\d{5})","$1 $2",["8"]]],"0","0$1"],"GI":["350","[256]\\\\d{7}",[8],[["(\\\\d{3})(\\\\d{5})","$1 $2",["2"]]]],"GL":["299","[1-689]\\\\d{5}",[6],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3"]]],"GM":["220","[2-9]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"GN":["224","[367]\\\\d{7,8}",[8,9],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["3"]],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","[56]\\\\d{8}",[9],[["([56]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["590|69[01]"]]],"0","0$1",null,null,null,null,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\\\d)\\\\d{4}"],["69(?:0\\\\d{2}|1(?:2[29]|3[0-5]))\\\\d{4}"]]],"GQ":["240","[23589]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[235]"]],["(\\\\d{3})(\\\\d{6})","$1 $2",["[89]"]]]],"GR":["30","[26-9]\\\\d{9}",[10],[["([27]\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["21|7"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["2[2-9]1|[689]"]],["(2\\\\d{3})(\\\\d{6})","$1 $2",["2[2-9][02-9]"]]]],"GT":["502","[2-7]\\\\d{7}|1[89]\\\\d{9}",[8,11],[["(\\\\d{4})(\\\\d{4})","$1 $2",["[2-7]"]],["(\\\\d{4})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","[5689]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"671"],"GW":["245","(?:4(?:0\\\\d{5}|4\\\\d{7})|9\\\\d{8})",[7,9],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["44|9[5-7]"]],["(\\\\d{3})(\\\\d{4})","$1 $2",["40"]]]],"GY":["592","[2-46-9]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"HK":["852","[2-7]\\\\d{7}|8[0-3]\\\\d{6,7}|9\\\\d{4,10}",[5,6,7,8,9,11],[["(\\\\d{4})(\\\\d{4})","$1 $2",["[2-7]|[89](?:0[1-9]|[1-9])"]],["(800)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["800"]],["(900)(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["900"]],["(900)(\\\\d{2,5})","$1 $2",["900"]]]],"HN":["504","[237-9]\\\\d{7}",[8],[["(\\\\d{4})(\\\\d{4})","$1-$2"]]],"HR":["385","[1-7]\\\\d{5,8}|[89]\\\\d{6,8}",[6,7,8,9],[["(1)(\\\\d{4})(\\\\d{3})","$1 $2 $3",["1"]],["([2-5]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[2-5]"]],["(9\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["9"]],["(6[01])(\\\\d{2})(\\\\d{2,3})","$1 $2 $3",["6[01]"]],["([67]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[67]"]],["(80[01])(\\\\d{2})(\\\\d{2,3})","$1 $2 $3",["80[01]"]],["(80[01])(\\\\d{3})(\\\\d{3})","$1 $2 $3",["80[01]"]]],"0","0$1"],"HT":["509","[2-489]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{4})","$1 $2 $3"]]],"HU":["36","[1-9]\\\\d{7,8}",[8,9],[["(1)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[2-9]"]]],"06","($1)"],"ID":["62","(?:[1-79]\\\\d{6,10}|8\\\\d{7,11})",[7,8,9,10,11,12],[["(\\\\d{2})(\\\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\\\d{3})(\\\\d{5,8})","$1 $2",["2[035-9]|[36][02-9]|[4579]"],"(0$1)"],["(8\\\\d{2})(\\\\d{3,4})(\\\\d{3})","$1-$2-$3",["8[1-35-9]"]],["(8\\\\d{2})(\\\\d{4})(\\\\d{4,5})","$1-$2-$3",["8[1-35-9]"]],["(1)(500)(\\\\d{3})","$1 $2 $3",["150","1500"],"$1"],["(177)(\\\\d{6,8})","$1 $2",["177"]],["(800)(\\\\d{5,7})","$1 $2",["800"]],["(804)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["804"]],["(80\\\\d)(\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["80[79]"]]],"0","0$1"],"IE":["353","[124-9]\\\\d{6,9}",[7,8,9,10],[["(1)(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["1"]],["(\\\\d{2})(\\\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"]],["(\\\\d{3})(\\\\d{5})","$1 $2",["40[24]|50[45]"]],["(48)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["48"]],["(818)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["818"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],["(8\\\\d)(\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3 $4",["8[35-9]5"],"0$1"],["(700)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["700"],"0$1"],["(\\\\d{4})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1(?:5|8[059])","1(?:5|8[059]0)"],"$1"]],"0","(0$1)"],"IL":["972","1\\\\d{6,11}|[2-589]\\\\d{3}(?:\\\\d{3,6})?|6\\\\d{3}|7\\\\d{6,9}",[4,7,8,9,10,11,12],[["([2-489])(\\\\d{3})(\\\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["([57]\\\\d)(\\\\d{3})(\\\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(153)(\\\\d{1,2})(\\\\d{3})(\\\\d{4})","$1 $2 $3 $4",["153"]],["(1)([7-9]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(1255)(\\\\d{3})","$1-$2",["125","1255"]],["(1200)(\\\\d{3})(\\\\d{3})","$1-$2-$3",["120","1200"]],["(1212)(\\\\d{2})(\\\\d{2})","$1-$2-$3",["121","1212"]],["(1599)(\\\\d{6})","$1-$2",["159","1599"]],["(151)(\\\\d{1,2})(\\\\d{3})(\\\\d{4})","$1-$2 $3-$4",["151"]],["(\\\\d{4})","*$1",["[2-689]"]]],"0"],"IM":["44","[135789]\\\\d{6,9}",[10],[["(7\\\\d{3})(\\\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\\\d{5})(\\\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\\\d{3})(\\\\d{5,6})","$1 $2",["1"]],["(800)(\\\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["80"]],["(800)(\\\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,[["1624[5-8]\\\\d{5}"],["7(?:4576|[59]24\\\\d|624[0-4689])\\\\d{5}"],["808162\\\\d{4}"],["(?:872299|90[0167]624)\\\\d{4}"],["70\\\\d{8}"],null,["3(?:08162\\\\d|3\\\\d{5}|4(?:40[49]06|5624\\\\d)|7(?:0624\\\\d|2299\\\\d))\\\\d{3}|55\\\\d{8}"],null,["56\\\\d{8}"],["8(?:4(?:40[49]06|5624\\\\d)|70624\\\\d)\\\\d{3}"]]],"IN":["91","008\\\\d{9}|1\\\\d{7,12}|[2-9]\\\\d{9,10}",[8,9,10,11,12,13],[["(\\\\d{8})","$1",["561","5616","56161"],"$1"],["(\\\\d{5})(\\\\d{5})","$1 $2",["6(?:00|12|2[03689]|3[05-9]|9[01])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9","6(?:00|127|2(?:0[0134]|3[589]|6[0-39]|8[0-3]|9[0-46])|3(?:0[0-39]|5[0-46-9]|6[0-2]|7[0156]|8[1-3569]|9[0-79])|9[01])|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9","6(?:00|1279|2(?:0[0134]|3[589]|6[0-39]|8[0-3]|9[0-46])|3(?:0[0-39]|5[0-46-9]|6[0-2]|7[0156]|8[1-3569]|9[0-79])|9[01])|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[05-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[04-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:[014](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|[16](?:[089]|7[02-7])|2(?:[09]|7[02-8]|8[0-689]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-8]))|9(?:[02-9]|1(?:[0289]|7[02-8])))|9"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-9]|80[2-46]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"]],["(\\\\d{4})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})(\\\\d{3})","$1 $2 $3 $4",["008"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["140"],"$1"],["(\\\\d{4})(\\\\d{2})(\\\\d{4})","$1 $2 $3",["160","1600"],"$1"],["(\\\\d{4})(\\\\d{4,5})","$1 $2",["180","1800"],"$1"],["(\\\\d{4})(\\\\d{2,4})(\\\\d{4})","$1 $2 $3",["180","1800"],"$1"],["(\\\\d{4})(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["186","1860"],"$1"],["(\\\\d{4})(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["18[06]"],"$1"]],"0","0$1",null,null,true],"IO":["246","3\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"IQ":["964","[1-7]\\\\d{7,9}",[8,9,10],[["(1)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1"]],["([2-6]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[2-6]"]],["(7\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"IR":["98","[1-8]\\\\d{5,9}|9(?:[0-4]\\\\d{8}|9\\\\d{8})",[6,7,10],[["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["[1-8]"]],["(\\\\d{2})(\\\\d{4,5})","$1 $2",["[1-8]"]],["(\\\\d{4,5})","$1",["96"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["9"]]],"0","0$1"],"IS":["354","[4-9]\\\\d{6}|38\\\\d{7}",[7,9],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[4-9]"]],["(3\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["3"]]]],"IT":["39","[01589]\\\\d{5,10}|3(?:[12457-9]\\\\d{8}|[36]\\\\d{7,9})",[6,7,8,9,10,11],[["(\\\\d{2})(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\\\d{4})(\\\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\\\d{4,6})","$1 $2",["0[26]"]],["(0\\\\d{2})(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\\\d{3})(\\\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\\\d{3})(\\\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\\\d{4})(\\\\d{4})","$1 $2",["894","894[5-9]"]],["(\\\\d{3})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,[["0(?:[26]\\\\d{4,9}|(?:1(?:[0159]\\\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\\\d{2,7})"],["3(?:[12457-9]\\\\d{8}|6\\\\d{7,8}|3\\\\d{7,9})",[9,10,11]],["80(?:0\\\\d{6}|3\\\\d{3})",[6,9]],["0878\\\\d{5}|1(?:44|6[346])\\\\d{6}|89(?:2\\\\d{3}|4(?:[0-4]\\\\d{2}|[5-9]\\\\d{4})|5(?:[0-4]\\\\d{2}|[5-9]\\\\d{6})|9\\\\d{6})",[6,8,9,10]],["1(?:78\\\\d|99)\\\\d{6}",[9,10]],null,null,null,["55\\\\d{8}",[10]],["84(?:[08]\\\\d{6}|[17]\\\\d{3})",[6,9]]]],"JE":["44","[135789]\\\\d{6,9}",[10],[["(7\\\\d{3})(\\\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\\\d{5})(\\\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\\\d{3})(\\\\d{5,6})","$1 $2",["1"]],["(800)(\\\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["80"]],["(800)(\\\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,[["1534[0-24-8]\\\\d{5}"],["7(?:509\\\\d|7(?:00[378]|97[7-9])|829\\\\d|937\\\\d)\\\\d{5}"],["80(?:07(?:35|81)|8901)\\\\d{4}"],["(?:871206|90(?:066[59]|1810|71(?:07|55)))\\\\d{4}"],["701511\\\\d{4}"],null,["3(?:0(?:07(?:35|81)|8901)|3\\\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\\\d{4}|55\\\\d{8}"],["76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\\\d{6}"],["56\\\\d{8}"],["8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\\\d{4}"]]],"JM":["1","[589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"876"],"JO":["962","[235-9]\\\\d{7,8}",[8,9],[["(\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(7)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["7[457-9]"]],["(\\\\d{2})(\\\\d{7})","$1 $2",["70"]],["(\\\\d{3})(\\\\d{5,6})","$1 $2",["8[0158]|9"]]],"0","0$1"],"JP":["81","[1-9]\\\\d{8,9}|00(?:[36]\\\\d{7,14}|7\\\\d{5,7}|8\\\\d{7})",[8,9,10,11,12,13,14,15,16,17],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1-$2-$3",["(?:12|57|99)0"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1-$2-$3",["800"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"]],["(\\\\d{4})(\\\\d)(\\\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"]],["(\\\\d{3})(\\\\d{2})(\\\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"]],["(\\\\d{3})(\\\\d{2})(\\\\d{4})","$1-$2-$3",["2(?:[34]7|[56]9|74|9[14-79])|82|993"]],["(\\\\d)(\\\\d{4})(\\\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1-$2-$3",["[2479][1-9]"]]],"0","0$1"],"KE":["254","20\\\\d{6,7}|[4-9]\\\\d{6,9}",[7,8,9,10],[["(\\\\d{2})(\\\\d{5,7})","$1 $2",["[24-6]"]],["(\\\\d{3})(\\\\d{6})","$1 $2",["7"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[89]"]]],"0","0$1","005|0"],"KG":["996","[235-8]\\\\d{8,9}",[9,10],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[25-7]|31[25]"]],["(\\\\d{4})(\\\\d{5})","$1 $2",["3(?:1[36]|[2-9])"]],["(\\\\d{3})(\\\\d{3})(\\\\d)(\\\\d{3})","$1 $2 $3 $4",["8"]]],"0","0$1"],"KH":["855","[1-9]\\\\d{7,9}",[8,9,10],[["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["1\\\\d[1-9]|[2-9]"],"0$1"],["(1[89]00)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[89]0","1[89]00"]]],"0"],"KI":["686","[2458]\\\\d{4}|3\\\\d{4,7}|[67]\\\\d{7}",[5,8],[],null,null,"0"],"KM":["269","[3478]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3"]]],"KN":["1","[589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"869"],"KP":["850","1\\\\d{9}|[28]\\\\d{7}",[8,10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1"]],["(\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["2"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"KR":["82","00(?:3\\\\d{8,9}|7\\\\d{9,11})|[1-7]\\\\d{4,9}|8\\\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\\\d{2})(\\\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"]],["(\\\\d{4})(\\\\d{4})","$1-$2",["1(?:5[246-9]|6[046-8]|8[03579])","1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"],"$1"],["(\\\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"]],["(\\\\d)(\\\\d{3,4})(\\\\d{4})","$1-$2-$3",["2[1-9]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1-$2-$3",["60[2-9]|80"]],["(\\\\d{2})(\\\\d{3,4})(\\\\d{4})","$1-$2-$3",["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1-$2-$3",["[57]0"]]],"0","0$1","0(8[1-46-8]|85\\\\d{2})?"],"KW":["965","[12569]\\\\d{6,7}",[7,8],[["(\\\\d{4})(\\\\d{3,4})","$1 $2",["[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[0-24-9]"]],["(\\\\d{3})(\\\\d{5})","$1 $2",["244|5(?:[015]|6[56])"]]]],"KY":["1","[3589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"345"],"KZ":["7","(?:33\\\\d|7\\\\d{2}|80[089])\\\\d{7}",[10],[["([3489]\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["7"]]],"8",null,null,null,null,null,[["33622\\\\d{5}|7(?:1(?:0(?:[23]\\\\d|4[0-3]|59|63)|1(?:[23]\\\\d|4[0-79]|59)|2(?:[23]\\\\d|59)|3(?:2\\\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\\\d|3[013-9]|5[1-9])|5(?:2\\\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\\\d|5[19]|61)|72\\\\d|8(?:[27]\\\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\\\d|4[46-9]|5[3469])|2(?:2\\\\d|3[0679]|46|5[12679])|3(?:[234]\\\\d|5[139])|4(?:2\\\\d|3[1235-9]|59)|5(?:[23]\\\\d|4[01246-8]|59|61)|6(?:2\\\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\\\d|40|5[279])|8(?:[23]\\\\d|4[0-3]|59)|9(?:2\\\\d|3[124578]|59)))\\\\d{5}"],["7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\\\d{7}"],["800\\\\d{7}"],["809\\\\d{7}"],["808\\\\d{7}"],null,null,null,["751\\\\d{7}"]]],"LA":["856","[2-8]\\\\d{7,9}",[8,9,10],[["(20)(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["20"]],["([2-8]\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"]],["(30)(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3 $4",["30"]]],"0","0$1"],"LB":["961","[13-9]\\\\d{6,7}",[7,8],[["(\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["([7-9]\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"]]],"0"],"LC":["1","[5789]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"758"],"LI":["423","6\\\\d{8}|[23789]\\\\d{6}",[7,9],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3",["[237-9]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["6[56]"]],["(69)(7\\\\d{2})(\\\\d{4})","$1 $2 $3",["697"]]],"0",null,"0|10(?:01|20|66)"],"LK":["94","[1-9]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[1-689]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"LR":["231","2\\\\d{7,8}|[378]\\\\d{8}|4\\\\d{6}|5\\\\d{6,8}",[7,8,9],[["(2\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["2"]],["([4-5])(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[45]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[23578]"]]],"0","0$1"],"LS":["266","[2568]\\\\d{7}",[8],[["(\\\\d{4})(\\\\d{4})","$1 $2"]]],"LT":["370","[3-9]\\\\d{7}",[8],[["([34]\\\\d)(\\\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"]],["([3-6]\\\\d{2})(\\\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"]],["([7-9]\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["[7-9]"],"8 $1"],["(5)(2\\\\d{2})(\\\\d{4})","$1 $2 $3",["52[0-79]"]]],"8","(8-$1)","[08]",null,true],"LU":["352","[24-9]\\\\d{3,10}|3(?:[0-46-9]\\\\d{2,9}|5[013-9]\\\\d{1,8})",[4,5,6,7,8,9,10,11],[["(\\\\d{2})(\\\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["20"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3 $4",["20"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"]],["(\\\\d{3})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["70|80[01]|90[015]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["6"]]],null,null,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\\\d)"],"LV":["371","[2689]\\\\d{7}",[8],[["([2689]\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[2689]"]]]],"LY":["218","[25679]\\\\d{8}",[9],[["([25-79]\\\\d)(\\\\d{7})","$1-$2",["[25-79]"]]],"0","0$1"],"MA":["212","[5-9]\\\\d{8}",[9],[["([5-7]\\\\d{2})(\\\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\\\d{3})(\\\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\\\d{4})(\\\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0","0$1",null,null,null,null,[["5(?:2(?:[015-79]\\\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\\\d|3(?:[0-48]\\\\d|[57][2-9]|6[2-8]|9[3-9])\\\\d|4[067]\\\\d{2}|5[03]\\\\d{2})\\\\d{4}"],["(?:6(?:[0-79]\\\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[017]))\\\\d{6}"],["80\\\\d{7}"],["89\\\\d{7}"],null,null,null,null,["5924[01]\\\\d{4}"]]],"MC":["377","[34689]\\\\d{7,8}",[8,9],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[39]"],"$1"],["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["4"]],["(6)(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4 $5",["6"]],["(\\\\d{3})(\\\\d{3})(\\\\d{2})","$1 $2 $3",["8"],"$1"]],"0","0$1"],"MD":["373","[235-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["22|3"]],["([25-7]\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["2[13-9]|[5-7]"]],["([89]\\\\d{2})(\\\\d{5})","$1 $2",["[89]"]]],"0","0$1"],"ME":["382","[2-9]\\\\d{7,8}",[8],[["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[2-57-9]|6[036-9]"]]],"0","0$1"],"MF":["590","[56]\\\\d{8}",[9],[["([56]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["590|69[01]"]]],"0",null,null,null,null,null,[["590(?:0[079]|13|2[79]|30|43|5[0-268]|7[79]|87)\\\\d{4}"],["69(?:0\\\\d{2}|1(?:2[29]|3[0-5]))\\\\d{4}"]]],"MG":["261","[23]\\\\d{8}",[9],[["([23]\\\\d)(\\\\d{2})(\\\\d{3})(\\\\d{2})","$1 $2 $3 $4",["[23]"]]],"0","0$1"],"MH":["692","[2-6]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1-$2"]],"1"],"MK":["389","[2-578]\\\\d{7}",[8],[["(2)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["2"]],["([347]\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[347]"]],["([58]\\\\d{2})(\\\\d)(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[58]"]]],"0","0$1"],"ML":["223","[24-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","[178]\\\\d{5,7}|[24-6]\\\\d{5,8}|9(?:[279]\\\\d{0,2}|5|[34]\\\\d{1,2}|6(?:\\\\d{1,2})?|8(?:\\\\d{2})?)\\\\d{6}",[6,7,8,9,10],[["(\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["1|2[245]"]],["(2)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["251"]],["(\\\\d)(\\\\d{2})(\\\\d{3})","$1 $2 $3",["16|2"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["432|67|81"]],["(\\\\d{2})(\\\\d{2})(\\\\d{3,4})","$1 $2 $3",["[4-8]"]],["(9)(\\\\d{3})(\\\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"]],["(9)([34]\\\\d{4})(\\\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"]],["(9)(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["92[56]"]],["(9)(\\\\d{3})(\\\\d{3})(\\\\d{2})","$1 $2 $3 $4",["93"]]],"0","0$1"],"MN":["976","[12]\\\\d{7,9}|[57-9]\\\\d{7}",[8,9,10],[["([12]\\\\d)(\\\\d{2})(\\\\d{4})","$1 $2 $3",["[12]1"]],["([12]2\\\\d)(\\\\d{5,6})","$1 $2",["[12]2[1-3]"]],["([12]\\\\d{3})(\\\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\\\d)2"]],["(\\\\d{4})(\\\\d{4})","$1 $2",["[57-9]"],"$1"],["([12]\\\\d{4})(\\\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\\\d)[4-9]"]]],"0","0$1"],"MO":["853","[268]\\\\d{7}",[8],[["([268]\\\\d{3})(\\\\d{4})","$1 $2",["[268]"]]]],"MP":["1","[5689]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"670"],"MQ":["596","[56]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"MR":["222","[2-48]\\\\d{7}",[8],[["([2-48]\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","[5689]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"664"],"MT":["356","[2357-9]\\\\d{7}",[8],[["(\\\\d{4})(\\\\d{4})","$1 $2"]]],"MU":["230","[2-9]\\\\d{6,7}",[7,8],[["([2-46-9]\\\\d{2})(\\\\d{4})","$1 $2",["[2-46-9]"]],["(5\\\\d{3})(\\\\d{4})","$1 $2",["5"]]]],"MV":["960","[346-8]\\\\d{6,9}|9(?:00\\\\d{7}|\\\\d{6})",[7,10],[["(\\\\d{3})(\\\\d{4})","$1-$2",["[3467]|9(?:0[1-9]|[1-9])"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[89]00"]]]],"MW":["265","(?:1(?:\\\\d{2})?|[2789]\\\\d{2}|31\\\\d)\\\\d{6}",[7,9],[["(\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1"]],["(2\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["2"]],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[17-9]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["31"]]],"0","0$1"],"MX":["52","[1-9]\\\\d{9,10}",[10,11],[["([358]\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["33|55|81"]],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"]],["(1)([358]\\\\d)(\\\\d{4})(\\\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",null,"$1 $2 $3 $4"],["(1)(\\\\d{3})(\\\\d{3})(\\\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",null,"$1 $2 $3 $4"]],"01","01 $1","0[12]|04[45](\\\\d{10})","1$1",true],"MY":["60","[13-9]\\\\d{7,9}",[8,9,10],[["([4-79])(\\\\d{3})(\\\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(3)(\\\\d{4})(\\\\d{4})","$1-$2 $3",["3"],"0$1"],["([18]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],["(1)([36-8]00)(\\\\d{2})(\\\\d{4})","$1-$2-$3-$4",["1[36-8]0","1[36-8]00"]],["(11)(\\\\d{4})(\\\\d{4})","$1-$2 $3",["11"],"0$1"],["(15[49])(\\\\d{3})(\\\\d{4})","$1-$2 $3",["15[49]"],"0$1"]],"0"],"MZ":["258","[28]\\\\d{7,8}",[8,9],[["([28]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],["(80\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["80"]]]],"NA":["264","[68]\\\\d{7,8}",[8,9],[["(8\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["8[1-35]"]],["(6\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["6"]],["(88)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["88"]],["(870)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["870"]]],"0","0$1"],"NC":["687","[2-57-9]\\\\d{5}",[6],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"]]]],"NE":["227","[0289]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["09|[289]"]],["(08)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["08"]]]],"NF":["672","[13]\\\\d{5}",[6],[["(\\\\d{2})(\\\\d{4})","$1 $2",["1"]],["(\\\\d)(\\\\d{5})","$1 $2",["3"]]]],"NG":["234","[1-6]\\\\d{5,8}|9\\\\d{5,9}|[78]\\\\d{5,13}",[7,8,10,11,12,13,14],[["(\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"]],["(\\\\d{2})(\\\\d{3})(\\\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["70|8[01]|90[235-9]"]],["([78]00)(\\\\d{4})(\\\\d{4,5})","$1 $2 $3",["[78]00"]],["([78]00)(\\\\d{5})(\\\\d{5,6})","$1 $2 $3",["[78]00"]],["(78)(\\\\d{2})(\\\\d{3})","$1 $2 $3",["78"]]],"0","0$1"],"NI":["505","[125-8]\\\\d{7}",[8],[["(\\\\d{4})(\\\\d{4})","$1 $2"]]],"NL":["31","1\\\\d{4,8}|[2-7]\\\\d{8}|[89]\\\\d{6,9}",[5,6,7,8,9,10],[["([1-578]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"]],["([1-5]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"]],["(6)(\\\\d{8})","$1 $2",["6[0-57-9]"]],["(66)(\\\\d{7})","$1 $2",["66"]],["(14)(\\\\d{3,4})","$1 $2",["14"],"$1"],["([89]0\\\\d)(\\\\d{4,7})","$1 $2",["[89]0"]]],"0","0$1"],"NO":["47","0\\\\d{4}|[2-9]\\\\d{7}",[5,8],[["([489]\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,[["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\\\d{6}",[8]],["(?:4[015-8]|5[89]|87|9\\\\d)\\\\d{6}",[8]],["80[01]\\\\d{5}",[8]],["82[09]\\\\d{5}",[8]],["880\\\\d{5}",[8]],null,["0\\\\d{4}|81(?:0(?:0[7-9]|1\\\\d)|5\\\\d{2})\\\\d{3}"],null,["85[0-5]\\\\d{5}",[8]],["810(?:0[0-6]|[2-8]\\\\d)\\\\d{3}",[8]]]],"NP":["977","[1-8]\\\\d{7}|9(?:[1-69]\\\\d{6,8}|7[2-6]\\\\d{5,7}|8\\\\d{8})",[8,10],[["(1)(\\\\d{7})","$1-$2",["1[2-6]"]],["(\\\\d{2})(\\\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"]],["(9\\\\d{2})(\\\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],"0","0$1"],"NR":["674","[458]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"NU":["683","[1-5]\\\\d{3}",[4]],"NZ":["64","6[235-9]\\\\d{6}|[2-57-9]\\\\d{7,9}",[8,9,10],[["(\\\\d)(\\\\d{3})(\\\\d{4})","$1-$2 $3",["240|[346]|7[2-57-9]|9[1-9]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["21"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"]],["(2\\\\d)(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["2[028]"]],["(\\\\d{3})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["90"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"]]],"0","0$1"],"OM":["968","(?:5|[279]\\\\d)\\\\d{6}|800\\\\d{5,6}",[7,8,9],[["(2\\\\d)(\\\\d{6})","$1 $2",["2"]],["([79]\\\\d{3})(\\\\d{4})","$1 $2",["[79]"]],["([58]00)(\\\\d{4,6})","$1 $2",["[58]00"]]]],"PA":["507","[1-9]\\\\d{6,7}",[7,8],[["(\\\\d{3})(\\\\d{4})","$1-$2",["[1-57-9]"]],["(\\\\d{4})(\\\\d{4})","$1-$2",["6"]]]],"PE":["51","[14-9]\\\\d{7,8}",[8,9],[["(1)(\\\\d{7})","$1 $2",["1"]],["([4-8]\\\\d)(\\\\d{6})","$1 $2",["[4-7]|8[2-4]"]],["(\\\\d{3})(\\\\d{5})","$1 $2",["80"]],["(9\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["9"],"$1"]],"0","(0$1)"],"PF":["689","4\\\\d{5,7}|8\\\\d{7}",[6,8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3",["44"]]]],"PG":["675","[1-9]\\\\d{6,7}",[7,8],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[13-689]|27"]],["(\\\\d{4})(\\\\d{4})","$1 $2",["20|7"]]]],"PH":["63","1\\\\d{10,12}|2\\\\d{5,7}|[3-7]\\\\d{8}|8\\\\d{7,9}|9\\\\d{9}",[6,8,9,10,11,12,13],[["(2)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(2)(\\\\d{5})","$1 $2",["2"],"(0$1)"],["(\\\\d{4})(\\\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\\\d{5})(\\\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["([3-8]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["81|9"],"0$1"],["(1800)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["180","1800"]],["(1800)(\\\\d{1,2})(\\\\d{3})(\\\\d{4})","$1 $2 $3 $4",["180","1800"]]],"0"],"PK":["92","1\\\\d{8}|[2-8]\\\\d{5,11}|9(?:[013-9]\\\\d{4,10}|2\\\\d(?:111\\\\d{6}|\\\\d{3,7}))",[8,9,10,11,12],[["([89]00)(\\\\d{3})(\\\\d{2})","$1 $2 $3",["[89]00"],"0$1"],["(1\\\\d{3})(\\\\d{5})","$1 $2",["1"],"$1"],["(\\\\d{2})(\\\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"]],["(\\\\d{3})(\\\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-469]","(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\\\d[2-9]"]],["(58\\\\d{3})(\\\\d{5})","$1 $2",["58[126]"]],["(3\\\\d{2})(\\\\d{7})","$1 $2",["3"],"0$1"],["(\\\\d{2})(111)(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"]],["(\\\\d{3})(111)(\\\\d{3})(\\\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\\\d111"]]],"0","(0$1)"],"PL":["48","[1-57-9]\\\\d{6,8}|6\\\\d{5,8}",[6,7,8,9],[["(\\\\d{3})(\\\\d{3})","$1 $2",["11[68]|64"]],["(\\\\d{5})","$1",["19"]],["(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],["(\\\\d{3})(\\\\d{2})(\\\\d{2,3})","$1 $2 $3",["64"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]]],"PM":["508","[45]\\\\d{5}",[6],[["([45]\\\\d)(\\\\d{2})(\\\\d{2})","$1 $2 $3",["[45]"]]],"0","0$1"],"PR":["1","[5789]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"787|939"],"PS":["970","1\\\\d{9}|[24589]\\\\d{7,8}",[8,9,10],[["([2489])(2\\\\d{2})(\\\\d{4})","$1 $2 $3",["[2489]2"]],["(5[69]\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["5[69]"]],["(1[78]00)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[78]0","1[78]00"],"$1"]],"0","0$1"],"PT":["351","[2-46-9]\\\\d{8}",[9],[["(2\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["2[12]"]],["([2-46-9]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"]]]],"PW":["680","[2-9]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"PY":["595","5[0-5]\\\\d{4,7}|[2-46-9]\\\\d{5,8}",[6,7,8,9],[["(\\\\d{2})(\\\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\\\d{3})(\\\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\\\d{3})(\\\\d{6})","$1 $2",["9[1-9]"],"0$1"],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["870","8700"]],["(\\\\d{3})(\\\\d{4,5})","$1 $2",["[2-8][1-9]"],"(0$1)"],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[2-8][1-9]"],"0$1"]],"0"],"QA":["974","[2-8]\\\\d{6,7}",[7,8],[["([28]\\\\d{2})(\\\\d{4})","$1 $2",["[28]"]],["([3-7]\\\\d{3})(\\\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","[268]\\\\d{8}",[9],[["([268]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[268]"]]],"0","0$1",null,null,null,"262|69|8"],"RO":["40","[23]\\\\d{5,8}|[7-9]\\\\d{8}",[6,9],[["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[23]1"]],["(\\\\d{2})(\\\\d{4})","$1 $2",["[23]1"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"]],["(2\\\\d{2})(\\\\d{3})","$1 $2",["2[3-6]"]]],"0","0$1"],"RS":["381","[126-9]\\\\d{4,11}|3(?:[0-79]\\\\d{3,10}|8[2-9]\\\\d{2,9})",[6,7,8,9,10,11,12],[["([23]\\\\d{2})(\\\\d{4,9})","$1 $2",["(?:2[389]|39)0"]],["([1-3]\\\\d)(\\\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"]],["(6\\\\d)(\\\\d{6,8})","$1 $2",["6"]],["([89]\\\\d{2})(\\\\d{3,9})","$1 $2",["[89]"]],["(7[26])(\\\\d{4,9})","$1 $2",["7[26]"]],["(7[08]\\\\d)(\\\\d{4,9})","$1 $2",["7[08]"]]],"0","0$1"],"RU":["7","[347-9]\\\\d{9}",[10],[["([3489]\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["7"]]],"8","8 ($1)",null,null,true,null,[["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\\\d{7}"],["9\\\\d{9}"],["80[04]\\\\d{7}"],["80[39]\\\\d{7}"],["808\\\\d{7}"]]],"RW":["250","[027-9]\\\\d{7,8}",[8,9],[["(2\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["2"]],["([7-9]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(0\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["0"]]],"0"],"SA":["966","[15]\\\\d{8}|8\\\\d{9}|92\\\\d{7}",[9,10],[["(1\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1[1-467]"]],["(5\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["5"]],["(92\\\\d{2})(\\\\d{5})","$1 $2",["92"],"$1"],["(800)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["800"],"$1"],["(811)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["811"]]],"0","0$1"],"SB":["677","[1-9]\\\\d{4,6}",[5,7],[["(\\\\d{2})(\\\\d{5})","$1 $2",["[7-9]"]]]],"SC":["248","[24689]\\\\d{5,6}",[7],[["(\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[246]"]]]],"SD":["249","[19]\\\\d{8}",[9],[["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3"]],"0","0$1"],"SE":["46","[1-35-9]\\\\d{5,11}|4\\\\d{6,8}",[6,7,8,9,10],[["(8)(\\\\d{2,3})(\\\\d{2,3})(\\\\d{2})","$1-$2 $3 $4",["8"],null,null,"$1 $2 $3 $4"],["([1-69]\\\\d)(\\\\d{2,3})(\\\\d{2})(\\\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],null,null,"$1 $2 $3 $4"],["([1-469]\\\\d)(\\\\d{3})(\\\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90"],null,null,"$1 $2 $3"],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3 $4"],["(\\\\d{3})(\\\\d{2,3})(\\\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3"],["(7\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1-$2 $3 $4",["7"],null,null,"$1 $2 $3 $4"],["(77)(\\\\d{2})(\\\\d{2})","$1-$2$3",["77"],null,null,"$1 $2 $3"],["(20)(\\\\d{2,3})(\\\\d{2})","$1-$2 $3",["20"],null,null,"$1 $2 $3"],["(9[034]\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{3})","$1-$2 $3 $4",["9[034]"],null,null,"$1 $2 $3 $4"],["(9[034]\\\\d)(\\\\d{4})","$1-$2",["9[034]"],null,null,"$1 $2"],["(\\\\d{3})(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-6]"],null,null,"$1 $2 $3 $4 $5"]],"0","0$1"],"SG":["65","[36]\\\\d{7}|[17-9]\\\\d{7,10}",[8,10,11],[["([3689]\\\\d{3})(\\\\d{4})","$1 $2",["[369]|8[1-9]"]],["(1[89]00)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1[89]0","1[89]00"]],["(7000)(\\\\d{4})(\\\\d{3})","$1 $2 $3",["700","7000"]],["(800)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["800"]]]],"SH":["290","[256]\\\\d{4}|8\\\\d{3}",[4,5],[],null,null,null,null,null,null,[["2(?:[0-57-9]\\\\d|6[4-9])\\\\d{2}"],["[56]\\\\d{4}",[5]],null,null,null,null,null,null,["262\\\\d{2}",[5]]]],"SI":["386","[1-7]\\\\d{6,7}|[89]\\\\d{4,7}",[5,6,7,8],[["(\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[12]|[34][24-8]|5[2-8]|7[3-8]"],"(0$1)"],["([3-7]\\\\d)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"]],["([89][09])(\\\\d{3,6})","$1 $2",["[89][09]"]],["([58]\\\\d{2})(\\\\d{5})","$1 $2",["59|8[1-3]"]]],"0","0$1"],"SJ":["47","0\\\\d{4}|[45789]\\\\d{7}",[5,8],[["([489]\\\\d{2})(\\\\d{2})(\\\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\\\d)(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,[["79\\\\d{6}",[8]],["(?:4[015-8]|5[89]|9\\\\d)\\\\d{6}",[8]],["80[01]\\\\d{5}",[8]],["82[09]\\\\d{5}",[8]],["880\\\\d{5}",[8]],null,["0\\\\d{4}|81(?:0(?:0[7-9]|1\\\\d)|5\\\\d{2})\\\\d{3}"],null,["85[0-5]\\\\d{5}",[8]],["810(?:0[0-6]|[2-8]\\\\d)\\\\d{3}",[8]]]],"SK":["421","(?:[2-68]\\\\d{5,8}|9\\\\d{6,8})",[6,7,9],[["(2)(1[67])(\\\\d{3,4})","$1 $2 $3",["21[67]"]],["([3-5]\\\\d)(\\\\d{2})(\\\\d{2,3})","$1 $2 $3",["[3-5]"]],["(2)(\\\\d{3})(\\\\d{3})(\\\\d{2})","$1/$2 $3 $4",["2"]],["([3-5]\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1/$2 $3 $4",["[3-5]"]],["([689]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[689]"]],["(9090)(\\\\d{3})","$1 $2",["909","9090"]]],"0","0$1"],"SL":["232","[2-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{6})","$1 $2"]],"0","(0$1)"],"SM":["378","[05-7]\\\\d{7,9}",[8,10],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(0549)(\\\\d{6})","$1 $2",["054","0549"],null,null,"($1) $2"],["(\\\\d{6})","0549 $1",["[89]"],null,null,"(0549) $1"]],null,null,"([89]\\\\d{5})","0549$1"],"SN":["221","[3789]\\\\d{8}",[9],[["(\\\\d{2})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[379]"]],["(\\\\d{3})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["8"]]]],"SO":["252","[1-9]\\\\d{5,8}",[6,7,8,9],[["(\\\\d{6})","$1",["[134]"]],["(\\\\d)(\\\\d{6})","$1 $2",["[13-5]|2[0-79]"]],["(\\\\d)(\\\\d{7})","$1 $2",["24|[67]"]],["(\\\\d{2})(\\\\d{4})","$1 $2",["8[125]"]],["(\\\\d{2})(\\\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["3[59]|4[89]|6[24-6]|79|8[08]|90"]]],"0"],"SR":["597","[2-8]\\\\d{5,6}",[6,7],[["(\\\\d{3})(\\\\d{3})","$1-$2",["[2-4]|5[2-58]"]],["(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1-$2-$3",["56"]],["(\\\\d{3})(\\\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","[19]\\\\d{8}",[9],[["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3",null,"0$1"]],"0"],"ST":["239","[29]\\\\d{6}",[7],[["(\\\\d{3})(\\\\d{4})","$1 $2"]]],"SV":["503","[267]\\\\d{7}|[89]\\\\d{6}(?:\\\\d{4})?",[7,8,11],[["(\\\\d{4})(\\\\d{4})","$1 $2",["[267]"]],["(\\\\d{3})(\\\\d{4})","$1 $2",["[89]"]],["(\\\\d{3})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","[5789]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"721"],"SY":["963","[1-59]\\\\d{7,8}",[8,9],[["(\\\\d{2})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[1-5]"]],["(9\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["9"]]],"0","0$1",null,null,true],"SZ":["268","[027]\\\\d{7}",[8],[["(\\\\d{4})(\\\\d{4})","$1 $2",["[027]"]]]],"TA":["290","8\\\\d{3}",[4],[],null,null,null,null,null,null,[["8\\\\d{3}"]]],"TC":["1","[5689]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"649"],"TD":["235","[2679]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4"]]],"TG":["228","[279]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","1\\\\d{8,9}|[2-9]\\\\d{7,8}",[8,9,10],[["(2)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["2"]],["([13-9]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["14|[3-9]"]],["(1[89]00)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["1[89]0","1[89]00"],"$1"]],"0","0$1"],"TJ":["992","[3-57-9]\\\\d{8}",[9],[["([349]\\\\d{2})(\\\\d{2})(\\\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["([457-9]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["4[148]|[578]|9(?:[0235-9]|1[59])"]],["(331700)(\\\\d)(\\\\d{2})","$1 $2 $3",["331","3317","33170","331700"]],["(\\\\d{4})(\\\\d)(\\\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"]]],"8",null,null,null,true],"TK":["690","[2-47]\\\\d{3,6}",[4,5,6,7]],"TL":["670","[2-489]\\\\d{6}|7\\\\d{6,7}",[7,8],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[2-489]|70"]],["(\\\\d{4})(\\\\d{4})","$1 $2",["7[3-8]"]]]],"TM":["993","[1-6]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2-$3-$4",["12"]],["(\\\\d{2})(\\\\d{6})","$1 $2",["6"],"8 $1"],["(\\\\d{3})(\\\\d)(\\\\d{2})(\\\\d{2})","$1 $2-$3-$4",["13|[2-5]"]]],"8","(8 $1)"],"TN":["216","[2-57-9]\\\\d{7}",[8],[["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3"]]],"TO":["676","[02-8]\\\\d{4,6}",[5,7],[["(\\\\d{2})(\\\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"]],["(\\\\d{3})(\\\\d{4})","$1 $2",["7[5-9]|8[47-9]"]],["(\\\\d{4})(\\\\d{3})","$1 $2",["0"]]]],"TR":["90","[2-589]\\\\d{9}|444\\\\d{4}",[7,10],[["(\\\\d{3})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)"],["(\\\\d{3})(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["5(?:[02-69]|16)"],"0$1"],["(\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["51|[89]"],"0$1"],["(444)(\\\\d{1})(\\\\d{3})","$1 $2 $3",["444"]]],"0",null,null,null,true],"TT":["1","[589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"868"],"TV":["688","[279]\\\\d{4,6}",[5,6,7]],"TW":["886","2\\\\d{6,8}|[3-689]\\\\d{7,8}|7\\\\d{7,9}",[7,8,9,10],[["(20)(\\\\d)(\\\\d{4})","$1 $2 $3",["202"]],["([258]0)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["20[013-9]|50[0-46-9]|80[0-79]"]],["([2-8])(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["[25][2-8]|[346]|[78][1-9]"]],["(9\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["9"]],["(70)(\\\\d{4})(\\\\d{4})","$1 $2 $3",["70"]]],"0","0$1"],"TZ":["255","\\\\d{9}",[7,9],[["([24]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[24]"]],["([67]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[67]"]],["([89]\\\\d{2})(\\\\d{2})(\\\\d{4})","$1 $2 $3",["[89]"]]],"0","0$1"],"UA":["380","[3-9]\\\\d{8}",[9],[["([3-9]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"]],["([3-689]\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"]],["([3-6]\\\\d{3})(\\\\d{5})","$1 $2",["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])","3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"]]],"0","0$1"],"UG":["256","\\\\d{9}",[9],[["(\\\\d{3})(\\\\d{6})","$1 $2",["20[0-8]|4(?:6[45]|[7-9])|[7-9]","20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"]],["(\\\\d{2})(\\\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"]],["(2024)(\\\\d{5})","$1 $2",["202","2024"]]],"0","0$1"],"US":["1","[2-9]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,true,null,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\\\d{6}"],["900[2-9]\\\\d{6}"],["5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\\\d{6}"]]],"UY":["598","[2489]\\\\d{6,7}",[7,8],[["(\\\\d{4})(\\\\d{4})","$1 $2",["[24]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],["(\\\\d{3})(\\\\d{4})","$1 $2",["[89]0"],"0$1"]],"0"],"UZ":["998","[679]\\\\d{8}",[9],[["([679]\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[679]"]]],"8","8 $1"],"VA":["39","(?:0(?:878\\\\d{5}|6698\\\\d{5})|[1589]\\\\d{5,10}|3(?:[12457-9]\\\\d{8}|[36]\\\\d{7,9}))",[6,8,9,10,11],[["(\\\\d{2})(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\\\d{4})(\\\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\\\d{4,6})","$1 $2",["0[26]"]],["(0\\\\d{2})(\\\\d{3,4})(\\\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\\\d{3})(\\\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\\\d{3})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\\\d{3})(\\\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\\\d{4})(\\\\d{4})","$1 $2",["894","894[5-9]"]],["(\\\\d{3})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,[["06698\\\\d{5}",[10]],["3(?:[12457-9]\\\\d{8}|6\\\\d{7,8}|3\\\\d{7,9})",[9,10,11]],["80(?:0\\\\d{6}|3\\\\d{3})",[6,9]],["0878\\\\d{5}|1(?:44|6[346])\\\\d{6}|89(?:2\\\\d{3}|4(?:[0-4]\\\\d{2}|[5-9]\\\\d{4})|5(?:[0-4]\\\\d{2}|[5-9]\\\\d{6})|9\\\\d{6})",[6,8,9,10]],["1(?:78\\\\d|99)\\\\d{6}",[9,10]],null,null,null,["55\\\\d{8}",[10]],["84(?:[08]\\\\d{6}|[17]\\\\d{3})",[6,9]]]],"VC":["1","[5789]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"784"],"VE":["58","[24589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{7})","$1-$2"]],"0","0$1"],"VG":["1","[2589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"284"],"VI":["1","[3589]\\\\d{9}",[10],[["(\\\\d{3})(\\\\d{3})(\\\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"340"],"VN":["84","1\\\\d{6,9}|2\\\\d{9}|6\\\\d{6,7}|7\\\\d{6}|8\\\\d{6,8}|9\\\\d{8}",[7,8,9,10],[["([17]99)(\\\\d{4})","$1 $2",["[17]99"]],["(\\\\d{2})(\\\\d{4})(\\\\d{4})","$1 $2 $3",["2[48]"]],["(80)(\\\\d{5})","$1 $2",["80"]],["(69\\\\d)(\\\\d{4,5})","$1 $2",["69"]],["(\\\\d{3})(\\\\d{4})(\\\\d{3})","$1 $2 $3",["2[0-35-79]"]],["([89]\\\\d)(\\\\d{3})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["8(?:8|9[89])|9"]],["(1[2689]\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"]],["(86[89])(\\\\d{3})(\\\\d{3})","$1 $2 $3",["86[89]"]],["(1[89]00)(\\\\d{4,6})","$1 $2",["1[89]0","1[89]00"],"$1"]],"0","0$1",null,null,true],"VU":["678","[2-57-9]\\\\d{4,6}",[5,7],[["(\\\\d{3})(\\\\d{4})","$1 $2",["[579]"]]]],"WF":["681","[4-8]\\\\d{5}",[6],[["(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3"]]],"WS":["685","[2-8]\\\\d{4,6}",[5,6,7],[["(8\\\\d{2})(\\\\d{3,4})","$1 $2",["8"]],["(7\\\\d)(\\\\d{5})","$1 $2",["7"]],["(\\\\d{5})","$1",["[2-6]"]]]],"XK":["383","[23][89]\\\\d{6,7}|4[3-79]\\\\d{6}|[89]00\\\\d{5}",[8,9],[["(\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["[23][89]|4[3-79]"]],["(\\\\d{3})(\\\\d{5})","$1 $2",["[89]00"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3})","$1 $2 $3"]],"0","0$1"],"YE":["967","[1-7]\\\\d{6,8}",[7,8,9],[["([1-7])(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"]],["(7\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["7[0137]"]]],"0","0$1"],"YT":["262","[268]\\\\d{8}",[9],[["([268]\\\\d{2})(\\\\d{2})(\\\\d{2})(\\\\d{2})","$1 $2 $3 $4",["[268]"]]],"0",null,null,null,null,"269|63"],"ZA":["27","[1-79]\\\\d{8}|8\\\\d{4,8}",[5,6,7,8,9],[["(860)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["860"]],["(\\\\d{2})(\\\\d{3,4})","$1 $2",["8[1-4]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{2,3})","$1 $2 $3",["8[1-4]"]],["(\\\\d{2})(\\\\d{3})(\\\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-57]|6[1-9])"]]],"0","0$1"],"ZM":["260","[289]\\\\d{8}",[9],[["(\\\\d{2})(\\\\d{4})","$1 $2",null,"$1"],["([1-8])(\\\\d{2})(\\\\d{4})","$1 $2 $3",["[1-8]"],"$1"],["([29]\\\\d)(\\\\d{7})","$1 $2",["[29]"]],["(800)(\\\\d{3})(\\\\d{3})","$1 $2 $3",["800"]]],"0","0$1"],"ZW":["263","2(?:[0-57-9]\\\\d{3,8}|6(?:[14]\\\\d{7}|\\\\d{4}))|[13-69]\\\\d{4,9}|7\\\\d{8}|8[06]\\\\d{5,8}",[5,6,7,8,9,10],[["([49])(\\\\d{3})(\\\\d{2,4})","$1 $2 $3",["4|9[2-9]"]],["(7\\\\d)(\\\\d{3})(\\\\d{4})","$1 $2 $3",["7"]],["(86\\\\d{2})(\\\\d{3})(\\\\d{3})","$1 $2 $3",["86[24]"]],["([2356]\\\\d{2})(\\\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"]],["(\\\\d{3})(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"]],["([1-356]\\\\d)(\\\\d{3,5})","$1 $2",["1[3-9]|2[02569]|3[0-69]|5[05689]|6"]],["([235]\\\\d)(\\\\d{3})(\\\\d{3,4})","$1 $2 $3",["[23]9|54"]],["([25]\\\\d{3})(\\\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"]],["(8\\\\d{3})(\\\\d{6})","$1 $2",["86"]],["(80\\\\d)(\\\\d{4})","$1 $2",["80"]]],"0","0$1"],"001":["979","\\\\d{9}",[9],[["(\\\\d)(\\\\d{4})(\\\\d{4})","$1 $2 $3"]]]}}'
        )

        /***/
      },

    /***/ '../node_modules/object-assign/index.js':
      /*!**********************************************!*\
  !*** ../node_modules/object-assign/index.js ***!
  \**********************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/

        /* eslint-disable no-unused-vars */
        var getOwnPropertySymbols = Object.getOwnPropertySymbols
        var hasOwnProperty = Object.prototype.hasOwnProperty
        var propIsEnumerable = Object.prototype.propertyIsEnumerable

        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined')
          }

          return Object(val)
        }

        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false
            }

            // Detect buggy property enumeration order in older V8 versions.

            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc') // eslint-disable-line no-new-wrappers
            test1[5] = 'de'
            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {}
            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i
            }
            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n]
            })
            if (order2.join('') !== '0123456789') {
              return false
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {}
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter
            })
            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false
            }

            return true
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false
          }
        }

        module.exports = shouldUseNative()
          ? Object.assign
          : function (target, source) {
              var from
              var to = toObject(target)
              var symbols

              for (var s = 1; s < arguments.length; s++) {
                from = Object(arguments[s])

                for (var key in from) {
                  if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key]
                  }
                }

                if (getOwnPropertySymbols) {
                  symbols = getOwnPropertySymbols(from)
                  for (var i = 0; i < symbols.length; i++) {
                    if (propIsEnumerable.call(from, symbols[i])) {
                      to[symbols[i]] = from[symbols[i]]
                    }
                  }
                }
              }

              return to
            }

        /***/
      },

    /***/ '../node_modules/prop-types/checkPropTypes.js':
      /*!****************************************************!*\
  !*** ../node_modules/prop-types/checkPropTypes.js ***!
  \****************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var printWarning = function () {}

        if (true) {
          var ReactPropTypesSecret = __webpack_require__(
            /*! ./lib/ReactPropTypesSecret */ '../node_modules/prop-types/lib/ReactPropTypesSecret.js'
          )
          var loggedTypeFailures = {}
          var has = Function.call.bind(Object.prototype.hasOwnProperty)

          printWarning = function (text) {
            var message = 'Warning: ' + text
            if (typeof console !== 'undefined') {
              console.error(message)
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message)
            } catch (x) {}
          }
        }

        /**
         * Assert that the values match with the type specs.
         * Error messages are memorized and will only be shown once.
         *
         * @param {object} typeSpecs Map of name to a ReactPropType
         * @param {object} values Runtime values that need to be type-checked
         * @param {string} location e.g. "prop", "context", "child context"
         * @param {string} componentName Name of the component for error messages.
         * @param {?Function} getStack Returns the component stack.
         * @private
         */
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
          if (true) {
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error
                // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.
                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error(
                      (componentName || 'React class') +
                        ': ' +
                        location +
                        ' type `' +
                        typeSpecName +
                        '` is invalid; ' +
                        'it must be a function, usually from the `prop-types` package, but received `' +
                        typeof typeSpecs[typeSpecName] +
                        '`.'
                    )
                    err.name = 'Invariant Violation'
                    throw err
                  }
                  error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret)
                } catch (ex) {
                  error = ex
                }
                if (error && !(error instanceof Error)) {
                  printWarning(
                    (componentName || 'React class') +
                      ': type specification of ' +
                      location +
                      ' `' +
                      typeSpecName +
                      '` is invalid; the type checker ' +
                      'function must return `null` or an `Error` but returned a ' +
                      typeof error +
                      '. ' +
                      'You may have forgotten to pass an argument to the type checker ' +
                      'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
                      'shape all require an argument).'
                  )
                }
                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error.message] = true

                  var stack = getStack ? getStack() : ''

                  printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''))
                }
              }
            }
          }
        }

        /**
         * Resets warning cache when testing.
         *
         * @private
         */
        checkPropTypes.resetWarningCache = function () {
          if (true) {
            loggedTypeFailures = {}
          }
        }

        module.exports = checkPropTypes

        /***/
      },

    /***/ '../node_modules/prop-types/factoryWithTypeCheckers.js':
      /*!*************************************************************!*\
  !*** ../node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \*************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var ReactIs = __webpack_require__(/*! react-is */ '../node_modules/react-is/index.js')
        var assign = __webpack_require__(/*! object-assign */ '../node_modules/object-assign/index.js')

        var ReactPropTypesSecret = __webpack_require__(
          /*! ./lib/ReactPropTypesSecret */ '../node_modules/prop-types/lib/ReactPropTypesSecret.js'
        )
        var checkPropTypes = __webpack_require__(/*! ./checkPropTypes */ '../node_modules/prop-types/checkPropTypes.js')

        var has = Function.call.bind(Object.prototype.hasOwnProperty)
        var printWarning = function () {}

        if (true) {
          printWarning = function (text) {
            var message = 'Warning: ' + text
            if (typeof console !== 'undefined') {
              console.error(message)
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message)
            } catch (x) {}
          }
        }

        function emptyFunctionThatReturnsNull() {
          return null
        }

        module.exports = function (isValidElement, throwOnDirectAccess) {
          /* global Symbol */
          var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator
          var FAUX_ITERATOR_SYMBOL = '@@iterator' // Before Symbol spec.

          /**
           * Returns the iterator method function contained on the iterable object.
           *
           * Be sure to invoke the function with the iterable as context:
           *
           *     var iteratorFn = getIteratorFn(myIterable);
           *     if (iteratorFn) {
           *       var iterator = iteratorFn.call(myIterable);
           *       ...
           *     }
           *
           * @param {?object} maybeIterable
           * @return {?function}
           */
          function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) || maybeIterable[FAUX_ITERATOR_SYMBOL])
            if (typeof iteratorFn === 'function') {
              return iteratorFn
            }
          }

          /**
           * Collection of methods that allow declaration and validation of props that are
           * supplied to React components. Example usage:
           *
           *   var Props = require('ReactPropTypes');
           *   var MyArticle = React.createClass({
           *     propTypes: {
           *       // An optional string prop named "description".
           *       description: Props.string,
           *
           *       // A required enum prop named "category".
           *       category: Props.oneOf(['News','Photos']).isRequired,
           *
           *       // A prop named "dialog" that requires an instance of Dialog.
           *       dialog: Props.instanceOf(Dialog).isRequired
           *     },
           *     render: function() { ... }
           *   });
           *
           * A more formal specification of how these methods are used:
           *
           *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
           *   decl := ReactPropTypes.{type}(.isRequired)?
           *
           * Each and every declaration produces a function with the same signature. This
           * allows the creation of custom validation functions. For example:
           *
           *  var MyLink = React.createClass({
           *    propTypes: {
           *      // An optional string or URI prop named "href".
           *      href: function(props, propName, componentName) {
           *        var propValue = props[propName];
           *        if (propValue != null && typeof propValue !== 'string' &&
           *            !(propValue instanceof URI)) {
           *          return new Error(
           *            'Expected a string or an URI for ' + propName + ' in ' +
           *            componentName
           *          );
           *        }
           *      }
           *    },
           *    render: function() {...}
           *  });
           *
           * @internal
           */

          var ANONYMOUS = '<<anonymous>>'

          // Important!
          // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
          var ReactPropTypes = {
            array: createPrimitiveTypeChecker('array'),
            bool: createPrimitiveTypeChecker('boolean'),
            func: createPrimitiveTypeChecker('function'),
            number: createPrimitiveTypeChecker('number'),
            object: createPrimitiveTypeChecker('object'),
            string: createPrimitiveTypeChecker('string'),
            symbol: createPrimitiveTypeChecker('symbol'),

            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            elementType: createElementTypeTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker,
          }

          /**
           * inlined Object.is polyfill to avoid requiring consumers ship their own
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
           */
          /*eslint-disable no-self-compare*/
          function is(x, y) {
            // SameValue algorithm
            if (x === y) {
              // Steps 1-5, 7-10
              // Steps 6.b-6.e: +0 != -0
              return x !== 0 || 1 / x === 1 / y
            } else {
              // Step 6.a: NaN == NaN
              return x !== x && y !== y
            }
          }
          /*eslint-enable no-self-compare*/

          /**
           * We use an Error-like object for backward compatibility as people may call
           * PropTypes directly and inspect their output. However, we don't use real
           * Errors anymore. We don't inspect their stack anyway, and creating them
           * is prohibitively expensive if they are created too often, such as what
           * happens in oneOfType() for any type before the one that matched.
           */
          function PropTypeError(message) {
            this.message = message
            this.stack = ''
          }
          // Make `instanceof Error` still work for returned errors.
          PropTypeError.prototype = Error.prototype

          function createChainableTypeChecker(validate) {
            if (true) {
              var manualPropTypeCallCache = {}
              var manualPropTypeWarningCount = 0
            }
            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
              componentName = componentName || ANONYMOUS
              propFullName = propFullName || propName

              if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                  // New behavior only for users of `prop-types` package
                  var err = new Error(
                    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
                      'Use `PropTypes.checkPropTypes()` to call them. ' +
                      'Read more at http://fb.me/use-check-prop-types'
                  )
                  err.name = 'Invariant Violation'
                  throw err
                } else if (true && typeof console !== 'undefined') {
                  // Old behavior for people using React.PropTypes
                  var cacheKey = componentName + ':' + propName
                  if (
                    !manualPropTypeCallCache[cacheKey] &&
                    // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3
                  ) {
                    printWarning(
                      'You are manually calling a React.PropTypes validation ' +
                        'function for the `' +
                        propFullName +
                        '` prop on `' +
                        componentName +
                        '`. This is deprecated ' +
                        'and will throw in the standalone `prop-types` package. ' +
                        'You may be seeing this warning due to a third-party PropTypes ' +
                        'library. See https://fb.me/react-warning-dont-call-proptypes ' +
                        'for details.'
                    )
                    manualPropTypeCallCache[cacheKey] = true
                    manualPropTypeWarningCount++
                  }
                }
              }
              if (props[propName] == null) {
                if (isRequired) {
                  if (props[propName] === null) {
                    return new PropTypeError(
                      'The ' +
                        location +
                        ' `' +
                        propFullName +
                        '` is marked as required ' +
                        ('in `' + componentName + '`, but its value is `null`.')
                    )
                  }
                  return new PropTypeError(
                    'The ' +
                      location +
                      ' `' +
                      propFullName +
                      '` is marked as required in ' +
                      ('`' + componentName + '`, but its value is `undefined`.')
                  )
                }
                return null
              } else {
                return validate(props, propName, componentName, location, propFullName)
              }
            }

            var chainedCheckType = checkType.bind(null, false)
            chainedCheckType.isRequired = checkType.bind(null, true)

            return chainedCheckType
          }

          function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
              var propValue = props[propName]
              var propType = getPropType(propValue)
              if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue)

                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type ' +
                    ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') +
                    ('`' + expectedType + '`.')
                )
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull)
          }

          function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError(
                  'Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.'
                )
              }
              var propValue = props[propName]
              if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue)
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type ' +
                    ('`' + propType + '` supplied to `' + componentName + '`, expected an array.')
                )
              }
              for (var i = 0; i < propValue.length; i++) {
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret)
                if (error instanceof Error) {
                  return error
                }
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName]
              if (!isValidElement(propValue)) {
                var propType = getPropType(propValue)
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type ' +
                    ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.')
                )
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createElementTypeTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName]
              if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue)
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type ' +
                    ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.')
                )
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
              if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS
                var actualClassName = getClassName(props[propName])
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type ' +
                    ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') +
                    ('instance of `' + expectedClassName + '`.')
                )
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) {
              if (true) {
                if (arguments.length > 1) {
                  printWarning(
                    'Invalid arguments supplied to oneOf, expected an array, got ' +
                      arguments.length +
                      ' arguments. ' +
                      'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
                  )
                } else {
                  printWarning('Invalid argument supplied to oneOf, expected an array.')
                }
              }
              return emptyFunctionThatReturnsNull
            }

            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName]
              for (var i = 0; i < expectedValues.length; i++) {
                if (is(propValue, expectedValues[i])) {
                  return null
                }
              }

              var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value)
                if (type === 'symbol') {
                  return String(value)
                }
                return value
              })
              return new PropTypeError(
                'Invalid ' +
                  location +
                  ' `' +
                  propFullName +
                  '` of value `' +
                  String(propValue) +
                  '` ' +
                  ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.')
              )
            }
            return createChainableTypeChecker(validate)
          }

          function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError(
                  'Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.'
                )
              }
              var propValue = props[propName]
              var propType = getPropType(propValue)
              if (propType !== 'object') {
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type ' +
                    ('`' + propType + '` supplied to `' + componentName + '`, expected an object.')
                )
              }
              for (var key in propValue) {
                if (has(propValue, key)) {
                  var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret)
                  if (error instanceof Error) {
                    return error
                  }
                }
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) {
              true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : undefined
              return emptyFunctionThatReturnsNull
            }

            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i]
              if (typeof checker !== 'function') {
                printWarning(
                  'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
                    'received ' +
                    getPostfixForTypeWarning(checker) +
                    ' at index ' +
                    i +
                    '.'
                )
                return emptyFunctionThatReturnsNull
              }
            }

            function validate(props, propName, componentName, location, propFullName) {
              for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                var checker = arrayOfTypeCheckers[i]
                if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                  return null
                }
              }

              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'))
            }
            return createChainableTypeChecker(validate)
          }

          function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              if (!isNode(props[propName])) {
                return new PropTypeError(
                  'Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.')
                )
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName]
              var propType = getPropType(propValue)
              if (propType !== 'object') {
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type `' +
                    propType +
                    '` ' +
                    ('supplied to `' + componentName + '`, expected `object`.')
                )
              }
              for (var key in shapeTypes) {
                var checker = shapeTypes[key]
                if (!checker) {
                  continue
                }
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret)
                if (error) {
                  return error
                }
              }
              return null
            }
            return createChainableTypeChecker(validate)
          }

          function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName]
              var propType = getPropType(propValue)
              if (propType !== 'object') {
                return new PropTypeError(
                  'Invalid ' +
                    location +
                    ' `' +
                    propFullName +
                    '` of type `' +
                    propType +
                    '` ' +
                    ('supplied to `' + componentName + '`, expected `object`.')
                )
              }
              // We need to check all keys in case some are required but missing from
              // props.
              var allKeys = assign({}, props[propName], shapeTypes)
              for (var key in allKeys) {
                var checker = shapeTypes[key]
                if (!checker) {
                  return new PropTypeError(
                    'Invalid ' +
                      location +
                      ' `' +
                      propFullName +
                      '` key `' +
                      key +
                      '` supplied to `' +
                      componentName +
                      '`.' +
                      '\nBad object: ' +
                      JSON.stringify(props[propName], null, '  ') +
                      '\nValid keys: ' +
                      JSON.stringify(Object.keys(shapeTypes), null, '  ')
                  )
                }
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret)
                if (error) {
                  return error
                }
              }
              return null
            }

            return createChainableTypeChecker(validate)
          }

          function isNode(propValue) {
            switch (typeof propValue) {
              case 'number':
              case 'string':
              case 'undefined':
                return true
              case 'boolean':
                return !propValue
              case 'object':
                if (Array.isArray(propValue)) {
                  return propValue.every(isNode)
                }
                if (propValue === null || isValidElement(propValue)) {
                  return true
                }

                var iteratorFn = getIteratorFn(propValue)
                if (iteratorFn) {
                  var iterator = iteratorFn.call(propValue)
                  var step
                  if (iteratorFn !== propValue.entries) {
                    while (!(step = iterator.next()).done) {
                      if (!isNode(step.value)) {
                        return false
                      }
                    }
                  } else {
                    // Iterator will provide entry [k,v] tuples rather than values.
                    while (!(step = iterator.next()).done) {
                      var entry = step.value
                      if (entry) {
                        if (!isNode(entry[1])) {
                          return false
                        }
                      }
                    }
                  }
                } else {
                  return false
                }

                return true
              default:
                return false
            }
          }

          function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === 'symbol') {
              return true
            }

            // falsy value can't be a Symbol
            if (!propValue) {
              return false
            }

            // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
            if (propValue['@@toStringTag'] === 'Symbol') {
              return true
            }

            // Fallback for non-spec compliant Symbols which are polyfilled.
            if (typeof Symbol === 'function' && propValue instanceof Symbol) {
              return true
            }

            return false
          }

          // Equivalent of `typeof` but with special handling for array and regexp.
          function getPropType(propValue) {
            var propType = typeof propValue
            if (Array.isArray(propValue)) {
              return 'array'
            }
            if (propValue instanceof RegExp) {
              // Old webkits (at least until Android 4.0) return 'function' rather than
              // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
              // passes PropTypes.object.
              return 'object'
            }
            if (isSymbol(propType, propValue)) {
              return 'symbol'
            }
            return propType
          }

          // This handles more types than `getPropType`. Only used for error messages.
          // See `createPrimitiveTypeChecker`.
          function getPreciseType(propValue) {
            if (typeof propValue === 'undefined' || propValue === null) {
              return '' + propValue
            }
            var propType = getPropType(propValue)
            if (propType === 'object') {
              if (propValue instanceof Date) {
                return 'date'
              } else if (propValue instanceof RegExp) {
                return 'regexp'
              }
            }
            return propType
          }

          // Returns a string that is postfixed to a warning about an invalid type.
          // For example, "undefined" or "of type array"
          function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value)
            switch (type) {
              case 'array':
              case 'object':
                return 'an ' + type
              case 'boolean':
              case 'date':
              case 'regexp':
                return 'a ' + type
              default:
                return type
            }
          }

          // Returns class name of the object, if any.
          function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) {
              return ANONYMOUS
            }
            return propValue.constructor.name
          }

          ReactPropTypes.checkPropTypes = checkPropTypes
          ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache
          ReactPropTypes.PropTypes = ReactPropTypes

          return ReactPropTypes
        }

        /***/
      },

    /***/ '../node_modules/prop-types/index.js':
      /*!*******************************************!*\
  !*** ../node_modules/prop-types/index.js ***!
  \*******************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        if (true) {
          var ReactIs = __webpack_require__(/*! react-is */ '../node_modules/react-is/index.js')

          // By explicitly using `prop-types` you are opting into new development behavior.
          // http://fb.me/prop-types-in-prod
          var throwOnDirectAccess = true
          module.exports = __webpack_require__(/*! ./factoryWithTypeCheckers */ '../node_modules/prop-types/factoryWithTypeCheckers.js')(
            ReactIs.isElement,
            throwOnDirectAccess
          )
        } else {
        }

        /***/
      },

    /***/ '../node_modules/prop-types/lib/ReactPropTypesSecret.js':
      /*!**************************************************************!*\
  !*** ../node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED'

        module.exports = ReactPropTypesSecret

        /***/
      },

    /***/ '../node_modules/react-is/cjs/react-is.development.js':
      /*!************************************************************!*\
  !*** ../node_modules/react-is/cjs/react-is.development.js ***!
  \************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'
        /** @license React v16.8.5
         * react-is.development.js
         *
         * Copyright (c) Facebook, Inc. and its affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        if (true) {
          ;(function () {
            'use strict'

            Object.defineProperty(exports, '__esModule', { value: true })

            // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
            // nor polyfill, then a plain number is used for performance.
            var hasSymbol = typeof Symbol === 'function' && Symbol.for

            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7
            var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca
            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb
            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc
            var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2
            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd
            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace
            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf
            var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf
            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0
            var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1
            var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3
            var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4

            function isValidElementType(type) {
              return (
                typeof type === 'string' ||
                typeof type === 'function' ||
                // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                type === REACT_FRAGMENT_TYPE ||
                type === REACT_CONCURRENT_MODE_TYPE ||
                type === REACT_PROFILER_TYPE ||
                type === REACT_STRICT_MODE_TYPE ||
                type === REACT_SUSPENSE_TYPE ||
                (typeof type === 'object' &&
                  type !== null &&
                  (type.$$typeof === REACT_LAZY_TYPE ||
                    type.$$typeof === REACT_MEMO_TYPE ||
                    type.$$typeof === REACT_PROVIDER_TYPE ||
                    type.$$typeof === REACT_CONTEXT_TYPE ||
                    type.$$typeof === REACT_FORWARD_REF_TYPE))
              )
            }

            /**
             * Forked from fbjs/warning:
             * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
             *
             * Only change is we use console.warn instead of console.error,
             * and do nothing when 'console' is not supported.
             * This really simplifies the code.
             * ---
             * Similar to invariant but only logs a warning if the condition is not met.
             * This can be used to log issues in development environments in critical
             * paths. Removing the logging code for production environments will keep the
             * same logic and follow the same code paths.
             */

            var lowPriorityWarning = function () {}

            {
              var printWarning = function (format) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = arguments[_key]
                }

                var argIndex = 0
                var message =
                  'Warning: ' +
                  format.replace(/%s/g, function () {
                    return args[argIndex++]
                  })
                if (typeof console !== 'undefined') {
                  console.warn(message)
                }
                try {
                  // --- Welcome to debugging React ---
                  // This error was thrown as a convenience so that you can use this stack
                  // to find the callsite that caused this warning to fire.
                  throw new Error(message)
                } catch (x) {}
              }

              lowPriorityWarning = function (condition, format) {
                if (format === undefined) {
                  throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument')
                }
                if (!condition) {
                  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                    args[_key2 - 2] = arguments[_key2]
                  }

                  printWarning.apply(undefined, [format].concat(args))
                }
              }
            }

            var lowPriorityWarning$1 = lowPriorityWarning

            function typeOf(object) {
              if (typeof object === 'object' && object !== null) {
                var $$typeof = object.$$typeof
                switch ($$typeof) {
                  case REACT_ELEMENT_TYPE:
                    var type = object.type

                    switch (type) {
                      case REACT_ASYNC_MODE_TYPE:
                      case REACT_CONCURRENT_MODE_TYPE:
                      case REACT_FRAGMENT_TYPE:
                      case REACT_PROFILER_TYPE:
                      case REACT_STRICT_MODE_TYPE:
                      case REACT_SUSPENSE_TYPE:
                        return type
                      default:
                        var $$typeofType = type && type.$$typeof

                        switch ($$typeofType) {
                          case REACT_CONTEXT_TYPE:
                          case REACT_FORWARD_REF_TYPE:
                          case REACT_PROVIDER_TYPE:
                            return $$typeofType
                          default:
                            return $$typeof
                        }
                    }
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PORTAL_TYPE:
                    return $$typeof
                }
              }

              return undefined
            }

            // AsyncMode is deprecated along with isAsyncMode
            var AsyncMode = REACT_ASYNC_MODE_TYPE
            var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE
            var ContextConsumer = REACT_CONTEXT_TYPE
            var ContextProvider = REACT_PROVIDER_TYPE
            var Element = REACT_ELEMENT_TYPE
            var ForwardRef = REACT_FORWARD_REF_TYPE
            var Fragment = REACT_FRAGMENT_TYPE
            var Lazy = REACT_LAZY_TYPE
            var Memo = REACT_MEMO_TYPE
            var Portal = REACT_PORTAL_TYPE
            var Profiler = REACT_PROFILER_TYPE
            var StrictMode = REACT_STRICT_MODE_TYPE
            var Suspense = REACT_SUSPENSE_TYPE

            var hasWarnedAboutDeprecatedIsAsyncMode = false

            // AsyncMode should be deprecated
            function isAsyncMode(object) {
              {
                if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                  hasWarnedAboutDeprecatedIsAsyncMode = true
                  lowPriorityWarning$1(
                    false,
                    'The ReactIs.isAsyncMode() alias has been deprecated, ' +
                      'and will be removed in React 17+. Update your code to use ' +
                      'ReactIs.isConcurrentMode() instead. It has the exact same API.'
                  )
                }
              }
              return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE
            }
            function isConcurrentMode(object) {
              return typeOf(object) === REACT_CONCURRENT_MODE_TYPE
            }
            function isContextConsumer(object) {
              return typeOf(object) === REACT_CONTEXT_TYPE
            }
            function isContextProvider(object) {
              return typeOf(object) === REACT_PROVIDER_TYPE
            }
            function isElement(object) {
              return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE
            }
            function isForwardRef(object) {
              return typeOf(object) === REACT_FORWARD_REF_TYPE
            }
            function isFragment(object) {
              return typeOf(object) === REACT_FRAGMENT_TYPE
            }
            function isLazy(object) {
              return typeOf(object) === REACT_LAZY_TYPE
            }
            function isMemo(object) {
              return typeOf(object) === REACT_MEMO_TYPE
            }
            function isPortal(object) {
              return typeOf(object) === REACT_PORTAL_TYPE
            }
            function isProfiler(object) {
              return typeOf(object) === REACT_PROFILER_TYPE
            }
            function isStrictMode(object) {
              return typeOf(object) === REACT_STRICT_MODE_TYPE
            }
            function isSuspense(object) {
              return typeOf(object) === REACT_SUSPENSE_TYPE
            }

            exports.typeOf = typeOf
            exports.AsyncMode = AsyncMode
            exports.ConcurrentMode = ConcurrentMode
            exports.ContextConsumer = ContextConsumer
            exports.ContextProvider = ContextProvider
            exports.Element = Element
            exports.ForwardRef = ForwardRef
            exports.Fragment = Fragment
            exports.Lazy = Lazy
            exports.Memo = Memo
            exports.Portal = Portal
            exports.Profiler = Profiler
            exports.StrictMode = StrictMode
            exports.Suspense = Suspense
            exports.isValidElementType = isValidElementType
            exports.isAsyncMode = isAsyncMode
            exports.isConcurrentMode = isConcurrentMode
            exports.isContextConsumer = isContextConsumer
            exports.isContextProvider = isContextProvider
            exports.isElement = isElement
            exports.isForwardRef = isForwardRef
            exports.isFragment = isFragment
            exports.isLazy = isLazy
            exports.isMemo = isMemo
            exports.isPortal = isPortal
            exports.isProfiler = isProfiler
            exports.isStrictMode = isStrictMode
            exports.isSuspense = isSuspense
          })()
        }

        /***/
      },

    /***/ '../node_modules/react-is/index.js':
      /*!*****************************************!*\
  !*** ../node_modules/react-is/index.js ***!
  \*****************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        if (false) {
        } else {
          module.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ '../node_modules/react-is/cjs/react-is.development.js')
        }

        /***/
      },

    /***/ '../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js':
      /*!*****************************************************************************!*\
  !*** ../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js ***!
  \*****************************************************************************/
      /*! exports provided: polyfill */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'polyfill', function () {
          return polyfill
        })
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        function componentWillMount() {
          // Call this.constructor.gDSFP to support sub-classes.
          var state = this.constructor.getDerivedStateFromProps(this.props, this.state)
          if (state !== null && state !== undefined) {
            this.setState(state)
          }
        }

        function componentWillReceiveProps(nextProps) {
          // Call this.constructor.gDSFP to support sub-classes.
          // Use the setState() updater to ensure state isn't stale in certain edge cases.
          function updater(prevState) {
            var state = this.constructor.getDerivedStateFromProps(nextProps, prevState)
            return state !== null && state !== undefined ? state : null
          }
          // Binding "this" is important for shallow renderer support.
          this.setState(updater.bind(this))
        }

        function componentWillUpdate(nextProps, nextState) {
          try {
            var prevProps = this.props
            var prevState = this.state
            this.props = nextProps
            this.state = nextState
            this.__reactInternalSnapshotFlag = true
            this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState)
          } finally {
            this.props = prevProps
            this.state = prevState
          }
        }

        // React may warn about cWM/cWRP/cWU methods being deprecated.
        // Add a flag to suppress these warnings for this special case.
        componentWillMount.__suppressDeprecationWarning = true
        componentWillReceiveProps.__suppressDeprecationWarning = true
        componentWillUpdate.__suppressDeprecationWarning = true

        function polyfill(Component) {
          var prototype = Component.prototype

          if (!prototype || !prototype.isReactComponent) {
            throw new Error('Can only polyfill class components')
          }

          if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
            return Component
          }

          // If new component APIs are defined, "unsafe" lifecycles won't be called.
          // Error if any of these lifecycles are present,
          // Because they would work differently between older and newer (16.3+) versions of React.
          var foundWillMountName = null
          var foundWillReceivePropsName = null
          var foundWillUpdateName = null
          if (typeof prototype.componentWillMount === 'function') {
            foundWillMountName = 'componentWillMount'
          } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
            foundWillMountName = 'UNSAFE_componentWillMount'
          }
          if (typeof prototype.componentWillReceiveProps === 'function') {
            foundWillReceivePropsName = 'componentWillReceiveProps'
          } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
            foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps'
          }
          if (typeof prototype.componentWillUpdate === 'function') {
            foundWillUpdateName = 'componentWillUpdate'
          } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
            foundWillUpdateName = 'UNSAFE_componentWillUpdate'
          }
          if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
            var componentName = Component.displayName || Component.name
            var newApiName =
              typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()'

            throw Error(
              'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
                componentName +
                ' uses ' +
                newApiName +
                ' but also contains the following legacy lifecycles:' +
                (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
                (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') +
                (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
                '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
                'https://fb.me/react-async-component-lifecycle-hooks'
            )
          }

          // React <= 16.2 does not support static getDerivedStateFromProps.
          // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
          // Newer versions of React will ignore these lifecycles if gDSFP exists.
          if (typeof Component.getDerivedStateFromProps === 'function') {
            prototype.componentWillMount = componentWillMount
            prototype.componentWillReceiveProps = componentWillReceiveProps
          }

          // React <= 16.2 does not support getSnapshotBeforeUpdate.
          // As a workaround, use cWU to invoke the new lifecycle.
          // Newer versions of React will ignore that lifecycle if gSBU exists.
          if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
            if (typeof prototype.componentDidUpdate !== 'function') {
              throw new Error(
                'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
              )
            }

            prototype.componentWillUpdate = componentWillUpdate

            var componentDidUpdate = prototype.componentDidUpdate

            prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
              // 16.3+ will not execute our will-update method;
              // It will pass a snapshot value to did-update though.
              // Older versions will require our polyfilled will-update value.
              // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
              // Because for <= 15.x versions this might be a "prevContext" object.
              // We also can't just check "__reactInternalSnapshot",
              // Because get-snapshot might return a falsy value.
              // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
              var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot

              componentDidUpdate.call(this, prevProps, prevState, snapshot)
            }
          }

          return Component
        }

        /***/
      },

    /***/ '../node_modules/react-responsive-ui/commonjs/Select.js':
      /*!**************************************************************!*\
  !*** ../node_modules/react-responsive-ui/commonjs/Select.js ***!
  \**************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _reactDom = __webpack_require__(/*! react-dom */ 'react-dom')

        var _reactDom2 = _interopRequireDefault(_reactDom)

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        var _scrollIntoViewIfNeeded = __webpack_require__(
          /*! scroll-into-view-if-needed */ '../node_modules/scroll-into-view-if-needed/dist/index.js'
        )

        var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded)

        var _dom = __webpack_require__(/*! ./utility/dom */ '../node_modules/react-responsive-ui/commonjs/utility/dom.js')

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && (typeof call === 'object' || typeof call === 'function') ? call : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass)
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        // Possible enhancements:
        //
        //  * If the menu is close to a screen edge,
        //    automatically reposition it so that it fits on the screen
        //  * Maybe show menu immediately above the toggler
        //    (like in Material design), not below it.
        //
        // https://material.google.com/components/menus.html

        var Empty_value_option_value = ''

        var value_prop_type = _propTypes2.default.oneOfType([
          _propTypes2.default.string,
          _propTypes2.default.number,
          _propTypes2.default.bool,
        ])

        var Select = (function (_PureComponent) {
          _inherits(Select, _PureComponent)

          function Select(props) {
            _classCallCheck(this, Select)

            // Shouldn't memory leak because
            // the set of options is assumed to be constant.
            var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props))

            _initialiseProps.call(_this)

            _this.options = {}

            var _this$props = _this.props,
              value = _this$props.value,
              autocomplete = _this$props.autocomplete,
              options = _this$props.options,
              children = _this$props.children,
              menu = _this$props.menu,
              toggler = _this$props.toggler,
              onChange = _this$props.onChange

            if (autocomplete) {
              if (!options) {
                throw new Error('"options" property is required for an "autocomplete" select')
              }

              _this.state.matching_options = _this.get_matching_options(options, value)
            }

            if (children && !menu) {
              _react2.default.Children.forEach(children, function (element) {
                if (!element.props.value) {
                  throw new Error('You must specify "value" prop on each child of <Select/>')
                }

                if (!element.props.label) {
                  throw new Error('You must specify "label" prop on each child of <Select/>')
                }
              })
            }

            if (menu && !toggler) {
              throw new Error('Supply a "toggler" component when enabling "menu" in <Select/>')
            }

            if (!menu && !onChange) {
              throw new Error('"onChange" property must be specified for a non-menu <Select/>')
            }
            return _this
          }

          // Client side rendering, javascript is enabled

          _createClass(Select, [
            {
              key: 'componentDidMount',
              value: function componentDidMount() {
                var _props = this.props,
                  fallback = _props.fallback,
                  nativeExpanded = _props.nativeExpanded

                document.addEventListener('click', this.document_clicked)

                if (fallback) {
                  this.setState({ javascript: true })
                }

                if (nativeExpanded) {
                  this.resize_native_expanded_select()
                  window.addEventListener('resize', this.resize_native_expanded_select)
                }
              },
            },
            {
              key: 'componentDidUpdate',
              value: function componentDidUpdate(previous_props, previous_state) {
                var _props2 = this.props,
                  nativeExpanded = _props2.nativeExpanded,
                  value = _props2.value
                var _state = this.state,
                  expanded = _state.expanded,
                  height = _state.height

                if (expanded !== previous_state.expanded) {
                  if (expanded && this.should_animate()) {
                    if (height === undefined) {
                      this.calculate_height()
                    }
                  }
                }

                // If the `value` changed then resize the native expanded `<select/>`
                if (nativeExpanded && value !== previous_props.value) {
                  this.resize_native_expanded_select()
                }
              },
            },
            {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                var nativeExpanded = this.props.nativeExpanded

                document.removeEventListener('click', this.document_clicked)

                if (nativeExpanded) {
                  window.removeEventListener('resize', this.resize_native_expanded_select)
                }

                clearTimeout(this.toggle_timeout)
                clearTimeout(this.scroll_into_view_timeout)
                clearTimeout(this.restore_focus_on_collapse_timeout)

                this.toggle_timeout = undefined
                this.scroll_into_view_timeout = undefined
                this.restore_focus_on_collapse_timeout = undefined
              },
            },
            {
              key: 'render',
              value: function render() {
                var _this2 = this

                var _props3 = this.props,
                  id = _props3.id,
                  upward = _props3.upward,
                  concise = _props3.concise,
                  compact = _props3.compact,
                  scroll = _props3.scroll,
                  children = _props3.children,
                  menu = _props3.menu,
                  toggler = _props3.toggler,
                  alignment = _props3.alignment,
                  autocomplete = _props3.autocomplete,
                  saveOnIcons = _props3.saveOnIcons,
                  fallback = _props3.fallback,
                  native = _props3.native,
                  nativeExpanded = _props3.nativeExpanded,
                  disabled = _props3.disabled,
                  required = _props3.required,
                  placeholder = _props3.placeholder,
                  label = _props3.label,
                  value = _props3.value,
                  error = _props3.error,
                  closeButton = _props3.closeButton,
                  closeAriaLabel = _props3.closeAriaLabel,
                  style = _props3.style,
                  className = _props3.className
                var _state2 = this.state,
                  expanded = _state2.expanded,
                  list_height = _state2.list_height

                var options = this.get_options()

                var list_style = void 0

                // Makes the options list scrollable (only when not in `autocomplete` mode).
                if (this.is_scrollable() && list_height !== undefined) {
                  list_style = { maxHeight: list_height + 'px' }
                }

                var overflow = scroll && options && this.overflown()

                var list_items = void 0

                // If a list of options is supplied as an array of `{ value, label }`,
                // then transform those elements to <buttons/>
                if (options) {
                  list_items = options.map(function (_ref, index) {
                    var value = _ref.value,
                      label = _ref.label,
                      icon = _ref.icon

                    return _this2.render_list_item({
                      index: index,
                      value: value,
                      label: label,
                      icon: !saveOnIcons && icon,
                      overflow: overflow,
                    })
                  })
                }
                // Else, if a list of options is supplied as a set of child React elements,
                // then render those elements.
                else {
                  list_items = _react2.default.Children.map(children, function (element, index) {
                    if (!element) {
                      return
                    }

                    return _this2.render_list_item({ index: index, element: element })
                  })
                }

                var wrapper_style = { textAlign: alignment }

                var selected = this.get_selected_option()

                var show_options_list = !native && !nativeExpanded && list_items.length > 0
                var show_label = label && (this.get_selected_option() || placeholder)

                return _react2.default.createElement(
                  'div',
                  {
                    ref: function ref(_ref3) {
                      return (_this2.select = _ref3)
                    },
                    onKeyDown: this.on_key_down_in_container,
                    onBlur: this.on_blur,
                    style: style ? _extends({}, wrapper_style, style) : wrapper_style,
                    className: (0, _classnames2.default)(
                      'rrui__select',
                      {
                        rrui__rich: fallback,
                        'rrui__select--menu': menu,
                        'rrui__select--upward': upward,
                        'rrui__select--expanded': expanded,
                        'rrui__select--collapsed': !expanded,
                        'rrui__select--disabled': disabled,
                        'rrui__select--compact': compact || (concise && !autocomplete),
                      },
                      className
                    ),
                  },
                  _react2.default.createElement(
                    'div',
                    {
                      className: (0, _classnames2.default)({
                        rrui__input: !toggler,
                      }),
                    },
                    !menu && !native && this.render_selected_item(show_label),
                    show_label &&
                      _react2.default.createElement(
                        'label',
                        {
                          htmlFor: id,
                          className: (0, _classnames2.default)('rrui__input-label', {
                            'rrui__input-label--required': required && value_is_empty(value),
                            'rrui__input-label--invalid': this.should_indicate_invalid(),
                          }),
                        },
                        label
                      ),
                    menu && this.render_toggler(),
                    show_options_list &&
                      _react2.default.createElement(
                        'ul',
                        {
                          ref: function ref(_ref2) {
                            return (_this2.list = _ref2)
                          },
                          style: list_style,
                          className: (0, _classnames2.default)(
                            'rrui__expandable',
                            'rrui__expandable--overlay',
                            'rrui__select__options',
                            'rrui__shadow',
                            {
                              'rrui__select__options--autocomplete': autocomplete,
                              'rrui__select__options--menu': menu,
                              'rrui__expandable--expanded': expanded,
                              'rrui__select__options--expanded': expanded,
                              'rrui__expandable--left-aligned': alignment === 'left',
                              'rrui__expandable--right-aligned': alignment === 'right',
                              'rrui__select__options--left-aligned': !children && alignment === 'left',
                              'rrui__select__options--right-aligned': !children && alignment === 'right',
                              // CSS selector performance optimization
                              'rrui__select__options--upward': upward,
                              'rrui__select__options--downward': !upward,
                            }
                          ),
                        },
                        list_items
                      ),
                    show_options_list &&
                      expanded &&
                      closeButton &&
                      _react2.default.createElement(
                        'button',
                        {
                          type: 'button',
                          onClick: this.toggle,
                          'aria-label': closeAriaLabel,
                          className: (0, _classnames2.default)('rrui__button-reset', 'rrui__select__close', {
                            'rrui__select__close--autocomplete': autocomplete,
                          }),
                        },
                        closeButton
                      ),
                    (native || (fallback && !this.state.javascript)) && this.render_static()
                  ),
                  this.should_indicate_invalid() && _react2.default.createElement('div', { className: 'rrui__input-error' }, error)
                )
              },
            },
            {
              key: 'render_list_item',
              value: function render_list_item(
                _ref4 // , first, last
              ) {
                var _this3 = this

                var index = _ref4.index,
                  element = _ref4.element,
                  value = _ref4.value,
                  label = _ref4.label,
                  icon = _ref4.icon,
                  overflow = _ref4.overflow
                var _props4 = this.props,
                  disabled = _props4.disabled,
                  menu = _props4.menu,
                  scrollbarPadding = _props4.scrollbarPadding
                var _state3 = this.state,
                  focused_option_value = _state3.focused_option_value,
                  expanded = _state3.expanded

                // If a list of options is supplied as a set of child React elements,
                // then extract values from their props.

                if (element) {
                  value = element.props.value
                }

                var is_focused = !menu && value === focused_option_value

                var item_style = void 0

                // on overflow the vertical scrollbar will take up space
                // reducing padding-right and the only way to fix that
                // is to add additional padding-right
                //
                // a hack to restore padding-right taken up by a vertical scrollbar
                if (overflow && scrollbarPadding) {
                  item_style = { marginRight: (0, _dom.getScrollbarWidth)() + 'px' }
                }

                var button = void 0

                // If a list of options is supplied as a set of child React elements,
                // then enhance those elements with extra props.
                if (element) {
                  var extra_props = {
                    style: item_style ? _extends({}, item_style, element.props.style) : element.props.style,
                    className: (0, _classnames2.default)(
                      'rrui__button-reset',
                      'rrui__select__option',
                      {
                        'rrui__select__option--focused': is_focused,
                      },
                      element.props.className
                    ),
                  }

                  var onClick = element.props.onClick

                  extra_props.onClick = function (event) {
                    if (menu) {
                      _this3.toggle()
                    } else {
                      _this3.item_clicked(value, event)
                    }

                    if (onClick) {
                      onClick(event)
                    }
                  }

                  button = _react2.default.cloneElement(element, extra_props)
                }
                // Else, if a list of options is supplied as an array of `{ value, label }`,
                // then transform those options to <buttons/>
                else {
                  if (icon) {
                    icon = render_icon(icon)
                  }

                  button = _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      onClick: function onClick(event) {
                        return _this3.item_clicked(value, event)
                      },
                      disabled: disabled,
                      tabIndex: '-1',
                      'aria-label': label,
                      className: (0, _classnames2.default)('rrui__button-reset', 'rrui__select__option', {
                        'rrui__select__option--focused': is_focused,
                        // CSS selector performance optimization
                        'rrui__select__option--disabled': disabled,
                      }),
                      style: item_style,
                    },
                    icon &&
                      _react2.default.cloneElement(icon, {
                        className: (0, _classnames2.default)(icon.props.className, 'rrui__select__option-icon'),
                      }),
                    label
                  )
                }

                return _react2.default.createElement(
                  'li',
                  {
                    key: get_option_key(value),
                    ref: function ref(_ref5) {
                      return (_this3.options[get_option_key(value)] = _ref5)
                    },
                    className: (0, _classnames2.default)('rrui__expandable__content', 'rrui__select__options-list-item', {
                      'rrui__select__separator-option': element && element.type === Select.Separator,
                      'rrui__expandable__content--expanded': expanded,
                      // CSS selector performance optimization
                      'rrui__select__options-list-item--expanded': expanded,
                    }),
                  },
                  button
                )
              },

              // Renders the selected option
              // and possibly a transparent native `<select/>` above it
              // so that the native `<select/>` expands upon click
              // on the selected option
              // (in case of `nativeExpanded` setting).
            },
            {
              key: 'render_selected_item',
              value: function render_selected_item(label_is_shown) {
                var _props5 = this.props,
                  nativeExpanded = _props5.nativeExpanded,
                  toggler = _props5.toggler

                if (toggler) {
                  return this.render_toggler()
                }

                var selected = this.render_selected_item_only(label_is_shown)

                if (nativeExpanded) {
                  return _react2.default.createElement(
                    'div',
                    { style: native_expanded_select_container_style },
                    this.render_static(),
                    selected
                  )
                }

                return selected
              },
            },
            {
              key: 'render_selected_item_only',
              value: function render_selected_item_only(label_is_shown) {
                var _this4 = this

                var _props6 = this.props,
                  children = _props6.children,
                  value = _props6.value,
                  placeholder = _props6.placeholder,
                  label = _props6.label,
                  disabled = _props6.disabled,
                  required = _props6.required,
                  autocomplete = _props6.autocomplete,
                  concise = _props6.concise,
                  nativeExpanded = _props6.nativeExpanded,
                  tabIndex = _props6.tabIndex,
                  onFocus = _props6.onFocus,
                  title = _props6.title,
                  ariaLabel = _props6.ariaLabel,
                  inputClassName = _props6.inputClassName,
                  toggleClassName = _props6.toggleClassName
                var _state4 = this.state,
                  expanded = _state4.expanded,
                  autocomplete_width = _state4.autocomplete_width,
                  autocomplete_input_value = _state4.autocomplete_input_value

                var selected = this.get_selected_option()
                var selected_label = this.get_selected_option_label()

                var selected_text = selected ? selected_label : placeholder || label

                var selected_style_classes = {
                  'rrui__input-element': true,
                }

                if (autocomplete && expanded) {
                  // style = { ...style, width: autocomplete_width + 'px' }

                  return _react2.default.createElement('input', {
                    type: 'text',
                    ref: function ref(_ref6) {
                      return (_this4.autocomplete = _ref6)
                    },
                    placeholder: selected_text,
                    value: autocomplete_input_value,
                    onChange: this.on_autocomplete_input_change,
                    onKeyDown: this.on_key_down,
                    onFocus: onFocus,
                    tabIndex: tabIndex,
                    title: title,
                    className: (0, _classnames2.default)(
                      selected_style_classes,
                      'rrui__input-field',
                      'rrui__select__autocomplete',
                      inputClassName,
                      // CSS selector performance optimization
                      // (should it even be optimized).
                      {
                        'rrui__input-field--disabled': disabled,
                      }
                    ),
                  })
                }

                var show_selected_as_an_icon = concise && selected && selected.icon

                return _react2.default.createElement(
                  'button',
                  {
                    ref: function ref(_ref7) {
                      return (_this4.selected = _ref7)
                    },
                    type: 'button',
                    disabled: disabled,
                    onClick: this.toggle,
                    onKeyDown: this.on_key_down,
                    onFocus: onFocus,
                    tabIndex: nativeExpanded ? -1 : tabIndex,
                    title: title,
                    'aria-label': ariaLabel,
                    className: (0, _classnames2.default)(
                      selected_style_classes,
                      'rrui__button-reset',
                      'rrui__select__button',
                      toggleClassName,
                      {
                        'rrui__select__button--empty': !selected_label,
                        'rrui__select__button--invalid': this.should_indicate_invalid(),
                        'rrui__input-element--invalid': this.should_indicate_invalid(),
                        // CSS selector performance optimization
                        // (should it even be optimized).
                        'rrui__select__button--disabled': disabled,
                      }
                    ),
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'rrui__select__selected-content' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: (0, _classnames2.default)('rrui__select__selected-label', {
                          'rrui__select__selected-label--required': !label_is_shown && required && value_is_empty(value),
                        }),
                      },
                      show_selected_as_an_icon
                        ? _react2.default.cloneElement(render_icon(selected.icon), { title: selected_label })
                        : selected_text
                    ),
                    _react2.default.createElement('div', {
                      className: (0, _classnames2.default)('rrui__select__arrow', {
                        // CSS selector performance optimization
                        'rrui__select__arrow--expanded': expanded,
                        'rrui__select__arrow--disabled': disabled,
                      }),
                    })
                  )
                )
              },
            },
            {
              key: 'render_toggler',
              value: function render_toggler() {
                var _this5 = this

                var toggler = this.props.toggler

                return _react2.default.createElement(
                  'div',
                  { className: 'rrui__select__toggler' },
                  _react2.default.cloneElement(toggler, {
                    ref: function ref(_ref8) {
                      return (_this5.selected = _ref8)
                    },
                    onClick: this.toggle,
                    onKeyDown: this.on_key_down,
                  })
                )
              },

              // supports disabled javascript
            },
            {
              key: 'render_static',
              value: function render_static() {
                var _this6 = this

                var _props7 = this.props,
                  id = _props7.id,
                  name = _props7.name,
                  value = _props7.value,
                  label = _props7.label,
                  disabled = _props7.disabled,
                  options = _props7.options,
                  menu = _props7.menu,
                  toggler = _props7.toggler,
                  fallback = _props7.fallback,
                  native = _props7.native,
                  nativeExpanded = _props7.nativeExpanded,
                  tabIndex = _props7.tabIndex,
                  children = _props7.children

                if (menu) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: (0, _classnames2.default)({
                        rrui__rich__fallback: fallback,
                      }),
                    },
                    toggler
                  )
                }

                return _react2.default.createElement(
                  'select',
                  {
                    ref: function ref(_ref9) {
                      return (_this6.native = _ref9)
                    },
                    id: id,
                    name: name,
                    value: value_is_empty(value) ? Empty_value_option_value : value,
                    disabled: disabled,
                    onChange: this.native_select_on_change,
                    tabIndex: native || nativeExpanded ? tabIndex : undefined,
                    className: (0, _classnames2.default)('rrui__input', 'rrui__select__native', {
                      'rrui__select__native-expanded': nativeExpanded,
                      rrui__rich__fallback: fallback,
                    }),
                  },
                  options
                    ? this.render_native_select_options(options, value_is_empty(value))
                    : _react2.default.Children.map(children, function (child) {
                        if (!child) {
                          return
                        }

                        return _react2.default.createElement(
                          'option',
                          {
                            className: 'rrui__select__native-option',
                            key: child.props.value,
                            value: child.props.value,
                          },
                          child.props.label
                        )
                      })
                )
              },
            },
            {
              key: 'render_native_select_options',
              value: function render_native_select_options(options, empty_option_is_selected) {
                var placeholder = this.props.placeholder

                var empty_option_present = false

                var rendered_options = options.map(function (option) {
                  var value = option.value,
                    label = option.label

                  if (value_is_empty(value)) {
                    empty_option_present = true
                    value = Empty_value_option_value
                  }

                  return _react2.default.createElement(
                    'option',
                    {
                      className: 'rrui__select__native-option',
                      key: get_option_key(value),
                      value: value,
                    },
                    label
                  )
                })

                if (empty_option_is_selected && !empty_option_present) {
                  rendered_options.unshift(
                    _react2.default.createElement(
                      'option',
                      {
                        className: 'rrui__select__native-option',
                        key: get_option_key(undefined),
                        value: '',
                      },
                      placeholder
                    )
                  )
                }

                return rendered_options
              },

              // Whether should indicate that the input value is invalid
            },
            {
              key: 'should_indicate_invalid',
              value: function should_indicate_invalid() {
                var _props8 = this.props,
                  indicateInvalid = _props8.indicateInvalid,
                  error = _props8.error

                return indicateInvalid && error
              },
            },
            {
              key: 'get_selected_option',
              value: function get_selected_option() {
                var value = this.props.value

                return this.get_option(value)
              },
            },
            {
              key: 'get_option',
              value: function get_option(value) {
                var _props9 = this.props,
                  options = _props9.options,
                  children = _props9.children

                if (options) {
                  return options.filter(function (x) {
                    return x.value === value
                  })[0]
                }

                var option = void 0

                _react2.default.Children.forEach(children, function (child) {
                  if (child.props.value === value) {
                    option = child
                  }
                })

                return option
              },
            },
            {
              key: 'get_option_index',
              value: function get_option_index(option) {
                var _props10 = this.props,
                  options = _props10.options,
                  children = _props10.children

                if (options) {
                  return options.indexOf(option)
                }

                var option_index = void 0

                _react2.default.Children.forEach(children, function (child, index) {
                  if (child.props.value === option.value) {
                    option_index = index
                  }
                })

                return option_index
              },
            },
            {
              key: 'get_selected_option_label',
              value: function get_selected_option_label() {
                var options = this.props.options

                var selected = this.get_selected_option()

                if (!selected) {
                  return
                }

                if (options) {
                  return selected.label
                }

                return selected.props.label
              },
            },
            {
              key: 'overflown',
              value: function overflown() {
                var _props11 = this.props,
                  options = _props11.options,
                  maxItems = _props11.maxItems

                return options.length > maxItems
              },
            },
            {
              key: 'scrollable_list_height',
              value: function scrollable_list_height(height, vertical_padding) {
                var maxItems = this.props.maxItems

                // (Adding vertical padding so that it shows these `maxItems` options fully)

                return (height - 2 * vertical_padding) * (maxItems / this.get_options().length) + vertical_padding
              },
            },
            {
              key: 'should_animate',
              value: function should_animate() {
                return true

                // return this.props.options.length >= this.props.transition_item_count_min
              },
            },
            {
              key: 'focus',
              value: function focus() {
                if (this.autocomplete) {
                  _focus(this.autocomplete)
                } else {
                  _focus(this.selected)
                }
              },

              // Would have used `onBlur={...}` event handler here
              // with `if (container.contains(event.relatedTarget))` condition,
              // but it doesn't work in IE in React.
              // https://github.com/facebook/react/issues/3751
              //
              // Therefore, using the hacky `document.onClick` handlers
              // and this `onKeyDown` Tab handler
              // until `event.relatedTarget` support is consistent in React.
              //

              // This handler is a workaround for `redux-form`
            },
            {
              key: 'get_options',
              value: function get_options() {
                var _props12 = this.props,
                  autocomplete = _props12.autocomplete,
                  autocompleteShowAll = _props12.autocompleteShowAll,
                  maxItems = _props12.maxItems,
                  options = _props12.options
                var matching_options = this.state.matching_options

                if (!autocomplete) {
                  return options
                }

                if (autocompleteShowAll) {
                  return matching_options
                }

                return matching_options.slice(0, maxItems)
              },

              // Get the previous option (relative to the currently focused option)
            },
            {
              key: 'previous_focusable_option',
              value: function previous_focusable_option() {
                var options = this.get_options()
                var focused_option_value = this.state.focused_option_value

                var i = 0
                while (i < options.length) {
                  if (options[i].value === focused_option_value) {
                    if (i - 1 >= 0) {
                      return options[i - 1]
                    }
                  }
                  i++
                }
              },

              // Get the next option (relative to the currently focused option)
            },
            {
              key: 'next_focusable_option',
              value: function next_focusable_option() {
                var options = this.get_options()
                var focused_option_value = this.state.focused_option_value

                var i = 0
                while (i < options.length) {
                  if (options[i].value === focused_option_value) {
                    if (i + 1 < options.length) {
                      return options[i + 1]
                    }
                  }
                  i++
                }
              },

              // Scrolls to an option having the value
            },
            {
              key: 'scroll_to',
              value: function scroll_to(value) {
                var vertical_padding = this.state.vertical_padding

                var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)])
                var list = _reactDom2.default.findDOMNode(this.list)

                // If this option isn't even shown
                // (e.g. autocomplete)
                // then don't scroll to it because there's nothing to scroll to.
                if (!option_element) {
                  return
                }

                var offset_top = option_element.offsetTop

                var is_first_option = list.firstChild === option_element

                // If it's the first one - then scroll to list top
                if (is_first_option) {
                  offset_top -= vertical_padding
                }

                list.scrollTop = offset_top
              },

              // Fully shows an option having the `value` (scrolls to it if neccessary)
            },
            {
              key: 'show_option',
              value: function show_option(value, gravity) {
                var vertical_padding = this.state.vertical_padding

                var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)])
                var list = _reactDom2.default.findDOMNode(this.list)

                var is_first_option = list.firstChild === option_element
                var is_last_option = list.lastChild === option_element

                switch (gravity) {
                  case 'top':
                    var top_line = option_element.offsetTop

                    if (is_first_option) {
                      top_line -= vertical_padding
                    }

                    if (top_line < list.scrollTop) {
                      list.scrollTop = top_line
                    }

                    return

                  case 'bottom':
                    var bottom_line = option_element.offsetTop + option_element.offsetHeight

                    if (is_last_option) {
                      bottom_line += vertical_padding
                    }

                    if (bottom_line > list.scrollTop + list.offsetHeight) {
                      list.scrollTop = bottom_line - list.offsetHeight
                    }

                    return
                }
              },

              // Calculates height of the expanded item list
            },
            {
              key: 'calculate_height',
              value: function calculate_height() {
                var options = this.props.options

                var list_dom_node = _reactDom2.default.findDOMNode(this.list)
                // const border = parseInt(window.getComputedStyle(list_dom_node).borderTopWidth)
                var height = list_dom_node.scrollHeight
                var vertical_padding = parseInt(window.getComputedStyle(list_dom_node).paddingTop)

                // For things like "accordeon".
                //
                // const images = list_dom_node.querySelectorAll('img')
                //
                // if (images.length > 0)
                // {
                // 	return this.preload_images(list_dom_node, images)
                // }

                var state = {
                  height: height,
                  vertical_padding: vertical_padding,

                  // If it's a regular `<select/>` with `<option/>`s
                  // then calculate its height.
                }
                if (this.is_scrollable() && options && this.overflown()) {
                  state.list_height = this.scrollable_list_height(height, vertical_padding)
                }

                this.setState(state)
              },
            },
            {
              key: 'is_scrollable',
              value: function is_scrollable() {
                var _props13 = this.props,
                  menu = _props13.menu,
                  autocomplete = _props13.autocomplete,
                  autocompleteShowAll = _props13.autocompleteShowAll,
                  scroll = _props13.scroll

                return !menu && ((autocomplete && autocompleteShowAll) || !autocomplete) && scroll
              },

              // This turned out not to work for `autocomplete`
              // because not all options are ever shown.
              // get_widest_label_width()
              // {
              // 	// <ul/> -> <li/> -> <button/>
              // 	const label = ReactDOM.findDOMNode(this.list).firstChild.firstChild
              //
              // 	const style = getComputedStyle(label)
              //
              // 	const width = parseFloat(style.width)
              // 	const side_padding = parseFloat(style.paddingLeft)
              //
              // 	return width - 2 * side_padding
              // }
            },
            {
              key: 'get_matching_options',
              value: function get_matching_options(options, value) {
                // If the autocomplete value is `undefined` or empty
                if (!value) {
                  return options
                }

                value = value.toLowerCase()

                return options.filter(function (_ref10) {
                  var label = _ref10.label,
                    verbose = _ref10.verbose

                  return (verbose || label).toLowerCase().indexOf(value) >= 0
                })
              },
            },
          ])

          return Select
        })(_react.PureComponent)

        Select.propTypes = {
          // A list of selectable options
          options: _propTypes2.default.arrayOf(
            _propTypes2.default.shape({
              // Option value (may be `undefined`)
              value: value_prop_type,
              // Option label (may be `undefined`)
              label: _propTypes2.default.string,
              // Option icon
              icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
            })
          ),

          // HTML form input `name` attribute
          name: _propTypes2.default.string,

          // Label which is placed above the select
          label: _propTypes2.default.string,

          // Placeholder (like "Choose")
          placeholder: _propTypes2.default.string,

          // Whether to use native `<select/>`
          native: _propTypes2.default.bool.isRequired,

          // Whether to use native `<select/>` when expanded
          nativeExpanded: _propTypes2.default.bool.isRequired,

          // Show icon only for selected item,
          // and only if `concise` is `true`.
          saveOnIcons: _propTypes2.default.bool,

          // Disables this control
          disabled: _propTypes2.default.bool,

          // Set to `true` to mark the field as required
          required: _propTypes2.default.bool.isRequired,

          // Selected option value
          value: value_prop_type,

          // Is called when an option is selected
          onChange: _propTypes2.default.func,

          // Is called when the select is focused
          onFocus: _propTypes2.default.func,

          // Is called when the select is blurred.
          // This `onBlur` interceptor is a workaround for `redux-form`,
          // so that it gets the parsed `value` in its `onBlur` handler,
          // not the formatted text.
          onBlur: _propTypes2.default.func,

          // (exotic use case)
          // Falls back to a plain HTML input
          // when javascript is disabled (e.g. Tor)
          fallback: _propTypes2.default.bool.isRequired,

          // Component CSS class
          className: _propTypes2.default.string,

          // Autocomplete `<input/>` CSS class
          inputClassName: _propTypes2.default.string,

          // `<button/>` toggler CSS class
          toggleClassName: _propTypes2.default.string,

          // CSS style object
          style: _propTypes2.default.object,

          // If this flag is set to `true`,
          // and `icon` is specified for a selected option,
          // then the selected option will be displayed
          // as icon only, without the label.
          concise: _propTypes2.default.bool,

          // If this flag is set to `true`,
          // then it makes `<Select/>` not stretch itself
          // to 100% width by making it `inline-block`.
          // Is set to `true` when `concise` is `true`
          // because it makes sense.
          compact: _propTypes2.default.bool,

          // HTML `tabindex` attribute
          tabIndex: _propTypes2.default.number,

          // If set to `true`, autocompletion is available
          // upon expanding the options list.
          autocomplete: _propTypes2.default.bool,

          // If set to `true`, autocomple will show all
          // matching options instead of just `maxItems`.
          autocompleteShowAll: _propTypes2.default.bool,

          // Options list alignment ("left", "right")
          alignment: _propTypes2.default.oneOf(['left', 'right']),

          // If `menu` flag is set to `true`
          // then it's gonna be a dropdown menu
          // with `children` elements inside
          // and therefore `onChange` won't be called
          // on menu item click.
          menu: _propTypes2.default.bool,

          // If `menu` flag is set to `true`
          // then `toggler` is the dropdown menu button.
          // E.g. `toggler={<DropDownMenuButton/>}`.
          // `toggler` must accept `onClick` and `onKeyDown` properties.
          toggler: _propTypes2.default.element,

          // If `scroll` is `false`, then options list
          // is not limited in height.
          // Is `true` by default (scrollable).
          scroll: _propTypes2.default.bool.isRequired,

          // If this flag is set to `true`,
          // then the dropdown expands itself upward.
          // (as opposed to the default downward)
          upward: _propTypes2.default.bool,

          // Maximum items fitting the options list height (scrollable).
          // In case of `autocomplete` that's the maximum number of matched items shown.
          // Is `6` by default.
          maxItems: _propTypes2.default.number.isRequired,

          // Is `true` by default (only when the list of options is scrollable)
          scrollbarPadding: _propTypes2.default.bool,

          focusUponSelection: _propTypes2.default.bool.isRequired,

          // When the `<Select/>` is expanded
          // the options list may not fit on the screen.
          // If `scrollIntoView` is `true` (which is the default)
          // then the browser will automatically scroll
          // so that the expanded options list fits on the screen.
          scrollIntoView: _propTypes2.default.bool.isRequired,

          // If `scrollIntoView` is `true` (which is the default)
          // then this is gonna be the delay after which it scrolls into view.
          expandAnimationDuration: _propTypes2.default.number.isRequired,

          onTabOut: _propTypes2.default.func,

          onToggle: _propTypes2.default.func,

          // `aria-label` for the `<Select/>`'s `<button/>`
          ariaLabel: _propTypes2.default.string.isRequired,

          // `aria-label` for the "Close" button
          // (which is an "x" visible in fullscreen mode).
          closeAriaLabel: _propTypes2.default.string.isRequired,

          // The "x" button that closes the `<Select/>`
          // in fullscreen mode on mobile devices.
          closeButton: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.oneOf([false])]).isRequired,

          // transition_item_count_min : PropTypes.number,
          // transition_duration_min : PropTypes.number,
          // transition_duration_max : PropTypes.number
        }
        Select.defaultProps = {
          alignment: 'left',
          scroll: true,
          maxItems: 6,
          scrollbarPadding: true,
          focusUponSelection: true,
          fallback: false,
          native: false,
          nativeExpanded: false,
          scrollIntoView: true,
          expandAnimationDuration: 150,

          // Set to `true` to mark the field as required
          required: false,

          // `aria-label` for the `<Select/>`'s `<button/>`
          ariaLabel: 'Select country',

          // `aria-label` for the "Close" button
          // (which is an "x" visible in fullscreen mode).
          closeAriaLabel: 'Close',

          // The "x" button that closes the `<Select/>`
          // in fullscreen mode on mobile devices.
          closeButton: _react2.default.createElement(
            'svg',
            { viewBox: '0 0 22 21', className: 'rrui__select__close-icon' },
            _react2.default.createElement(
              'g',
              { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
              _react2.default.createElement(
                'g',
                { className: 'rrui__select__close-icon-path', transform: 'translate(-1367.000000, -40.000000)', strokeWidth: '1' },
                _react2.default.createElement(
                  'g',
                  { transform: 'translate(1368.000000, 41.000000)' },
                  _react2.default.createElement('path', { d: 'M0.807611845,0.307611845 L19.1923882,18.6923882' }),
                  _react2.default.createElement('path', {
                    d: 'M0.807611845,0.307611845 L19.1923882,18.6923882',
                    transform: 'translate(10.000000, 9.500000) scale(-1, 1) translate(-10.000000, -9.500000) ',
                  })
                )
              )
            )
          ),

          // transition_item_count_min : 1,
          // transition_duration_min : 60, // milliseconds
          // transition_duration_max : 100 // milliseconds
        }

        var _initialiseProps = function _initialiseProps() {
          var _this7 = this

          this.state = {
            // Is initialized during the first `componentDidUpdate()` call
            vertical_padding: 0,
          }

          this.native_select_on_change = function (event) {
            var _props14 = _this7.props,
              onChange = _props14.onChange,
              previous_value = _props14.value

            var value = event.target.value

            // Convert back from an empty string to `undefined`
            if (value === Empty_value_option_value) {
              // `null` is not accounted for, use `undefined` instead.
              value = undefined
            }

            // Call `onChange` only if `value` did actually change
            if (value !== previous_value) {
              onChange(value)
            }
          }

          this.resize_native_expanded_select = function () {
            // For some strange reason 1px on the right side of the `<select/>`
            // still falls through to the underlying selected option label.
            _reactDom2.default.findDOMNode(_this7.native).style.width =
              _reactDom2.default.findDOMNode(_this7.selected).offsetWidth + 1 + 'px'
          }

          this.toggle = function (event) {
            var toggle_options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}

            if (event) {
              // Don't navigate away when clicking links
              event.preventDefault()

              // Not discarding the click event because
              // other expanded selects may be listening to it.
              // // Discard the click event so that it won't reach `document` click listener
              // event.stopPropagation() // doesn't work
              // event.nativeEvent.stopImmediatePropagation()
            }

            var _props15 = _this7.props,
              menu = _props15.menu,
              toggler = _props15.toggler,
              disabled = _props15.disabled,
              autocomplete = _props15.autocomplete,
              options = _props15.options,
              value = _props15.value,
              focusUponSelection = _props15.focusUponSelection,
              onToggle = _props15.onToggle,
              nativeExpanded = _props15.nativeExpanded,
              scrollIntoView = _props15.scrollIntoView,
              expandAnimationDuration = _props15.expandAnimationDuration

            if (nativeExpanded) {
              return
            }

            if (disabled) {
              return
            }

            if (!menu && options.length === 0) {
              return
            }

            clearTimeout(_this7.toggle_timeout)
            clearTimeout(_this7.scroll_into_view_timeout)
            clearTimeout(_this7.restore_focus_on_collapse_timeout)

            _this7.toggle_timeout = undefined
            _this7.scroll_into_view_timeout = undefined
            _this7.restore_focus_on_collapse_timeout = undefined

            var expanded = _this7.state.expanded

            if (!expanded && autocomplete) {
              _this7.setState({
                // The input value can't be `undefined`
                // because in that case React would complain
                // about it being an "uncontrolled input"
                autocomplete_input_value: '',
                matching_options: options,
              })

              // if (!this.state.autocomplete_width)
              // {
              // 	this.setState({ autocomplete_width: this.get_widest_label_width() })
              // }
            }

            // Deferring expanding the select upon click
            // because `document.onClick(event)` should fire first,
            // otherwise `event.target` in that handler will be detached
            // from the document and so `this.document_clicked()` handler will
            // immediately toggle the select back to collapsed state.
            _this7.toggle_timeout = setTimeout(function () {
              _this7.toggle_timeout = undefined

              _this7.setState(
                {
                  expanded: !expanded,
                },
                function () {
                  var is_now_expanded = _this7.state.expanded

                  if (!toggle_options.dont_focus_after_toggle) {
                    // If it's autocomplete, then focus <input/> field
                    // upon toggling the select component.
                    if (autocomplete) {
                      if (is_now_expanded) {
                        // Focus the input after the select is expanded
                        _focus(_this7.autocomplete)
                      } else if (focusUponSelection) {
                        // Focus the toggler after the select is collapsed
                        _focus(_this7.selected)
                      }
                    } else {
                      // For some reason Firefox loses focus
                      // upon select expansion via a click,
                      // so this extra `.focus()` works around that issue.
                      _focus(_this7.selected)
                    }
                  }

                  _this7.scroll_into_view_timeout = setTimeout(function () {
                    _this7.scroll_into_view_timeout = undefined

                    var is_still_expanded = _this7.state.expanded

                    // For some reason in IE 11 "scroll into view" scrolls
                    // to the top of the page, therefore turn it off for IE.
                    if (is_still_expanded && _this7.list && scrollIntoView && !is_internet_explorer()) {
                      var element = _reactDom2.default.findDOMNode(_this7.list)

                      // https://developer.mozilla.org/ru/docs/Web/API/Element/scrollIntoViewIfNeeded
                      if (element.scrollIntoViewIfNeeded) {
                        element.scrollIntoViewIfNeeded(false)
                      } else {
                        // https://github.com/stipsan/scroll-into-view-if-needed
                        ;(0, _scrollIntoViewIfNeeded2.default)(element, false, { duration: 800 })
                      }
                    }
                  }, expandAnimationDuration * 1.1)
                }
              )

              if (!expanded && options) {
                // Focus either the selected option
                // or the first option in the list.

                var focused_option_value = value || options[0].value

                _this7.setState({ focused_option_value: focused_option_value })

                // Scroll down to the focused option
                _this7.scroll_to(focused_option_value)
              }

              if (onToggle) {
                onToggle(!expanded)
              }

              if (toggle_options.callback) {
                toggle_options.callback()
              }
            }, 0)
          }

          this.item_clicked = function (value, event) {
            if (event) {
              event.preventDefault()
            }

            var _props16 = _this7.props,
              onChange = _props16.onChange,
              previous_value = _props16.value

            _this7.toggle(undefined, {
              callback: function callback() {
                // Call `onChange` only if `value` did actually change
                if (value !== previous_value) {
                  onChange(value)
                }
              },
            })
          }

          this.document_clicked = function (event) {
            var autocomplete = _reactDom2.default.findDOMNode(_this7.autocomplete)
            var selected_option = _reactDom2.default.findDOMNode(_this7.selected)
            var options_list = _reactDom2.default.findDOMNode(_this7.list)

            // Don't close the select if its expander button has been clicked,
            // or if autocomplete has been clicked,
            // or if an option was selected from the list.
            if (
              (options_list && options_list.contains(event.target)) ||
              (autocomplete && autocomplete.contains(event.target)) ||
              (selected_option && selected_option.contains(event.target))
            ) {
              return
            }

            _this7.setState({ expanded: false })

            var onToggle = _this7.props.onToggle

            if (onToggle) {
              onToggle(false)
            }
          }

          this.on_key_down_in_container = function (event) {
            if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
              return
            }

            var expanded = _this7.state.expanded

            switch (event.keyCode) {
              // Toggle on Tab out
              case 9:
                if (expanded) {
                  _this7.toggle(undefined, { dont_focus_after_toggle: true })

                  var onTabOut = _this7.props.onTabOut

                  if (onTabOut) {
                    onTabOut(event)
                  }
                }
                return
            }
          }

          this.on_key_down = function (event) {
            var onKeyDown = _this7.props.onKeyDown

            if (onKeyDown) {
              onKeyDown(event)
            }

            if ((0, _dom.submitFormOnCtrlEnter)(event, _this7.autocomplete || _this7.selected)) {
              return
            }

            if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
              return
            }

            var _props17 = _this7.props,
              options = _props17.options,
              value = _props17.value,
              autocomplete = _props17.autocomplete
            var _state5 = _this7.state,
              expanded = _state5.expanded,
              focused_option_value = _state5.focused_option_value

            // Maybe add support for `children` arrow navigation in future

            if (options) {
              switch (event.keyCode) {
                // Select the previous option (if present) on up arrow
                case 38:
                  event.preventDefault()

                  var previous = _this7.previous_focusable_option()

                  if (previous) {
                    _this7.show_option(previous.value, 'top')
                    return _this7.setState({ focused_option_value: previous.value })
                  }

                  return

                // Select the next option (if present) on down arrow
                case 40:
                  event.preventDefault()

                  var next = _this7.next_focusable_option()

                  if (next) {
                    _this7.show_option(next.value, 'bottom')
                    return _this7.setState({ focused_option_value: next.value })
                  }

                  return

                // Collapse on Escape
                //
                // Maybe add this kind of support for "Escape" key in some future:
                //  hiding the item list, cancelling current item selection process
                //  and restoring the selection present before the item list was toggled.
                //
                case 27:
                  // Collapse the list if it's expanded
                  if (_this7.state.expanded) {
                    _this7.toggle()

                    // Restore focus when the list is collapsed
                    _this7.restore_focus_on_collapse_timeout = setTimeout(function () {
                      _this7.restore_focus_on_collapse_timeout = undefined
                      _focus(_this7.selected)
                    }, 0)
                  }

                  return

                // on Enter
                case 13:
                  // Choose the focused item on Enter
                  if (expanded) {
                    event.preventDefault()

                    // If an item is focused
                    // (which may not be the case
                    //  when autocomplete is matching no items)
                    // (still for non-autocomplete select
                    //  it is valid to have a default option)
                    if (_this7.get_options() && _this7.get_options().length > 0) {
                      // Choose the focused item
                      _this7.item_clicked(focused_option_value)
                    }
                  }
                  // Else it should have just submitted the form on Enter,
                  // but it wouldn't because the select element activator is a <button/>
                  // therefore hitting Enter while being focused on it just pushes that button.
                  // So submit the enclosing form manually.
                  else {
                    if ((0, _dom.submitContainingForm)(_reactDom2.default.findDOMNode(_this7.select))) {
                      event.preventDefault()
                    }
                  }

                  return

                // on Spacebar
                case 32:
                  // Choose the focused item on Enter
                  if (expanded) {
                    // only if it it's an `options` select
                    // and also if it's not an autocomplete
                    if (_this7.get_options() && !autocomplete) {
                      event.preventDefault()

                      // `focused_option_value` could be non-existent
                      // in case of `autocomplete`, but since
                      // we're explicitly not handling autocomplete here
                      // it is valid to select any options including the default ones.
                      _this7.item_clicked(focused_option_value)
                    }
                  }
                  // Otherwise, the spacebar keydown event on a `<button/>`
                  // will trigger `onClick` and `.toggle()` will be called.

                  return
              }
            }
          }

          this.on_blur = function (event) {
            var _props18 = _this7.props,
              onBlur = _props18.onBlur,
              value = _props18.value

            // If clicked on a select option then don't trigger "blur" event

            if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
              return
            }

            // This `onBlur` interceptor is a workaround for `redux-form`,
            // so that it gets the right (parsed, not the formatted one)
            // `event.target.value` in its `onBlur` handler.
            if (onBlur) {
              var _event = _extends({}, event, {
                target: _extends({}, event.target, {
                  value: value,
                }),

                // For `redux-form` event detection.
                // https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
              })
              _event.stopPropagation = event.stopPropagation
              _event.preventDefault = event.preventDefault

              onBlur(_event)
            }
          }

          this.on_autocomplete_input_change = function (event) {
            var options = _this7.props.options

            var input = event.target.value
            var matching_options = _this7.get_matching_options(options, input)

            _this7.setState({
              autocomplete_input_value: input,
              matching_options: matching_options,
              focused_option_value: matching_options.length > 0 ? matching_options[0].value : undefined,
            })
          }
        }

        exports.default = Select

        Select.Separator = function (props) {
          return _react2.default.createElement('div', { className: 'rrui__select__separator' })
        }

        var native_expanded_select_container_style = {
          display: 'inline-block',

          // There can be an `undefined` value,
          // so just `{ value }` won't do here.
        }
        function get_option_key(value) {
          return value_is_empty(value) ? '@@rrui/select/undefined' : value
        }

        function value_is_empty(value) {
          return value === null || value === undefined
        }

        // Detects Internet Explorer.
        // https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie-with-jquery
        function is_internet_explorer() {
          return window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0
        }

        /**
         * Focuses on a React component (if any).
         * @param  {?object} component
         */
        function _focus(component) {
          if (!component) {
            return
          }

          if (typeof component.focus === 'function') {
            return component.focus()
          }

          var node = _reactDom2.default.findDOMNode(component)
          if (node) {
            return node.focus()
          }
        }

        function render_icon(icon) {
          return typeof icon === 'function' ? icon() : icon
        }
        //# sourceMappingURL=Select.js.map

        /***/
      },

    /***/ '../node_modules/react-responsive-ui/commonjs/utility/dom.js':
      /*!*******************************************************************!*\
  !*** ../node_modules/react-responsive-ui/commonjs/utility/dom.js ***!
  \*******************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.submitFormOnCtrlEnter = submitFormOnCtrlEnter
        exports.submitContainingForm = submitContainingForm
        exports.getScrollbarWidth = getScrollbarWidth

        var _reactDom = __webpack_require__(/*! react-dom */ 'react-dom')

        var _reactDom2 = _interopRequireDefault(_reactDom)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        // Submits the form on `Ctrl` + `Enter` (or `Cmd` + `Enter`).
        function submitFormOnCtrlEnter(event, component) {
          if ((event.ctrlKey || event.metaKey) && event.keyCode === 13) {
            if (submitContainingForm(_reactDom2.default.findDOMNode(component))) {
              event.preventDefault()
              return true
            }
          }
        }

        function submitContainingForm(node) {
          while (node.parentElement) {
            node = node.parentElement
            if (node instanceof HTMLFormElement) {
              // Won't use `node.submit()` because it bypasses `onSubmit`.
              // Will click the submit button instead.
              var submit = node.querySelector('button[type=submit]')
              if (submit) {
                submit.click()
                return true
              }
            }
          }
        }

        function getScrollbarWidth() {
          // // `window.innerWidth` has a bug:
          // // it's decreases as the page scale is increased.
          // // Therefore not using it.
          // // (Full width) - (Width minus scrollbar)
          // return document.body.clientWidth - window.innerWidth

          return 17
        }
        //# sourceMappingURL=dom.js.map

        /***/
      },

    /***/ '../node_modules/scroll-into-view-if-needed/dist/calculate.js':
      /*!********************************************************************!*\
  !*** ../node_modules/scroll-into-view-if-needed/dist/calculate.js ***!
  \********************************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return calculate
        })
        var __assign =
          (undefined && undefined.__assign) ||
          Object.assign ||
          function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i]
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
            }
            return t
          }
        var handleScroll = function (parent, _a) {
          var scrollLeft = _a.scrollLeft,
            scrollTop = _a.scrollTop
          parent.scrollLeft = scrollLeft
          parent.scrollTop = scrollTop
        }
        function calculate(target, options) {
          if (!target || !(target instanceof HTMLElement)) throw new Error('Element is required in scrollIntoViewIfNeeded')
          var config = __assign({ handleScroll: handleScroll }, options)
          var defaultOffset = { top: 0, right: 0, bottom: 0, left: 0 }
          config.offset = config.offset ? __assign({}, defaultOffset, config.offset) : defaultOffset
          function withinBounds(value, min, max, extent) {
            if (config.centerIfNeeded === false || (max <= value + extent && value <= min + extent)) {
              return Math.min(max, Math.max(min, value))
            } else {
              return (min + max) / 2
            }
          }
          var offset = config.offset
          var offsetTop = offset.top
          var offsetLeft = offset.left
          var offsetBottom = offset.bottom
          var offsetRight = offset.right
          function makeArea(left, top, width, height) {
            return {
              left: left + offsetLeft,
              top: top + offsetTop,
              width: width,
              height: height,
              right: left + offsetLeft + width + offsetRight,
              bottom: top + offsetTop + height + offsetBottom,
              translate: function (x, y) {
                return makeArea(x + left + offsetLeft, y + top + offsetTop, width, height)
              },
              relativeFromTo: function (lhs, rhs) {
                var newLeft = left + offsetLeft,
                  newTop = top + offsetTop
                lhs = lhs.offsetParent
                rhs = rhs.offsetParent
                if (lhs === rhs) {
                  return area
                }
                for (; lhs; lhs = lhs.offsetParent) {
                  newLeft += lhs.offsetLeft + lhs.clientLeft
                  newTop += lhs.offsetTop + lhs.clientTop
                }
                for (; rhs; rhs = rhs.offsetParent) {
                  newLeft -= rhs.offsetLeft + rhs.clientLeft
                  newTop -= rhs.offsetTop + rhs.clientTop
                }
                return makeArea(newLeft, newTop, width, height)
              },
            }
          }
          var parent,
            area = makeArea(target.offsetLeft, target.offsetTop, target.offsetWidth, target.offsetHeight)
          while ((parent = target.parentNode) instanceof HTMLElement && target !== config.boundary) {
            var clientLeft = parent.offsetLeft + parent.clientLeft
            var clientTop = parent.offsetTop + parent.clientTop
            // Make area relative to parent's client area.
            area = area.relativeFromTo(target, parent).translate(-clientLeft, -clientTop)
            var scrollLeft = withinBounds(parent.scrollLeft, area.right - parent.clientWidth, area.left, parent.clientWidth)
            var scrollTop = withinBounds(parent.scrollTop, area.bottom - parent.clientHeight, area.top, parent.clientHeight)
            // Pass the new coordinates to the handleScroll callback
            config.handleScroll(parent, { scrollLeft: scrollLeft, scrollTop: scrollTop }, config)
            // Determine actual scroll amount by reading back scroll properties.
            area = area.translate(clientLeft - parent.scrollLeft, clientTop - parent.scrollTop)
            target = parent
          }
        }

        /***/
      },

    /***/ '../node_modules/scroll-into-view-if-needed/dist/index.js':
      /*!****************************************************************!*\
  !*** ../node_modules/scroll-into-view-if-needed/dist/index.js ***!
  \****************************************************************/
      /*! exports provided: default */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return scrollIntoViewIfNeeded
        })
        /* harmony import */ var amator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! amator */ '../node_modules/amator/index.js')
        /* harmony import */ var amator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(
          amator__WEBPACK_IMPORTED_MODULE_0__
        )
        /* harmony import */ var _calculate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! ./calculate */ '../node_modules/scroll-into-view-if-needed/dist/calculate.js'
        )
        var __assign =
          (undefined && undefined.__assign) ||
          Object.assign ||
          function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i]
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
            }
            return t
          }

        var handleScroll = function (parent, _a, config) {
          var scrollLeft = _a.scrollLeft,
            scrollTop = _a.scrollTop
          if (config.duration) {
            amator__WEBPACK_IMPORTED_MODULE_0___default()(
              parent,
              {
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
              },
              { duration: config.duration, easing: config.easing }
            )
          } else {
            parent.scrollLeft = scrollLeft
            parent.scrollTop = scrollTop
          }
        }
        function isBoolean(options) {
          return typeof options === 'boolean'
        }
        function scrollIntoViewIfNeeded(target, options, animateOptions, finalElement, offsetOptions) {
          if (offsetOptions === void 0) {
            offsetOptions = {}
          }
          if (!target || !(target instanceof HTMLElement)) throw new Error('Element is required in scrollIntoViewIfNeeded')
          var config = { centerIfNeeded: false, handleScroll: handleScroll }
          if (isBoolean(options)) {
            config.centerIfNeeded = options
          } else {
            config = __assign({}, config, options)
          }
          var defaultOffset = { top: 0, right: 0, bottom: 0, left: 0 }
          config.offset = config.offset ? __assign({}, defaultOffset, config.offset) : defaultOffset
          if (animateOptions) {
            config.duration = animateOptions.duration
            config.easing = animateOptions.easing
          }
          if (finalElement) {
            config.boundary = finalElement
          }
          if (offsetOptions.offsetTop) {
            config.offset.top = offsetOptions.offsetTop
          }
          if (offsetOptions.offsetRight) {
            config.offset.right = offsetOptions.offsetRight
          }
          if (offsetOptions.offsetBottom) {
            config.offset.bottom = offsetOptions.offsetBottom
          }
          if (offsetOptions.offsetLeft) {
            config.offset.left = offsetOptions.offsetLeft
          }
          return Object(_calculate__WEBPACK_IMPORTED_MODULE_1__['default'])(target, config)
        }

        /***/
      },

    /***/ '../node_modules/semver-compare/index.js':
      /*!***********************************************!*\
  !*** ../node_modules/semver-compare/index.js ***!
  \***********************************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = function cmp(a, b) {
          var pa = a.split('.')
          var pb = b.split('.')
          for (var i = 0; i < 3; i++) {
            var na = Number(pa[i])
            var nb = Number(pb[i])
            if (na > nb) return 1
            if (nb > na) return -1
            if (!isNaN(na) && isNaN(nb)) return 1
            if (isNaN(na) && !isNaN(nb)) return -1
          }
          return 0
        }

        /***/
      },

    /***/ './index.js':
      /*!******************!*\
  !*** ./index.js ***!
  \******************/
      /*! exports provided: PhoneInputNative, PhoneInputReactResponsiveUI, default, PhoneInput, formatPhoneNumber, parsePhoneNumberCharacters, parsePhoneNumberCharacter, InputBasic, InputSmart, InternationalIcon, Input */
      /***/ function (module, __webpack_exports__, __webpack_require__) {
        'use strict'
        __webpack_require__.r(__webpack_exports__)
        /* harmony import */ var _modules_PhoneInputNativeDefaultMetadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! ./modules/PhoneInputNativeDefaultMetadata */ './modules/PhoneInputNativeDefaultMetadata.js'
        )
        /* harmony import */ var _modules_PhoneInputNativeDefaultMetadata__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_PhoneInputNativeDefaultMetadata__WEBPACK_IMPORTED_MODULE_0__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'PhoneInputNative', function () {
          return _modules_PhoneInputNativeDefaultMetadata__WEBPACK_IMPORTED_MODULE_0___default.a
        })
        /* harmony import */ var _modules_PhoneInputReactResponsiveUIDefaultMetadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! ./modules/PhoneInputReactResponsiveUIDefaultMetadata */ './modules/PhoneInputReactResponsiveUIDefaultMetadata.js'
        )
        /* harmony import */ var _modules_PhoneInputReactResponsiveUIDefaultMetadata__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_PhoneInputReactResponsiveUIDefaultMetadata__WEBPACK_IMPORTED_MODULE_1__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(
          __webpack_exports__,
          'PhoneInputReactResponsiveUI',
          function () {
            return _modules_PhoneInputReactResponsiveUIDefaultMetadata__WEBPACK_IMPORTED_MODULE_1___default.a
          }
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'default', function () {
          return _modules_PhoneInputReactResponsiveUIDefaultMetadata__WEBPACK_IMPORTED_MODULE_1___default.a
        })
        /* harmony import */ var _modules_PhoneInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          /*! ./modules/PhoneInput */ './modules/PhoneInput.js'
        )
        /* harmony import */ var _modules_PhoneInput__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_PhoneInput__WEBPACK_IMPORTED_MODULE_2__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'PhoneInput', function () {
          return _modules_PhoneInput__WEBPACK_IMPORTED_MODULE_2___default.a
        })
        /* harmony import */ var _modules_formatPhoneNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          /*! ./modules/formatPhoneNumber */ './modules/formatPhoneNumber.js'
        )
        /* harmony import */ var _modules_formatPhoneNumber__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_formatPhoneNumber__WEBPACK_IMPORTED_MODULE_3__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'formatPhoneNumber', function () {
          return _modules_formatPhoneNumber__WEBPACK_IMPORTED_MODULE_3___default.a
        })
        /* harmony import */ var _modules_parsePhoneNumberCharacters__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
          /*! ./modules/parsePhoneNumberCharacters */ './modules/parsePhoneNumberCharacters.js'
        )
        /* harmony import */ var _modules_parsePhoneNumberCharacters__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_parsePhoneNumberCharacters__WEBPACK_IMPORTED_MODULE_4__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(
          __webpack_exports__,
          'parsePhoneNumberCharacters',
          function () {
            return _modules_parsePhoneNumberCharacters__WEBPACK_IMPORTED_MODULE_4___default.a
          }
        )
        /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, 'parsePhoneNumberCharacter', function () {
          return _modules_parsePhoneNumberCharacters__WEBPACK_IMPORTED_MODULE_4__['parsePhoneNumberCharacter']
        })

        /* harmony import */ var _modules_InputBasic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
          /*! ./modules/InputBasic */ './modules/InputBasic.js'
        )
        /* harmony import */ var _modules_InputBasic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_InputBasic__WEBPACK_IMPORTED_MODULE_5__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'InputBasic', function () {
          return _modules_InputBasic__WEBPACK_IMPORTED_MODULE_5___default.a
        })
        /* harmony import */ var _modules_InputSmart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
          /*! ./modules/InputSmart */ './modules/InputSmart.js'
        )
        /* harmony import */ var _modules_InputSmart__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_InputSmart__WEBPACK_IMPORTED_MODULE_6__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'InputSmart', function () {
          return _modules_InputSmart__WEBPACK_IMPORTED_MODULE_6___default.a
        })
        /* harmony import */ var _modules_InternationalIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
          /*! ./modules/InternationalIcon */ './modules/InternationalIcon.js'
        )
        /* harmony import */ var _modules_InternationalIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_InternationalIcon__WEBPACK_IMPORTED_MODULE_7__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'InternationalIcon', function () {
          return _modules_InternationalIcon__WEBPACK_IMPORTED_MODULE_7___default.a
        })
        /* harmony import */ var _modules_PhoneInputReactResponsiveUI__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
          /*! ./modules/PhoneInputReactResponsiveUI */ './modules/PhoneInputReactResponsiveUI.js'
        )
        /* harmony import */ var _modules_PhoneInputReactResponsiveUI__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/ __webpack_require__.n(
          _modules_PhoneInputReactResponsiveUI__WEBPACK_IMPORTED_MODULE_8__
        )
        /* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, 'Input', function () {
          return _modules_PhoneInputReactResponsiveUI__WEBPACK_IMPORTED_MODULE_8___default.a
        })

        // Deprecated export. Will be removed in version 2.x.

        /***/
      },

    /***/ './modules/CountrySelectNative.js':
      /*!****************************************!*\
  !*** ./modules/CountrySelectNative.js ***!
  \****************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _class, _temp2

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        var CountrySelectNative =
          ((_temp2 = _class = (function (_Component) {
            _inherits(CountrySelectNative, _Component)

            function CountrySelectNative() {
              var _ref

              var _temp, _this, _ret

              _classCallCheck(this, CountrySelectNative)

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key]
              }

              return (
                (_ret =
                  ((_temp =
                    ((_this = _possibleConstructorReturn(
                      this,
                      (_ref = CountrySelectNative.__proto__ || Object.getPrototypeOf(CountrySelectNative)).call.apply(
                        _ref,
                        [this].concat(args)
                      )
                    )),
                    _this)),
                  (_this.onChange = function (event) {
                    var onChange = _this.props.onChange

                    onChange(event.target.value)
                  }),
                  _temp)),
                _possibleConstructorReturn(_this, _ret)
              )
            }

            // storeSelectRef = (ref) => this.select = ref
            // ref={ this.storeSelectRef }

            _createClass(CountrySelectNative, [
              {
                key: 'render',
                value: function render() {
                  var _props = this.props,
                    name = _props.name,
                    value = _props.value,
                    options = _props.options,
                    disabled = _props.disabled,
                    tabIndex = _props.tabIndex,
                    className = _props.className,
                    SelectArrow = _props.selectArrowComponent

                  var selectedOption =
                    options.filter(function (option) {
                      return option.value === value
                    })[0] || options[0]
                  var SelectedCountryFlag = selectedOption.icon

                  return _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(className, 'react-phone-number-input__country--native') },
                    _react2.default.createElement(SelectedCountryFlag, null),
                    _react2.default.createElement(
                      'select',
                      {
                        name: name,
                        value: value,
                        onChange: this.onChange,
                        disabled: disabled,
                        tabIndex: tabIndex,
                        className: 'react-phone-number-input__country-select',
                      },
                      options.map(function (_ref2) {
                        var value = _ref2.value,
                          label = _ref2.label
                        return _react2.default.createElement('option', { key: value || '-', value: value }, label)
                      })
                    ),
                    _react2.default.createElement(SelectArrow, null)
                  )
                },

                // toggle()
                // {
                // 	this.select.click()
                // }
              },
            ])

            return CountrySelectNative
          })(_react.Component)),
          (_class.propTypes = {
            selectArrowComponent: _propTypes2.default.func.isRequired,
          }),
          (_class.defaultProps = {
            selectArrowComponent: function selectArrowComponent() {
              return _react2.default.createElement('div', { className: 'react-phone-number-input__country-select-arrow' })
            },
          }),
          _temp2)
        exports.default = CountrySelectNative
        //# sourceMappingURL=CountrySelectNative.js.map

        /***/
      },

    /***/ './modules/CountrySelectReactResponsiveUI.js':
      /*!***************************************************!*\
  !*** ./modules/CountrySelectReactResponsiveUI.js ***!
  \***************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _class, _temp2

        // Could have been `import { Select } from 'react-responsive-ui'`
        // but in that case Webpack bundles the whole `react-responsive-ui` package.

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        var _Select = __webpack_require__(
          /*! react-responsive-ui/commonjs/Select */ '../node_modules/react-responsive-ui/commonjs/Select.js'
        )

        var _Select2 = _interopRequireDefault(_Select)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        var CountrySelectReactResponsiveUI =
          ((_temp2 = _class = (function (_Component) {
            _inherits(CountrySelectReactResponsiveUI, _Component)

            function CountrySelectReactResponsiveUI() {
              var _ref

              var _temp, _this, _ret

              _classCallCheck(this, CountrySelectReactResponsiveUI)

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key]
              }

              return (
                (_ret =
                  ((_temp =
                    ((_this = _possibleConstructorReturn(
                      this,
                      (_ref = CountrySelectReactResponsiveUI.__proto__ || Object.getPrototypeOf(CountrySelectReactResponsiveUI)).call.apply(
                        _ref,
                        [this].concat(args)
                      )
                    )),
                    _this)),
                  (_this.onTabOut = function (event) {
                    var focusPhoneInputField = _this.props.focusPhoneInputField

                    event.preventDefault()

                    // Focus the phone number input upon country selection
                    // (do it in a timeout because the `<input/>`
                    //  is hidden while selecting a country)
                    setTimeout(focusPhoneInputField, 0)
                  }),
                  _temp)),
                _possibleConstructorReturn(_this, _ret)
              )
            }

            _createClass(CountrySelectReactResponsiveUI, [
              {
                key: 'render',

                // storeSelectRef = (ref) => this.select = ref
                // ref={ this.storeSelectRef }

                // toggle()
                // {
                // 	this.select.toggle()
                // }
                value: function render() {
                  var _props = this.props,
                    name = _props.name,
                    value = _props.value,
                    onChange = _props.onChange,
                    options = _props.options,
                    disabled = _props.disabled,
                    tabIndex = _props.tabIndex,
                    className = _props.className,
                    hidePhoneInputField = _props.hidePhoneInputField,
                    ariaLabel = _props.ariaLabel,
                    closeAriaLabel = _props.closeAriaLabel,
                    saveOnIcons = _props.saveOnIcons,
                    nativeExpanded = _props.nativeExpanded,
                    maxItems = _props.maxItems,
                    inputClassName = _props.inputClassName,
                    toggleClassName = _props.toggleClassName

                  return _react2.default.createElement(_Select2.default, {
                    name: name,
                    value: value,
                    onChange: onChange,
                    options: options,
                    disabled: disabled,
                    tabIndex: tabIndex,
                    className: (0, _classnames2.default)(className, {
                      'react-phone-number-input__country--native-expanded': nativeExpanded,
                    }),
                    onToggle: hidePhoneInputField,
                    onTabOut: this.onTabOut,
                    ariaLabel: ariaLabel,
                    closeAriaLabel: closeAriaLabel,
                    saveOnIcons: saveOnIcons,
                    nativeExpanded: nativeExpanded,
                    maxItems: maxItems,
                    inputClassName: inputClassName,
                    toggleClassName: toggleClassName,
                    focusUponSelection: false,
                    concise: true,
                    autocomplete: true,
                    autocompleteShowAll: true,
                  })
                },

                // Focuses phone number `<input/>` field
                // on tab out of the country `<select/>`.
              },
            ])

            return CountrySelectReactResponsiveUI
          })(_react.Component)),
          (_class.defaultProps = {
            // Whether to use native country `<select/>` when it's expanded.
            // Deprecated. Use `<PhoneInputNative/>` instead.
            nativeExpanded: false,

            // If set to `false`, then country flags will be shown
            // for all countries when country `<select/>` is expanded.
            // By default shows flag only for currently selected country.
            // (is `true` by default to save user's traffic
            //  because all flags are about 3 MegaBytes)
            saveOnIcons: true,
          }),
          _temp2)
        exports.default = CountrySelectReactResponsiveUI
        //# sourceMappingURL=CountrySelectReactResponsiveUI.js.map

        /***/
      },

    /***/ './modules/Flag.js':
      /*!*************************!*\
  !*** ./modules/Flag.js ***!
  \*************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        // Default country flag icon.
        // `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size.
        // https://github.com/catamphetamine/react-phone-number-input/issues/111
        var FlagComponent = function FlagComponent(_ref) {
          var country = _ref.country,
            flags = _ref.flags,
            flagsPath = _ref.flagsPath,
            className = _ref.className

          if (flags && flags[country]) {
            return _react2.default.cloneElement(flags[country](), {
              className: (0, _classnames2.default)('react-phone-number-input__icon', className),
            })
          }

          return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('react-phone-number-input__icon', className) },
            _react2.default.createElement('img', {
              alt: country,
              className: 'react-phone-number-input__icon-image',
              src: '' + flagsPath + country.toUpperCase() + '.svg',
            })
          )
        }

        FlagComponent.propTypes = {
          // The country to be selected by default.
          // Two-letter country code ("ISO 3166-1 alpha-2").
          country: _propTypes2.default.string.isRequired,

          // Country flag icon components.
          // By default flag icons are inserted as `<img/>`s
          // with their `src` pointed to `flag-icon-css` github repo.
          // There might be cases (e.g. an offline application)
          // where having a large (3 megabyte) `<svg/>` flags
          // bundle is more appropriate.
          // `import flags from 'react-phone-number-input/flags'`.
          flags: _propTypes2.default.objectOf(_propTypes2.default.func),

          // A base URL path for national flag SVG icons.
          // By default it uses the ones from `flag-icon-css` github repo.
          flagsPath: _propTypes2.default.string.isRequired,
        }

        exports.default = FlagComponent
        //# sourceMappingURL=Flag.js.map

        /***/
      },

    /***/ './modules/InputBasic.js':
      /*!*******************************!*\
  !*** ./modules/InputBasic.js ***!
  \*******************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _class

        // Both these functions are exported from `react-phone-number-input`.

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _reactLifecyclesCompat = __webpack_require__(
          /*! react-lifecycles-compat */ '../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js'
        )

        var _parsePhoneNumberCharacters = __webpack_require__(/*! ./parsePhoneNumberCharacters */ './modules/parsePhoneNumberCharacters.js')

        var _parsePhoneNumberCharacters2 = _interopRequireDefault(_parsePhoneNumberCharacters)

        var _formatPhoneNumber = __webpack_require__(/*! ./formatPhoneNumber */ './modules/formatPhoneNumber.js')

        var _formatPhoneNumber2 = _interopRequireDefault(_formatPhoneNumber)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {}
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
            target[i] = obj[i]
          }
          return target
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        /**
         * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
         * but still works good enough. When erasing or inserting digits in the middle
         * of a phone number the caret usually jumps to the end: this is the expected
         * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
         */
        var InputBasic =
          (0, _reactLifecyclesCompat.polyfill)(
            (_class = (function (_PureComponent) {
              _inherits(InputBasic, _PureComponent)

              function InputBasic() {
                var _ref

                var _temp, _this, _ret

                _classCallCheck(this, InputBasic)

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key]
                }

                return (
                  (_ret =
                    ((_temp =
                      ((_this = _possibleConstructorReturn(
                        this,
                        (_ref = InputBasic.__proto__ || Object.getPrototypeOf(InputBasic)).call.apply(_ref, [this].concat(args))
                      )),
                      _this)),
                    (_this.state = {}),
                    (_this.onChange = function (event) {
                      var _this$props = _this.props,
                        onChange = _this$props.onChange,
                        lenientInput = _this$props.lenientInput
                      var value = _this.state.value

                      var alphaRegex = /[a-zA-Z#*]+/g
                      var targetValue = event.target.value
                      var hasAlpha = alphaRegex.test(targetValue)

                      var newValue = (0, _parsePhoneNumberCharacters2.default)(targetValue)

                      //parseAttempt !== event.target.value
                      if (lenientInput && hasAlpha) {
                        newValue = event.target.value
                      }

                      // By default, if a value is something like `"(123)"`
                      // then Backspace would only erase the rightmost brace
                      // becoming something like `"(123"`
                      // which would give the same `"123"` value
                      // which would then be formatted back to `"(123)"`
                      // and so a user wouldn't be able to erase the phone number.
                      // Working around this issue with this simple hack.
                      if (newValue === value) {
                        if (_this.format(newValue).indexOf(targetValue) === 0) {
                          // Trim the last digit (or plus sign).
                          newValue = newValue.slice(0, -1)
                        }
                      }

                      // Prevents React from resetting the `<input/>` caret position.
                      // https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
                      // https://github.com/facebook/react/issues/955
                      _this.setState({ value: newValue }, function () {
                        return onChange(newValue)
                      })
                    }),
                    (_this.storeInput = function (ref) {
                      return (_this.input = ref)
                    }),
                    _temp)),
                  _possibleConstructorReturn(_this, _ret)
                )
              }

              _createClass(
                InputBasic,
                [
                  {
                    key: 'format',
                    value: function format(value) {
                      var _props = this.props,
                        country = _props.country,
                        metadata = _props.metadata,
                        lenientInput = _props.lenientInput

                      var alphaRegex = /[a-zA-Z#*]+/g

                      if (lenientInput && alphaRegex.test(value)) {
                        return value
                      }

                      return (0, _formatPhoneNumber2.default)(value, country, metadata).text
                    },
                  },
                  {
                    key: 'focus',
                    value: function focus() {
                      this.input.focus()
                    },
                  },
                  {
                    key: 'render',
                    value: function render() {
                      var _props2 = this.props,
                        onChange = _props2.onChange,
                        country = _props2.country,
                        metadata = _props2.metadata,
                        lenientInput = _props2.lenientInput,
                        rest = _objectWithoutProperties(_props2, ['onChange', 'country', 'metadata', 'lenientInput'])

                      // Prevents React from resetting the `<input/>` caret position.
                      // https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
                      // https://github.com/facebook/react/issues/955

                      var value = this.state.value

                      return _react2.default.createElement(
                        'input',
                        _extends({}, rest, {
                          ref: this.storeInput,
                          value: this.format(value),
                          onChange: this.onChange,
                        })
                      )
                    },
                  },
                ],
                [
                  {
                    key: 'getDerivedStateFromProps',

                    // Prevents React from resetting the `<input/>` caret position.
                    // https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
                    // https://github.com/facebook/react/issues/955
                    value: function getDerivedStateFromProps(_ref2) {
                      var value = _ref2.value

                      return { value: value }
                    },
                  },
                ]
              )

              return InputBasic
            })(_react.PureComponent))
          ) || _class

        exports.default = InputBasic
        //# sourceMappingURL=InputBasic.js.map

        /***/
      },

    /***/ './modules/InputSmart.js':
      /*!*******************************!*\
  !*** ./modules/InputSmart.js ***!
  \*******************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _inputFormat = __webpack_require__(/*! input-format */ '../node_modules/input-format/index.js')

        var _parsePhoneNumberCharacters = __webpack_require__(/*! ./parsePhoneNumberCharacters */ './modules/parsePhoneNumberCharacters.js')

        var _formatPhoneNumber = __webpack_require__(/*! ./formatPhoneNumber */ './modules/formatPhoneNumber.js')

        var _formatPhoneNumber2 = _interopRequireDefault(_formatPhoneNumber)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {}
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
            target[i] = obj[i]
          }
          return target
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        // Both these functions are exported from `react-phone-number-input`.

        /**
         * This input uses `input-format` library
         * for "smart" caret positioning.
         */
        var InputSmart = (function (_Component) {
          _inherits(InputSmart, _Component)

          function InputSmart() {
            var _ref

            var _temp, _this, _ret

            _classCallCheck(this, InputSmart)

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key]
            }

            return (
              (_ret =
                ((_temp =
                  ((_this = _possibleConstructorReturn(
                    this,
                    (_ref = InputSmart.__proto__ || Object.getPrototypeOf(InputSmart)).call.apply(_ref, [this].concat(args))
                  )),
                  _this)),
                (_this.storeInput = function (ref) {
                  return (_this.input = ref)
                }),
                _temp)),
              _possibleConstructorReturn(_this, _ret)
            )
          }

          _createClass(
            InputSmart,
            [
              {
                key: 'focus',
                value: function focus() {
                  this.input.focus()
                },
              },
              {
                key: 'render',
                value: function render() {
                  var _props = this.props,
                    country = _props.country,
                    metadata = _props.metadata,
                    lenientInput = _props.lenientInput,
                    rest = _objectWithoutProperties(_props, ['country', 'metadata', 'lenientInput'])

                  return _react2.default.createElement(
                    _inputFormat.ReactInput,
                    _extends({}, rest, {
                      ref: this.storeInput,
                      parse: lenientInput ? InputSmart.parse : _parsePhoneNumberCharacters.parsePhoneNumberCharacter,
                      format: function format(value) {
                        return lenientInput
                          ? InputSmart.format(value, country, metadata)
                          : (0, _formatPhoneNumber2.default)(value, country, metadata)
                      },
                    })
                  )
                },
              },
            ],
            [
              {
                key: 'format',
                value: function format(value, country, metadata) {
                  var alphaRegex = /[a-zA-Z#*]+/g
                  var val = (0, _formatPhoneNumber2.default)(value, country, metadata)
                  if (alphaRegex.test(value)) {
                    return { text: value, template: '' }
                  }
                  return val
                },
              },
              {
                key: 'parse',
                value: function parse(character, value) {
                  var alphaRegex = /[a-zA-Z#*]+/g
                  if (alphaRegex.test(character)) {
                    return character
                  }

                  return (0, _parsePhoneNumberCharacters.parsePhoneNumberCharacter)(character, value)
                },
              },
            ]
          )

          return InputSmart
        })(_react.Component)

        exports.default = InputSmart
        //# sourceMappingURL=InputSmart.js.map

        /***/
      },

    /***/ './modules/InternationalIcon.js':
      /*!**************************************!*\
  !*** ./modules/InternationalIcon.js ***!
  \**************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = InternationalIcon

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function InternationalIcon() {
          return _react2.default.createElement(
            'svg',
            {
              version: '1.1',
              xmlns: 'http://www.w3.org/2000/svg',
              xmlnsXlink: 'http://www.w3.org/1999/xlink',
              viewBox: '0 0 356.926 356.926',
            },
            _react2.default.createElement(
              'g',
              null,
              _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', {
                  d:
                    'M211.89,213.669c0-10.475-8.521-18.997-18.996-18.997c-0.401,0-0.799,0.017-1.193,0.041v2.406 c0.396-0.028,0.79-0.061,1.193-0.061c9.158,0,16.608,7.452,16.608,16.611s-7.45,16.61-16.608,16.61 c-0.269,0-0.53-0.027-0.795-0.041v0.897v1.509v4.723H186.2v3.182h13.388v-3.182h-5.104v-4.774 C204.218,231.781,211.89,223.607,211.89,213.669z',
                }),
                _react2.default.createElement(
                  'g',
                  null,
                  _react2.default.createElement('polygon', {
                    points:
                      '260.072,79.408 260.398,82.045 256.447,82.882 255.913,88.517 260.677,88.517 266.998,87.913 270.251,84.021 266.788,82.678 264.883,80.488 262.024,75.858 260.677,69.329 255.286,70.409 253.799,72.721 253.799,75.312 256.378,77.084 ',
                  }),
                  _react2.default.createElement('polygon', {
                    points: '255.495,81.569 255.773,78.037 252.637,76.683 248.233,77.706 244.945,82.94 244.945,86.344 248.768,86.344 ',
                  }),
                  _react2.default.createElement('path', {
                    d:
                      'M164.852,96.598l-0.976,2.498h-4.7v2.428h1.121c0,0,0.07,0.511,0.168,1.191l2.876-0.238l1.783-1.121l0.465-2.248 l2.335-0.204l0.912-1.888l-2.138-0.442L164.852,96.598z',
                  }),
                  _react2.default.createElement('polygon', {
                    points: '152.739,101.001 152.565,103.366 155.976,103.081 156.324,100.705 154.279,99.096 \t\t\t',
                  }),
                  _react2.default.createElement('path', {
                    d:
                      'M356.868,176.633c-0.047-5.223-0.313-10.398-0.802-15.505c-1.662-17.01-5.717-33.311-11.828-48.589 c-0.441-1.127-0.859-2.283-1.336-3.41c-8.121-19.183-19.531-36.646-33.474-51.721c-0.906-0.987-1.835-1.952-2.765-2.916 c-2.649-2.736-5.333-5.415-8.156-7.971C266.788,17.631,224.642,0,178.463,0C131.896,0,89.447,17.957,57.635,47.271 c-7.413,6.832-14.221,14.303-20.408,22.285C13.919,99.717,0,137.49,0,178.463c0,98.398,80.059,178.463,178.463,178.463 c69.225,0,129.316-39.643,158.897-97.399c6.32-12.327,11.247-25.491,14.569-39.294c0.837-3.486,1.58-7.018,2.208-10.585 c1.801-10.137,2.788-20.56,2.788-31.196C356.902,177.859,356.868,177.249,356.868,176.633z M323.278,105.306l1.022-1.162 c1.359,2.637,2.649,5.304,3.846,8.028l-1.708-0.07l-3.172,0.436v-7.233H323.278z M297.484,74.156l0.023-7.971 c2.812,2.975,5.508,6.036,8.087,9.214l-3.207,4.781l-11.247-0.111l-0.696-2.341L297.484,74.156z M82.214,54.364v-0.302h3.567 l0.325-1.226h5.838v2.55l-1.691,2.236h-8.052v-3.259H82.214z M87.925,62.323c0,0,3.578-0.61,3.892-0.61c0.296,0,0,3.573,0,3.573 l-8.081,0.511l-1.534-1.847L87.925,62.323z M334.642,133.156h-13.06l-7.971-5.92l-8.365,0.808v5.112h-2.648l-2.848-2.033 l-14.512-3.671v-9.4l-18.38,1.423l-5.705,3.062h-7.285l-3.59-0.36l-8.854,4.926v9.254l-18.097,13.065l1.5,5.583h3.677 l-0.964,5.315l-2.58,0.953l-0.133,13.884l15.633,17.823h6.819l0.407-1.081h12.246l3.531-3.265h6.948l3.812,3.811l10.328,1.069 l-1.359,13.757l11.503,20.28l-6.064,11.572l0.406,5.438l4.775,4.752v13.095l6.251,8.412v10.897h5.391 c-30.046,36.913-75.823,60.534-127.026,60.534c-90.312,0-163.783-73.454-163.783-163.777c0-22.732,4.665-44.401,13.077-64.089 v-5.106l5.855-7.11c2.033-3.846,4.212-7.582,6.542-11.235l0.25,2.974l-6.791,8.261c-2.108,3.985-4.084,8.052-5.855,12.217v9.312 l6.791,3.276v12.955l6.535,11.136l5.316,0.808l0.68-3.817l-6.245-9.661l-1.237-9.388h3.677l1.557,9.673l9.051,13.193l-2.33,4.27 l5.734,8.795l14.291,3.532v-2.306l5.711,0.808l-0.534,4.078l4.484,0.825l6.948,1.888l9.8,11.171l12.507,0.941l1.237,10.207 l-8.58,5.984l-0.39,9.115l-1.237,5.588l12.386,15.5l0.947,5.32c0,0,4.49,1.209,5.048,1.209c0.535,0,10.062,7.227,10.062,7.227 v28.024l3.393,0.964l-2.294,12.92l5.71,7.634l-1.068,12.827l7.563,13.269l9.696,8.47l9.731,0.197l0.952-3.148l-7.163-6.029 l0.418-2.986l1.272-3.684l0.273-3.741l-4.839-0.14l-2.44-3.066l4.021-3.881l0.546-2.916l-4.496-1.29l0.261-2.719l6.402-0.976 l9.73-4.672l3.265-6.006l10.196-13.06l-2.312-10.213l3.131-5.438l9.399,0.278l6.327-5.02l2.051-19.693l7.04-8.877l1.237-5.704 l-6.39-2.045l-4.224-6.942l-14.419-0.145l-11.444-4.351l-0.534-8.162l-3.811-6.675l-10.335-0.145l-5.995-9.382l-5.298-2.585 l-0.273,2.858l-9.672,0.569l-3.532-4.926l-10.079-2.045l-8.302,9.603l-13.065-2.23l-0.953-14.727l-9.527-1.632l3.805-7.221 l-1.092-4.148l-12.531,8.371l-7.877-0.964l-2.817-6.158l1.737-6.355l4.339-8.005l9.998-5.072h19.322l-0.064,5.891l6.948,3.235 l-0.558-10.062l5.007-5.037l10.103-6.64l0.703-4.659l10.068-10.486l10.707-5.937l-0.941-0.773l7.256-6.826l2.655,0.703 l1.214,1.522l2.76-3.062l0.68-0.296l-3.021-0.43l-3.084-0.987v-2.963l1.632-1.33h3.579l1.655,0.726l1.418,2.858l1.737-0.267 v-0.244l0.5,0.163l5.02-0.772l0.714-2.463l2.852,0.726v2.667l-2.666,1.818h0.018l0.377,2.928l9.115,2.794c0,0,0,0.035,0.023,0.11 l2.079-0.18l0.146-3.939l-7.209-3.282l-0.396-1.894l5.972-2.033l0.273-5.722l-6.245-3.805l-0.412-9.667l-8.581,4.218h-3.143 l0.837-7.355l-11.688-2.748l-4.816,3.654v11.119l-8.673,2.754l-3.486,7.244l-3.758,0.604v-9.277l-8.162-1.133l-4.096-2.667 l-1.639-6.007l14.611-8.54l7.14-2.179l0.72,4.804l3.991-0.215l0.308-2.411l4.166-0.599l0.07-0.842l-1.784-0.738l-0.407-2.544 l5.118-0.43l3.091-3.213l0.18-0.238l0.035,0.012l0.941-0.976l10.753-1.354l4.746,4.032l-12.467,6.64l15.871,3.747l2.045-5.31 h6.948l2.44-4.625l-4.903-1.226v-5.856l-15.359-6.803l-10.62,1.226l-6.001,3.125l0.407,7.628l-6.257-0.953l-0.964-4.212 l6.007-5.449l-10.898-0.535l-3.125,0.953l-1.359,3.677l4.084,0.686l-0.813,4.084l-6.936,0.406l-1.092,2.725L118.987,52.4 c0,0-0.273-5.711-0.703-5.711c-0.389,0,7.901-0.145,7.901-0.145l5.995-5.85l-3.271-1.632l-4.339,4.223l-7.222-0.406l-4.403-6.019 h-9.254L94.03,44.07h8.848l0.796,2.597l-2.307,2.172l9.807,0.279l1.487,3.532l-11.032-0.407l-0.546-2.725l-6.925-1.499 l-3.689-2.033l-8.255,0.069c27.043-19.699,60.284-31.358,96.226-31.358c41.403,0,79.263,15.476,108.124,40.915l-1.929,3.474 l-7.564,2.962l-3.194,3.462l0.743,4.02l3.893,0.546l2.358,5.867l6.704-2.713l1.127,7.86h-2.045l-5.519-0.819l-6.111,1.022 l-5.926,8.377l-8.458,1.319l-1.221,7.25l3.579,0.842l-1.046,4.665l-8.412-1.69l-7.703,1.69l-1.639,4.293l1.325,9.01l4.531,2.115 l7.61-0.046l5.123-0.465l1.58-4.078l8.018-10.422l5.264,1.081l5.193-4.7l0.976,3.678l12.78,8.621l-1.557,2.108l-5.763-0.308 l2.23,3.137l3.556,0.79l4.159-1.737l-0.093-5.002l1.859-0.923l-1.487-1.575l-8.528-4.758l-2.254-6.314h7.099l2.243,2.248 l6.134,5.257l0.244,6.367l6.332,6.733l2.348-9.231l4.392-2.394l0.802,7.552l4.287,4.7l8.54-0.139 c1.661,4.247,3.148,8.563,4.427,12.978L334.642,133.156z M97.324,81.092l4.27-2.044l3.881,0.929l-1.324,5.211l-4.183,1.319 L97.324,81.092z M120.073,93.35v3.37h-9.783l-3.689-1.028l0.918-2.341l4.7-1.94h6.437v1.94H120.073z M124.582,98.05v3.259 l-2.463,1.58l-3.044,0.575c0,0,0-4.903,0-5.415H124.582z M121.822,96.72v-3.893l3.363,3.067L121.822,96.72z M123.355,104.568 v3.178l-2.347,2.347h-5.211l0.813-3.573l2.463-0.215l0.5-1.226L123.355,104.568z M110.39,98.05h5.408l-6.948,9.696l-2.852-1.534 l0.616-4.084L110.39,98.05z M132.529,103.464v3.166h-5.211l-1.417-2.062v-2.951h0.406L132.529,103.464z M127.748,99.096 l1.475-1.557l2.498,1.557l-1.999,1.656L127.748,99.096z M337.291,141.428l0.511-0.61c0.232,0.93,0.441,1.859,0.662,2.789 L337.291,141.428z',
                  }),
                  _react2.default.createElement('path', { d: 'M27.734,109.268v5.106c1.771-4.177,3.747-8.231,5.855-12.223L27.734,109.268z' })
                )
              )
            )
          )
        }
        //# sourceMappingURL=InternationalIcon.js.map

        /***/
      },

    /***/ './modules/PhoneInput.js':
      /*!*******************************!*\
  !*** ./modules/PhoneInput.js ***!
  \*******************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _class, _class2, _temp, _initialiseProps

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _reactLifecyclesCompat = __webpack_require__(
          /*! react-lifecycles-compat */ '../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js'
        )

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        var _InputSmart = __webpack_require__(/*! ./InputSmart */ './modules/InputSmart.js')

        var _InputSmart2 = _interopRequireDefault(_InputSmart)

        var _InputBasic = __webpack_require__(/*! ./InputBasic */ './modules/InputBasic.js')

        var _InputBasic2 = _interopRequireDefault(_InputBasic)

        var _InternationalIcon = __webpack_require__(/*! ./InternationalIcon */ './modules/InternationalIcon.js')

        var _InternationalIcon2 = _interopRequireDefault(_InternationalIcon)

        var _Flag = __webpack_require__(/*! ./Flag */ './modules/Flag.js')

        var _Flag2 = _interopRequireDefault(_Flag)

        var _inputControl = __webpack_require__(/*! ./input-control */ './modules/input-control.js')

        var _countries = __webpack_require__(/*! ./countries */ './modules/countries.js')

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {}
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
            target[i] = obj[i]
          }
          return target
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        // Allows passing custom `libphonenumber-js` metadata
        // to reduce the overall bundle size.
        var PhoneNumberInput =
          (0, _reactLifecyclesCompat.polyfill)(
            (_class =
              ((_temp = _class2 = (function (_PureComponent) {
                _inherits(PhoneNumberInput, _PureComponent)

                function PhoneNumberInput(props) {
                  _classCallCheck(this, PhoneNumberInput)

                  var _this = _possibleConstructorReturn(
                    this,
                    (PhoneNumberInput.__proto__ || Object.getPrototypeOf(PhoneNumberInput)).call(this, props)
                  )

                  _initialiseProps.call(_this)

                  var _this$props = _this.props,
                    value = _this$props.value,
                    country = _this$props.country,
                    countries = _this$props.countries,
                    labels = _this$props.labels,
                    international = _this$props.international,
                    metadata = _this$props.metadata

                  // Will be removed in version 2.x.

                  if (typeof _this.props.internationalIcon !== 'function') {
                    throw new Error(
                      "You're passing a custom `internationalIcon` property to `react-phone-number-input` component. In the latest version it may only be a React component (a class or a function), not a React element. Wrap `internationalIcon` into a function to resolve the error: `() => internationalIcon`."
                    )
                  }

                  var parsed_number = (0, _inputControl.parsePhoneNumber)(value, metadata)

                  var pre_selected_country = (0, _inputControl.getPreSelectedCountry)(
                    parsed_number,
                    country,
                    countries,
                    international,
                    metadata
                  )

                  _this.state = {
                    // Workaround for `this.props` inside `getDerivedStateFromProps()`.
                    props: _this.props,

                    // The country selected.
                    country: pre_selected_country,

                    // Generate country `<select/>` options.
                    country_select_options: generate_country_select_options(_this.props),

                    // `parsed_input` state property holds non-formatted user's input.
                    // The reason is that there's no way of finding out
                    // in which form should `value` be displayed: international or national.
                    // E.g. if `value` is `+78005553535` then it could be input
                    // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
                    // Hence storing just `value`is not sufficient for correct formatting.
                    // E.g. if a user entered `8 (800) 555-35-35`
                    // then value is `+78005553535` and `parsed_input` is `88005553535`
                    // and if a user entered `+7 800 555 35 35`
                    // then value is `+78005553535` and `parsed_input` is `+78005553535`.
                    parsed_input: generateParsedInput(value, parsed_number, _this.props),

                    // `value` property is duplicated in state.
                    // The reason is that `getDerivedStateFromProps()`
                    // needs this `value` to compare to the new `value` property
                    // to find out if `parsed_input` needs updating:
                    // If the `value` property changed externally
                    // then it won't be equal to state `value`
                    // in which case `parsed_input` and `country` get updated.
                    value: value,
                  }
                  return _this
                }

                // Country `<select/>` `onChange` handler.

                // Phone number `<input/>` `onKeyDown` handler.

                // `<input/>` `onChange` handler.
                // Updates `value` property accordingly.
                // (so that they are kept in sync).
                // `parsed_input` must be a parsed phone number
                // or an empty string.
                // E.g.: `""`, `"+"`, `"+123"`, `"123"`.

                // This `onBlur` interceptor is a workaround for `redux-form`
                // so that it gets the up-to-date `value` in its `onBlur` handler.
                // Without this fix it just gets the actual (raw) input field textual value.
                // E.g. `+7 800 555 35 35` instead of `+78005553535`.
                //
                // A developer is not supposed to pass this `onBlur` property manually.
                // Instead, `redux-form` passes `onBlur` to this component automatically
                // and this component patches that `onBlur` handler (a hacky way but works).
                //

                // When country `<select/>` is toggled.

                _createClass(
                  PhoneNumberInput,
                  [
                    {
                      key: 'onCountryChange',

                      // Some people requested an `onCountryChange` event listener.
                      // No valid reason was given other than compliance with some legacy code
                      // which stored both phone number and country in a database.
                      // https://github.com/catamphetamine/react-phone-number-input/issues/128
                      value: function onCountryChange(new_country) {
                        var onCountryChange = this.props.onCountryChange
                        var country = this.state.country

                        if (onCountryChange && new_country !== country) {
                          onCountryChange(new_country)
                        }
                      },

                      // Can be called externally.
                    },
                    {
                      key: 'render',
                      value: function render() {
                        var _props = this.props,
                          name = _props.name,
                          disabled = _props.disabled,
                          autoComplete = _props.autoComplete,
                          countrySelectTabIndex = _props.countrySelectTabIndex,
                          showCountrySelect = _props.showCountrySelect,
                          style = _props.style,
                          className = _props.className,
                          inputClassName = _props.inputClassName,
                          getInputClassName = _props.getInputClassName,
                          countrySelectProperties = _props.countrySelectProperties,
                          lenientInput = _props.lenientInput,
                          error = _props.error,
                          indicateInvalid = _props.indicateInvalid,
                          CountrySelectComponent = _props.countrySelectComponent,
                          inputComponent = _props.inputComponent,
                          smartCaret = _props.smartCaret,
                          ext = _props.ext,
                          countries = _props.countries,
                          labels = _props.labels,
                          _ = _props.country,
                          flags = _props.flags,
                          flagComponent = _props.flagComponent,
                          flagsPath = _props.flagsPath,
                          international = _props.international,
                          internationalIcon = _props.internationalIcon,
                          displayInitialValueAsLocalNumber = _props.displayInitialValueAsLocalNumber,
                          onCountryChange = _props.onCountryChange,
                          countrySelectHidesPhoneInputField = _props.countrySelectHidesPhoneInputField,
                          locale = _props.locale,
                          metadata = _props.metadata,
                          phoneNumberInputProps = _objectWithoutProperties(_props, [
                            'name',
                            'disabled',
                            'autoComplete',
                            'countrySelectTabIndex',
                            'showCountrySelect',
                            'style',
                            'className',
                            'inputClassName',
                            'getInputClassName',
                            'countrySelectProperties',
                            'lenientInput',
                            'error',
                            'indicateInvalid',
                            'countrySelectComponent',
                            'inputComponent',
                            'smartCaret',
                            'ext',
                            'countries',
                            'labels',
                            'country',
                            'flags',
                            'flagComponent',
                            'flagsPath',
                            'international',
                            'internationalIcon',
                            'displayInitialValueAsLocalNumber',
                            'onCountryChange',
                            'countrySelectHidesPhoneInputField',
                            'locale',
                            'metadata',
                          ])

                        var _state = this.state,
                          country = _state.country,
                          hidePhoneInputField = _state.hidePhoneInputField,
                          country_select_options = _state.country_select_options,
                          parsed_input = _state.parsed_input

                        var InputComponent = inputComponent || (smartCaret ? _InputSmart2.default : _InputBasic2.default)

                        // Extract `countrySelectProperties` from `this.props`
                        // also removing them from `phoneNumberInputProps`.
                        var _countrySelectProps = {}
                        if (countrySelectProperties) {
                          for (var key in countrySelectProperties) {
                            if (this.props.hasOwnProperty(key)) {
                              _countrySelectProps[countrySelectProperties[key]] = this.props[key]
                              delete phoneNumberInputProps[key]
                            }
                          }
                        }

                        return _react2.default.createElement(
                          'div',
                          {
                            style: style,
                            className: (0, _classnames2.default)(
                              'react-phone-number-input',
                              {
                                'react-phone-number-input--invalid': error && indicateInvalid,
                              },
                              className
                            ),
                          },
                          _react2.default.createElement(
                            'div',
                            { className: 'react-phone-number-input__row' },
                            showCountrySelect &&
                              _react2.default.createElement(
                                CountrySelectComponent,
                                _extends({}, _countrySelectProps, {
                                  ref: this.storeCountrySelectInstance,
                                  name: name ? name + '__country' : undefined,
                                  value: country,
                                  options: country_select_options,
                                  onChange: this.onCountrySelected,
                                  disabled: disabled,
                                  tabIndex: countrySelectTabIndex,
                                  hidePhoneInputField: this.hidePhoneInputField,
                                  focusPhoneInputField: this.focus,
                                  className: 'react-phone-number-input__country',
                                })
                              ),
                            !hidePhoneInputField &&
                              _react2.default.createElement(
                                InputComponent,
                                _extends(
                                  {
                                    type: 'tel',
                                    name: name,
                                  },
                                  phoneNumberInputProps,
                                  {
                                    ref: this.storePhoneNumberInputInstance,
                                    metadata: metadata,
                                    country: country,
                                    value: parsed_input || '',
                                    onChange: this.onChange,
                                    onBlur: this.onBlur,
                                    onKeyDown: this.onPhoneNumberKeyDown,
                                    disabled: disabled,
                                    autoComplete: autoComplete,
                                    lenientInput: lenientInput,
                                    className: (0, _classnames2.default)(
                                      'react-phone-number-input__phone',
                                      // Will be uncommented for version 2.x
                                      // {
                                      // 	'react-phone-number-input__phone--disabled' : disabled,
                                      // 	'react-phone-number-input__phone--invalid'  : error && indicateInvalid
                                      // },
                                      inputClassName,
                                      getInputClassName && getInputClassName({ disabled: disabled, invalid: error && indicateInvalid })
                                    ),
                                  }
                                )
                              ),
                            ext &&
                              !hidePhoneInputField &&
                              _react2.default.createElement(
                                'label',
                                { className: 'react-phone-number-input__ext' },
                                (labels && labels.ext) || 'ext.',
                                _react2.default.cloneElement(ext, {
                                  type: ext.props.type === undefined ? 'number' : ext.props.type,
                                  className: (0, _classnames2.default)(
                                    'react-phone-number-input__ext-input',
                                    // Will be uncommented for version 2.x
                                    // {
                                    // 	'react-phone-number-input__phone--disabled' : disabled,
                                    // },
                                    inputClassName,
                                    getInputClassName && getInputClassName({ disabled: disabled }),
                                    ext.props.className
                                  ),
                                })
                              )
                          ),
                          error &&
                            indicateInvalid &&
                            _react2.default.createElement(
                              'div',
                              { className: (0, _classnames2.default)('react-phone-number-input__error', 'rrui__input-error') },
                              error
                            )
                        )
                      },
                    },
                  ],
                  [
                    {
                      key: 'getDerivedStateFromProps',
                      value: function getDerivedStateFromProps(props, state) {
                        var country = state.country,
                          hasChangedCountry = state.hasChangedCountry,
                          value = state.value,
                          _state$props = state.props,
                          old_default_country = _state$props.country,
                          old_value = _state$props.value
                        var metadata = props.metadata,
                          new_default_country = props.country,
                          new_value = props.value

                        // Emulate `prevProps` via `state.props`.

                        var new_state = {
                          props: props,

                          // If `countries` or `labels` or `international` changed
                          // then re-generate country `<select/>` options.
                        }
                        if (
                          props.countries !== state.props.countries ||
                          props.labels !== state.props.labels ||
                          props.international !== state.props.international
                        ) {
                          new_state.country_select_options = generate_country_select_options(props)
                        }

                        // If the default country changed.
                        // (e.g. in case of ajax GeoIP detection after page loaded)
                        // then select it but only if the user didn't previously select
                        // another country and no phone number has been entered so far.
                        // Because if the user has already started inputting a phone number
                        // then he's okay with no country being selected at all ("International")
                        // and doesn't want to be disturbed, doesn't want his input to be screwed, etc.
                        if (new_default_country !== old_default_country && !hasChangedCountry && !value && !new_value) {
                          return _extends({}, new_state, {
                            country: new_default_country,
                          })
                        }
                        // If a new `value` is set externally.
                        // (e.g. as a result of an ajax API request
                        //  to get user's phone after page loaded)
                        // The first part — `new_value !== old_value` —
                        // is basically `props.value !== prevProps.value`
                        // so it means "if value property was changed externally".
                        // The second part — `new_value !== value` —
                        // is for ignoring the `getDerivedStateFromProps()` call
                        // which happens in `this.onChange()` right after `this.setState()`.
                        // If this `getDerivedStateFromProps()` call isn't ignored
                        // then the country flag would reset on each input.
                        else if (new_value !== old_value && new_value !== value) {
                          var parsed_number = (0, _inputControl.parsePhoneNumber)(new_value, metadata)

                          return _extends({}, new_state, {
                            parsed_input: generateParsedInput(new_value, parsed_number, props),
                            value: new_value,
                            country: !!parsed_number.country ? parsed_number.country : country,
                          })
                        }

                        // Maybe `new_state.country_select_options` changed.
                        // In any case, update `prevProps`.
                        return new_state
                      },
                    },
                  ]
                )

                return PhoneNumberInput
              })(_react.PureComponent)),
              (_class2.propTypes = {
                // Phone number in E.164 format.
                // E.g. "+12223333333" for USA.
                value: _propTypes2.default.string,

                // `onChange` handler is called each time
                // the phone number `<input/>` is edited.
                onChange: _propTypes2.default.func.isRequired,

                // `onBlur` is usually passed by `redux-form`.
                onBlur: _propTypes2.default.func,

                // `onKeyDown` handler (e.g. to handle Enter key press).
                onKeyDown: _propTypes2.default.func,

                // Some people requested an `onCountryChange` event listener.
                // No valid reason was given other than compliance with some legacy code
                // which stored both phone number and country in a database.
                // https://github.com/catamphetamine/react-phone-number-input/issues/128
                onCountryChange: _propTypes2.default.func,

                // Disables both the phone number `<input/>`
                // and the country `<select/>`.
                // (is `false` by default)
                disabled: _propTypes2.default.bool.isRequired,

                // Allows skipping validation and parsing of a phone number
                // when no number can be discerned. Used in cases of backwards compatibility
                // with less correct fields.
                lenientInput: _propTypes2.default.bool.isRequired,

                // Web browser's "autocomplete" feature
                // remembers the phone number being input
                // and can also autofill the `<input/>`
                // with previously remembered phone numbers.
                //
                // Default value: "tel".
                //
                // https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
                //
                // "So when should you use autocomplete="off"?
                //  One example is when you've implemented your own version
                //  of autocomplete for search. Another example is any form field
                //  where users will input and submit different kinds of information
                //  where it would not be useful to have the browser remember
                //  what was submitted previously".
                //
                autoComplete: _propTypes2.default.string.isRequired,

                // Should the initially passed phone number `value`
                // be converted to a national phone number for its country.
                // (is `false` by default)
                displayInitialValueAsLocalNumber: _propTypes2.default.bool.isRequired,

                // The country to be selected by default.
                // Two-letter country code ("ISO 3166-1 alpha-2").
                country: _propTypes2.default.string,

                // Only these countries will be available for selection.
                // Includes all countries by default.
                countries: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

                // Custom country `<select/>` option names.
                // E.g. `{ ZZ: 'Международный', RU: 'Россия', US: 'США', ... }`
                labels: _propTypes2.default.objectOf(_propTypes2.default.string),

                // Country flag icon components.
                // By default flag icons are inserted as `<img/>`s
                // with their `src` pointed to `flag-icon-css` github repo.
                // There might be cases (e.g. an offline application)
                // where having a large (3 megabyte) `<svg/>` flags
                // bundle is more appropriate.
                // `import flags from 'react-phone-number-input/flags'`.
                flags: _propTypes2.default.objectOf(_propTypes2.default.func),

                // Flag icon component.
                flagComponent: _propTypes2.default.func.isRequired,

                // A base URL path for national flag SVG icons.
                // By default it uses the ones from `flag-icon-css` github repo.
                flagsPath: _propTypes2.default.string.isRequired,

                // Whether to add the "International" option
                // to the list of countries.
                // By default it's added if the list of `countries` hasn't been overridden.
                international: _propTypes2.default.bool,

                // Custom "International" country `<select/>` option icon.
                internationalIcon: _propTypes2.default.func.isRequired,

                // Whether to show country `<select/>`.
                // (is `true` by default)
                showCountrySelect: _propTypes2.default.bool.isRequired,

                // HTML `tabindex` attribute for the country `<select/>`.
                countrySelectTabIndex: _propTypes2.default.number,

                // `<Phone/>` component CSS style object.
                style: _propTypes2.default.object,

                // `<Phone/>` component CSS class.
                className: _propTypes2.default.string,

                // `<input/>` CSS class.
                // Both for the phone number `<input/>` and
                // `react-responsive-ui` `<Select/>` autocomplete input.
                inputClassName: _propTypes2.default.string,

                // Returns phone number `<input/>` CSS class string.
                // Receives an object of shape `{ disabled : boolean?, invalid : boolean? }`.
                getInputClassName: _propTypes2.default.func,

                // Country `<select/>` component.
                //
                // Receives properties:
                //
                // * `name : string?` — HTML `name` attribute.
                // * `value : string?` — The currently selected country code.
                // * `onChange(value : string?)` — Updates the `value`.
                // * `options : object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value : string?, label : string, icon : React.Component }`.
                // * `disabled : boolean?` — HTML `disabled` attribute.
                // * `tabIndex : (number|string)?` — HTML `tabIndex` attribute.
                // * `className : string` — CSS class name.
                //
                // Optional properties (should be ignored unless needed):
                //
                // * `hidePhoneInputField(hide : boolean)` — Can be called to show/hide phone input field. Takes `hide : boolean` argument. E.g. `react-responsive-ui` `<Select/>` uses this to hide phone number input when country select is expanded.
                // * `focusPhoneInputField()` — Can be called to manually focus phone input field. E.g. `react-responsive-ui` `<Select/>` uses this to focus phone number input after country selection in a timeout (after the phone input field is no longer hidden).
                //
                countrySelectComponent: _propTypes2.default.func.isRequired,

                // Phone number `<input/>` component.
                //
                // Receives properties:
                //
                // * `value : string` — The parsed phone number. E.g.: `""`, `"+"`, `"+123"`, `"123"`.
                // * `onChange(value : string)` — Updates the `value`.
                // * `country : string?` — The currently selected country. `undefined` means "International" (no country selected).
                // * `metadata : object` — `libphonenumber-js` metadata.
                // * All other properties should be passed through to the underlying `<input/>`.
                //
                // Must also implement `.focus()` method.
                //
                inputComponent: _propTypes2.default.func,

                // Set to `false` to use `inputComponent={InputBasic}`
                // instead of `input-format`'s `<ReactInput/>`.
                // Is `true` by default.
                smartCaret: _propTypes2.default.bool.isRequired,

                // For example, `react-responsive-ui` `<Select/>`
                // hides the phone number input field when expanded.
                // Is `false` by default.
                countrySelectHidesPhoneInputField: _propTypes2.default.bool.isRequired,

                // Phone number extension element.
                ext: _propTypes2.default.node,

                // An error message shown below the phone number `<input/>`.
                error: _propTypes2.default.string,

                // The `error` is shown only when `indicateInvalid` is true.
                indicateInvalid: _propTypes2.default.bool,

                // Translation.
                locale: _propTypes2.default.objectOf(_propTypes2.default.string),

                // `libphonenumber-js` metadata
                metadata: _propTypes2.default.shape({
                  country_calling_codes: _propTypes2.default.object.isRequired,
                  countries: _propTypes2.default.object.isRequired,
                }).isRequired,
              }),
              (_class2.defaultProps = {
                // Not disabled.
                disabled: false,

                lenientInput: false,

                // Remember (and autofill) the value as a phone number.
                autoComplete: 'tel',

                // Include all countries.
                countries: _countries.countries,

                // Flag icon component.
                flagComponent: _Flag2.default,

                // By default use icons from `flag-icon-css` github repo.
                flagsPath: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/',

                // Default "International" country `<select/>` option icon (globe).
                internationalIcon: _InternationalIcon2.default,

                // Show country `<select/>`.
                showCountrySelect: true,

                // Don't convert the initially passed phone number `value`
                // to a national phone number for its country.
                // The reason is that the newer generation grows up when
                // there are no stationary phones and therefore everyone inputs
                // phone numbers with a `+` in their smartphones
                // so phone numbers written in international form
                // are gradually being considered more natural than local ones.
                displayInitialValueAsLocalNumber: false,

                // Set to `false` to use `inputComponent={InputBasic}`
                // instead of `input-format`'s `<ReactInput/>`.
                // Is `true` by default.
                smartCaret: true,

                // `react-responsive-ui` `<Select/>` sets this to true
                // to hide the phone number input field when expanded.
                countrySelectHidesPhoneInputField: false,
              }),
              (_initialiseProps = function _initialiseProps() {
                var _this2 = this

                this.onCountrySelected = function (new_country) {
                  var _props2 = _this2.props,
                    metadata = _props2.metadata,
                    onChange = _props2.onChange,
                    countrySelectHidesPhoneInputField = _props2.countrySelectHidesPhoneInputField
                  var _state2 = _this2.state,
                    old_parsed_input = _state2.parsed_input,
                    old_country = _state2.country

                  // After the new `country` has been selected,
                  // if the phone number `<input/>` holds any digits
                  // then migrate those digits for the new `country`.

                  var new_parsed_input = (0, _inputControl.migrateParsedInputForNewCountry)(
                    old_parsed_input,
                    old_country,
                    new_country,
                    metadata
                  )

                  // Check if it can't possibly be a number
                  var alpha = /[a-zA-Z]+/

                  var new_value = (0, _inputControl.e164)(new_parsed_input, new_country, metadata)

                  _this2.onCountryChange(new_country)

                  // Focus the phone number `<input/>` upon country selection.
                  // The default behaviour.
                  if (!countrySelectHidesPhoneInputField) {
                    _this2.focus()
                  }

                  _this2.setState(
                    {
                      country: new_country,
                      hasChangedCountry: true,
                      parsed_input: new_parsed_input,
                      value: new_value,
                    },
                    function () {
                      // Update the new `value` property.
                      // Doing it after the `state` has been updated
                      // because `onChange()` will trigger `getDerivedStateFromProps()`
                      // with the new `value` which will be compared to `state.value` there.
                      onChange(new_value)

                      // Focus the phone number `<input/>` upon country selection.
                      // Doing it in a `setState()` callback because the phone number
                      // `<input/>` is hidden while country `<select/>` is expanded.
                      if (countrySelectHidesPhoneInputField) {
                        _this2.focus()
                      }
                    }
                  )
                }

                this.onPhoneNumberKeyDown = function (event) {
                  var onKeyDown = _this2.props.onKeyDown

                  // Actually "Down arrow" key is used for showing "autocomplete" ("autofill") options.
                  // (e.g. previously entered phone numbers for `autoComplete="tel"`)
                  // // Expand country `<select/>`` on "Down arrow" key press.
                  // if (event.keyCode === 40) {
                  // 	this.country_select.toggle()
                  // }

                  if (onKeyDown) {
                    onKeyDown(event)
                  }
                }

                this.onChange = function (parsed_input) {
                  var _props3 = _this2.props,
                    onChange = _props3.onChange,
                    countries = _props3.countries,
                    international = _props3.international,
                    metadata = _props3.metadata,
                    lenientInput = _props3.lenientInput
                  var country = _this2.state.country

                  var alphaRegex = /[a-zA-Z#*]+/g
                  var hasAlpha = alphaRegex.test(parsed_input)

                  if (parsed_input) {
                    // If the phone number being input is an international one
                    // then tries to derive the country from the phone number.
                    // (regardless of whether there's any country currently selected)
                    if (parsed_input[0] === '+') {
                      country = (0, _inputControl.getCountryForParsedInput)(parsed_input, country, countries, international, metadata)

                      _this2.onCountryChange(country)
                    }
                    // If this `onChange()` event was triggered
                    // as a result of selecting "International" country
                    // then force-prepend a `+` sign if the phone number
                    // `<input/>` value isn't in international format.
                    else if (!country && !(lenientInput && hasAlpha)) {
                      parsed_input = '+' + parsed_input
                    }
                  }

                  // Generate the new `value` property.
                  var value = (0, _inputControl.e164)(parsed_input, country, metadata)

                  _this2.setState(
                    {
                      parsed_input: parsed_input,
                      value: value,
                      country: country,
                    },
                    // Update the new `value` property.
                    // Doing it after the `state` has been updated
                    // because `onChange()` will trigger `getDerivedStateFromProps()`
                    // with the new `value` which will be compared to `state.value` there.
                    function () {
                      return onChange(lenientInput ? (hasAlpha ? parsed_input : value) : value)
                    }
                  )
                }

                this.onBlur = function (event) {
                  var onBlur = _this2.props.onBlur
                  var value = _this2.state.value

                  if (!onBlur) {
                    return
                  }

                  // `event` is React's `SyntheticEvent`.
                  // Its `.value` is read-only therefore cloning it.
                  var _event = _extends({}, event, {
                    target: _extends({}, event.target, {
                      value: value,
                    }),

                    // For `redux-form` event detection.
                    // https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
                  })
                  _event.stopPropagation = event.stopPropagation
                  _event.preventDefault = event.preventDefault

                  return onBlur(_event)
                }

                this.hidePhoneInputField = function (hide) {
                  _this2.setState({
                    hidePhoneInputField: hide,
                  })
                }

                this.focus = function () {
                  return _this2.number_input.focus()
                }

                this.storeCountrySelectInstance = function (_) {
                  return (_this2.country_select = _)
                }

                this.storePhoneNumberInputInstance = function (_) {
                  return (_this2.number_input = _)
                }
              }),
              _temp))
          ) || _class

        // Generates country `<select/>` options.

        exports.default = PhoneNumberInput
        function generate_country_select_options(props) {
          var countries = props.countries,
            labels = props.labels,
            international = props.international

          return (0, _inputControl.getCountrySelectOptions)(countries, labels, international).map(function (_ref) {
            var value = _ref.value,
              label = _ref.label
            return {
              value: value,
              label: label,
              icon: createCountrySelectOptionIconComponent(value, label, props),
            }
          })
        }

        function createCountrySelectOptionIconComponent(value, label, props) {
          var flags = props.flags,
            flagsPath = props.flagsPath,
            FlagComponent = props.flagComponent,
            InternationalIcon = props.internationalIcon

          if (value) {
            return function (props) {
              return _react2.default.createElement(FlagComponent, {
                country: value,
                flags: flags,
                flagsPath: flagsPath,
                className: props ? props.className : undefined,
              })
            }
          }

          return function (props) {
            return _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)(
                  'react-phone-number-input__icon',
                  'react-phone-number-input__icon--international',
                  props && props.className
                ),
              },
              _react2.default.createElement(InternationalIcon, null)
            )
          }
        }

        function generateParsedInput(value, parsed_number, props) {
          var displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
            metadata = props.metadata

          // If the `value` (E.164 phone number)
          // belongs to the currently selected country
          // and `displayInitialValueAsLocalNumber` property is `true`
          // then convert `value` (E.164 phone number)
          // to a local phone number digits.
          // E.g. '+78005553535' -> '88005553535'.

          if (displayInitialValueAsLocalNumber && parsed_number.country) {
            return (0, _inputControl.generateNationalNumberDigits)(parsed_number, metadata)
          }

          return value
        }
        //# sourceMappingURL=PhoneInput.js.map

        /***/
      },

    /***/ './modules/PhoneInputNative.js':
      /*!*************************************!*\
  !*** ./modules/PhoneInputNative.js ***!
  \*************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _class, _temp2

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        var _PhoneInput = __webpack_require__(/*! ./PhoneInput */ './modules/PhoneInput.js')

        var _PhoneInput2 = _interopRequireDefault(_PhoneInput)

        var _CountrySelectNative = __webpack_require__(/*! ./CountrySelectNative */ './modules/CountrySelectNative.js')

        var _CountrySelectNative2 = _interopRequireDefault(_CountrySelectNative)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        var PhoneInputNative =
          ((_temp2 = _class = (function (_Component) {
            _inherits(PhoneInputNative, _Component)

            function PhoneInputNative() {
              var _ref

              var _temp, _this, _ret

              _classCallCheck(this, PhoneInputNative)

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key]
              }

              return (
                (_ret =
                  ((_temp =
                    ((_this = _possibleConstructorReturn(
                      this,
                      (_ref = PhoneInputNative.__proto__ || Object.getPrototypeOf(PhoneInputNative)).call.apply(_ref, [this].concat(args))
                    )),
                    _this)),
                  (_this.storeInputRef = function (ref) {
                    return (_this.input = ref)
                  }),
                  (_this.getInputClassName = function (_ref2) {
                    var disabled = _ref2.disabled,
                      invalid = _ref2.invalid

                    return (0, _classnames2.default)(
                      // Will be removed in version 2.x
                      'react-phone-number-input__phone--native',
                      {
                        'react-phone-number-input__phone--disabled': disabled,
                        'react-phone-number-input__phone--invalid': invalid,
                      }
                    )
                  }),
                  _temp)),
                _possibleConstructorReturn(_this, _ret)
              )
            }

            _createClass(PhoneInputNative, [
              {
                key: 'render',
                value: function render() {
                  return _react2.default.createElement(
                    _PhoneInput2.default,
                    _extends({}, this.props, {
                      ref: this.storeInputRef,
                      getInputClassName: this.getInputClassName,
                      countrySelectComponent: _CountrySelectNative2.default,
                      countrySelectProperties: countrySelectProperties,
                    })
                  )
                },
              },
              {
                key: 'focus',

                // Proxy `.focus()` method.
                value: function focus() {
                  return this.input.focus()
                },
              },
            ])

            return PhoneInputNative
          })(_react.Component)),
          (_class.propTypes = {
            // Replaces the default country select arrow.
            countrySelectArrowComponent: _propTypes2.default.func,
          }),
          _temp2)
        exports.default = PhoneInputNative

        var countrySelectProperties = {
          countrySelectArrowComponent: 'selectArrowComponent',
        }
        //# sourceMappingURL=PhoneInputNative.js.map

        /***/
      },

    /***/ './modules/PhoneInputNativeDefaultMetadata.js':
      /*!****************************************************!*\
  !*** ./modules/PhoneInputNativeDefaultMetadata.js ***!
  \****************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _metadata = __webpack_require__(/*! libphonenumber-js/metadata.min */ '../node_modules/libphonenumber-js/metadata.min.json')

        var _metadata2 = _interopRequireDefault(_metadata)

        var _PhoneInputNative = __webpack_require__(/*! ./PhoneInputNative */ './modules/PhoneInputNative.js')

        var _PhoneInputNative2 = _interopRequireDefault(_PhoneInputNative)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        var PhoneInputNativeDefaultMetadata = (function (_Component) {
          _inherits(PhoneInputNativeDefaultMetadata, _Component)

          function PhoneInputNativeDefaultMetadata() {
            var _ref

            var _temp, _this, _ret

            _classCallCheck(this, PhoneInputNativeDefaultMetadata)

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key]
            }

            return (
              (_ret =
                ((_temp =
                  ((_this = _possibleConstructorReturn(
                    this,
                    (_ref = PhoneInputNativeDefaultMetadata.__proto__ || Object.getPrototypeOf(PhoneInputNativeDefaultMetadata)).call.apply(
                      _ref,
                      [this].concat(args)
                    )
                  )),
                  _this)),
                (_this.storeInputRef = function (ref) {
                  return (_this.input = ref)
                }),
                _temp)),
              _possibleConstructorReturn(_this, _ret)
            )
          }

          _createClass(PhoneInputNativeDefaultMetadata, [
            {
              key: 'render',
              value: function render() {
                return _react2.default.createElement(
                  _PhoneInputNative2.default,
                  _extends({}, this.props, {
                    ref: this.storeInputRef,
                    metadata: _metadata2.default,
                  })
                )
              },

              // Proxy `.focus()` method.
            },
            {
              key: 'focus',
              value: function focus() {
                return this.input.focus()
              },
            },
          ])

          return PhoneInputNativeDefaultMetadata
        })(_react.Component)

        exports.default = PhoneInputNativeDefaultMetadata
        //# sourceMappingURL=PhoneInputNativeDefaultMetadata.js.map

        /***/
      },

    /***/ './modules/PhoneInputReactResponsiveUI.js':
      /*!************************************************!*\
  !*** ./modules/PhoneInputReactResponsiveUI.js ***!
  \************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _class, _temp2

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _propTypes = __webpack_require__(/*! prop-types */ '../node_modules/prop-types/index.js')

        var _propTypes2 = _interopRequireDefault(_propTypes)

        var _classnames = __webpack_require__(/*! classnames */ '../node_modules/classnames/index.js')

        var _classnames2 = _interopRequireDefault(_classnames)

        var _PhoneInput = __webpack_require__(/*! ./PhoneInput */ './modules/PhoneInput.js')

        var _PhoneInput2 = _interopRequireDefault(_PhoneInput)

        var _CountrySelectReactResponsiveUI = __webpack_require__(
          /*! ./CountrySelectReactResponsiveUI */ './modules/CountrySelectReactResponsiveUI.js'
        )

        var _CountrySelectReactResponsiveUI2 = _interopRequireDefault(_CountrySelectReactResponsiveUI)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        var PhoneInputReactResponsiveUI =
          ((_temp2 = _class = (function (_Component) {
            _inherits(PhoneInputReactResponsiveUI, _Component)

            function PhoneInputReactResponsiveUI() {
              var _ref

              var _temp, _this, _ret

              _classCallCheck(this, PhoneInputReactResponsiveUI)

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key]
              }

              return (
                (_ret =
                  ((_temp =
                    ((_this = _possibleConstructorReturn(
                      this,
                      (_ref = PhoneInputReactResponsiveUI.__proto__ || Object.getPrototypeOf(PhoneInputReactResponsiveUI)).call.apply(
                        _ref,
                        [this].concat(args)
                      )
                    )),
                    _this)),
                  (_this.storeInputRef = function (ref) {
                    return (_this.input = ref)
                  }),
                  (_this.getInputClassName = function (_ref2) {
                    var disabled = _ref2.disabled,
                      invalid = _ref2.invalid

                    return (0, _classnames2.default)('rrui__input', 'rrui__input-element', 'rrui__input-field', {
                      'rrui__input-field--invalid': invalid,
                      'rrui__input-field--disabled': disabled,
                    })
                  }),
                  _temp)),
                _possibleConstructorReturn(_this, _ret)
              )
            }

            _createClass(PhoneInputReactResponsiveUI, [
              {
                key: 'render',
                value: function render() {
                  return _react2.default.createElement(
                    _PhoneInput2.default,
                    _extends({}, this.props, {
                      ref: this.storeInputRef,
                      getInputClassName: this.getInputClassName,
                      countrySelectComponent: _CountrySelectReactResponsiveUI2.default,
                      countrySelectProperties: countrySelectProperties,
                      countrySelectHidesPhoneInputField: true,
                    })
                  )
                },
              },
              {
                key: 'focus',

                // Proxy `.focus()` method.
                value: function focus() {
                  return this.input.focus()
                },
              },
            ])

            return PhoneInputReactResponsiveUI
          })(_react.Component)),
          (_class.propTypes = {
            // `<input/>` CSS class.
            // Both for the phone number `<input/>` and
            // the country select autocomplete `<input/>`.
            inputClassName: _propTypes2.default.string,

            // If set to `false`, then country flags will be shown
            // for all countries when country `<select/>` is expanded.
            // By default shows flag only for currently selected country.
            saveOnIcons: _propTypes2.default.bool,

            // Whether to use native country `<select/>` when it's expanded.
            // Deprecated. Will be removed in some future major version.
            // Use `<PhoneInputNative/>` instead.
            nativeCountrySelect: _propTypes2.default.bool,

            // `aria-label` for the `<Select/>`'s toggle `<button/>`.
            countrySelectAriaLabel: _propTypes2.default.string,

            // `aria-label` for the `<Select/>`'s "Close" button
            // (which is an "x" visible in fullscreen mode).
            // (not yet implemented but is likely to be).
            countrySelectCloseAriaLabel: _propTypes2.default.string,

            // Defines the height (in items) of the expanded country `<select/>`.
            countrySelectMaxItems: _propTypes2.default.number,

            // Country `<select/>` toggle `<button/>` CSS class.
            // Deprecated. Will be removed in some future major version.
            countrySelectToggleClassName: _propTypes2.default.string,
          }),
          _temp2)
        exports.default = PhoneInputReactResponsiveUI

        var countrySelectProperties = {
          inputClassName: 'inputClassName',
          saveOnIcons: 'saveOnIcons',
          nativeCountrySelect: 'nativeExpanded',
          countrySelectAriaLabel: 'ariaLabel',
          countrySelectCloseAriaLabel: 'closeAriaLabel',
          countrySelectMaxItems: 'maxItems',
          countrySelectToggleClassName: 'toggleClassName',
        }
        //# sourceMappingURL=PhoneInputReactResponsiveUI.js.map

        /***/
      },

    /***/ './modules/PhoneInputReactResponsiveUIDefaultMetadata.js':
      /*!***************************************************************!*\
  !*** ./modules/PhoneInputReactResponsiveUIDefaultMetadata.js ***!
  \***************************************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        var _typeof =
          typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function (obj) {
                return typeof obj
              }
            : function (obj) {
                return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
              }

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = undefined

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i]
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key]
                }
              }
            }
            return target
          }

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i]
              descriptor.enumerable = descriptor.enumerable || false
              descriptor.configurable = true
              if ('value' in descriptor) descriptor.writable = true
              Object.defineProperty(target, descriptor.key, descriptor)
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps)
            if (staticProps) defineProperties(Constructor, staticProps)
            return Constructor
          }
        })()

        var _react = __webpack_require__(/*! react */ 'react')

        var _react2 = _interopRequireDefault(_react)

        var _metadata = __webpack_require__(/*! libphonenumber-js/metadata.min */ '../node_modules/libphonenumber-js/metadata.min.json')

        var _metadata2 = _interopRequireDefault(_metadata)

        var _PhoneInputReactResponsiveUI = __webpack_require__(
          /*! ./PhoneInputReactResponsiveUI */ './modules/PhoneInputReactResponsiveUI.js'
        )

        var _PhoneInputReactResponsiveUI2 = _interopRequireDefault(_PhoneInputReactResponsiveUI)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function')
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
          }
          return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === 'object' || typeof call === 'function')
            ? call
            : self
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError(
              'Super expression must either be null or a function, not ' +
                (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass))
            )
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: { value: subClass, enumerable: false, writable: true, configurable: true },
          })
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass)
        }

        var PhoneInputReactResponsiveUIDefaultMetadata = (function (_Component) {
          _inherits(PhoneInputReactResponsiveUIDefaultMetadata, _Component)

          function PhoneInputReactResponsiveUIDefaultMetadata() {
            var _ref

            var _temp, _this, _ret

            _classCallCheck(this, PhoneInputReactResponsiveUIDefaultMetadata)

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key]
            }

            return (
              (_ret =
                ((_temp =
                  ((_this = _possibleConstructorReturn(
                    this,
                    (_ref =
                      PhoneInputReactResponsiveUIDefaultMetadata.__proto__ ||
                      Object.getPrototypeOf(PhoneInputReactResponsiveUIDefaultMetadata)).call.apply(_ref, [this].concat(args))
                  )),
                  _this)),
                (_this.storeInputRef = function (ref) {
                  return (_this.input = ref)
                }),
                _temp)),
              _possibleConstructorReturn(_this, _ret)
            )
          }

          _createClass(PhoneInputReactResponsiveUIDefaultMetadata, [
            {
              key: 'render',
              value: function render() {
                return _react2.default.createElement(
                  _PhoneInputReactResponsiveUI2.default,
                  _extends({}, this.props, {
                    ref: this.storeInputRef,
                    metadata: _metadata2.default,
                  })
                )
              },

              // Proxy `.focus()` method.
            },
            {
              key: 'focus',
              value: function focus() {
                return this.input.focus()
              },
            },
          ])

          return PhoneInputReactResponsiveUIDefaultMetadata
        })(_react.Component)

        exports.default = PhoneInputReactResponsiveUIDefaultMetadata
        //# sourceMappingURL=PhoneInputReactResponsiveUIDefaultMetadata.js.map

        /***/
      },

    /***/ './modules/countries.js':
      /*!******************************!*\
  !*** ./modules/countries.js ***!
  \******************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.countries = undefined

        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = []
            var _n = true
            var _d = false
            var _e = undefined
            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value)
                if (i && _arr.length === i) break
              }
            } catch (err) {
              _d = true
              _e = err
            } finally {
              try {
                if (!_n && _i['return']) _i['return']()
              } finally {
                if (_d) throw _e
              }
            }
            return _arr
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i)
            } else {
              throw new TypeError('Invalid attempt to destructure non-iterable instance')
            }
          }
        })() // A list of all country names
        // sorted by country code.

        var _countries = __webpack_require__(/*! ./countries.json */ './modules/countries.json')

        var _countries2 = _interopRequireDefault(_countries)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        // A list of all country codes.
        var countries = (exports.countries = [])

        // Country code to country name map.
        var default_country_names = {
          // From ISO 3166-1:2006(E/F):
          //
          // 8.1.3   User-assigned code elements
          //
          // If users need code elements to represent country names not included
          // in this part of ISO 3166, the series of letters AA, QM to QZ, XA
          // to XZ, and ZZ, and the series AAA to AAZ, QMA to QZZ, XAA to XZZ,
          // and ZZA to ZZZ respectively, and the series of numbers 900 to 999
          // are available. These users should inform the ISO 3166/MA of such use.
          //
          ZZ: 'International',

          // Populate country codes and country names.
        }
        for (
          var _iterator = _countries2.default,
            _isArray = Array.isArray(_iterator),
            _i = 0,
            _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
          ;

        ) {
          var _ref

          if (_isArray) {
            if (_i >= _iterator.length) break
            _ref = _iterator[_i++]
          } else {
            _i = _iterator.next()
            if (_i.done) break
            _ref = _i.value
          }

          var country = _ref

          var _country = _slicedToArray(country, 2),
            code = _country[0],
            name = _country[1]

          countries.push(code)
          default_country_names[code] = name
        }

        exports.default = default_country_names
        //# sourceMappingURL=countries.js.map

        /***/
      },

    /***/ './modules/countries.json':
      /*!********************************!*\
  !*** ./modules/countries.json ***!
  \********************************/
      /*! exports provided: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, default */
      /***/ function (module) {
        module.exports = JSON.parse(
          '[["AF","Afghanistan (‫افغانستان‬‎)"],["AX","Åland Islands"],["AL","Albania (Shqipëri)"],["DZ","Algeria (‫الجزائر‬‎)"],["AS","American Samoa (Amerika Sāmoa)"],["AD","Andorra"],["AO","Angola"],["AI","Anguilla"],["AG","Antigua and Barbuda"],["AR","Argentina"],["AM","Armenia (Հայաստան)"],["AW","Aruba"],["AU","Australia"],["AT","Austria (Österreich)"],["AZ","Azerbaijan (Azərbaycan)"],["BS","Bahamas"],["BH","Bahrain (‫البحرين‬‎)"],["BD","Bangladesh (বাংলাদেশ)"],["BB","Barbados"],["BY","Belarus (Беларусь)"],["BE","Belgium (België)"],["BZ","Belize"],["BJ","Benin (Bénin)"],["BM","Bermuda"],["BT","Bhutan (འབྲུག)"],["BO","Bolivia"],["BA","Bosnia and Herzegovina"],["BW","Botswana"],["BR","Brazil (Brasil)"],["IO","British Indian Ocean Territory"],["VG","British Virgin Islands"],["BN","Brunei (Negara Brunei Darussalam)"],["BG","Bulgaria (България)"],["BF","Burkina Faso"],["BI","Burundi (Uburundi)"],["KH","Cambodia (កម្ពុជា)"],["CM","Cameroon (Cameroun)"],["CA","Canada"],["CV","Cape Verde (Kabu Verdi)"],["BQ","Caribbean Netherlands"],["KY","Cayman Islands"],["CF","Central African Republic"],["TD","Chad (Tchad)"],["CL","Chile"],["CN","China (中国)"],["CX","Christmas Island"],["CC","Cocos (Keeling) Islands"],["CO","Colombia"],["KM","Comoros (‫جزر القمر‬‎)"],["CD","Congo (DRC) (Kongo)"],["CG","Congo (Republic) (Congo-Brazzaville)"],["CK","Cook Islands"],["CR","Costa Rica"],["CI","Côte d’Ivoire"],["HR","Croatia (Hrvatska)"],["CU","Cuba"],["CW","Curaçao"],["CY","Cyprus (Κύπρος)"],["CZ","Czech Republic (Česká republika)"],["DK","Denmark (Danmark)"],["DJ","Djibouti"],["DM","Dominica"],["DO","Dominican Republic"],["EC","Ecuador"],["EG","Egypt (‫مصر‬‎)"],["SV","El Salvador"],["GQ","Equatorial Guinea (Guinea Ecuatorial)"],["ER","Eritrea"],["EE","Estonia (Eesti)"],["ET","Ethiopia"],["FK","Falkland Islands (Islas Malvinas)"],["FO","Faroe Islands (Føroyar)"],["FJ","Fiji (Matanitu Tugalala o Viti)"],["FI","Finland (Suomi)"],["FR","France (République française)"],["GF","French Guiana (Guyane française)"],["PF","French Polynesia (Polynésie française)"],["GA","Gabon (République gabonaise)"],["GM","Gambia"],["GE","Georgia (საქართველო)"],["DE","Germany (Deutschland)"],["GH","Ghana (Gaana)"],["GI","Gibraltar"],["GR","Greece (Ελλάδα)"],["GL","Greenland (Kalaallit Nunaat)"],["GD","Grenada"],["GP","Guadeloupe"],["GU","Guam (Guåhån)"],["GT","Guatemala"],["GG","Guernsey"],["GN","Guinea (Guinée)"],["GW","Guinea-Bissau (Guiné Bissau)"],["GY","Guyana"],["HT","Haiti (République d\'Haïti)"],["HN","Honduras"],["HK","Hong Kong (香港)"],["HU","Hungary (Magyarország)"],["IS","Iceland (Ísland)"],["IN","India (भारत)"],["ID","Indonesia"],["IR","Iran (‫ایران‬‎)"],["IQ","Iraq (‫العراق‬‎)"],["IE","Ireland"],["IM","Isle of Man"],["IL","Israel (‫ישראל‬‎)"],["IT","Italy (Italia)"],["JM","Jamaica"],["JP","Japan (日本)"],["JE","Jersey"],["JO","Jordan (‫الأردن‬‎)"],["KZ","Kazakhstan (Казахстан)"],["KE","Kenya"],["KI","Kiribati"],["XK","Kosovo"],["KW","Kuwait (‫الكويت‬‎)"],["KG","Kyrgyzstan (Кыргызстан)"],["LA","Laos (ລາວ)"],["LV","Latvia (Latvija)"],["LB","Lebanon (‫لبنان‬‎)"],["LS","Lesotho"],["LR","Liberia"],["LY","Libya (‫ليبيا‬‎)"],["LI","Liechtenstein"],["LT","Lithuania (Lietuva)"],["LU","Luxembourg (Lëtzebuerg)"],["MO","Macau (澳門)"],["MK","Macedonia (FYROM) (Македонија)"],["MG","Madagascar (Madagasikara)"],["MW","Malawi (Malaŵi)"],["MY","Malaysia"],["MV","Maldives"],["ML","Mali"],["MT","Malta"],["MH","Marshall Islands"],["MQ","Martinique"],["MR","Mauritania (‫موريتانيا‬‎)"],["MU","Mauritius (Moris)"],["YT","Mayotte"],["MX","Mexico (México)"],["FM","Micronesia"],["MD","Moldova (Republica Moldova)"],["MC","Monaco"],["MN","Mongolia (Монгол)"],["ME","Montenegro (Crna Gora)"],["MS","Montserrat"],["MA","Morocco (‫المغرب‬‎)"],["MZ","Mozambique (Moçambique)"],["MM","Myanmar (Burma) (မြန်မာ)"],["NA","Namibia (Namibië)"],["NR","Nauru (Repubrikin Naoero)"],["NP","Nepal (नेपाल)"],["NL","Netherlands (Nederland)"],["NC","New Caledonia (Nouvelle-Calédonie)"],["NZ","New Zealand"],["NI","Nicaragua"],["NE","Niger (Nijar)"],["NG","Nigeria"],["NU","Niue (Niuē)"],["NF","Norfolk Island"],["KP","North Korea (조선 민주주의 인민 공화국)"],["MP","Northern Mariana Islands"],["NO","Norway (Norge)"],["OM","Oman (‫عُمان‬‎)"],["PK","Pakistan (‫پاکستان‬‎)"],["PW","Palau (Beluu er a Belau)"],["PS","Palestine (‫فلسطين‬‎)"],["PA","Panama (Panamá)"],["PG","Papua New Guinea"],["PY","Paraguay (Tetã Paraguái)"],["PE","Peru (Perú)"],["PH","Philippines (Republika ng Pilipinas)"],["PL","Poland (Polska)"],["PT","Portugal (República Portuguesa)"],["PR","Puerto Rico"],["QA","Qatar (‫قطر‬‎)"],["RE","Réunion (La Réunion)"],["RO","Romania (România)"],["RU","Russia (Россия)"],["RW","Rwanda"],["BL","Saint Barthélemy (Saint-Barthélemy)"],["SH","Saint Helena"],["KN","Saint Kitts and Nevis"],["LC","Saint Lucia"],["MF","Saint Martin (Saint-Martin)"],["PM","Saint Pierre and Miquelon"],["VC","Saint Vincent and the Grenadines"],["WS","Samoa (Sāmoa)"],["SM","San Marino"],["ST","São Tomé and Príncipe"],["SA","Saudi Arabia (‫المملكة العربية السعودية‬‎)"],["SN","Senegal (Sénégal)"],["RS","Serbia (Србија)"],["SC","Seychelles (Repiblik Sesel)"],["SL","Sierra Leone"],["SG","Singapore (Singapura) (新加坡共和国)"],["SX","Sint Maarten"],["SK","Slovakia (Slovensko)"],["SI","Slovenia (Slovenija)"],["SB","Solomon Islands"],["SO","Somalia (Soomaaliya)"],["ZA","South Africa"],["KR","South Korea (대한민국)"],["SS","South Sudan (‫جنوب السودان‬‎)"],["ES","Spain (España)"],["LK","Sri Lanka (ශ්‍රී ලංකාව)"],["SD","Sudan (‫السودان‬‎)"],["SR","Suriname"],["SJ","Svalbard and Jan Mayen"],["SZ","Swaziland (Umbuso weSwatini)"],["SE","Sweden (Sverige)"],["CH","Switzerland (Schweiz)"],["SY","Syria (‫سوريا‬‎)"],["TW","Taiwan (台灣)"],["TJ","Tajikistan (Ҷумҳурии Тоҷикистон)"],["TZ","Tanzania"],["TH","Thailand (ไทย)"],["TL","Timor-Leste (Timór-Leste)"],["TG","Togo (République togolaise)"],["TK","Tokelau"],["TO","Tonga"],["TT","Trinidad and Tobago"],["TN","Tunisia (‫تونس‬‎)"],["TR","Turkey (Türkiye)"],["TM","Turkmenistan (Türkmenistan)"],["TC","Turks and Caicos Islands"],["TV","Tuvalu"],["VI","U.S. Virgin Islands"],["UG","Uganda"],["UA","Ukraine (Україна)"],["AE","United Arab Emirates (‫الإمارات العربية المتحدة‬‎)"],["GB","United Kingdom"],["US","United States"],["UY","Uruguay"],["UZ","Uzbekistan (Oʻzbekiston)"],["VU","Vanuatu"],["VA","Vatican City (Città del Vaticano)"],["VE","Venezuela"],["VN","Vietnam (Việt Nam)"],["WF","Wallis and Futuna (Wallis-et-Futuna)"],["EH","Western Sahara (‫الصحراء الغربية‬‎)"],["YE","Yemen (‫اليمن‬‎)"],["ZM","Zambia"],["ZW","Zimbabwe"]]'
        )

        /***/
      },

    /***/ './modules/formatPhoneNumber.js':
      /*!**************************************!*\
  !*** ./modules/formatPhoneNumber.js ***!
  \**************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = formatPhoneNumber

        var _custom = __webpack_require__(/*! libphonenumber-js/custom */ '../node_modules/libphonenumber-js/custom.js')

        /**
         * Formats a (possibly incomplete) phone number.
         * The phone number can be either in E.164 format
         * or in a form of national number digits.
         * Is used for `input-format`'s `format()` function.
         * https://github.com/catamphetamine/input-format
         * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
         * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
         * @return {object} `{ text : string, template : string }`
         */
        function formatPhoneNumber(value, country, metadata) {
          // "As you type" formatter.
          var formatter = new _custom.AsYouType(country, metadata)

          // Format the number.
          var text = formatter.input(value)

          return { text: text, template: formatter.template }
        }
        //# sourceMappingURL=formatPhoneNumber.js.map

        /***/
      },

    /***/ './modules/input-control.js':
      /*!**********************************!*\
  !*** ./modules/input-control.js ***!
  \**********************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.getPreSelectedCountry = getPreSelectedCountry
        exports.getCountrySelectOptions = getCountrySelectOptions
        exports.parsePhoneNumber = parsePhoneNumber
        exports.generateNationalNumberDigits = generateNationalNumberDigits
        exports.migrateParsedInputForNewCountry = migrateParsedInputForNewCountry
        exports.e164 = e164
        exports.getCountryForParsedInput = getCountryForParsedInput
        exports.get_country_from_possibly_incomplete_international_phone_number = get_country_from_possibly_incomplete_international_phone_number
        exports.compare_strings = compare_strings
        exports.has_international_option = has_international_option
        exports.strip_country_calling_code = strip_country_calling_code
        exports.get_national_significant_number_part = get_national_significant_number_part
        exports.could_number_belong_to_country = could_number_belong_to_country

        var _custom = __webpack_require__(/*! libphonenumber-js/custom */ '../node_modules/libphonenumber-js/custom.js')

        var _countries2 = __webpack_require__(/*! ./countries */ './modules/countries.js')

        var _countries3 = _interopRequireDefault(_countries2)

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj }
        }

        /**
         * Decides which country should be pre-selected
         * when the phone number input component is first mounted.
         * @param  {object} parsedNumber - A parsed number object: `{ country, phone }`. Can be an empty object.
         * @param  {string?} country - Pre-defined country (two-letter code).
         * @param  {string[]} countries - A list of countries available.
         * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
         * @param  {object} metadata - `libphonenumber-js` metadata
         * @return {string?}
         */
        function getPreSelectedCountry(parsed_number, country, countries, includeInternationalOption, metadata) {
          // If can get country from E.164 phone number
          // then it overrides the `country` passed (or not passed).
          if (parsed_number.country) {
            // `country` will be left `undefined` in case of non-detection.
            country = parsed_number.country
          }

          // Only pre-select a country if it's in the available `countries` list.
          if (countries.indexOf(country) < 0) {
            country = undefined
          }

          // If there will be no "International" option
          // then some `country` must be selected.
          // It will still be the wrong country though.
          // But still country `<select/>` can't be left in a broken state.
          if (!country && !has_international_option(countries, includeInternationalOption)) {
            country = countries[0]
          }

          return country
        }

        /**
         * Generates a sorted list of country `<select/>` options.
         * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
         * @param  {object?} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
         * @param  {boolean} includeInternationalOption - Whether should include "International" option at the top of the list.
         * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
         */
        function getCountrySelectOptions(_countries, country_names, includeInternationalOption) {
          // Generates a `<Select/>` option for each country.
          var country_select_options = _countries.map(function (country) {
            return {
              value: country,
              label: (country_names && country_names[country]) || _countries3.default[country],
            }
          })

          // Sort the list of countries alphabetically.
          //
          // This is only done when custom `countries` are supplied.
          //
          // If no custom `countries` are supplied
          // then this means the default list of `countries`
          // is used which is already sorted by country name alphabetically.
          //
          if (_countries !== _countries2.countries || country_names) {
            country_select_options.sort(function (a, b) {
              return compare_strings(a.label, b.label)
            })
          }

          // Add the "International" option to the country list (if suitable)
          if (has_international_option(_countries, includeInternationalOption)) {
            country_select_options.unshift({
              label: (country_names && country_names.ZZ) || _countries3.default.ZZ,
            })
          }

          return country_select_options
        }

        /**
         * Parses a E.164 phone number to an object having shape `{ country : string, phone : string }`.
         * @param {string} value = E.164 phone number.
         * @param  {object} metadata - `libphonenumber-js` metadata
         * @example
         * parsePhoneNumber('+78005553535')
         * // returns `{ country: 'RU', phone: '8005553535' }`
         */
        function parsePhoneNumber(value, metadata) {
          return (0, _custom.parseNumber)(value || '', metadata)
        }

        /**
         * Generates national number digits for a parsed phone.
         * May prepend national prefix.
         * @param  {object} parsedPhone - Object having shape `{ country : string, phone : string }`.
         * @param  {object} metadata - `libphonenumber-js` metadata
         * @return {string}
         * @example
         * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
         * // returns '88005553535'
         */
        function generateNationalNumberDigits(parsed_phone, metadata) {
          return (0, _custom.formatNumber)(parsed_phone, 'National', metadata).replace(/\D/g, '')
        }

        /**
         * Migrates `<input/>` parsed `value` for the newly selected `country`.
         * @param {string?} value - The `value` parsed from phone number `<input/>` (it's the `parsed_input` state property, not the `value` property).
         * @param {string?} previousCountry - Previously selected country.
         * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
         * @param {object} metadata - `libphonenumber-js` metadata.
         * @return {string}
         */
        function migrateParsedInputForNewCountry(value, previous_country, new_country, metadata) {
          // If `parsed_input` is empty
          // then no need to migrate anything.
          if (!value) {
            return value
          }

          // If switching to some country.
          // (from "International" or another country)
          // If switching from "International" then `value` starts with a `+`.
          // Otherwise it may or may not start with a `+`.
          if (new_country) {
            // If the phone number was entered in international format
            // then migrate it to the newly selected country.
            // The phone number may be incomplete.
            // The phone number entered not necessarily starts with
            // the previously selected country phone prefix.
            if (value[0] === '+') {
              // If the international phone number already contains
              // any country calling code then trim the country calling code part.
              // (that could also be the newly selected country phone code prefix as well)
              // `value` doesn't neccessarily belong to `previous_country`.
              // (e.g. if a user enters an international number
              //  not belonging to any of the reduced `countries` list)
              value = strip_country_calling_code(value, previous_country, metadata)

              // Prepend country calling code prefix
              // for the newly selected country.
              return '+' + (0, _custom.getCountryCallingCode)(new_country, metadata) + value
            }
          }
          // If switching to "International" from a country.
          else {
            // If the phone number was entered in national format.
            if (value[0] !== '+') {
              // Format the national phone number as an international one.
              // The phone number entered not necessarily even starts with
              // the previously selected country phone prefix.
              // Even if the phone number belongs to whole another country
              // it will still be parsed into some national phone number.
              var partial_national_significant_number = get_national_significant_number_part(value, previous_country, metadata)
              return (0, _custom.formatNumber)(partial_national_significant_number, previous_country, 'E.164', metadata)
            }
          }

          return value
        }

        /**
         * Converts phone number digits to a (possibly incomplete) E.164 phone number.
         * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
         * @param  {string?} country
         * @param  {[object} metadata - `libphonenumber-js` metadata.
         * @return {string?}
         */
        function e164(number, country, metadata) {
          if (!number) {
            return
          }

          // If the phone number is being input in international format.
          if (number[0] === '+') {
            // If it's just the `+` sign then return nothing.
            if (number === '+') {
              return
            }

            // If there are any digits then the `value` is returned as is.
            return number
          }

          // For non-international phone numbers
          // an accompanying country code is required.
          if (!country) {
            return
          }

          var partial_national_significant_number = get_national_significant_number_part(number, country, metadata)

          if (!partial_national_significant_number) {
            return
          }

          return (0, _custom.formatNumber)(partial_national_significant_number, country, 'E.164', metadata)
        }

        // If the phone number being input is an international one
        // then tries to derive the country from the phone number.
        // (regardless of whether there's any country currently selected)
        /**
         * @param {string} parsedInput - A possibly incomplete E.164 phone number.
         * @param {string?} country - Currently selected country.
         * @param {string[]} countries - A list of available countries.
         * @param {boolean} includeInternationalOption - Whether "International" country option is available.
         * @param  {[object} metadata - `libphonenumber-js` metadata.
         * @return {string?}
         */
        function getCountryForParsedInput(parsed_input, country, countries, includeInternationalOption, metadata) {
          if (parsed_input === '+') {
            // Don't change the currently selected country yet.
            return country
          }

          var derived_country = get_country_from_possibly_incomplete_international_phone_number(parsed_input, metadata)

          // If a phone number is being input in international form
          // and the country can already be derived from it,
          // then select that country.
          if (derived_country && countries.indexOf(derived_country) >= 0) {
            return derived_country
          }
          // If "International" country option has not been disabled
          // and the international phone number entered doesn't correspond
          // to the currently selected country then reset the currently selected country.
          else if (
            country &&
            has_international_option(countries, includeInternationalOption) &&
            !could_number_belong_to_country(parsed_input, country, metadata)
          ) {
            return undefined
          }

          // Don't change the currently selected country.
          return country
        }

        /**
         * Determines the country for a given (possibly incomplete) E.164 phone number.
         * @param  {string} number - A possibly incomplete E.164 phone number.
         * @param  {object} metadata - `libphonenumber-js` metadata.
         * @return {string?}
         */
        function get_country_from_possibly_incomplete_international_phone_number(number, metadata) {
          var formatter = new _custom.AsYouType(null, metadata)
          formatter.input(number)
          // `001` is a special "non-geograpical entity" code
          // in Google's `libphonenumber` library.
          if (formatter.country === '001') {
            return
          }
          return formatter.country
        }

        /**
         * Compares two strings.
         * A helper for `Array.sort()`.
         */
        function compare_strings(a, b) {
          // Use `String.localeCompare` if it's available.
          // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
          // Which means everyone except IE <= 10 and Safari <= 10.
          if (String.prototype.localeCompare) {
            return a.localeCompare(b)
          }
          return a < b ? -1 : a > b ? 1 : 0
        }

        /**
         * Whether should add the "International" option to country `<select/>`.
         */
        function has_international_option(_countries, includeInternationalOption) {
          // If this behaviour is explicitly set, then do as it says.
          if (includeInternationalOption !== undefined) {
            return includeInternationalOption
          }

          // If the list of `countries` has been overridden
          // then only show "International" option
          // if no countries have been left out.
          // The reasoning is that if some countries were left out
          // and a user selects "International" option
          // then he can input a phone number for a non-included country
          // and perhaps that's what a developer didn't encourage
          // when he was reducing the set of selectable countries.
          return _countries.length >= _countries2.countries.length
        }

        /**
         * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
         * @param {string} number - (possibly incomplete) E.164 phone number.
         * @param {string?} country - A possible country for this phone number.
         * @param {object} metadata - `libphonenumber-js` metadata.
         * @return {string}
         */
        function strip_country_calling_code(number, country, metadata) {
          // Just an optimization, so that it
          // doesn't have to iterate through all country calling codes.
          if (country) {
            var country_calling_prefix = '+' + (0, _custom.getCountryCallingCode)(country, metadata)

            // If `country` fits the actual `number`.
            if (number.length < country_calling_prefix.length) {
              if (country_calling_prefix.indexOf(number) === 0) {
                return ''
              }
            } else {
              if (number.indexOf(country_calling_prefix) === 0) {
                return number.slice(country_calling_prefix.length)
              }
            }
          }

          // If `country` doesn't fit the actual `number`.
          // Try all available country calling codes.
          for (
            var _iterator = Object.keys(metadata.country_calling_codes),
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var country_calling_code = _ref

            if (number.indexOf(country_calling_code) === '+'.length) {
              return number.slice('+'.length + country_calling_code.length)
            }
          }

          return ''
        }

        /**
         * Parses a partially entered national phone number digits
         * (or a partially entered E.164 international phone number)
         * and returns the national significant number part.
         * National significant number returned doesn't come with a national prefix.
         * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
         * @param {string?} country
         * @param {object} metadata - `libphonenumber-js` metadata.
         */
        function get_national_significant_number_part(number, country, metadata) {
          // Create "as you type" formatter.
          var formatter = new _custom.AsYouType(country, metadata)

          // Input partial national phone number.
          formatter.input(number)

          // Return the parsed partial national phone number.
          return formatter.getNationalNumber()
        }

        /**
         * Checks if a partially entered E.164 phone number could belong to a country.
         * @param  {string} number
         * @param  {string} country
         * @return {boolean}
         */
        function could_number_belong_to_country(number, country, metadata) {
          var country_calling_code = (0, _custom.getCountryCallingCode)(country, metadata)

          var i = 0
          while (i + 1 < number.length && i < country_calling_code.length) {
            if (number[i + 1] !== country_calling_code[i]) {
              return false
            }
            i++
          }

          return true
        }
        //# sourceMappingURL=input-control.js.map

        /***/
      },

    /***/ './modules/parsePhoneNumberCharacters.js':
      /*!***********************************************!*\
  !*** ./modules/parsePhoneNumberCharacters.js ***!
  \***********************************************/
      /*! no static exports found */
      /***/ function (module, exports, __webpack_require__) {
        'use strict'

        Object.defineProperty(exports, '__esModule', {
          value: true,
        })
        exports.default = parsePhoneNumberCharacters
        exports.parsePhoneNumberCharacter = parsePhoneNumberCharacter

        var _inputFormat = __webpack_require__(/*! input-format */ '../node_modules/input-format/index.js')

        /**
         * Parses phone number characters from a string.
         * @param  {string} string
         * @return {string}
         * @example
         * ```js
         * parsePhoneNumberCharacters('8 (800) 555')
         * // Outputs '8800555'.
         * parsePhoneNumberCharacters('+7 800 555')
         * // Outputs '+7800555'.
         * ```
         */
        function parsePhoneNumberCharacters(string) {
          var result = ''

          // Using `.split('')` here instead of normal `for ... of`
          // because the importing application doesn't neccessarily include an ES6 polyfill.
          // The `.split('')` approach discards "exotic" UTF-8 characters
          // (the ones consisting of four bytes) but digits
          // (including non-European ones) don't fall into that range
          // so such "exotic" characters would be discarded anyway.
          for (
            var _iterator = string.split(''),
              _isArray = Array.isArray(_iterator),
              _i = 0,
              _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
            ;

          ) {
            var _ref

            if (_isArray) {
              if (_i >= _iterator.length) break
              _ref = _iterator[_i++]
            } else {
              _i = _iterator.next()
              if (_i.done) break
              _ref = _i.value
            }

            var character = _ref

            result += parsePhoneNumberCharacter(character, result) || ''
          }

          return result
        }

        /**
         * `input-format` `parse()` function.
         * https://github.com/catamphetamine/input-format
         * @param  {string} character - Yet another character from raw input string.
         * @param  {string} value - The value parsed so far.
         * @param  {object} meta - Optional custom use-case-specific metadata.
         * @return {string?} The parsed character.
         */
        function parsePhoneNumberCharacter(character, value) {
          // Only allow a leading `+`.
          if (character === '+') {
            // If this `+` is not the first parsed character
            // then discard it.
            if (value) {
              return
            }

            return '+'
          }

          // Allow digits.
          return (0, _inputFormat.parseDigit)(character)
        }
        //# sourceMappingURL=parsePhoneNumberCharacters.js.map

        /***/
      },

    /***/ react:
      /*!************************!*\
  !*** external "react" ***!
  \************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = require('react')

        /***/
      },

    /***/ 'react-dom':
      /*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
      /*! no static exports found */
      /***/ function (module, exports) {
        module.exports = require('react-dom')

        /***/
      },

    /******/
  }
)
